/* tslint:disable */
/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType } from 'graphql';
/**
 * This file is auto-generated by graphql-schema-typescript
 * Please note that any changes in this file may be overwritten
 */
 

/*******************************
 *                             *
 *          TYPE DEFS          *
 *                             *
 *******************************/
/**
 * An object with an ID
 */
export interface GQLNode {
  
  /**
   * The id of the object.
   */
  id: string;
}

/** Use this to resolve interface type Node */
export type GQLPossibleNodeTypeNames =
'Admin' |
'Amenity' |
'AppFile' |
'Category' |
'Chat' |
'Community' |
'CommunityAdmin' |
'Company' |
'Currency' |
'Document' |
'Event' |
'Group' |
'HelpDesk' |
'Installation' |
'Invitation' |
'Item' |
'ItemBooking' |
'JoinRequest' |
'Language' |
'Location' |
'Message' |
'MyClass' |
'NotifSending' |
'Notification' |
'Order' |
'PaymentPlan' |
'PhoneVerification' |
'PollOption' |
'Post' |
'PostTranslate' |
'Promo' |
'PushNotificationLog' |
'Referral' |
'Report' |
'Review' |
'Role' |
'Session' |
'Subscr' |
'SubscrPayment' |
'Task' |
'Transaction' |
'User';

export interface GQLNodeNameMap {
  Node: GQLNode;
  Admin: GQLAdmin;
  Amenity: GQLAmenity;
  AppFile: GQLAppFile;
  Category: GQLCategory;
  Chat: GQLChat;
  Community: GQLCommunity;
  CommunityAdmin: GQLCommunityAdmin;
  Company: GQLCompany;
  Currency: GQLCurrency;
  Document: GQLDocument;
  Event: GQLEvent;
  Group: GQLGroup;
  HelpDesk: GQLHelpDesk;
  Installation: GQLInstallation;
  Invitation: GQLInvitation;
  Item: GQLItem;
  ItemBooking: GQLItemBooking;
  JoinRequest: GQLJoinRequest;
  Language: GQLLanguage;
  Location: GQLLocation;
  Message: GQLMessage;
  MyClass: GQLMyClass;
  NotifSending: GQLNotifSending;
  Notification: GQLNotification;
  Order: GQLOrder;
  PaymentPlan: GQLPaymentPlan;
  PhoneVerification: GQLPhoneVerification;
  PollOption: GQLPollOption;
  Post: GQLPost;
  PostTranslate: GQLPostTranslate;
  Promo: GQLPromo;
  PushNotificationLog: GQLPushNotificationLog;
  Referral: GQLReferral;
  Report: GQLReport;
  Review: GQLReview;
  Role: GQLRole;
  Session: GQLSession;
  Subscr: GQLSubscr;
  SubscrPayment: GQLSubscrPayment;
  Task: GQLTask;
  Transaction: GQLTransaction;
  User: GQLUser;
}

/**
 * The ParseObject interface type is used as a base type for the auto generated object types.
 */
export interface GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/** Use this to resolve interface type ParseObject */
export type GQLPossibleParseObjectTypeNames =
'Admin' |
'Amenity' |
'AppFile' |
'Category' |
'Chat' |
'Community' |
'CommunityAdmin' |
'Company' |
'Currency' |
'Document' |
'Event' |
'Group' |
'HelpDesk' |
'Installation' |
'Invitation' |
'Item' |
'ItemBooking' |
'JoinRequest' |
'Language' |
'Location' |
'Message' |
'MyClass' |
'NotifSending' |
'Notification' |
'Order' |
'PaymentPlan' |
'PhoneVerification' |
'PollOption' |
'Post' |
'PostTranslate' |
'Promo' |
'PushNotificationLog' |
'Referral' |
'Report' |
'Review' |
'Role' |
'Session' |
'Subscr' |
'SubscrPayment' |
'Task' |
'Transaction' |
'User';

export interface GQLParseObjectNameMap {
  ParseObject: GQLParseObject;
  Admin: GQLAdmin;
  Amenity: GQLAmenity;
  AppFile: GQLAppFile;
  Category: GQLCategory;
  Chat: GQLChat;
  Community: GQLCommunity;
  CommunityAdmin: GQLCommunityAdmin;
  Company: GQLCompany;
  Currency: GQLCurrency;
  Document: GQLDocument;
  Event: GQLEvent;
  Group: GQLGroup;
  HelpDesk: GQLHelpDesk;
  Installation: GQLInstallation;
  Invitation: GQLInvitation;
  Item: GQLItem;
  ItemBooking: GQLItemBooking;
  JoinRequest: GQLJoinRequest;
  Language: GQLLanguage;
  Location: GQLLocation;
  Message: GQLMessage;
  MyClass: GQLMyClass;
  NotifSending: GQLNotifSending;
  Notification: GQLNotification;
  Order: GQLOrder;
  PaymentPlan: GQLPaymentPlan;
  PhoneVerification: GQLPhoneVerification;
  PollOption: GQLPollOption;
  Post: GQLPost;
  PostTranslate: GQLPostTranslate;
  Promo: GQLPromo;
  PushNotificationLog: GQLPushNotificationLog;
  Referral: GQLReferral;
  Report: GQLReport;
  Review: GQLReview;
  Role: GQLRole;
  Session: GQLSession;
  Subscr: GQLSubscr;
  SubscrPayment: GQLSubscrPayment;
  Task: GQLTask;
  Transaction: GQLTransaction;
  User: GQLUser;
}

/**
 * The SchemaField interface type is used as a base type for the different supported fields of an object class schema.
 */
export interface GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/** Use this to resolve interface type SchemaField */
export type GQLPossibleSchemaFieldTypeNames =
'SchemaACLField' |
'SchemaArrayField' |
'SchemaBooleanField' |
'SchemaBytesField' |
'SchemaDateField' |
'SchemaFileField' |
'SchemaGeoPointField' |
'SchemaNumberField' |
'SchemaObjectField' |
'SchemaPointerField' |
'SchemaPolygonField' |
'SchemaRelationField' |
'SchemaStringField';

export interface GQLSchemaFieldNameMap {
  SchemaField: GQLSchemaField;
  SchemaACLField: GQLSchemaACLField;
  SchemaArrayField: GQLSchemaArrayField;
  SchemaBooleanField: GQLSchemaBooleanField;
  SchemaBytesField: GQLSchemaBytesField;
  SchemaDateField: GQLSchemaDateField;
  SchemaFileField: GQLSchemaFileField;
  SchemaGeoPointField: GQLSchemaGeoPointField;
  SchemaNumberField: GQLSchemaNumberField;
  SchemaObjectField: GQLSchemaObjectField;
  SchemaPointerField: GQLSchemaPointerField;
  SchemaPolygonField: GQLSchemaPolygonField;
  SchemaRelationField: GQLSchemaRelationField;
  SchemaStringField: GQLSchemaStringField;
}

/**
 * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
 */
export type GQLArrayResult =
GQLAdmin |
GQLAmenity |
GQLAppFile |
GQLCategory |
GQLChat |
GQLCommunity |
GQLCommunityAdmin |
GQLCompany |
GQLCurrency |
GQLDocument |
GQLElement |
GQLEvent |
GQLGroup |
GQLHelpDesk |
GQLInstallation |
GQLInvitation |
GQLItem |
GQLItemBooking |
GQLJoinRequest |
GQLLanguage |
GQLLocation |
GQLMessage |
GQLMyClass |
GQLNotifSending |
GQLNotification |
GQLOrder |
GQLPaymentPlan |
GQLPhoneVerification |
GQLPollOption |
GQLPost |
GQLPostTranslate |
GQLPromo |
GQLPushNotificationLog |
GQLReferral |
GQLReport |
GQLReview |
GQLRole |
GQLSession |
GQLSubscr |
GQLSubscrPayment |
GQLTask |
GQLTransaction |
GQLUser;

/** Use this to resolve union type ArrayResult */
export type GQLPossibleArrayResultTypeNames =
'Admin' |
'Amenity' |
'AppFile' |
'Category' |
'Chat' |
'Community' |
'CommunityAdmin' |
'Company' |
'Currency' |
'Document' |
'Element' |
'Event' |
'Group' |
'HelpDesk' |
'Installation' |
'Invitation' |
'Item' |
'ItemBooking' |
'JoinRequest' |
'Language' |
'Location' |
'Message' |
'MyClass' |
'NotifSending' |
'Notification' |
'Order' |
'PaymentPlan' |
'PhoneVerification' |
'PollOption' |
'Post' |
'PostTranslate' |
'Promo' |
'PushNotificationLog' |
'Referral' |
'Report' |
'Review' |
'Role' |
'Session' |
'Subscr' |
'SubscrPayment' |
'Task' |
'Transaction' |
'User';

export interface GQLArrayResultNameMap {
  ArrayResult: GQLArrayResult;
  Admin: GQLAdmin;
  Amenity: GQLAmenity;
  AppFile: GQLAppFile;
  Category: GQLCategory;
  Chat: GQLChat;
  Community: GQLCommunity;
  CommunityAdmin: GQLCommunityAdmin;
  Company: GQLCompany;
  Currency: GQLCurrency;
  Document: GQLDocument;
  Element: GQLElement;
  Event: GQLEvent;
  Group: GQLGroup;
  HelpDesk: GQLHelpDesk;
  Installation: GQLInstallation;
  Invitation: GQLInvitation;
  Item: GQLItem;
  ItemBooking: GQLItemBooking;
  JoinRequest: GQLJoinRequest;
  Language: GQLLanguage;
  Location: GQLLocation;
  Message: GQLMessage;
  MyClass: GQLMyClass;
  NotifSending: GQLNotifSending;
  Notification: GQLNotification;
  Order: GQLOrder;
  PaymentPlan: GQLPaymentPlan;
  PhoneVerification: GQLPhoneVerification;
  PollOption: GQLPollOption;
  Post: GQLPost;
  PostTranslate: GQLPostTranslate;
  Promo: GQLPromo;
  PushNotificationLog: GQLPushNotificationLog;
  Referral: GQLReferral;
  Report: GQLReport;
  Review: GQLReview;
  Role: GQLRole;
  Session: GQLSession;
  Subscr: GQLSubscr;
  SubscrPayment: GQLSubscrPayment;
  Task: GQLTask;
  Transaction: GQLTransaction;
  User: GQLUser;
}

/**
 * Current access control list of the current object.
 */
export interface GQLACL {
  
  /**
   * Public access control list.
   */
  public?: GQLPublicACL;
  
  /**
   * Access control list for roles.
   */
  roles?: Array<GQLRoleACL>;
  
  /**
   * Access control list for users.
   */
  users?: Array<GQLUserACL>;
}

export interface GQLAccountTransferPayload {
  success?: boolean;
}

/**
 * The Admin object type is used in operations that involve outputting objects of Admin class.
 */
export interface GQLAdmin extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Communities.
   */
  Communities?: string;
  
  /**
   * This is the object Configurations.
   */
  Configurations?: string;
  
  /**
   * This is the object HelpCentre.
   */
  HelpCentre?: string;
  
  /**
   * This is the object Listings.
   */
  Listings?: string;
  
  /**
   * This is the object Members.
   */
  Members?: string;
  
  /**
   * This is the object Promotions.
   */
  Promotions?: string;
  
  /**
   * This is the object Requests.
   */
  Requests?: string;
  
  /**
   * This is the object Settings.
   */
  Settings?: string;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isFullAccess.
   */
  isFullAccess?: boolean;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLAdminConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLAdminEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

export interface GQLAdminCreatePayload {
  admin: string;
}

export interface GQLAdminDashboardPayload {
  averageListingPrice?: number;
  averageListingRating?: number;
  averageMemberRating?: number;
  countActiveListings?: number;
  countCommunities?: number;
  countFreeListings?: number;
  countInactiveListings?: number;
  countListingMembers?: number;
  countListings?: number;
  countListingsRevenue?: number;
  countManagers?: number;
  countMembers?: number;
  countPaidListings?: number;
  countRentalListings?: number;
  countRequestedListingMembers?: number;
  countRevenue?: number;
  countReviewsAndRatings?: number;
  countSellingListings?: number;
  countServiceListings?: number;
  countSubscrRevenue?: number;
  countSuccessfulTransactions?: number;
}

/**
 * An edge in a connection.
 */
export interface GQLAdminEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLAdmin;
}

/**
 * The Amenity object type is used in operations that involve outputting objects of Amenity class.
 */
export interface GQLAmenity extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  AdmHidden?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  ApproveReq?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Bookings.
   */
  Bookings: GQLOrderConnection;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Featured?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUser;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocation;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Published?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Requests.
   */
  Requests: GQLOrderConnection;
  
  /**
   * This is the object Reviews.
   */
  Reviews: GQLReviewConnection;
  
  /**
   * This is the object Transactions.
   */
  Transactions: GQLTransactionConnection;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Updated?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers: GQLUserConnection;
  
  /**
   * This is the object allowGuests.
   */
  allowGuests?: boolean;
  
  /**
   * This is the object autoBooking.
   */
  autoBooking?: boolean;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  availabilityOverride?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object bookingPeriod.
   */
  bookingPeriod: string;
  
  /**
   * This is the object bookingSlots.
   */
  bookingSlots: string;
  
  /**
   * This is the object bookingTiming.
   */
  bookingTiming?: GQLObject;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  images?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object isBookable.
   */
  isBookable?: boolean;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object maxBookingPerSlot.
   */
  maxBookingPerSlot: number;
  
  /**
   * This is the object maxBookingsPerDay.
   */
  maxBookingsPerDay: number;
  
  /**
   * This is the object maxResidentsPerBooking.
   */
  maxResidentsPerBooking: number;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  messageAssignees?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object multipleFutureBookings.
   */
  multipleFutureBookings?: boolean;
  
  /**
   * This is the object name.
   */
  name: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object popularDay.
   */
  popularDay?: string;
  
  /**
   * This is the object popularTime.
   */
  popularTime?: GQLDate;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType: string;
  
  /**
   * This is the object totalBookings.
   */
  totalBookings?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLAmenityConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLAmenityEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLAmenityEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLAmenity;
}

/**
 * The AppFile object type is used in operations that involve outputting objects of AppFile class.
 */
export interface GQLAppFile extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object file.
   */
  file?: GQLFileInfo;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object mime.
   */
  mime?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLAppFileConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLAppFileEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLAppFileEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLAppFile;
}

export interface GQLBookAmenityPayload {
  orderId: string;
}

export interface GQLBookEventPayload {
  orderId: string;
}

export interface GQLCalcOrderDataPayload {
  cfListerAbs?: number;
  cfListerAmt?: number;
  cfListerPrc?: number;
  cfRequesterAbs?: number;
  cfRequesterAmt?: number;
  cfRequesterPrc?: number;
  discount?: number;
  discountType?: string;
  endTime?: string;
  hfListerAbs?: number;
  hfListerAmt?: number;
  hfListerPrc?: number;
  hfRequesterAbs?: number;
  hfRequesterAmt?: number;
  hfRequesterPrc?: number;
  itemAmount?: number;
  listerTotalAmt?: number;
  listingType?: string;
  period?: number;
  ppListerAbs?: number;
  ppListerAmt?: number;
  ppListerPrc?: number;
  ppRequesterAbs?: number;
  ppRequesterAmt?: number;
  ppRequesterPrc?: number;
  price?: number;
  pricePeriod?: string;
  requesterTotalAmt?: number;
  rewardType?: string;
  sfListerAmt?: number;
  sfRequesterAmt?: number;
  startTime?: string;
}

export interface GQLCallCloudCodePayload {
  clientMutationId?: string;
  
  /**
   * This is the result value of the cloud code function execution.
   */
  result?: GQLAny;
}

export interface GQLCardInfoPayload {
  address_zip?: string;
  address_zip_check?: string;
  brand?: string;
  country?: string;
  customer?: string;
  cvc_check?: string;
  exp_month: number;
  exp_year: number;
  fingerprint?: string;
  funding?: string;
  id: string;
  last4: string;
  name?: string;
  object?: string;
}

/**
 * The Category object type is used in operations that involve outputting objects of Category class.
 */
export interface GQLCategory extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLCategoryConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLCategoryEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLCategoryEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLCategory;
}

export interface GQLChangePasswordPayload {
  clientMutationId?: string;
  ok: boolean;
}

export interface GQLChartDataPayload {
  date: string;
  value: number;
}

/**
 * The Chat object type is used in operations that involve outputting objects of Chat class.
 */
export interface GQLChat extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Members.
   */
  Members: GQLUserConnection;
  
  /**
   * This is the object Messages.
   */
  Messages: GQLMessageConnection;
  
  /**
   * This is the object Support.
   */
  Support?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isArchived.
   */
  isArchived?: boolean;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLChatConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLChatEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLChatEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLChat;
}

/**
 * The Class type is used to return the information about an object class.
 */
export interface GQLClass {
  
  /**
   * This is the name of the object class.
   */
  name: string;
  
  /**
   * These are the schema's fields of the object class.
   */
  schemaFields: Array<GQLSchemaField>;
}

/**
 * The Community object type is used in operations that involve outputting objects of Community class.
 */
export interface GQLCommunity extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Admins.
   */
  Admins: GQLCommunityAdminConnection;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFile;
  
  /**
   * This is the object Invitations.
   */
  Invitations: GQLInvitationConnection;
  
  /**
   * This is the object Items.
   */
  Items: GQLItemConnection;
  
  /**
   * This is the object JoinRequests.
   */
  JoinRequests: GQLJoinRequestConnection;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocation;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUser;
  
  /**
   * This is the object Residents.
   */
  Residents: GQLUserConnection;
  
  /**
   * This is the object Subscr.
   */
  Subscr?: GQLSubscr;
  
  /**
   * This is the object accessType.
   */
  accessType?: string;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  address_add?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the object allowChat.
   */
  allowChat?: boolean;
  
  /**
   * This is the object allowEvents.
   */
  allowEvents?: boolean;
  
  /**
   * This is the object allowPosts.
   */
  allowPosts?: boolean;
  
  /**
   * This is the object buildings.
   */
  buildings?: string;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObject;
  
  /**
   * This is the object countItems.
   */
  countItems?: number;
  
  /**
   * This is the object countMembers.
   */
  countMembers?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObject;
  
  /**
   * This is the object invitation.
   */
  invitation?: string;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object listingApproval.
   */
  listingApproval?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object neighbourhood.
   */
  neighbourhood?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object options.
   */
  options?: GQLObject;
  
  /**
   * This is the object passCode.
   */
  passCode?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object totalMessages.
   */
  totalMessages?: number;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object units.
   */
  units?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object zip.
   */
  zip?: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  zip_add?: Array<GQLArrayResult | null>;
}

/**
 * The CommunityAdmin object type is used in operations that involve outputting objects of CommunityAdmin class.
 */
export interface GQLCommunityAdmin extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Communities.
   */
  Communities?: string;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object Configurations.
   */
  Configurations?: string;
  
  /**
   * This is the object HelpCentre.
   */
  HelpCentre?: string;
  
  /**
   * This is the object Listings.
   */
  Listings?: string;
  
  /**
   * This is the object Members.
   */
  Members?: string;
  
  /**
   * This is the object Promotions.
   */
  Promotions?: string;
  
  /**
   * This is the object Requests.
   */
  Requests?: string;
  
  /**
   * This is the object Settings.
   */
  Settings?: string;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object label.
   */
  label?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLCommunityAdminConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLCommunityAdminEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLCommunityAdminEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLCommunityAdmin;
}

export interface GQLCommunityAdminPayload {
  communityAdminId: string;
  success?: boolean;
}

/**
 * A connection to a list of items.
 */
export interface GQLCommunityConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLCommunityEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLCommunityEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLCommunity;
}

export interface GQLCommunityForNewUserPayload {
  communityId?: string;
}

/**
 * The Company object type is used in operations that involve outputting objects of Company class.
 */
export interface GQLCompany extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Featured?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUser;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Published?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Reports.
   */
  Reports: GQLReportConnection;
  
  /**
   * This is the object Viewers.
   */
  Viewers: GQLUserConnection;
  
  /**
   * This is the object category.
   */
  category?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  images?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  interestedUsers?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object phone.
   */
  phone?: string;
  
  /**
   * This is the object promoCTA.
   */
  promoCTA?: string;
  
  /**
   * This is the object promoDescr.
   */
  promoDescr?: string;
  
  /**
   * This is the object promoTagline.
   */
  promoTagline?: string;
  
  /**
   * This is the object promotion.
   */
  promotion?: boolean;
  
  /**
   * This is the object revealCode.
   */
  revealCode?: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object totalClicks.
   */
  totalClicks?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object visitedWebsite.
   */
  visitedWebsite?: string;
  
  /**
   * This is the object website.
   */
  website?: string;
}

/**
 * A connection to a list of items.
 */
export interface GQLCompanyConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLCompanyEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLCompanyEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLCompany;
}

export interface GQLConnectStripeAccPayload {
  accountConnected?: boolean;
  accountLink?: string;
}

export interface GQLCreateAdminPayload {
  
  /**
   * This is the created object.
   */
  admin: GQLAdmin;
  clientMutationId?: string;
}

export interface GQLCreateAmenityPayload {
  
  /**
   * This is the created object.
   */
  amenity: GQLAmenity;
  clientMutationId?: string;
}

export interface GQLCreateAppFilePayload {
  
  /**
   * This is the created object.
   */
  appFile: GQLAppFile;
  clientMutationId?: string;
}

export interface GQLCreateCategoryPayload {
  
  /**
   * This is the created object.
   */
  category: GQLCategory;
  clientMutationId?: string;
}

export interface GQLCreateChatPayload {
  
  /**
   * This is the created object.
   */
  chat: GQLChat;
  clientMutationId?: string;
}

export interface GQLCreateClassPayload {
  
  /**
   * This is the created class.
   */
  class: GQLClass;
  clientMutationId?: string;
}

export interface GQLCreateCommunityAdminPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  communityAdmin: GQLCommunityAdmin;
}

export interface GQLCreateCommunityPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  community: GQLCommunity;
}

export interface GQLCreateCompanyPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  company: GQLCompany;
}

export interface GQLCreateCurrencyPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  currency: GQLCurrency;
}

export interface GQLCreateDocumentPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  document: GQLDocument;
}

export interface GQLCreateEventPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  event: GQLEvent;
}

export interface GQLCreateFilePayload {
  clientMutationId?: string;
  
  /**
   * This is the created file info.
   */
  fileInfo: GQLFileInfo;
}

export interface GQLCreateGroupPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  group: GQLGroup;
}

export interface GQLCreateHelpDeskPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  helpDesk: GQLHelpDesk;
}

export interface GQLCreateInstallationPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  installation: GQLInstallation;
}

export interface GQLCreateInvitationPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  invitation: GQLInvitation;
}

export interface GQLCreateItemBookingPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  itemBooking: GQLItemBooking;
}

export interface GQLCreateItemPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  item: GQLItem;
}

export interface GQLCreateJoinRequestPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  joinRequest: GQLJoinRequest;
}

export interface GQLCreateLanguagePayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  language: GQLLanguage;
}

export interface GQLCreateLocationPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  location: GQLLocation;
}

export interface GQLCreateMessagePayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  message: GQLMessage;
}

export interface GQLCreateMultiplyItemsPayload {
  listId?: Array<string | null>;
}

export interface GQLCreateMyClassPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  myClass: GQLMyClass;
}

export interface GQLCreateNotifSendingPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  notifSending: GQLNotifSending;
}

export interface GQLCreateNotificationPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  notification: GQLNotification;
}

export interface GQLCreateOrderPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  order: GQLOrder;
}

export interface GQLCreatePaymentPlanPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  paymentPlan: GQLPaymentPlan;
}

export interface GQLCreatePhoneVerificationPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  phoneVerification: GQLPhoneVerification;
}

export interface GQLCreatePollOptionPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  pollOption: GQLPollOption;
}

export interface GQLCreatePostPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  post: GQLPost;
}

export interface GQLCreatePostTranslatePayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  postTranslate: GQLPostTranslate;
}

export interface GQLCreatePromoPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  promo: GQLPromo;
}

export interface GQLCreatePushNotificationLogPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  pushNotificationLog: GQLPushNotificationLog;
}

export interface GQLCreateReferralPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  referral: GQLReferral;
}

export interface GQLCreateReportPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  report: GQLReport;
}

export interface GQLCreateReviewPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  review: GQLReview;
}

export interface GQLCreateRolePayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  role: GQLRole;
}

export interface GQLCreateSessionPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  session: GQLSession;
}

export interface GQLCreateSubscrPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  subscr: GQLSubscr;
}

export interface GQLCreateSubscrPaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  subscrPayment: GQLSubscrPayment;
}

export interface GQLCreateTaskPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  task: GQLTask;
}

export interface GQLCreateTransactionPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  transaction: GQLTransaction;
}

export interface GQLCreateUserPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  user: GQLUser;
}

/**
 * The Currency object type is used in operations that involve outputting objects of Currency class.
 */
export interface GQLCurrency extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object sign.
   */
  sign?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLCurrencyConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLCurrencyEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLCurrencyEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLCurrency;
}

export interface GQLDashboardChartPayload {
  data?: Array<GQLChartDataPayload | null>;
}

export interface GQLDeleteAdminPayload {
  
  /**
   * This is the deleted object.
   */
  admin: GQLAdmin;
  clientMutationId?: string;
}

export interface GQLDeleteAmenityPayload {
  
  /**
   * This is the deleted object.
   */
  amenity: GQLAmenity;
  clientMutationId?: string;
}

export interface GQLDeleteAppFilePayload {
  
  /**
   * This is the deleted object.
   */
  appFile: GQLAppFile;
  clientMutationId?: string;
}

export interface GQLDeleteCategoryPayload {
  
  /**
   * This is the deleted object.
   */
  category: GQLCategory;
  clientMutationId?: string;
}

export interface GQLDeleteChatPayload {
  
  /**
   * This is the deleted object.
   */
  chat: GQLChat;
  clientMutationId?: string;
}

export interface GQLDeleteClassPayload {
  
  /**
   * This is the deleted class.
   */
  class: GQLClass;
  clientMutationId?: string;
}

export interface GQLDeleteCommunityAdminPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  communityAdmin: GQLCommunityAdmin;
}

export interface GQLDeleteCommunityPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  community: GQLCommunity;
}

export interface GQLDeleteCompanyPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  company: GQLCompany;
}

export interface GQLDeleteCurrencyPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  currency: GQLCurrency;
}

export interface GQLDeleteDocumentPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  document: GQLDocument;
}

export interface GQLDeleteEventPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  event: GQLEvent;
}

export interface GQLDeleteGroupPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  group: GQLGroup;
}

export interface GQLDeleteHelpDeskPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  helpDesk: GQLHelpDesk;
}

export interface GQLDeleteInstallationPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  installation: GQLInstallation;
}

export interface GQLDeleteInvitationPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  invitation: GQLInvitation;
}

export interface GQLDeleteItemBookingPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  itemBooking: GQLItemBooking;
}

export interface GQLDeleteItemPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  item: GQLItem;
}

export interface GQLDeleteJoinRequestPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  joinRequest: GQLJoinRequest;
}

export interface GQLDeleteLanguagePayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  language: GQLLanguage;
}

export interface GQLDeleteLocationPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  location: GQLLocation;
}

export interface GQLDeleteMessagePayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  message: GQLMessage;
}

export interface GQLDeleteMyClassPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  myClass: GQLMyClass;
}

export interface GQLDeleteNotifSendingPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  notifSending: GQLNotifSending;
}

export interface GQLDeleteNotificationPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  notification: GQLNotification;
}

export interface GQLDeleteOrderPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  order: GQLOrder;
}

export interface GQLDeletePaymentPlanPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  paymentPlan: GQLPaymentPlan;
}

export interface GQLDeletePhoneVerificationPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  phoneVerification: GQLPhoneVerification;
}

export interface GQLDeletePollOptionPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  pollOption: GQLPollOption;
}

export interface GQLDeletePostPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  post: GQLPost;
}

export interface GQLDeletePostTranslatePayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  postTranslate: GQLPostTranslate;
}

export interface GQLDeletePromoPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  promo: GQLPromo;
}

export interface GQLDeletePushNotificationLogPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  pushNotificationLog: GQLPushNotificationLog;
}

export interface GQLDeleteReferralPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  referral: GQLReferral;
}

export interface GQLDeleteReportPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  report: GQLReport;
}

export interface GQLDeleteReviewPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  review: GQLReview;
}

export interface GQLDeleteRolePayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  role: GQLRole;
}

export interface GQLDeleteSessionPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  session: GQLSession;
}

export interface GQLDeleteSubscrPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  subscr: GQLSubscr;
}

export interface GQLDeleteSubscrPaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  subscrPayment: GQLSubscrPayment;
}

export interface GQLDeleteTaskPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  task: GQLTask;
}

export interface GQLDeleteTransactionPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  transaction: GQLTransaction;
}

export interface GQLDeleteUserPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  user: GQLUser;
}

export interface GQLDirectAddMemberPayload {
  added: string;
}

/**
 * The Document object type is used in operations that involve outputting objects of Document class.
 */
export interface GQLDocument extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object Cover.
   */
  Cover?: GQLAppFile;
  
  /**
   * This is the object DocFile.
   */
  DocFile?: GQLAppFile;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLDocumentConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLDocumentEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLDocumentEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLDocument;
}

/**
 * The Element object type is used to return array items' value.
 */
export interface GQLElement {
  
  /**
   * Return the value of the element in the array
   */
  value: GQLAny;
}

/**
 * The Event object type is used in operations that involve outputting objects of Event class.
 */
export interface GQLEvent extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  AdmHidden?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  ApproveReq?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Attendees.
   */
  Attendees: GQLUserConnection;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Featured?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUser;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocation;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Published?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Reports.
   */
  Reports: GQLReportConnection;
  
  /**
   * This is the object Requests.
   */
  Requests: GQLOrderConnection;
  
  /**
   * This is the object Reviews.
   */
  Reviews: GQLReviewConnection;
  
  /**
   * This is the object Transactions.
   */
  Transactions: GQLTransactionConnection;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Updated?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers: GQLUserConnection;
  
  /**
   * This is the object allowGuests.
   */
  allowGuests?: boolean;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr: string;
  
  /**
   * This is the object endTime.
   */
  endTime?: GQLDate;
  
  /**
   * This is the object eventType.
   */
  eventType?: string;
  
  /**
   * This is the object expiresDate.
   */
  expiresDate?: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  images?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object likes.
   */
  likes: GQLUserConnection;
  
  /**
   * This is the object listerReminded.
   */
  listerReminded?: boolean;
  
  /**
   * This is the object listerReminded6am.
   */
  listerReminded6am?: boolean;
  
  /**
   * This is the object locationDetails.
   */
  locationDetails?: string;
  
  /**
   * This is the object maxAttendees.
   */
  maxAttendees: number;
  
  /**
   * This is the object maxGuestsPerAttendee.
   */
  maxGuestsPerAttendee: number;
  
  /**
   * This is the object name.
   */
  name: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object openTo.
   */
  openTo?: string;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: number;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType: string;
  
  /**
   * This is the object showAttendees.
   */
  showAttendees?: boolean;
  
  /**
   * This is the object startTime.
   */
  startTime?: GQLDate;
  
  /**
   * This is the object totalAttendees.
   */
  totalAttendees?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLEventConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLEventEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLEventEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLEvent;
}

export interface GQLFeeObject {
  cfListerAbs?: number;
  cfListerPrc?: number;
  cfRequesterAbs?: number;
  cfRequesterPrc?: number;
  message?: string;
}

/**
 * The FileInfo object type is used to return the information about files.
 */
export interface GQLFileInfo {
  
  /**
   * This is the file name.
   */
  name: string;
  
  /**
   * This is the url in which the file can be downloaded.
   */
  url: string;
}

export interface GQLGenerateAiOpenApiTextPayload {
  gptResponseText?: string;
}

export interface GQLGenerateUsernamePayload {
  name: string;
}

/**
 * The GeoPoint object type is used to return the information about geo point fields.
 */
export interface GQLGeoPoint {
  
  /**
   * This is the latitude.
   */
  latitude: number;
  
  /**
   * This is the longitude.
   */
  longitude: number;
}

export interface GQLGetAccBalancePayload {
  balance: number;
}

export interface GQLGetItemArraysPayload {
  approvedItems?: Array<GQLObject | null>;
  featuredItems?: Array<GQLObject | null>;
}

export interface GQLGetManagersListPayload {
  email?: string;
  fullName?: string;
  id?: string;
  label?: string;
}

export interface GQLGetResidentsAvatarPayload {
  users?: Array<GQLObject | null>;
}

export interface GQLGetUserByReferralPayload {
  user: GQLObject;
}

export interface GQLGetUserCardsPayload {
  cards?: Array<GQLCardInfoPayload | null>;
  defaultCardId?: string;
}

/**
 * The Group object type is used in operations that involve outputting objects of Group class.
 */
export interface GQLGroup extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFile;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Featured?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Members.
   */
  Members: GQLUserConnection;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLGroupConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLGroupEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLGroupEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLGroup;
}

export interface GQLGroupPayload {
  success: boolean;
}

/**
 * The HelpDesk object type is used in operations that involve outputting objects of HelpDesk class.
 */
export interface GQLHelpDesk extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Assignee.
   */
  Assignee?: GQLUser;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object assignTo.
   */
  assignTo?: string;
  
  /**
   * This is the object buttonTitle.
   */
  buttonTitle?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object dailyQuoteAuthor.
   */
  dailyQuoteAuthor?: string;
  
  /**
   * This is the object descr.
   */
  descr: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object layOutOrder.
   */
  layOutOrder?: number;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object title.
   */
  title: string;
  
  /**
   * This is the object type.
   */
  type: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLHelpDeskConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLHelpDeskEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLHelpDeskEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLHelpDesk;
}

export interface GQLHidePostPayload {
  post?: GQLObject;
}

/**
 * The Installation object type is used in operations that involve outputting objects of Installation class.
 */
export interface GQLInstallation extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object GCMSenderId.
   */
  GCMSenderId?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object appIdentifier.
   */
  appIdentifier?: string;
  
  /**
   * This is the object appName.
   */
  appName?: string;
  
  /**
   * This is the object appVersion.
   */
  appVersion?: string;
  
  /**
   * This is the object badge.
   */
  badge?: number;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  channels?: Array<GQLArrayResult | null>;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object deviceToken.
   */
  deviceToken?: string;
  
  /**
   * This is the object deviceType.
   */
  deviceType?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object localeIdentifier.
   */
  localeIdentifier?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object parseVersion.
   */
  parseVersion?: string;
  
  /**
   * This is the object pushType.
   */
  pushType?: string;
  
  /**
   * This is the object timeZone.
   */
  timeZone?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLInstallationConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLInstallationEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLInstallationEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLInstallation;
}

/**
 * The Invitation object type is used in operations that involve outputting objects of Invitation class.
 */
export interface GQLInvitation extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailText.
   */
  emailText?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object invLink.
   */
  invLink?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLInvitationConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLInvitationEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLInvitationEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLInvitation;
}

export interface GQLInvoiceItemOrderPayload {
  entryFee: number;
  serviceCharge: number;
  stripeFee: number;
  total: number;
}

/**
 * The Item object type is used in operations that involve outputting objects of Item class.
 */
export interface GQLItem extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  AdmHidden?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  ApproveReq?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Featured?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUser;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocation;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Published?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Reports.
   */
  Reports: GQLReportConnection;
  
  /**
   * This is the object Requests.
   */
  Requests: GQLOrderConnection;
  
  /**
   * This is the object Reviews.
   */
  Reviews: GQLReviewConnection;
  
  /**
   * This is the object Transactions.
   */
  Transactions: GQLTransactionConnection;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Updated?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers: GQLUserConnection;
  
  /**
   * This is the object category.
   */
  category?: string;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object createdAt_custom.
   */
  createdAt_custom?: GQLDate;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object discount.
   */
  discount?: number;
  
  /**
   * This is the object discountType.
   */
  discountType?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  images?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object income.
   */
  income?: number;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object isSold.
   */
  isSold?: boolean;
  
  /**
   * This is the object likes.
   */
  likes: GQLUserConnection;
  
  /**
   * This is the object listingType.
   */
  listingType?: string;
  
  /**
   * This is the object maxPeriod.
   */
  maxPeriod?: number;
  
  /**
   * This is the object minDuration.
   */
  minDuration?: number;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object originalPrice.
   */
  originalPrice?: number;
  
  /**
   * This is the object price.
   */
  price?: number;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: string;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object totalCompletedOrders.
   */
  totalCompletedOrders?: number;
  
  /**
   * This is the object totalRequests.
   */
  totalRequests?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object yearPurchased.
   */
  yearPurchased?: string;
}

/**
 * The ItemBooking object type is used in operations that involve outputting objects of ItemBooking class.
 */
export interface GQLItemBooking extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItem;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrder;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object from.
   */
  from?: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object to.
   */
  to?: GQLDate;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLItemBookingConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLItemBookingEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLItemBookingEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLItemBooking;
}

/**
 * A connection to a list of items.
 */
export interface GQLItemConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLItemEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLItemEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLItem;
}

/**
 * The JoinRequest object type is used in operations that involve outputting objects of JoinRequest class.
 */
export interface GQLJoinRequest extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object Invitation.
   */
  Invitation?: GQLInvitation;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object answer.
   */
  answer?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object request.
   */
  request?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLJoinRequestConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLJoinRequestEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLJoinRequestEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLJoinRequest;
}

/**
 * The Language object type is used in operations that involve outputting objects of Language class.
 */
export interface GQLLanguage extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isDisabled.
   */
  isDisabled?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLLanguageConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLLanguageEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLLanguageEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLLanguage;
}

export interface GQLLikeEventPayload {
  success?: boolean;
}

export interface GQLLikeListingPayload {
  success?: boolean;
}

export interface GQLLikePostPayload {
  post?: GQLObject;
}

/**
 * The Location object type is used in operations that involve outputting objects of Location class.
 */
export interface GQLLocation extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object City.
   */
  City?: GQLLocation;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocation;
  
  /**
   * This is the object State.
   */
  State?: GQLLocation;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPoint;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isDisabled.
   */
  isDisabled?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLLocationConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLLocationEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLLocationEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLLocation;
}

export interface GQLLogInPayload {
  clientMutationId?: string;
  
  /**
   * This is the existing user that was logged in and returned as a viewer.
   */
  viewer: GQLViewer;
}

export interface GQLLogInWithPayload {
  clientMutationId?: string;
  
  /**
   * This is the new user that was created, signed up and returned as a viewer.
   */
  viewer: GQLViewer;
}

export interface GQLLogOutPayload {
  clientMutationId?: string;
  
  /**
   * It's always true.
   */
  ok: boolean;
}

export interface GQLManagerDashboardPayload {
  averageTransactionRating?: number;
  coffeeTransactions?: number;
  completedInvitations?: number;
  countAmenityBooked?: number;
  countAmenityViews?: number;
  countEventAttended?: number;
  countEventViews?: number;
  countInternalMessages?: number;
  countListingValue?: number;
  countListings?: number;
  countLoopPostComments?: number;
  countLoopPostLikes?: number;
  countLoopPosts?: number;
  countMembers?: number;
  countProfileViews?: number;
  countReports?: number;
  countTransactionValue?: number;
  countTransactions?: number;
  fee?: GQLFeeObject;
  freeTransactions?: number;
  incomeGenerated?: number;
  rentalTransactions?: number;
  saleTransactions?: number;
  serviceTransactions?: number;
  totalInvitations?: number;
}

/**
 * The Message object type is used in operations that involve outputting objects of Message class.
 */
export interface GQLMessage extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Attachments?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUser;
  
  /**
   * This is the object Chat.
   */
  Chat?: GQLChat;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrder;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Seen?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  ShowTo?: Array<GQLArrayResult | null>;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object localRef.
   */
  localRef?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object supportMsgStatus.
   */
  supportMsgStatus?: string;
  
  /**
   * This is the object text.
   */
  text?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLMessageConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLMessageEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLMessageEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLMessage;
}

/**
 * Mutation is the top level type for mutations.
 */
export interface GQLMutation {
  accountTransfer: GQLAccountTransferPayload;
  adminCreate?: GQLAdminCreatePayload;
  adminCreateUser?: GQLCreateUserPayload;
  adminDashboard?: GQLAdminDashboardPayload;
  adminDashboardChart?: GQLDashboardChartPayload;
  adminDeleteUser?: GQLDeleteUserPayload;
  adminEdit?: boolean;
  adminLogin?: GQLLogInPayload;
  adminRemove?: boolean;
  adminUpdateUser?: GQLUpdateUserPayload;
  amenityManageButtons: boolean;
  archiveNotifications: boolean;
  badgeClear?: boolean;
  bookAmenity: GQLBookAmenityPayload;
  bookEvent: GQLBookEventPayload;
  calcOrderData?: GQLCalcOrderDataPayload;
  
  /**
   * The callCloudCode mutation can be used to invoke a cloud code function.
   */
  callCloudCode?: GQLCallCloudCodePayload;
  changePassword?: GQLChangePasswordPayload;
  changeSubscriptionPlan: boolean;
  checkCommExternalPayments: boolean;
  communityAdminCreate: GQLCommunityAdminPayload;
  communityAdminEdit?: boolean;
  communityAdminRemove?: boolean;
  companyManageButtons: boolean;
  confirmUserRemoval?: boolean;
  connectStripeAccount: GQLConnectStripeAccPayload;
  countTotalClicks: boolean;
  
  /**
   * The createAdmin mutation can be used to create a new object of the Admin class.
   */
  createAdmin?: GQLCreateAdminPayload;
  
  /**
   * The createAmenity mutation can be used to create a new object of the Amenity class.
   */
  createAmenity?: GQLCreateAmenityPayload;
  
  /**
   * The createAppFile mutation can be used to create a new object of the AppFile class.
   */
  createAppFile?: GQLCreateAppFilePayload;
  
  /**
   * The createCategory mutation can be used to create a new object of the Category class.
   */
  createCategory?: GQLCreateCategoryPayload;
  
  /**
   * The createChat mutation can be used to create a new object of the Chat class.
   */
  createChat?: GQLCreateChatPayload;
  
  /**
   * The createClass mutation can be used to create the schema for a new object class.
   */
  createClass?: GQLCreateClassPayload;
  
  /**
   * The createCommunity mutation can be used to create a new object of the Community class.
   */
  createCommunity?: GQLCreateCommunityPayload;
  
  /**
   * The createCommunityAdmin mutation can be used to create a new object of the CommunityAdmin class.
   */
  createCommunityAdmin?: GQLCreateCommunityAdminPayload;
  createCommunityForNewUser: GQLCommunityForNewUserPayload;
  
  /**
   * The createCompany mutation can be used to create a new object of the Company class.
   */
  createCompany?: GQLCreateCompanyPayload;
  createCompanyReport: boolean;
  
  /**
   * The createCurrency mutation can be used to create a new object of the Currency class.
   */
  createCurrency?: GQLCreateCurrencyPayload;
  
  /**
   * The createDocument mutation can be used to create a new object of the Document class.
   */
  createDocument?: GQLCreateDocumentPayload;
  
  /**
   * The createEvent mutation can be used to create a new object of the Event class.
   */
  createEvent?: GQLCreateEventPayload;
  
  /**
   * The createFile mutation can be used to create and upload a new file.
   */
  createFile?: GQLCreateFilePayload;
  
  /**
   * The createGroup mutation can be used to create a new object of the Group class.
   */
  createGroup?: GQLCreateGroupPayload;
  
  /**
   * The createHelpDesk mutation can be used to create a new object of the HelpDesk class.
   */
  createHelpDesk?: GQLCreateHelpDeskPayload;
  
  /**
   * The createInstallation mutation can be used to create a new object of the Installation class.
   */
  createInstallation?: GQLCreateInstallationPayload;
  
  /**
   * The createInvitation mutation can be used to create a new object of the Invitation class.
   */
  createInvitation?: GQLCreateInvitationPayload;
  
  /**
   * The createItem mutation can be used to create a new object of the Item class.
   */
  createItem?: GQLCreateItemPayload;
  
  /**
   * The createItemBooking mutation can be used to create a new object of the ItemBooking class.
   */
  createItemBooking?: GQLCreateItemBookingPayload;
  
  /**
   * The createJoinRequest mutation can be used to create a new object of the JoinRequest class.
   */
  createJoinRequest?: GQLCreateJoinRequestPayload;
  
  /**
   * The createLanguage mutation can be used to create a new object of the Language class.
   */
  createLanguage?: GQLCreateLanguagePayload;
  
  /**
   * The createLocation mutation can be used to create a new object of the Location class.
   */
  createLocation?: GQLCreateLocationPayload;
  
  /**
   * The createMessage mutation can be used to create a new object of the Message class.
   */
  createMessage?: GQLCreateMessagePayload;
  createMultiplyItems: GQLCreateMultiplyItemsPayload;
  
  /**
   * The createMyClass mutation can be used to create a new object of the MyClass class.
   */
  createMyClass?: GQLCreateMyClassPayload;
  
  /**
   * The createNotifSending mutation can be used to create a new object of the NotifSending class.
   */
  createNotifSending?: GQLCreateNotifSendingPayload;
  
  /**
   * The createNotification mutation can be used to create a new object of the Notification class.
   */
  createNotification?: GQLCreateNotificationPayload;
  
  /**
   * The createOrder mutation can be used to create a new object of the Order class.
   */
  createOrder?: GQLCreateOrderPayload;
  
  /**
   * The createPaymentPlan mutation can be used to create a new object of the PaymentPlan class.
   */
  createPaymentPlan?: GQLCreatePaymentPlanPayload;
  
  /**
   * The createPhoneVerification mutation can be used to create a new object of the PhoneVerification class.
   */
  createPhoneVerification?: GQLCreatePhoneVerificationPayload;
  
  /**
   * The createPollOption mutation can be used to create a new object of the PollOption class.
   */
  createPollOption?: GQLCreatePollOptionPayload;
  
  /**
   * The createPost mutation can be used to create a new object of the Post class.
   */
  createPost?: GQLCreatePostPayload;
  
  /**
   * The createPostTranslate mutation can be used to create a new object of the PostTranslate class.
   */
  createPostTranslate?: GQLCreatePostTranslatePayload;
  
  /**
   * The createPromo mutation can be used to create a new object of the Promo class.
   */
  createPromo?: GQLCreatePromoPayload;
  
  /**
   * The createPushNotificationLog mutation can be used to create a new object of the PushNotificationLog class.
   */
  createPushNotificationLog?: GQLCreatePushNotificationLogPayload;
  
  /**
   * The createReferral mutation can be used to create a new object of the Referral class.
   */
  createReferral?: GQLCreateReferralPayload;
  
  /**
   * The createReport mutation can be used to create a new object of the Report class.
   */
  createReport?: GQLCreateReportPayload;
  
  /**
   * The createReview mutation can be used to create a new object of the Review class.
   */
  createReview?: GQLCreateReviewPayload;
  
  /**
   * The createRole mutation can be used to create a new object of the Role class.
   */
  createRole?: GQLCreateRolePayload;
  
  /**
   * The createSession mutation can be used to create a new object of the Session class.
   */
  createSession?: GQLCreateSessionPayload;
  
  /**
   * The createSubscr mutation can be used to create a new object of the Subscr class.
   */
  createSubscr?: GQLCreateSubscrPayload;
  
  /**
   * The createSubscrPayment mutation can be used to create a new object of the SubscrPayment class.
   */
  createSubscrPayment?: GQLCreateSubscrPaymentPayload;
  
  /**
   * The createTask mutation can be used to create a new object of the Task class.
   */
  createTask?: GQLCreateTaskPayload;
  
  /**
   * The createTransaction mutation can be used to create a new object of the Transaction class.
   */
  createTransaction?: GQLCreateTransactionPayload;
  
  /**
   * The createUser mutation can be used to create a new object of the User class.
   */
  createUser?: GQLCreateUserPayload;
  createUserReferral: boolean;
  deactivateUser?: boolean;
  
  /**
   * The deleteAdmin mutation can be used to delete an object of the Admin class.
   */
  deleteAdmin?: GQLDeleteAdminPayload;
  
  /**
   * The deleteAmenity mutation can be used to delete an object of the Amenity class.
   */
  deleteAmenity?: GQLDeleteAmenityPayload;
  
  /**
   * The deleteAppFile mutation can be used to delete an object of the AppFile class.
   */
  deleteAppFile?: GQLDeleteAppFilePayload;
  
  /**
   * The deleteCategory mutation can be used to delete an object of the Category class.
   */
  deleteCategory?: GQLDeleteCategoryPayload;
  
  /**
   * The deleteChat mutation can be used to delete an object of the Chat class.
   */
  deleteChat?: GQLDeleteChatPayload;
  
  /**
   * The deleteClass mutation can be used to delete an existing object class.
   */
  deleteClass?: GQLDeleteClassPayload;
  
  /**
   * The deleteCommunity mutation can be used to delete an object of the Community class.
   */
  deleteCommunity?: GQLDeleteCommunityPayload;
  
  /**
   * The deleteCommunityAdmin mutation can be used to delete an object of the CommunityAdmin class.
   */
  deleteCommunityAdmin?: GQLDeleteCommunityAdminPayload;
  
  /**
   * The deleteCompany mutation can be used to delete an object of the Company class.
   */
  deleteCompany?: GQLDeleteCompanyPayload;
  
  /**
   * The deleteCurrency mutation can be used to delete an object of the Currency class.
   */
  deleteCurrency?: GQLDeleteCurrencyPayload;
  
  /**
   * The deleteDocument mutation can be used to delete an object of the Document class.
   */
  deleteDocument?: GQLDeleteDocumentPayload;
  
  /**
   * The deleteEvent mutation can be used to delete an object of the Event class.
   */
  deleteEvent?: GQLDeleteEventPayload;
  
  /**
   * The deleteGroup mutation can be used to delete an object of the Group class.
   */
  deleteGroup?: GQLDeleteGroupPayload;
  
  /**
   * The deleteHelpDesk mutation can be used to delete an object of the HelpDesk class.
   */
  deleteHelpDesk?: GQLDeleteHelpDeskPayload;
  
  /**
   * The deleteInstallation mutation can be used to delete an object of the Installation class.
   */
  deleteInstallation?: GQLDeleteInstallationPayload;
  
  /**
   * The deleteInvitation mutation can be used to delete an object of the Invitation class.
   */
  deleteInvitation?: GQLDeleteInvitationPayload;
  
  /**
   * The deleteItem mutation can be used to delete an object of the Item class.
   */
  deleteItem?: GQLDeleteItemPayload;
  
  /**
   * The deleteItemBooking mutation can be used to delete an object of the ItemBooking class.
   */
  deleteItemBooking?: GQLDeleteItemBookingPayload;
  
  /**
   * The deleteJoinRequest mutation can be used to delete an object of the JoinRequest class.
   */
  deleteJoinRequest?: GQLDeleteJoinRequestPayload;
  
  /**
   * The deleteLanguage mutation can be used to delete an object of the Language class.
   */
  deleteLanguage?: GQLDeleteLanguagePayload;
  
  /**
   * The deleteLocation mutation can be used to delete an object of the Location class.
   */
  deleteLocation?: GQLDeleteLocationPayload;
  
  /**
   * The deleteMessage mutation can be used to delete an object of the Message class.
   */
  deleteMessage?: GQLDeleteMessagePayload;
  
  /**
   * The deleteMyClass mutation can be used to delete an object of the MyClass class.
   */
  deleteMyClass?: GQLDeleteMyClassPayload;
  
  /**
   * The deleteNotifSending mutation can be used to delete an object of the NotifSending class.
   */
  deleteNotifSending?: GQLDeleteNotifSendingPayload;
  
  /**
   * The deleteNotification mutation can be used to delete an object of the Notification class.
   */
  deleteNotification?: GQLDeleteNotificationPayload;
  
  /**
   * The deleteOrder mutation can be used to delete an object of the Order class.
   */
  deleteOrder?: GQLDeleteOrderPayload;
  
  /**
   * The deletePaymentPlan mutation can be used to delete an object of the PaymentPlan class.
   */
  deletePaymentPlan?: GQLDeletePaymentPlanPayload;
  
  /**
   * The deletePhoneVerification mutation can be used to delete an object of the PhoneVerification class.
   */
  deletePhoneVerification?: GQLDeletePhoneVerificationPayload;
  
  /**
   * The deletePollOption mutation can be used to delete an object of the PollOption class.
   */
  deletePollOption?: GQLDeletePollOptionPayload;
  
  /**
   * The deletePost mutation can be used to delete an object of the Post class.
   */
  deletePost?: GQLDeletePostPayload;
  
  /**
   * The deletePostTranslate mutation can be used to delete an object of the PostTranslate class.
   */
  deletePostTranslate?: GQLDeletePostTranslatePayload;
  
  /**
   * The deletePromo mutation can be used to delete an object of the Promo class.
   */
  deletePromo?: GQLDeletePromoPayload;
  
  /**
   * The deletePushNotificationLog mutation can be used to delete an object of the PushNotificationLog class.
   */
  deletePushNotificationLog?: GQLDeletePushNotificationLogPayload;
  
  /**
   * The deleteReferral mutation can be used to delete an object of the Referral class.
   */
  deleteReferral?: GQLDeleteReferralPayload;
  
  /**
   * The deleteReport mutation can be used to delete an object of the Report class.
   */
  deleteReport?: GQLDeleteReportPayload;
  
  /**
   * The deleteReview mutation can be used to delete an object of the Review class.
   */
  deleteReview?: GQLDeleteReviewPayload;
  
  /**
   * The deleteRole mutation can be used to delete an object of the Role class.
   */
  deleteRole?: GQLDeleteRolePayload;
  
  /**
   * The deleteSession mutation can be used to delete an object of the Session class.
   */
  deleteSession?: GQLDeleteSessionPayload;
  
  /**
   * The deleteSubscr mutation can be used to delete an object of the Subscr class.
   */
  deleteSubscr?: GQLDeleteSubscrPayload;
  
  /**
   * The deleteSubscrPayment mutation can be used to delete an object of the SubscrPayment class.
   */
  deleteSubscrPayment?: GQLDeleteSubscrPaymentPayload;
  
  /**
   * The deleteTask mutation can be used to delete an object of the Task class.
   */
  deleteTask?: GQLDeleteTaskPayload;
  
  /**
   * The deleteTransaction mutation can be used to delete an object of the Transaction class.
   */
  deleteTransaction?: GQLDeleteTransactionPayload;
  
  /**
   * The deleteUser mutation can be used to delete an object of the User class.
   */
  deleteUser?: GQLDeleteUserPayload;
  directAddMember: GQLDirectAddMemberPayload;
  eventManageButtons: boolean;
  generateAiOpenApiText: GQLGenerateAiOpenApiTextPayload;
  generateUsername: GQLGenerateUsernamePayload;
  getAccountBalance: GQLGetAccBalancePayload;
  getEventItem?: GQLgetEventPayload;
  getItemArrays: GQLGetItemArraysPayload;
  getManagersList: Array<GQLGetManagersListPayload | null>;
  getNewPassword?: boolean;
  getPaymentPlatformDashboardLink: GQLPaymentPlatformDashLinkPayload;
  getResidentsAvatar: GQLGetResidentsAvatarPayload;
  getSeoOrderItemData?: GQLgetSeoOrderItemDataPayload;
  getUserByReferral: GQLGetUserByReferralPayload;
  getUserInsightsData: GQLSupportInsightPayload;
  getUserPermissionsList: GQLPermissionsListPayload;
  groupManageButtons: boolean;
  helpDeskListOrder: boolean;
  hidePost: GQLHidePostPayload;
  itemManagerButtons: boolean;
  itemResidentButtons: boolean;
  joinGroup: GQLGroupPayload;
  leaveCommunity?: boolean;
  leaveGroup: GQLGroupPayload;
  likeHandler?: GQLLikePostPayload;
  likeHandlerEvent?: GQLLikeEventPayload;
  likeHandlerListing?: GQLLikeListingPayload;
  linkWithSocial: boolean;
  
  /**
   * The logIn mutation can be used to log in an existing user.
   */
  logIn?: GQLLogInPayload;
  
  /**
   * The logInWith mutation can be used to signup, login user with 3rd party authentication system. This mutation create a user if the authData do not correspond to an existing one.
   */
  logInWith?: GQLLogInWithPayload;
  
  /**
   * The logOut mutation can be used to log out an existing user.
   */
  logOut?: GQLLogOutPayload;
  makeOrder?: GQLOrderPayload;
  manageOrder?: GQLOrderPayload;
  managerDashboard?: GQLManagerDashboardPayload;
  managerDashboardChart?: GQLDashboardChartPayload;
  managerRemoveResident: boolean;
  messageSetSeen: boolean;
  newViewer?: GQLViewObjectPayload;
  notifyManager?: GQLNotifyManagerPayload;
  paySubscription: GQLPaySubscrPayload;
  paymentAddCard: boolean;
  paymentCalculateItemOrder: GQLInvoiceItemOrderPayload;
  paymentDeleteCard: boolean;
  paymentGetUserCards: GQLGetUserCardsPayload;
  paymentItemOrder: boolean;
  paymentSetDefaultCard: boolean;
  pinUnpinPost: boolean;
  preOrderCalcData: GQLPreOrderCalcDataPayLoad;
  reactionHandler?: GQLReactionHandlerPayload;
  registerPushNotification: boolean;
  removeUser?: boolean;
  removeVoteInPoll: boolean;
  
  /**
   * The resetPassword mutation can be used to reset the password of an existing user.
   */
  resetPassword?: GQLResetPasswordPayload;
  residentDashboard?: GQLResidentDashboardPayload;
  rmUserPushNotification: boolean;
  sendResidentInvitations: boolean;
  
  /**
   * The sendVerificationEmail mutation can be used to send the verification email again.
   */
  sendVerificationEmail?: GQLSendVerificationEmailPayload;
  setDevicePush: boolean;
  setDocumentStatus: boolean;
  setOffline: boolean;
  setOnline: boolean;
  
  /**
   * The signUp mutation can be used to create and sign up a new user.
   */
  signUp?: GQLSignUpPayload;
  unlinkWithSocial: boolean;
  
  /**
   * The updateAdmin mutation can be used to update an object of the Admin class.
   */
  updateAdmin?: GQLUpdateAdminPayload;
  
  /**
   * The updateAmenity mutation can be used to update an object of the Amenity class.
   */
  updateAmenity?: GQLUpdateAmenityPayload;
  
  /**
   * The updateAppFile mutation can be used to update an object of the AppFile class.
   */
  updateAppFile?: GQLUpdateAppFilePayload;
  
  /**
   * The updateCategory mutation can be used to update an object of the Category class.
   */
  updateCategory?: GQLUpdateCategoryPayload;
  
  /**
   * The updateChat mutation can be used to update an object of the Chat class.
   */
  updateChat?: GQLUpdateChatPayload;
  
  /**
   * The updateClass mutation can be used to update the schema for an existing object class.
   */
  updateClass?: GQLUpdateClassPayload;
  
  /**
   * The updateCommunity mutation can be used to update an object of the Community class.
   */
  updateCommunity?: GQLUpdateCommunityPayload;
  
  /**
   * The updateCommunityAdmin mutation can be used to update an object of the CommunityAdmin class.
   */
  updateCommunityAdmin?: GQLUpdateCommunityAdminPayload;
  
  /**
   * The updateCompany mutation can be used to update an object of the Company class.
   */
  updateCompany?: GQLUpdateCompanyPayload;
  
  /**
   * The updateCurrency mutation can be used to update an object of the Currency class.
   */
  updateCurrency?: GQLUpdateCurrencyPayload;
  
  /**
   * The updateDocument mutation can be used to update an object of the Document class.
   */
  updateDocument?: GQLUpdateDocumentPayload;
  
  /**
   * The updateEvent mutation can be used to update an object of the Event class.
   */
  updateEvent?: GQLUpdateEventPayload;
  
  /**
   * The updateGroup mutation can be used to update an object of the Group class.
   */
  updateGroup?: GQLUpdateGroupPayload;
  
  /**
   * The updateHelpDesk mutation can be used to update an object of the HelpDesk class.
   */
  updateHelpDesk?: GQLUpdateHelpDeskPayload;
  
  /**
   * The updateInstallation mutation can be used to update an object of the Installation class.
   */
  updateInstallation?: GQLUpdateInstallationPayload;
  
  /**
   * The updateInvitation mutation can be used to update an object of the Invitation class.
   */
  updateInvitation?: GQLUpdateInvitationPayload;
  
  /**
   * The updateItem mutation can be used to update an object of the Item class.
   */
  updateItem?: GQLUpdateItemPayload;
  
  /**
   * The updateItemBooking mutation can be used to update an object of the ItemBooking class.
   */
  updateItemBooking?: GQLUpdateItemBookingPayload;
  
  /**
   * The updateJoinRequest mutation can be used to update an object of the JoinRequest class.
   */
  updateJoinRequest?: GQLUpdateJoinRequestPayload;
  
  /**
   * The updateLanguage mutation can be used to update an object of the Language class.
   */
  updateLanguage?: GQLUpdateLanguagePayload;
  
  /**
   * The updateLocation mutation can be used to update an object of the Location class.
   */
  updateLocation?: GQLUpdateLocationPayload;
  
  /**
   * The updateMessage mutation can be used to update an object of the Message class.
   */
  updateMessage?: GQLUpdateMessagePayload;
  
  /**
   * The updateMyClass mutation can be used to update an object of the MyClass class.
   */
  updateMyClass?: GQLUpdateMyClassPayload;
  
  /**
   * The updateNotifSending mutation can be used to update an object of the NotifSending class.
   */
  updateNotifSending?: GQLUpdateNotifSendingPayload;
  
  /**
   * The updateNotification mutation can be used to update an object of the Notification class.
   */
  updateNotification?: GQLUpdateNotificationPayload;
  
  /**
   * The updateOrder mutation can be used to update an object of the Order class.
   */
  updateOrder?: GQLUpdateOrderPayload;
  
  /**
   * The updatePaymentPlan mutation can be used to update an object of the PaymentPlan class.
   */
  updatePaymentPlan?: GQLUpdatePaymentPlanPayload;
  
  /**
   * The updatePhoneVerification mutation can be used to update an object of the PhoneVerification class.
   */
  updatePhoneVerification?: GQLUpdatePhoneVerificationPayload;
  
  /**
   * The updatePollOption mutation can be used to update an object of the PollOption class.
   */
  updatePollOption?: GQLUpdatePollOptionPayload;
  
  /**
   * The updatePost mutation can be used to update an object of the Post class.
   */
  updatePost?: GQLUpdatePostPayload;
  
  /**
   * The updatePostTranslate mutation can be used to update an object of the PostTranslate class.
   */
  updatePostTranslate?: GQLUpdatePostTranslatePayload;
  
  /**
   * The updatePromo mutation can be used to update an object of the Promo class.
   */
  updatePromo?: GQLUpdatePromoPayload;
  updatePushNotification: boolean;
  
  /**
   * The updatePushNotificationLog mutation can be used to update an object of the PushNotificationLog class.
   */
  updatePushNotificationLog?: GQLUpdatePushNotificationLogPayload;
  
  /**
   * The updateReferral mutation can be used to update an object of the Referral class.
   */
  updateReferral?: GQLUpdateReferralPayload;
  
  /**
   * The updateReport mutation can be used to update an object of the Report class.
   */
  updateReport?: GQLUpdateReportPayload;
  
  /**
   * The updateReview mutation can be used to update an object of the Review class.
   */
  updateReview?: GQLUpdateReviewPayload;
  
  /**
   * The updateRole mutation can be used to update an object of the Role class.
   */
  updateRole?: GQLUpdateRolePayload;
  
  /**
   * The updateSession mutation can be used to update an object of the Session class.
   */
  updateSession?: GQLUpdateSessionPayload;
  
  /**
   * The updateSubscr mutation can be used to update an object of the Subscr class.
   */
  updateSubscr?: GQLUpdateSubscrPayload;
  
  /**
   * The updateSubscrPayment mutation can be used to update an object of the SubscrPayment class.
   */
  updateSubscrPayment?: GQLUpdateSubscrPaymentPayload;
  
  /**
   * The updateTask mutation can be used to update an object of the Task class.
   */
  updateTask?: GQLUpdateTaskPayload;
  
  /**
   * The updateTransaction mutation can be used to update an object of the Transaction class.
   */
  updateTransaction?: GQLUpdateTransactionPayload;
  
  /**
   * The updateUser mutation can be used to update an object of the User class.
   */
  updateUser?: GQLUpdateUserPayload;
  verifyCode?: GQLVerifyCodePayload;
  verifyEmail?: GQLVerifyEmailPayload;
  verifyPhone?: GQLVerifyPhonePayload;
  voteInPoll: boolean;
  waveHandlerUser?: GQLWaveUserPayload;
}

/**
 * The MyClass object type is used in operations that involve outputting objects of MyClass class.
 */
export interface GQLMyClass extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object myField.
   */
  myField?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLMyClassConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLMyClassEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLMyClassEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLMyClass;
}

/**
 * The NotifSending object type is used in operations that involve outputting objects of NotifSending class.
 */
export interface GQLNotifSending extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object amenityAutoBookedEmailSent.
   */
  amenityAutoBookedEmailSent?: GQLDate;
  
  /**
   * This is the object amenityAutoBookedSmsSent.
   */
  amenityAutoBookedSmsSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledListerEmailSent.
   */
  amenityCanceledListerEmailSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledListerSmsSent.
   */
  amenityCanceledListerSmsSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledRequesterEmailSent.
   */
  amenityCanceledRequesterEmailSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledRequesterSmsSent.
   */
  amenityCanceledRequesterSmsSent?: GQLDate;
  
  /**
   * This is the object amenityConfirmationEmailSent.
   */
  amenityConfirmationEmailSent?: GQLDate;
  
  /**
   * This is the object amenityConfirmationSmsSent.
   */
  amenityConfirmationSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderBookedEmailSent.
   */
  amenityOrderBookedEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderBookedSmsSent.
   */
  amenityOrderBookedSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderCanceledEmailSent.
   */
  amenityOrderCanceledEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderCanceledSmsSent.
   */
  amenityOrderCanceledSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderPendingEmailSent.
   */
  amenityOrderPendingEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderPendingSmsSent.
   */
  amenityOrderPendingSmsSent?: GQLDate;
  
  /**
   * This is the object amenityReminderEmailSent.
   */
  amenityReminderEmailSent?: GQLDate;
  
  /**
   * This is the object amenityReminderPushSent.
   */
  amenityReminderPushSent?: GQLDate;
  
  /**
   * This is the object amenityReminderSmsSent.
   */
  amenityReminderSmsSent?: GQLDate;
  
  /**
   * This is the object amenityRequestEmailSent.
   */
  amenityRequestEmailSent?: GQLDate;
  
  /**
   * This is the object amenityRequestSmsSent.
   */
  amenityRequestSmsSent?: GQLDate;
  
  /**
   * This is the object blockUserEmailSent.
   */
  blockUserEmailSent?: GQLDate;
  
  /**
   * This is the object blockUserSmsSent.
   */
  blockUserSmsSent?: GQLDate;
  
  /**
   * This is the object companyReportedEmailSent.
   */
  companyReportedEmailSent?: GQLDate;
  
  /**
   * This is the object companyReportedSmsSent.
   */
  companyReportedSmsSent?: GQLDate;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object eventAttendeesEmailSent.
   */
  eventAttendeesEmailSent?: GQLDate;
  
  /**
   * This is the object eventAttendeesPushSent.
   */
  eventAttendeesPushSent?: GQLDate;
  
  /**
   * This is the object eventAttendeesSmsSent.
   */
  eventAttendeesSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderAttendingEmailSent.
   */
  eventOrderAttendingEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderAttendingSmsSent.
   */
  eventOrderAttendingSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderCanceledEmailSent.
   */
  eventOrderCanceledEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderCanceledSmsSent.
   */
  eventOrderCanceledSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderPendingEmailSent.
   */
  eventOrderPendingEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderPendingSmsSent.
   */
  eventOrderPendingSmsSent?: GQLDate;
  
  /**
   * This is the object eventReminderEmailSent.
   */
  eventReminderEmailSent?: GQLDate;
  
  /**
   * This is the object eventReminderPushSent.
   */
  eventReminderPushSent?: GQLDate;
  
  /**
   * This is the object eventReminderSmsSent.
   */
  eventReminderSmsSent?: GQLDate;
  
  /**
   * This is the object eventReportedEmailSent.
   */
  eventReportedEmailSent?: GQLDate;
  
  /**
   * This is the object eventReportedSmsSent.
   */
  eventReportedSmsSent?: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object itemReviewEmailSent.
   */
  itemReviewEmailSent?: GQLDate;
  
  /**
   * This is the object itemReviewSmsSent.
   */
  itemReviewSmsSent?: GQLDate;
  
  /**
   * This is the object itemViewEmailSent.
   */
  itemViewEmailSent?: GQLDate;
  
  /**
   * This is the object itemViewPushSent.
   */
  itemViewPushSent?: GQLDate;
  
  /**
   * This is the object itemViewSmsSent.
   */
  itemViewSmsSent?: GQLDate;
  
  /**
   * This is the object joinCommunitySmsSent.
   */
  joinCommunitySmsSent?: GQLDate;
  
  /**
   * This is the object joinRequestEmailSent.
   */
  joinRequestEmailSent?: GQLDate;
  
  /**
   * This is the object listingApprovedEmailSent.
   */
  listingApprovedEmailSent?: GQLDate;
  
  /**
   * This is the object listingApprovedSmsSent.
   */
  listingApprovedSmsSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestEmailSent.
   */
  listingPublishRequestEmailSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestPushSent.
   */
  listingPublishRequestPushSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestSmsSent.
   */
  listingPublishRequestSmsSent?: GQLDate;
  
  /**
   * This is the object listingRemovedEmailSent.
   */
  listingRemovedEmailSent?: GQLDate;
  
  /**
   * This is the object listingRemovedSmsSent.
   */
  listingRemovedSmsSent?: GQLDate;
  
  /**
   * This is the object listingRemovedSmsSmsSent.
   */
  listingRemovedSmsSmsSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesEmailSent.
   */
  managedAmenitiesEmailSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesPushSent.
   */
  managedAmenitiesPushSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesSmsSent.
   */
  managedAmenitiesSmsSent?: GQLDate;
  
  /**
   * This is the object newCommentEmailSent.
   */
  newCommentEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentInGroupEmailSent.
   */
  newCommentInGroupEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentPollEmailSent.
   */
  newCommentPollEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentPushSent.
   */
  newCommentPushSent?: GQLDate;
  
  /**
   * This is the object newCommentSmsSent.
   */
  newCommentSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinLikeEmailSent.
   */
  newJoinLikeEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinLikePushSent.
   */
  newJoinLikePushSent?: GQLDate;
  
  /**
   * This is the object newJoinLikeSmsSent.
   */
  newJoinLikeSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinSmileEmailSent.
   */
  newJoinSmileEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinSmilePushSent.
   */
  newJoinSmilePushSent?: GQLDate;
  
  /**
   * This is the object newJoinSmileSmsSent.
   */
  newJoinSmileSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinWaveEmailSent.
   */
  newJoinWaveEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinWavePushSent.
   */
  newJoinWavePushSent?: GQLDate;
  
  /**
   * This is the object newJoinWaveSmsSent.
   */
  newJoinWaveSmsSent?: GQLDate;
  
  /**
   * This is the object newLikeEmailSent.
   */
  newLikeEmailSent?: GQLDate;
  
  /**
   * This is the object newLikePollEmailSent.
   */
  newLikePollEmailSent?: GQLDate;
  
  /**
   * This is the object newLikePushSent.
   */
  newLikePushSent?: GQLDate;
  
  /**
   * This is the object newLikeSmsSent.
   */
  newLikeSmsSent?: GQLDate;
  
  /**
   * This is the object newListingEmailSent.
   */
  newListingEmailSent?: GQLDate;
  
  /**
   * This is the object newListingPushSent.
   */
  newListingPushSent?: GQLDate;
  
  /**
   * This is the object newListingSmsSent.
   */
  newListingSmsSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostEmailSent.
   */
  newManagerAdminPostEmailSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostPushSent.
   */
  newManagerAdminPostPushSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostSmsSent.
   */
  newManagerAdminPostSmsSent?: GQLDate;
  
  /**
   * This is the object newMessageEmailSent.
   */
  newMessageEmailSent?: GQLDate;
  
  /**
   * This is the object newMessagePushSent.
   */
  newMessagePushSent?: GQLDate;
  
  /**
   * This is the object newMessageSmsSent.
   */
  newMessageSmsSent?: GQLDate;
  
  /**
   * This is the object newNoticeEmailSent.
   */
  newNoticeEmailSent?: GQLDate;
  
  /**
   * This is the object newNoticeSmsSent.
   */
  newNoticeSmsSent?: GQLDate;
  
  /**
   * This is the object newPostEmailSent.
   */
  newPostEmailSent?: GQLDate;
  
  /**
   * This is the object newPostPushSent.
   */
  newPostPushSent?: GQLDate;
  
  /**
   * This is the object newPostSmsSent.
   */
  newPostSmsSent?: GQLDate;
  
  /**
   * This is the object newResidentEmailSent.
   */
  newResidentEmailSent?: GQLDate;
  
  /**
   * This is the object newResidentPushSent.
   */
  newResidentPushSent?: GQLDate;
  
  /**
   * This is the object newResidentSmsSent.
   */
  newResidentSmsSent?: GQLDate;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object orderBuyAcceptedEmailSent.
   */
  orderBuyAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderBuyAcceptedSmsSent.
   */
  orderBuyAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderBuyRejectedEmailSent.
   */
  orderBuyRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderBuyRejectedSmsSent.
   */
  orderBuyRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRentAcceptedEmailSent.
   */
  orderRentAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderRentAcceptedSmsSent.
   */
  orderRentAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRentRejectedEmailSent.
   */
  orderRentRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderRentRejectedSmsSent.
   */
  orderRentRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRequestEmailSent.
   */
  orderRequestEmailSent?: GQLDate;
  
  /**
   * This is the object orderRequestSmsSent.
   */
  orderRequestSmsSent?: GQLDate;
  
  /**
   * This is the object orderServiceAcceptedEmailSent.
   */
  orderServiceAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderServiceAcceptedSmsSent.
   */
  orderServiceAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderServiceRejectedEmailSent.
   */
  orderServiceRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderServiceRejectedSmsSent.
   */
  orderServiceRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object rejectedRequestEmailSent.
   */
  rejectedRequestEmailSent?: GQLDate;
  
  /**
   * This is the object reportListingEmailSent.
   */
  reportListingEmailSent?: GQLDate;
  
  /**
   * This is the object reportListingSmsSent.
   */
  reportListingSmsSent?: GQLDate;
  
  /**
   * This is the object reportPostEmailSent.
   */
  reportPostEmailSent?: GQLDate;
  
  /**
   * This is the object reportPostSmsSent.
   */
  reportPostSmsSent?: GQLDate;
  
  /**
   * This is the object reportUserEmailSent.
   */
  reportUserEmailSent?: GQLDate;
  
  /**
   * This is the object reportUserSmsSent.
   */
  reportUserSmsSent?: GQLDate;
  
  /**
   * This is the object residentRemovedEmailSent.
   */
  residentRemovedEmailSent?: GQLDate;
  
  /**
   * This is the object residentRemovedSmsSent.
   */
  residentRemovedSmsSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesEmailSent.
   */
  unmanagedAmenitiesEmailSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesPushSent.
   */
  unmanagedAmenitiesPushSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesSmsSent.
   */
  unmanagedAmenitiesSmsSent?: GQLDate;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object userViewEmailSent.
   */
  userViewEmailSent?: GQLDate;
  
  /**
   * This is the object userViewPushSent.
   */
  userViewPushSent?: GQLDate;
  
  /**
   * This is the object userViewSmsSent.
   */
  userViewSmsSent?: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLNotifSendingConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLNotifSendingEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLNotifSendingEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLNotifSending;
}

/**
 * The Notification object type is used in operations that involve outputting objects of Notification class.
 */
export interface GQLNotification extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object event.
   */
  event?: string;
  
  /**
   * This is the object from.
   */
  from?: GQLUser;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifTypes?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object seenDate.
   */
  seenDate?: GQLDate;
  
  /**
   * This is the object sendAt.
   */
  sendAt?: GQLDate;
  
  /**
   * This is the object sentIn.
   */
  sentIn?: GQLObject;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object to.
   */
  to?: GQLUser;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLNotificationConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLNotificationEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLNotificationEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLNotification;
}

export interface GQLNotifyManagerPayload {
  ok?: boolean;
}

/**
 * The Order object type is used in operations that involve outputting objects of Order class.
 */
export interface GQLOrder extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Amenity.
   */
  Amenity?: GQLAmenity;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrency;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEvent;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItem;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUser;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocation;
  
  /**
   * This is the object Requester.
   */
  Requester?: GQLUser;
  
  /**
   * This is the object acceptedByLister.
   */
  acceptedByLister?: GQLDate;
  
  /**
   * This is the object acceptedByRequester.
   */
  acceptedByRequester?: GQLDate;
  
  /**
   * This is the object attendeeGuests.
   */
  attendeeGuests?: number;
  
  /**
   * This is the object cfListerAbs.
   */
  cfListerAbs?: number;
  
  /**
   * This is the object cfListerAmt.
   */
  cfListerAmt?: number;
  
  /**
   * This is the object cfListerPrc.
   */
  cfListerPrc?: number;
  
  /**
   * This is the object cfRequesterAbs.
   */
  cfRequesterAbs?: number;
  
  /**
   * This is the object cfRequesterAmt.
   */
  cfRequesterAmt?: number;
  
  /**
   * This is the object cfRequesterPrc.
   */
  cfRequesterPrc?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object discount.
   */
  discount?: number;
  
  /**
   * This is the object discountAmount.
   */
  discountAmount?: number;
  
  /**
   * This is the object discountType.
   */
  discountType?: string;
  
  /**
   * This is the object endTime.
   */
  endTime?: GQLDate;
  
  /**
   * This is the object externalPayments.
   */
  externalPayments?: boolean;
  
  /**
   * This is the object hangehDiscount.
   */
  hangehDiscount?: number;
  
  /**
   * This is the object hfListerAbs.
   */
  hfListerAbs?: number;
  
  /**
   * This is the object hfListerAmt.
   */
  hfListerAmt?: number;
  
  /**
   * This is the object hfListerPrc.
   */
  hfListerPrc?: number;
  
  /**
   * This is the object hfRequesterAbs.
   */
  hfRequesterAbs?: number;
  
  /**
   * This is the object hfRequesterAmt.
   */
  hfRequesterAmt?: number;
  
  /**
   * This is the object hfRequesterPrc.
   */
  hfRequesterPrc?: number;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object itemAmount.
   */
  itemAmount?: number;
  
  /**
   * This is the object listerTotalAmt.
   */
  listerTotalAmt?: number;
  
  /**
   * This is the object listingType.
   */
  listingType?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object oldStatus.
   */
  oldStatus?: string;
  
  /**
   * This is the object orderType.
   */
  orderType?: string;
  
  /**
   * This is the object payMethod.
   */
  payMethod?: string;
  
  /**
   * This is the object period.
   */
  period?: number;
  
  /**
   * This is the object ppListerAbs.
   */
  ppListerAbs?: number;
  
  /**
   * This is the object ppListerAmt.
   */
  ppListerAmt?: number;
  
  /**
   * This is the object ppListerPrc.
   */
  ppListerPrc?: number;
  
  /**
   * This is the object ppRequesterAbs.
   */
  ppRequesterAbs?: number;
  
  /**
   * This is the object ppRequesterAmt.
   */
  ppRequesterAmt?: number;
  
  /**
   * This is the object ppRequesterPrc.
   */
  ppRequesterPrc?: number;
  
  /**
   * This is the object price.
   */
  price?: number;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: string;
  
  /**
   * This is the object recurringEvent.
   */
  recurringEvent?: boolean;
  
  /**
   * This is the object reminder6atMorningSent.
   */
  reminder6atMorningSent?: boolean;
  
  /**
   * This is the object reminderSent.
   */
  reminderSent?: boolean;
  
  /**
   * This is the object requesterTotalAmt.
   */
  requesterTotalAmt?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: string;
  
  /**
   * This is the object sfListerAmt.
   */
  sfListerAmt?: number;
  
  /**
   * This is the object sfRequesterAmt.
   */
  sfRequesterAmt?: number;
  
  /**
   * This is the object startTime.
   */
  startTime?: GQLDate;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLOrderConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLOrderEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLOrderEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLOrder;
}

export interface GQLOrderPayload {
  order: string;
}

/**
 * Information about pagination in a connection.
 */
export interface GQLPageInfo {
  
  /**
   * When paginating forwards, the cursor to continue.
   */
  endCursor?: string;
  
  /**
   * When paginating forwards, are there more items?
   */
  hasNextPage: boolean;
  
  /**
   * When paginating backwards, are there more items?
   */
  hasPreviousPage: boolean;
  
  /**
   * When paginating backwards, the cursor to continue.
   */
  startCursor?: string;
}

export interface GQLPaySubscrPayload {
  error?: string;
  success: boolean;
}

/**
 * The PaymentPlan object type is used in operations that involve outputting objects of PaymentPlan class.
 */
export interface GQLPaymentPlan extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrency;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocation;
  
  /**
   * This is the object communityFee.
   */
  communityFee?: boolean;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object extraListing.
   */
  extraListing?: number;
  
  /**
   * This is the object extraResident.
   */
  extraResident?: number;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isPublic.
   */
  isPublic?: boolean;
  
  /**
   * This is the object listingCap.
   */
  listingCap?: number;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  options?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object priceMonth.
   */
  priceMonth?: number;
  
  /**
   * This is the object priceYear.
   */
  priceYear?: number;
  
  /**
   * This is the object rentFees.
   */
  rentFees?: GQLObject;
  
  /**
   * This is the object rentalExternal.
   */
  rentalExternal?: boolean;
  
  /**
   * This is the object residentCap.
   */
  residentCap?: number;
  
  /**
   * This is the object salesExternal.
   */
  salesExternal?: boolean;
  
  /**
   * This is the object salesFees.
   */
  salesFees?: GQLObject;
  
  /**
   * This is the object serviceExternal.
   */
  serviceExternal?: boolean;
  
  /**
   * This is the object serviceFees.
   */
  serviceFees?: GQLObject;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLPaymentPlanConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLPaymentPlanEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLPaymentPlanEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLPaymentPlan;
}

export interface GQLPaymentPlatformDashLinkPayload {
  error?: string;
  url?: string;
}

export interface GQLPermissionsListPayload {
  error?: string;
  permissionsList: Array<string | null>;
}

/**
 * The PhoneVerification object type is used in operations that involve outputting objects of PhoneVerification class.
 */
export interface GQLPhoneVerification extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object verificationCode.
   */
  verificationCode?: string;
}

/**
 * A connection to a list of items.
 */
export interface GQLPhoneVerificationConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLPhoneVerificationEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLPhoneVerificationEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLPhoneVerification;
}

/**
 * The PollOption object type is used in operations that involve outputting objects of PollOption class.
 */
export interface GQLPollOption extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPost;
  
  /**
   * This is the object Translate.
   */
  Translate?: GQLPostTranslate;
  
  /**
   * This is the object Voted.
   */
  Voted: GQLUserConnection;
  
  /**
   * This is the object countVotes.
   */
  countVotes?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isVoted.
   */
  isVoted?: boolean;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object position.
   */
  position?: number;
  
  /**
   * This is the object text.
   */
  text?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLPollOptionConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLPollOptionEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLPollOptionEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLPollOption;
}

/**
 * The Post object type is used in operations that involve outputting objects of Post class.
 */
export interface GQLPost extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Attachments?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUser;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object Group.
   */
  Group?: GQLGroup;
  
  /**
   * This is the object Hide.
   */
  Hide: GQLUserConnection;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Items?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Options.
   */
  Options: GQLPollOptionConnection;
  
  /**
   * This is the object Parent.
   */
  Parent?: GQLPost;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Pin?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Reports.
   */
  Reports: GQLReportConnection;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Seen?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Translate.
   */
  Translate?: GQLPostTranslate;
  
  /**
   * This is the object comments.
   */
  comments: GQLPostConnection;
  
  /**
   * This is the object countComments.
   */
  countComments?: number;
  
  /**
   * This is the object countHides.
   */
  countHides?: number;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the object countSmiles.
   */
  countSmiles?: number;
  
  /**
   * This is the object countWaves.
   */
  countWaves?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isComment.
   */
  isComment?: boolean;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isHidden.
   */
  isHidden?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isMulti.
   */
  isMulti?: boolean;
  
  /**
   * This is the object isSmile.
   */
  isSmile?: boolean;
  
  /**
   * This is the object isWave.
   */
  isWave?: boolean;
  
  /**
   * This is the object likes.
   */
  likes: GQLUserConnection;
  
  /**
   * This is the object localRef.
   */
  localRef?: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  medium?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object notShow.
   */
  notShow?: boolean;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  pollOptions?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object sentAs.
   */
  sentAs?: string;
  
  /**
   * This is the object smiles.
   */
  smiles: GQLUserConnection;
  
  /**
   * This is the object text.
   */
  text?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object waves.
   */
  waves: GQLUserConnection;
}

/**
 * A connection to a list of items.
 */
export interface GQLPostConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLPostEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLPostEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLPost;
}

/**
 * The PostTranslate object type is used in operations that involve outputting objects of PostTranslate class.
 */
export interface GQLPostTranslate extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object PollOption.
   */
  PollOption?: GQLPollOption;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPost;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object en.
   */
  en?: string;
  
  /**
   * This is the object fr.
   */
  fr?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object originalLang.
   */
  originalLang?: string;
  
  /**
   * This is the object ru.
   */
  ru?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLPostTranslateConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLPostTranslateEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLPostTranslateEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLPostTranslate;
}

export interface GQLPreOrderCalcDataPayLoad {
  hangehDiscount: number;
  itemCost: number;
  ppRequesterAmt: number;
  requesterTotalAmt: number;
  sfRequesterAmt: number;
}

/**
 * The Promo object type is used in operations that involve outputting objects of Promo class.
 */
export interface GQLPromo extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Communities?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrency;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocation;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object endDate.
   */
  endDate?: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isCommunity.
   */
  isCommunity?: boolean;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object startDate.
   */
  startDate?: GQLDate;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object usageLimit.
   */
  usageLimit?: number;
  
  /**
   * This is the object value.
   */
  value?: number;
  
  /**
   * This is the object valueType.
   */
  valueType?: string;
}

/**
 * A connection to a list of items.
 */
export interface GQLPromoConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLPromoEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLPromoEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLPromo;
}

/**
 * Allow to manage public rights.
 */
export interface GQLPublicACL {
  
  /**
   * Allow anyone to read the current object.
   */
  read?: boolean;
  
  /**
   * Allow anyone to write on the current object.
   */
  write?: boolean;
}

/**
 * The PushNotificationLog object type is used in operations that involve outputting objects of PushNotificationLog class.
 */
export interface GQLPushNotificationLog extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object message.
   */
  message?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object result.
   */
  result?: boolean;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object user.
   */
  user?: GQLUser;
}

/**
 * A connection to a list of items.
 */
export interface GQLPushNotificationLogConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLPushNotificationLogEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLPushNotificationLogEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLPushNotificationLog;
}

/**
 * Query is the top level type for queries.
 */
export interface GQLQuery {
  
  /**
   * The admin query can be used to get an object of the Admin class by its id.
   */
  admin: GQLAdmin;
  
  /**
   * The admins query can be used to find objects of the Admin class.
   */
  admins: GQLAdminConnection;
  
  /**
   * The amenities query can be used to find objects of the Amenity class.
   */
  amenities: GQLAmenityConnection;
  
  /**
   * The amenity query can be used to get an object of the Amenity class by its id.
   */
  amenity: GQLAmenity;
  
  /**
   * The appFile query can be used to get an object of the AppFile class by its id.
   */
  appFile: GQLAppFile;
  
  /**
   * The appFiles query can be used to find objects of the AppFile class.
   */
  appFiles: GQLAppFileConnection;
  
  /**
   * The categories query can be used to find objects of the Category class.
   */
  categories: GQLCategoryConnection;
  
  /**
   * The category query can be used to get an object of the Category class by its id.
   */
  category: GQLCategory;
  
  /**
   * The chat query can be used to get an object of the Chat class by its id.
   */
  chat: GQLChat;
  
  /**
   * The chats query can be used to find objects of the Chat class.
   */
  chats: GQLChatConnection;
  
  /**
   * The class query can be used to retrieve an existing object class.
   */
  class: GQLClass;
  
  /**
   * The classes query can be used to retrieve the existing object classes.
   */
  classes: Array<GQLClass>;
  
  /**
   * The communities query can be used to find objects of the Community class.
   */
  communities: GQLCommunityConnection;
  
  /**
   * The community query can be used to get an object of the Community class by its id.
   */
  community: GQLCommunity;
  
  /**
   * The communityAdmin query can be used to get an object of the CommunityAdmin class by its id.
   */
  communityAdmin: GQLCommunityAdmin;
  
  /**
   * The communityAdmins query can be used to find objects of the CommunityAdmin class.
   */
  communityAdmins: GQLCommunityAdminConnection;
  
  /**
   * The companies query can be used to find objects of the Company class.
   */
  companies: GQLCompanyConnection;
  
  /**
   * The company query can be used to get an object of the Company class by its id.
   */
  company: GQLCompany;
  
  /**
   * The currencies query can be used to find objects of the Currency class.
   */
  currencies: GQLCurrencyConnection;
  
  /**
   * The currency query can be used to get an object of the Currency class by its id.
   */
  currency: GQLCurrency;
  
  /**
   * The document query can be used to get an object of the Document class by its id.
   */
  document: GQLDocument;
  
  /**
   * The documents query can be used to find objects of the Document class.
   */
  documents: GQLDocumentConnection;
  
  /**
   * The event query can be used to get an object of the Event class by its id.
   */
  event: GQLEvent;
  
  /**
   * The events query can be used to find objects of the Event class.
   */
  events: GQLEventConnection;
  
  /**
   * The group query can be used to get an object of the Group class by its id.
   */
  group: GQLGroup;
  
  /**
   * The groups query can be used to find objects of the Group class.
   */
  groups: GQLGroupConnection;
  
  /**
   * The health query can be used to check if the server is up and running.
   */
  health: boolean;
  
  /**
   * The helpDesk query can be used to get an object of the HelpDesk class by its id.
   */
  helpDesk: GQLHelpDesk;
  
  /**
   * The helpDesks query can be used to find objects of the HelpDesk class.
   */
  helpDesks: GQLHelpDeskConnection;
  
  /**
   * The installation query can be used to get an object of the Installation class by its id.
   */
  installation: GQLInstallation;
  
  /**
   * The installations query can be used to find objects of the Installation class.
   */
  installations: GQLInstallationConnection;
  
  /**
   * The invitation query can be used to get an object of the Invitation class by its id.
   */
  invitation: GQLInvitation;
  
  /**
   * The invitations query can be used to find objects of the Invitation class.
   */
  invitations: GQLInvitationConnection;
  
  /**
   * The item query can be used to get an object of the Item class by its id.
   */
  item: GQLItem;
  
  /**
   * The itemBooking query can be used to get an object of the ItemBooking class by its id.
   */
  itemBooking: GQLItemBooking;
  
  /**
   * The itemBookings query can be used to find objects of the ItemBooking class.
   */
  itemBookings: GQLItemBookingConnection;
  
  /**
   * The items query can be used to find objects of the Item class.
   */
  items: GQLItemConnection;
  
  /**
   * The joinRequest query can be used to get an object of the JoinRequest class by its id.
   */
  joinRequest: GQLJoinRequest;
  
  /**
   * The joinRequests query can be used to find objects of the JoinRequest class.
   */
  joinRequests: GQLJoinRequestConnection;
  
  /**
   * The language query can be used to get an object of the Language class by its id.
   */
  language: GQLLanguage;
  
  /**
   * The languages query can be used to find objects of the Language class.
   */
  languages: GQLLanguageConnection;
  
  /**
   * The location query can be used to get an object of the Location class by its id.
   */
  location: GQLLocation;
  
  /**
   * The locations query can be used to find objects of the Location class.
   */
  locations: GQLLocationConnection;
  
  /**
   * The message query can be used to get an object of the Message class by its id.
   */
  message: GQLMessage;
  
  /**
   * The messages query can be used to find objects of the Message class.
   */
  messages: GQLMessageConnection;
  
  /**
   * The myClass query can be used to get an object of the MyClass class by its id.
   */
  myClass: GQLMyClass;
  
  /**
   * The myClasses query can be used to find objects of the MyClass class.
   */
  myClasses: GQLMyClassConnection;
  
  /**
   * Fetches an object given its ID
   */
  node?: GQLNode;
  
  /**
   * The notifSending query can be used to get an object of the NotifSending class by its id.
   */
  notifSending: GQLNotifSending;
  
  /**
   * The notifSendings query can be used to find objects of the NotifSending class.
   */
  notifSendings: GQLNotifSendingConnection;
  
  /**
   * The notification query can be used to get an object of the Notification class by its id.
   */
  notification: GQLNotification;
  
  /**
   * The notifications query can be used to find objects of the Notification class.
   */
  notifications: GQLNotificationConnection;
  
  /**
   * The order query can be used to get an object of the Order class by its id.
   */
  order: GQLOrder;
  
  /**
   * The orders query can be used to find objects of the Order class.
   */
  orders: GQLOrderConnection;
  
  /**
   * The paymentPlan query can be used to get an object of the PaymentPlan class by its id.
   */
  paymentPlan: GQLPaymentPlan;
  
  /**
   * The paymentPlans query can be used to find objects of the PaymentPlan class.
   */
  paymentPlans: GQLPaymentPlanConnection;
  
  /**
   * The phoneVerification query can be used to get an object of the PhoneVerification class by its id.
   */
  phoneVerification: GQLPhoneVerification;
  
  /**
   * The phoneVerifications query can be used to find objects of the PhoneVerification class.
   */
  phoneVerifications: GQLPhoneVerificationConnection;
  
  /**
   * The pollOption query can be used to get an object of the PollOption class by its id.
   */
  pollOption: GQLPollOption;
  
  /**
   * The pollOptions query can be used to find objects of the PollOption class.
   */
  pollOptions: GQLPollOptionConnection;
  
  /**
   * The post query can be used to get an object of the Post class by its id.
   */
  post: GQLPost;
  
  /**
   * The postTranslate query can be used to get an object of the PostTranslate class by its id.
   */
  postTranslate: GQLPostTranslate;
  
  /**
   * The postTranslates query can be used to find objects of the PostTranslate class.
   */
  postTranslates: GQLPostTranslateConnection;
  
  /**
   * The posts query can be used to find objects of the Post class.
   */
  posts: GQLPostConnection;
  
  /**
   * The promo query can be used to get an object of the Promo class by its id.
   */
  promo: GQLPromo;
  
  /**
   * The promos query can be used to find objects of the Promo class.
   */
  promos: GQLPromoConnection;
  
  /**
   * The pushNotificationLog query can be used to get an object of the PushNotificationLog class by its id.
   */
  pushNotificationLog: GQLPushNotificationLog;
  
  /**
   * The pushNotificationLogs query can be used to find objects of the PushNotificationLog class.
   */
  pushNotificationLogs: GQLPushNotificationLogConnection;
  
  /**
   * The referral query can be used to get an object of the Referral class by its id.
   */
  referral: GQLReferral;
  
  /**
   * The referrals query can be used to find objects of the Referral class.
   */
  referrals: GQLReferralConnection;
  
  /**
   * The report query can be used to get an object of the Report class by its id.
   */
  report: GQLReport;
  
  /**
   * The reports query can be used to find objects of the Report class.
   */
  reports: GQLReportConnection;
  
  /**
   * The review query can be used to get an object of the Review class by its id.
   */
  review: GQLReview;
  
  /**
   * The reviews query can be used to find objects of the Review class.
   */
  reviews: GQLReviewConnection;
  
  /**
   * The role query can be used to get an object of the Role class by its id.
   */
  role: GQLRole;
  
  /**
   * The roles query can be used to find objects of the Role class.
   */
  roles: GQLRoleConnection;
  searchSessions?: GQLSessionConnection;
  
  /**
   * The session query can be used to get an object of the Session class by its id.
   */
  session: GQLSession;
  
  /**
   * The sessions query can be used to find objects of the Session class.
   */
  sessions: GQLSessionConnection;
  
  /**
   * The subscr query can be used to get an object of the Subscr class by its id.
   */
  subscr: GQLSubscr;
  
  /**
   * The subscrPayment query can be used to get an object of the SubscrPayment class by its id.
   */
  subscrPayment: GQLSubscrPayment;
  
  /**
   * The subscrPayments query can be used to find objects of the SubscrPayment class.
   */
  subscrPayments: GQLSubscrPaymentConnection;
  
  /**
   * The subscrs query can be used to find objects of the Subscr class.
   */
  subscrs: GQLSubscrConnection;
  
  /**
   * The task query can be used to get an object of the Task class by its id.
   */
  task: GQLTask;
  
  /**
   * The tasks query can be used to find objects of the Task class.
   */
  tasks: GQLTaskConnection;
  
  /**
   * The transaction query can be used to get an object of the Transaction class by its id.
   */
  transaction: GQLTransaction;
  
  /**
   * The transactions query can be used to find objects of the Transaction class.
   */
  transactions: GQLTransactionConnection;
  
  /**
   * The user query can be used to get an object of the User class by its id.
   */
  user: GQLUser;
  
  /**
   * The users query can be used to find objects of the User class.
   */
  users: GQLUserConnection;
  
  /**
   * The viewer query can be used to return the current user data.
   */
  viewer: GQLViewer;
}

export interface GQLReactionHandlerPayload {
  success?: boolean;
}

/**
 * The Referral object type is used in operations that involve outputting objects of Referral class.
 */
export interface GQLReferral extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object ReferralBy.
   */
  ReferralBy?: GQLUser;
  
  /**
   * This is the object Referrals.
   */
  Referrals: GQLUserConnection;
  
  /**
   * This is the object ReferralsCount.
   */
  ReferralsCount?: number;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object accumulatedDiscount.
   */
  accumulatedDiscount?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object userMadeTransaction.
   */
  userMadeTransaction?: boolean;
}

/**
 * A connection to a list of items.
 */
export interface GQLReferralConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLReferralEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLReferralEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLReferral;
}

/**
 * The Report object type is used in operations that involve outputting objects of Report class.
 */
export interface GQLReport extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Community.
   */
  Community: GQLCommunity;
  
  /**
   * This is the object Company.
   */
  Company?: GQLCompany;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEvent;
  
  /**
   * This is the object Group.
   */
  Group?: GQLGroup;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItem;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPost;
  
  /**
   * This is the object Reporter.
   */
  Reporter?: GQLUser;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object blockUserText.
   */
  blockUserText?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object reportText.
   */
  reportText?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLReportConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLReportEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLReportEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLReport;
}

export interface GQLResetPasswordPayload {
  clientMutationId?: string;
  
  /**
   * It's always true.
   */
  ok: boolean;
}

export interface GQLResidentDashboardPayload {
  averageRatingGiven?: number;
  averageRatingReceived?: number;
  countEarned?: number;
  countInteractions?: number;
  countItemValue?: number;
  countListingViews?: number;
  countListings?: number;
  countOthersTransactions?: number;
  countOwnTransactions?: number;
  countSpent?: number;
}

/**
 * The Review object type is used in operations that involve outputting objects of Review class.
 */
export interface GQLReview extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Amenity.
   */
  Amenity?: GQLAmenity;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUser;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEvent;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItem;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrder;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object stars.
   */
  stars?: number;
  
  /**
   * This is the object subject.
   */
  subject?: string;
  
  /**
   * This is the object text.
   */
  text?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLReviewConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLReviewEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLReviewEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLReview;
}

/**
 * The Role object type is used in operations that involve outputting objects of Role class.
 */
export interface GQLRole extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object roles.
   */
  roles: GQLRoleConnection;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object users.
   */
  users: GQLUserConnection;
}

/**
 * Allow to manage roles in ACL. If read and write are null the role have read and write rights.
 */
export interface GQLRoleACL {
  
  /**
   * Allow users who are members of the role to read the current object.
   */
  read: boolean;
  
  /**
   * Name of the targetted Role.
   */
  roleName: string;
  
  /**
   * Allow users who are members of the role to write on the current object.
   */
  write: boolean;
}

/**
 * A connection to a list of items.
 */
export interface GQLRoleConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLRoleEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLRoleEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLRole;
}

/**
 * The SchemaACLField is used to return information of an ACL field.
 */
export interface GQLSchemaACLField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaArrayField is used to return information of an Array field.
 */
export interface GQLSchemaArrayField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaBooleanField is used to return information of a Boolean field.
 */
export interface GQLSchemaBooleanField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaBytesField is used to return information of a Bytes field.
 */
export interface GQLSchemaBytesField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaDateField is used to return information of a Date field.
 */
export interface GQLSchemaDateField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaFileField is used to return information of a File field.
 */
export interface GQLSchemaFileField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaGeoPointField is used to return information of a Geo Point field.
 */
export interface GQLSchemaGeoPointField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaNumberField is used to return information of a Number field.
 */
export interface GQLSchemaNumberField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaObjectField is used to return information of an Object field.
 */
export interface GQLSchemaObjectField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaPointerField is used to return information of a Pointer field.
 */
export interface GQLSchemaPointerField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
  
  /**
   * This is the name of the target class for the field.
   */
  targetClassName: string;
}

/**
 * The SchemaPolygonField is used to return information of a Polygon field.
 */
export interface GQLSchemaPolygonField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaRelationField is used to return information of a Relation field.
 */
export interface GQLSchemaRelationField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
  
  /**
   * This is the name of the target class for the field.
   */
  targetClassName: string;
}

/**
 * The SchemaStringField is used to return information of a String field.
 */
export interface GQLSchemaStringField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

export interface GQLSendVerificationEmailPayload {
  clientMutationId?: string;
  
  /**
   * It's always true.
   */
  ok: boolean;
}

/**
 * The Session object type is used in operations that involve outputting objects of Session class.
 */
export interface GQLSession extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object createdWith.
   */
  createdWith?: GQLObject;
  
  /**
   * This is the object expiresAt.
   */
  expiresAt?: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object restricted.
   */
  restricted?: boolean;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object user.
   */
  user?: GQLUser;
}

/**
 * A connection to a list of items.
 */
export interface GQLSessionConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLSessionEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLSessionEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLSession;
}

export interface GQLSignUpPayload {
  clientMutationId?: string;
  
  /**
   * This is the new user that was created, signed up and returned as a viewer.
   */
  viewer: GQLViewer;
}

/**
 * The Subscr object type is used in operations that involve outputting objects of Subscr class.
 */
export interface GQLSubscr extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Communities.
   */
  Communities: GQLCommunityConnection;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUser;
  
  /**
   * This is the object PaymentPlan.
   */
  PaymentPlan?: GQLPaymentPlan;
  
  /**
   * This is the object SubscrPayments.
   */
  SubscrPayments: GQLSubscrPaymentConnection;
  
  /**
   * This is the object beginAt.
   */
  beginAt?: GQLDate;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object expireAt.
   */
  expireAt?: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object netPaid.
   */
  netPaid?: number;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object paymentPeriod.
   */
  paymentPeriod?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLSubscrConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLSubscrEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLSubscrEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLSubscr;
}

/**
 * The SubscrPayment object type is used in operations that involve outputting objects of SubscrPayment class.
 */
export interface GQLSubscrPayment extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Subscr.
   */
  Subscr?: GQLSubscr;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object amount.
   */
  amount?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object data.
   */
  data?: string;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLSubscrPaymentConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLSubscrPaymentEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLSubscrPaymentEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLSubscrPayment;
}

export interface GQLSupportInsightPayload {
  amenitiesBooked?: number;
  eventsAttended?: number;
  listingsPosted?: number;
  listingsTransactions?: number;
  listingsValueSum?: number;
  moneySpent?: number;
  totalLikes?: number;
  totalMessages?: number;
  totalPosts?: number;
  totalSessions?: number;
}

/**
 * The Task object type is used in operations that involve outputting objects of Task class.
 */
export interface GQLTask extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object File.
   */
  File?: GQLAppFile;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  options?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object processedRow.
   */
  processedRow?: number;
  
  /**
   * This is the object result.
   */
  result?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLTaskConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLTaskEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLTaskEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLTask;
}

/**
 * The Transaction object type is used in operations that involve outputting objects of Transaction class.
 */
export interface GQLTransaction extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunity;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrder;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object amount.
   */
  amount?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object data.
   */
  data?: string;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object transferDest.
   */
  transferDest?: string;
  
  /**
   * This is the object transferGroup.
   */
  transferGroup?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLTransactionConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLTransactionEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLTransactionEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLTransaction;
}

export interface GQLUpdateAdminPayload {
  
  /**
   * This is the updated object.
   */
  admin: GQLAdmin;
  clientMutationId?: string;
}

export interface GQLUpdateAmenityPayload {
  
  /**
   * This is the updated object.
   */
  amenity: GQLAmenity;
  clientMutationId?: string;
}

export interface GQLUpdateAppFilePayload {
  
  /**
   * This is the updated object.
   */
  appFile: GQLAppFile;
  clientMutationId?: string;
}

export interface GQLUpdateCategoryPayload {
  
  /**
   * This is the updated object.
   */
  category: GQLCategory;
  clientMutationId?: string;
}

export interface GQLUpdateChatPayload {
  
  /**
   * This is the updated object.
   */
  chat: GQLChat;
  clientMutationId?: string;
}

export interface GQLUpdateClassPayload {
  
  /**
   * This is the updated class.
   */
  class: GQLClass;
  clientMutationId?: string;
}

export interface GQLUpdateCommunityAdminPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  communityAdmin: GQLCommunityAdmin;
}

export interface GQLUpdateCommunityPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  community: GQLCommunity;
}

export interface GQLUpdateCompanyPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  company: GQLCompany;
}

export interface GQLUpdateCurrencyPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  currency: GQLCurrency;
}

export interface GQLUpdateDocumentPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  document: GQLDocument;
}

export interface GQLUpdateEventPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  event: GQLEvent;
}

export interface GQLUpdateGroupPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  group: GQLGroup;
}

export interface GQLUpdateHelpDeskPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  helpDesk: GQLHelpDesk;
}

export interface GQLUpdateInstallationPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  installation: GQLInstallation;
}

export interface GQLUpdateInvitationPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  invitation: GQLInvitation;
}

export interface GQLUpdateItemBookingPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  itemBooking: GQLItemBooking;
}

export interface GQLUpdateItemPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  item: GQLItem;
}

export interface GQLUpdateJoinRequestPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  joinRequest: GQLJoinRequest;
}

export interface GQLUpdateLanguagePayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  language: GQLLanguage;
}

export interface GQLUpdateLocationPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  location: GQLLocation;
}

export interface GQLUpdateMessagePayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  message: GQLMessage;
}

export interface GQLUpdateMyClassPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  myClass: GQLMyClass;
}

export interface GQLUpdateNotifSendingPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  notifSending: GQLNotifSending;
}

export interface GQLUpdateNotificationPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  notification: GQLNotification;
}

export interface GQLUpdateOrderPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  order: GQLOrder;
}

export interface GQLUpdatePaymentPlanPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  paymentPlan: GQLPaymentPlan;
}

export interface GQLUpdatePhoneVerificationPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  phoneVerification: GQLPhoneVerification;
}

export interface GQLUpdatePollOptionPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  pollOption: GQLPollOption;
}

export interface GQLUpdatePostPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  post: GQLPost;
}

export interface GQLUpdatePostTranslatePayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  postTranslate: GQLPostTranslate;
}

export interface GQLUpdatePromoPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  promo: GQLPromo;
}

export interface GQLUpdatePushNotificationLogPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  pushNotificationLog: GQLPushNotificationLog;
}

export interface GQLUpdateReferralPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  referral: GQLReferral;
}

export interface GQLUpdateReportPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  report: GQLReport;
}

export interface GQLUpdateReviewPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  review: GQLReview;
}

export interface GQLUpdateRolePayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  role: GQLRole;
}

export interface GQLUpdateSessionPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  session: GQLSession;
}

export interface GQLUpdateSubscrPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  subscr: GQLSubscr;
}

export interface GQLUpdateSubscrPaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  subscrPayment: GQLSubscrPayment;
}

export interface GQLUpdateTaskPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  task: GQLTask;
}

export interface GQLUpdateTransactionPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  transaction: GQLTransaction;
}

export interface GQLUpdateUserPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  user: GQLUser;
}

/**
 * The User object type is used in operations that involve outputting objects of User class.
 */
export interface GQLUser extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFile;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  Blocked?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object Communities.
   */
  Communities: GQLCommunityConnection;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocation;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrency;
  
  /**
   * This is the object Language.
   */
  Language?: GQLLanguage;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocation;
  
  /**
   * This is the object Orders.
   */
  Orders: GQLOrderConnection;
  
  /**
   * This is the object ReferralCode.
   */
  ReferralCode?: string;
  
  /**
   * This is the object Reports.
   */
  Reports: GQLReportConnection;
  
  /**
   * This is the object Reviews.
   */
  Reviews: GQLReviewConnection;
  
  /**
   * This is the object Viewers.
   */
  Viewers: GQLUserConnection;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object aptSuite.
   */
  aptSuite?: string;
  
  /**
   * This is the object authData.
   */
  authData?: GQLObject;
  
  /**
   * This is the object bio.
   */
  bio?: string;
  
  /**
   * This is the object birthDate.
   */
  birthDate?: GQLDate;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  cardInfo?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObject;
  
  /**
   * This is the object checkListSeen.
   */
  checkListSeen?: boolean;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object distance.
   */
  distance?: string;
  
  /**
   * This is the object earned.
   */
  earned?: number;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: boolean;
  
  /**
   * This is the object firstLetter.
   */
  firstLetter?: string;
  
  /**
   * This is the object firstName.
   */
  firstName?: string;
  
  /**
   * This is the object gender.
   */
  gender?: string;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPoint;
  
  /**
   * This is the object homepage.
   */
  homepage?: string;
  
  /**
   * This is the object howDidYouHear.
   */
  howDidYouHear?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObject;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  interests?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isInvited.
   */
  isInvited?: boolean;
  
  /**
   * This is the object isOnline.
   */
  isOnline?: boolean;
  
  /**
   * This is the object isSupport.
   */
  isSupport?: boolean;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object isWaved.
   */
  isWaved?: boolean;
  
  /**
   * This is the object languages.
   */
  languages?: string;
  
  /**
   * This is the object lastName.
   */
  lastName?: string;
  
  /**
   * This is the object lastVisitedCommunity.
   */
  lastVisitedCommunity?: string;
  
  /**
   * This is the object listingCount.
   */
  listingCount?: number;
  
  /**
   * This is the object livingWith.
   */
  livingWith?: string;
  
  /**
   * This is the object mobilePushEnabled.
   */
  mobilePushEnabled?: boolean;
  
  /**
   * This is the object msgIncoming.
   */
  msgIncoming?: string;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyAmenityReminder?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyDigest?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyEventAttendees?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyEventReminder?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyHelpCentre?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyJoinRequest?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyLikeOrComment?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyListingView?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyListingsRequest?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyLoopPost?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyManagedAmenities?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyManagerAdminPost?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyMarketingAndFeatures?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyMessage?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewCommunities?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewListing?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewListings?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewMember?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewMembers?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewRequests?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewResidentListings?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewResidents?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyNewTransaction?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyOrderRequest?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyProfileView?: Array<GQLArrayResult | null>;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  notifyUnmanagedAmenities?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object occupation.
   */
  occupation?: string;
  
  /**
   * This is the object onlineDate.
   */
  onlineDate?: GQLDate;
  
  /**
   * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
   */
  personInterests?: Array<GQLArrayResult | null>;
  
  /**
   * This is the object phone.
   */
  phone?: string;
  
  /**
   * This is the object phoneVerified.
   */
  phoneVerified?: boolean;
  
  /**
   * This is the object platformStripeId.
   */
  platformStripeId?: string;
  
  /**
   * This is the object profileViewOff.
   */
  profileViewOff?: boolean;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object recommendations.
   */
  recommendations?: GQLObject;
  
  /**
   * This is the object spent.
   */
  spent?: number;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeConnectedId.
   */
  stripeConnectedId?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object study.
   */
  study?: string;
  
  /**
   * This is the object tips.
   */
  tips?: GQLObject;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object username.
   */
  username?: string;
  
  /**
   * This is the object work.
   */
  work?: string;
  
  /**
   * This is the object zip.
   */
  zip?: string;
}

/**
 * Allow to manage users in ACL. If read and write are null the users have read and write rights.
 */
export interface GQLUserACL {
  
  /**
   * Allow the user to read the current object.
   */
  read: boolean;
  
  /**
   * ID of the targetted User.
   */
  userId: string;
  
  /**
   * Allow the user to write on the current object.
   */
  write: boolean;
}

/**
 * A connection to a list of items.
 */
export interface GQLUserConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLUserEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLUserEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLUser;
}

export interface GQLVerifyCodePayload {
  clientMutationId?: string;
  ok?: boolean;
}

export interface GQLVerifyEmailPayload {
  clientMutationId?: string;
  ok: boolean;
}

export interface GQLVerifyPhonePayload {
  clientMutationId?: string;
  ok?: boolean;
}

export interface GQLViewObjectPayload {
  error?: string;
  success: boolean;
}

/**
 * The Viewer object type is used in operations that involve outputting the current user data.
 */
export interface GQLViewer {
  
  /**
   * The current user session token.
   */
  sessionToken: string;
  
  /**
   * This is the current user.
   */
  user: GQLUser;
}

export interface GQLWaveUserPayload {
  success?: boolean;
}

export interface GQLgetEventPayload {
  event?: GQLObject;
}

export interface GQLgetSeoOrderItemDataPayload {
  item?: GQLObject;
}

export enum GQLAdminChartTypes {
  activeListings = 'activeListings',
  averageListingPrice = 'averageListingPrice',
  averageListingRating = 'averageListingRating',
  averageMemberRating = 'averageMemberRating',
  communities = 'communities',
  freeListings = 'freeListings',
  inactiveListings = 'inactiveListings',
  listingMembers = 'listingMembers',
  listingRevenue = 'listingRevenue',
  listings = 'listings',
  managers = 'managers',
  members = 'members',
  paidListings = 'paidListings',
  rentalListings = 'rentalListings',
  requestedListingMembers = 'requestedListingMembers',
  revenue = 'revenue',
  reviewsAndRatings = 'reviewsAndRatings',
  sellingListings = 'sellingListings',
  serviceListings = 'serviceListings',
  subscrRevenue = 'subscrRevenue',
  successfulTransactions = 'successfulTransactions'
}

/**
 * The AdminOrder input type is used when sorting objects of the Admin class.
 */
export enum GQLAdminOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Communities_ASC = 'Communities_ASC',
  Communities_DESC = 'Communities_DESC',
  Configurations_ASC = 'Configurations_ASC',
  Configurations_DESC = 'Configurations_DESC',
  HelpCentre_ASC = 'HelpCentre_ASC',
  HelpCentre_DESC = 'HelpCentre_DESC',
  Listings_ASC = 'Listings_ASC',
  Listings_DESC = 'Listings_DESC',
  Members_ASC = 'Members_ASC',
  Members_DESC = 'Members_DESC',
  Promotions_ASC = 'Promotions_ASC',
  Promotions_DESC = 'Promotions_DESC',
  Requests_ASC = 'Requests_ASC',
  Requests_DESC = 'Requests_DESC',
  Settings_ASC = 'Settings_ASC',
  Settings_DESC = 'Settings_DESC',
  Transactions_ASC = 'Transactions_ASC',
  Transactions_DESC = 'Transactions_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isFullAccess_ASC = 'isFullAccess_ASC',
  isFullAccess_DESC = 'isFullAccess_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLAmenityManageAction {
  publish = 'publish',
  unpublish = 'unpublish'
}

/**
 * The AmenityOrder input type is used when sorting objects of the Amenity class.
 */
export enum GQLAmenityOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  AdmHidden_ASC = 'AdmHidden_ASC',
  AdmHidden_DESC = 'AdmHidden_DESC',
  ApproveReq_ASC = 'ApproveReq_ASC',
  ApproveReq_DESC = 'ApproveReq_DESC',
  Bookings_ASC = 'Bookings_ASC',
  Bookings_DESC = 'Bookings_DESC',
  Featured_ASC = 'Featured_ASC',
  Featured_DESC = 'Featured_DESC',
  Lister_ASC = 'Lister_ASC',
  Lister_DESC = 'Lister_DESC',
  Location_ASC = 'Location_ASC',
  Location_DESC = 'Location_DESC',
  Published_ASC = 'Published_ASC',
  Published_DESC = 'Published_DESC',
  Requests_ASC = 'Requests_ASC',
  Requests_DESC = 'Requests_DESC',
  Reviews_ASC = 'Reviews_ASC',
  Reviews_DESC = 'Reviews_DESC',
  Transactions_ASC = 'Transactions_ASC',
  Transactions_DESC = 'Transactions_DESC',
  Updated_ASC = 'Updated_ASC',
  Updated_DESC = 'Updated_DESC',
  Viewers_ASC = 'Viewers_ASC',
  Viewers_DESC = 'Viewers_DESC',
  allowGuests_ASC = 'allowGuests_ASC',
  allowGuests_DESC = 'allowGuests_DESC',
  autoBooking_ASC = 'autoBooking_ASC',
  autoBooking_DESC = 'autoBooking_DESC',
  availabilityOverride_ASC = 'availabilityOverride_ASC',
  availabilityOverride_DESC = 'availabilityOverride_DESC',
  bookingPeriod_ASC = 'bookingPeriod_ASC',
  bookingPeriod_DESC = 'bookingPeriod_DESC',
  bookingSlots_ASC = 'bookingSlots_ASC',
  bookingSlots_DESC = 'bookingSlots_DESC',
  bookingTiming_ASC = 'bookingTiming_ASC',
  bookingTiming_DESC = 'bookingTiming_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  images_ASC = 'images_ASC',
  images_DESC = 'images_DESC',
  isBookable_ASC = 'isBookable_ASC',
  isBookable_DESC = 'isBookable_DESC',
  isDeleted_ASC = 'isDeleted_ASC',
  isDeleted_DESC = 'isDeleted_DESC',
  isPublished_ASC = 'isPublished_ASC',
  isPublished_DESC = 'isPublished_DESC',
  maxBookingPerSlot_ASC = 'maxBookingPerSlot_ASC',
  maxBookingPerSlot_DESC = 'maxBookingPerSlot_DESC',
  maxBookingsPerDay_ASC = 'maxBookingsPerDay_ASC',
  maxBookingsPerDay_DESC = 'maxBookingsPerDay_DESC',
  maxResidentsPerBooking_ASC = 'maxResidentsPerBooking_ASC',
  maxResidentsPerBooking_DESC = 'maxResidentsPerBooking_DESC',
  messageAssignees_ASC = 'messageAssignees_ASC',
  messageAssignees_DESC = 'messageAssignees_DESC',
  multipleFutureBookings_ASC = 'multipleFutureBookings_ASC',
  multipleFutureBookings_DESC = 'multipleFutureBookings_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  popularDay_ASC = 'popularDay_ASC',
  popularDay_DESC = 'popularDay_DESC',
  popularTime_ASC = 'popularTime_ASC',
  popularTime_DESC = 'popularTime_DESC',
  rating_ASC = 'rating_ASC',
  rating_DESC = 'rating_DESC',
  rewardType_ASC = 'rewardType_ASC',
  rewardType_DESC = 'rewardType_DESC',
  totalBookings_ASC = 'totalBookings_ASC',
  totalBookings_DESC = 'totalBookings_DESC',
  totalViews_ASC = 'totalViews_ASC',
  totalViews_DESC = 'totalViews_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The AppFileOrder input type is used when sorting objects of the AppFile class.
 */
export enum GQLAppFileOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Owner_ASC = 'Owner_ASC',
  Owner_DESC = 'Owner_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  file_ASC = 'file_ASC',
  file_DESC = 'file_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mime_ASC = 'mime_ASC',
  mime_DESC = 'mime_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLButtonsManagerTypes {
  approve = 'approve',
  feature = 'feature',
  hide = 'hide',
  unfeature = 'unfeature'
}

export enum GQLButtonsResidentTypes {
  publish = 'publish',
  unlist = 'unlist'
}

/**
 * The CategoryOrder input type is used when sorting objects of the Category class.
 */
export enum GQLCategoryOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The ChatOrder input type is used when sorting objects of the Chat class.
 */
export enum GQLChatOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Members_ASC = 'Members_ASC',
  Members_DESC = 'Members_DESC',
  Messages_ASC = 'Messages_ASC',
  Messages_DESC = 'Messages_DESC',
  Support_ASC = 'Support_ASC',
  Support_DESC = 'Support_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isArchived_ASC = 'isArchived_ASC',
  isArchived_DESC = 'isArchived_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The CloudCodeFunction enum type contains a list of all available cloud code functions.
 */
export enum GQLCloudCodeFunction {
  accountTransfer = 'accountTransfer',
  adminCreate = 'adminCreate',
  adminCreateUser = 'adminCreateUser',
  adminDashboard = 'adminDashboard',
  adminDashboardChart = 'adminDashboardChart',
  adminDeleteUser = 'adminDeleteUser',
  adminEdit = 'adminEdit',
  adminLogin = 'adminLogin',
  adminRemove = 'adminRemove',
  adminUpdateUser = 'adminUpdateUser',
  amenityManageButtons = 'amenityManageButtons',
  archiveNotifications = 'archiveNotifications',
  badgeClear = 'badgeClear',
  calcOrderData = 'calcOrderData',
  changePassword = 'changePassword',
  changeSubscriptionPlan = 'changeSubscriptionPlan',
  checkCommExternalPayments = 'checkCommExternalPayments',
  communityAdminCreate = 'communityAdminCreate',
  communityAdminEdit = 'communityAdminEdit',
  communityAdminRemove = 'communityAdminRemove',
  companyManageButtons = 'companyManageButtons',
  confirmUserRemoval = 'confirmUserRemoval',
  connectStripeAccount = 'connectStripeAccount',
  countTotalClicks = 'countTotalClicks',
  createCommunityForNewUser = 'createCommunityForNewUser',
  createCompanyReport = 'createCompanyReport',
  createMultiplyItems = 'createMultiplyItems',
  createUserReferral = 'createUserReferral',
  deactivateUser = 'deactivateUser',
  directAddMember = 'directAddMember',
  eventManageButtons = 'eventManageButtons',
  generateAiOpenApiText = 'generateAiOpenApiText',
  generateUsername = 'generateUsername',
  getAccountBalance = 'getAccountBalance',
  getEventItem = 'getEventItem',
  getItemArrays = 'getItemArrays',
  getManagersList = 'getManagersList',
  getNewPassword = 'getNewPassword',
  getPaymentPlatformDashboardLink = 'getPaymentPlatformDashboardLink',
  getResidentsAvatar = 'getResidentsAvatar',
  getSeoOrderItemData = 'getSeoOrderItemData',
  getUserByReferral = 'getUserByReferral',
  getUserInsightsData = 'getUserInsightsData',
  getUserPermissionsList = 'getUserPermissionsList',
  groupManageButtons = 'groupManageButtons',
  helpDeskListOrder = 'helpDeskListOrder',
  hidePost = 'hidePost',
  itemManagerButtons = 'itemManagerButtons',
  itemResidentButtons = 'itemResidentButtons',
  joinGroup = 'joinGroup',
  leaveCommunity = 'leaveCommunity',
  leaveGroup = 'leaveGroup',
  likeHandler = 'likeHandler',
  likeHandlerEvent = 'likeHandlerEvent',
  likeHandlerListing = 'likeHandlerListing',
  linkWithSocial = 'linkWithSocial',
  makeOrder = 'makeOrder',
  manageOrder = 'manageOrder',
  managerDashboard = 'managerDashboard',
  managerDashboardChart = 'managerDashboardChart',
  managerRemoveResident = 'managerRemoveResident',
  messageSetSeen = 'messageSetSeen',
  newViewer = 'newViewer',
  notifyManager = 'notifyManager',
  paySubscription = 'paySubscription',
  paymentAddCard = 'paymentAddCard',
  paymentDeleteCard = 'paymentDeleteCard',
  paymentGetUserCards = 'paymentGetUserCards',
  paymentSetDefaultCard = 'paymentSetDefaultCard',
  pinUnpinPost = 'pinUnpinPost',
  preOrderCalcData = 'preOrderCalcData',
  reactionHandler = 'reactionHandler',
  registerPushNotification = 'registerPushNotification',
  removeUser = 'removeUser',
  removeVoteInPoll = 'removeVoteInPoll',
  residentDashboard = 'residentDashboard',
  rmUserPushNotification = 'rmUserPushNotification',
  searchSessions = 'searchSessions',
  sendResidentInvitations = 'sendResidentInvitations',
  setDevicePush = 'setDevicePush',
  setDocumentStatus = 'setDocumentStatus',
  setOffline = 'setOffline',
  setOnline = 'setOnline',
  unlinkWithSocial = 'unlinkWithSocial',
  updatePushNotification = 'updatePushNotification',
  verifyCode = 'verifyCode',
  verifyEmail = 'verifyEmail',
  verifyPhone = 'verifyPhone',
  voteInPoll = 'voteInPoll',
  waveHandlerUser = 'waveHandlerUser'
}

/**
 * The CommunityAdminOrder input type is used when sorting objects of the CommunityAdmin class.
 */
export enum GQLCommunityAdminOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Communities_ASC = 'Communities_ASC',
  Communities_DESC = 'Communities_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Configurations_ASC = 'Configurations_ASC',
  Configurations_DESC = 'Configurations_DESC',
  HelpCentre_ASC = 'HelpCentre_ASC',
  HelpCentre_DESC = 'HelpCentre_DESC',
  Listings_ASC = 'Listings_ASC',
  Listings_DESC = 'Listings_DESC',
  Members_ASC = 'Members_ASC',
  Members_DESC = 'Members_DESC',
  Promotions_ASC = 'Promotions_ASC',
  Promotions_DESC = 'Promotions_DESC',
  Requests_ASC = 'Requests_ASC',
  Requests_DESC = 'Requests_DESC',
  Settings_ASC = 'Settings_ASC',
  Settings_DESC = 'Settings_DESC',
  Transactions_ASC = 'Transactions_ASC',
  Transactions_DESC = 'Transactions_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The CommunityOrder input type is used when sorting objects of the Community class.
 */
export enum GQLCommunityOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Admins_ASC = 'Admins_ASC',
  Admins_DESC = 'Admins_DESC',
  Avatar_ASC = 'Avatar_ASC',
  Avatar_DESC = 'Avatar_DESC',
  Invitations_ASC = 'Invitations_ASC',
  Invitations_DESC = 'Invitations_DESC',
  Items_ASC = 'Items_ASC',
  Items_DESC = 'Items_DESC',
  JoinRequests_ASC = 'JoinRequests_ASC',
  JoinRequests_DESC = 'JoinRequests_DESC',
  Location_ASC = 'Location_ASC',
  Location_DESC = 'Location_DESC',
  Owner_ASC = 'Owner_ASC',
  Owner_DESC = 'Owner_DESC',
  Residents_ASC = 'Residents_ASC',
  Residents_DESC = 'Residents_DESC',
  Subscr_ASC = 'Subscr_ASC',
  Subscr_DESC = 'Subscr_DESC',
  accessType_ASC = 'accessType_ASC',
  accessType_DESC = 'accessType_DESC',
  address_ASC = 'address_ASC',
  address_DESC = 'address_DESC',
  address_add_ASC = 'address_add_ASC',
  address_add_DESC = 'address_add_DESC',
  alias_ASC = 'alias_ASC',
  alias_DESC = 'alias_DESC',
  allowChat_ASC = 'allowChat_ASC',
  allowChat_DESC = 'allowChat_DESC',
  allowEvents_ASC = 'allowEvents_ASC',
  allowEvents_DESC = 'allowEvents_DESC',
  allowPosts_ASC = 'allowPosts_ASC',
  allowPosts_DESC = 'allowPosts_DESC',
  buildings_ASC = 'buildings_ASC',
  buildings_DESC = 'buildings_DESC',
  checkList_ASC = 'checkList_ASC',
  checkList_DESC = 'checkList_DESC',
  countItems_ASC = 'countItems_ASC',
  countItems_DESC = 'countItems_DESC',
  countMembers_ASC = 'countMembers_ASC',
  countMembers_DESC = 'countMembers_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  identityData_ASC = 'identityData_ASC',
  identityData_DESC = 'identityData_DESC',
  invitation_ASC = 'invitation_ASC',
  invitation_DESC = 'invitation_DESC',
  isVerified_ASC = 'isVerified_ASC',
  isVerified_DESC = 'isVerified_DESC',
  listingApproval_ASC = 'listingApproval_ASC',
  listingApproval_DESC = 'listingApproval_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  neighbourhood_ASC = 'neighbourhood_ASC',
  neighbourhood_DESC = 'neighbourhood_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  options_ASC = 'options_ASC',
  options_DESC = 'options_DESC',
  passCode_ASC = 'passCode_ASC',
  passCode_DESC = 'passCode_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  totalMessages_ASC = 'totalMessages_ASC',
  totalMessages_DESC = 'totalMessages_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  units_ASC = 'units_ASC',
  units_DESC = 'units_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  zip_ASC = 'zip_ASC',
  zip_DESC = 'zip_DESC',
  zip_add_ASC = 'zip_add_ASC',
  zip_add_DESC = 'zip_add_DESC'
}

export enum GQLCompanyManageAction {
  feature = 'feature',
  interested = 'interested',
  publish = 'publish',
  unfeature = 'unfeature',
  unpublish = 'unpublish'
}

/**
 * The CompanyOrder input type is used when sorting objects of the Company class.
 */
export enum GQLCompanyOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Featured_ASC = 'Featured_ASC',
  Featured_DESC = 'Featured_DESC',
  Owner_ASC = 'Owner_ASC',
  Owner_DESC = 'Owner_DESC',
  Published_ASC = 'Published_ASC',
  Published_DESC = 'Published_DESC',
  Reports_ASC = 'Reports_ASC',
  Reports_DESC = 'Reports_DESC',
  Viewers_ASC = 'Viewers_ASC',
  Viewers_DESC = 'Viewers_DESC',
  category_ASC = 'category_ASC',
  category_DESC = 'category_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  images_ASC = 'images_ASC',
  images_DESC = 'images_DESC',
  interestedUsers_ASC = 'interestedUsers_ASC',
  interestedUsers_DESC = 'interestedUsers_DESC',
  isPublished_ASC = 'isPublished_ASC',
  isPublished_DESC = 'isPublished_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  phone_ASC = 'phone_ASC',
  phone_DESC = 'phone_DESC',
  promoCTA_ASC = 'promoCTA_ASC',
  promoCTA_DESC = 'promoCTA_DESC',
  promoDescr_ASC = 'promoDescr_ASC',
  promoDescr_DESC = 'promoDescr_DESC',
  promoTagline_ASC = 'promoTagline_ASC',
  promoTagline_DESC = 'promoTagline_DESC',
  promotion_ASC = 'promotion_ASC',
  promotion_DESC = 'promotion_DESC',
  revealCode_ASC = 'revealCode_ASC',
  revealCode_DESC = 'revealCode_DESC',
  sessionToken_ASC = 'sessionToken_ASC',
  sessionToken_DESC = 'sessionToken_DESC',
  totalClicks_ASC = 'totalClicks_ASC',
  totalClicks_DESC = 'totalClicks_DESC',
  totalViews_ASC = 'totalViews_ASC',
  totalViews_DESC = 'totalViews_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  visitedWebsite_ASC = 'visitedWebsite_ASC',
  visitedWebsite_DESC = 'visitedWebsite_DESC',
  website_ASC = 'website_ASC',
  website_DESC = 'website_DESC'
}

/**
 * The CurrencyOrder input type is used when sorting objects of the Currency class.
 */
export enum GQLCurrencyOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  code_ASC = 'code_ASC',
  code_DESC = 'code_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  sign_ASC = 'sign_ASC',
  sign_DESC = 'sign_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLDocumentActions {
  delete = 'delete',
  publish = 'publish',
  unlist = 'unlist'
}

/**
 * The DocumentOrder input type is used when sorting objects of the Document class.
 */
export enum GQLDocumentOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Cover_ASC = 'Cover_ASC',
  Cover_DESC = 'Cover_DESC',
  DocFile_ASC = 'DocFile_ASC',
  DocFile_DESC = 'DocFile_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  alias_ASC = 'alias_ASC',
  alias_DESC = 'alias_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isDeleted_ASC = 'isDeleted_ASC',
  isDeleted_DESC = 'isDeleted_DESC',
  isPublished_ASC = 'isPublished_ASC',
  isPublished_DESC = 'isPublished_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLEventManageAction {
  publish = 'publish',
  unpublish = 'unpublish'
}

/**
 * The EventOrder input type is used when sorting objects of the Event class.
 */
export enum GQLEventOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  AdmHidden_ASC = 'AdmHidden_ASC',
  AdmHidden_DESC = 'AdmHidden_DESC',
  ApproveReq_ASC = 'ApproveReq_ASC',
  ApproveReq_DESC = 'ApproveReq_DESC',
  Attendees_ASC = 'Attendees_ASC',
  Attendees_DESC = 'Attendees_DESC',
  Featured_ASC = 'Featured_ASC',
  Featured_DESC = 'Featured_DESC',
  Lister_ASC = 'Lister_ASC',
  Lister_DESC = 'Lister_DESC',
  Location_ASC = 'Location_ASC',
  Location_DESC = 'Location_DESC',
  Published_ASC = 'Published_ASC',
  Published_DESC = 'Published_DESC',
  Reports_ASC = 'Reports_ASC',
  Reports_DESC = 'Reports_DESC',
  Requests_ASC = 'Requests_ASC',
  Requests_DESC = 'Requests_DESC',
  Reviews_ASC = 'Reviews_ASC',
  Reviews_DESC = 'Reviews_DESC',
  Transactions_ASC = 'Transactions_ASC',
  Transactions_DESC = 'Transactions_DESC',
  Updated_ASC = 'Updated_ASC',
  Updated_DESC = 'Updated_DESC',
  Viewers_ASC = 'Viewers_ASC',
  Viewers_DESC = 'Viewers_DESC',
  allowGuests_ASC = 'allowGuests_ASC',
  allowGuests_DESC = 'allowGuests_DESC',
  countLikes_ASC = 'countLikes_ASC',
  countLikes_DESC = 'countLikes_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  endTime_ASC = 'endTime_ASC',
  endTime_DESC = 'endTime_DESC',
  eventType_ASC = 'eventType_ASC',
  eventType_DESC = 'eventType_DESC',
  expiresDate_ASC = 'expiresDate_ASC',
  expiresDate_DESC = 'expiresDate_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  images_ASC = 'images_ASC',
  images_DESC = 'images_DESC',
  isDeleted_ASC = 'isDeleted_ASC',
  isDeleted_DESC = 'isDeleted_DESC',
  isLike_ASC = 'isLike_ASC',
  isLike_DESC = 'isLike_DESC',
  isPublished_ASC = 'isPublished_ASC',
  isPublished_DESC = 'isPublished_DESC',
  likes_ASC = 'likes_ASC',
  likes_DESC = 'likes_DESC',
  listerReminded6am_ASC = 'listerReminded6am_ASC',
  listerReminded6am_DESC = 'listerReminded6am_DESC',
  listerReminded_ASC = 'listerReminded_ASC',
  listerReminded_DESC = 'listerReminded_DESC',
  locationDetails_ASC = 'locationDetails_ASC',
  locationDetails_DESC = 'locationDetails_DESC',
  maxAttendees_ASC = 'maxAttendees_ASC',
  maxAttendees_DESC = 'maxAttendees_DESC',
  maxGuestsPerAttendee_ASC = 'maxGuestsPerAttendee_ASC',
  maxGuestsPerAttendee_DESC = 'maxGuestsPerAttendee_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  openTo_ASC = 'openTo_ASC',
  openTo_DESC = 'openTo_DESC',
  pricePeriod_ASC = 'pricePeriod_ASC',
  pricePeriod_DESC = 'pricePeriod_DESC',
  rating_ASC = 'rating_ASC',
  rating_DESC = 'rating_DESC',
  rewardType_ASC = 'rewardType_ASC',
  rewardType_DESC = 'rewardType_DESC',
  showAttendees_ASC = 'showAttendees_ASC',
  showAttendees_DESC = 'showAttendees_DESC',
  startTime_ASC = 'startTime_ASC',
  startTime_DESC = 'startTime_DESC',
  totalAttendees_ASC = 'totalAttendees_ASC',
  totalAttendees_DESC = 'totalAttendees_DESC',
  totalViews_ASC = 'totalViews_ASC',
  totalViews_DESC = 'totalViews_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLGroupManageAction {
  feature = 'feature',
  unfeature = 'unfeature'
}

/**
 * The GroupOrder input type is used when sorting objects of the Group class.
 */
export enum GQLGroupOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Avatar_ASC = 'Avatar_ASC',
  Avatar_DESC = 'Avatar_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Featured_ASC = 'Featured_ASC',
  Featured_DESC = 'Featured_DESC',
  Members_ASC = 'Members_ASC',
  Members_DESC = 'Members_DESC',
  alias_ASC = 'alias_ASC',
  alias_DESC = 'alias_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isDeleted_ASC = 'isDeleted_ASC',
  isDeleted_DESC = 'isDeleted_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The HelpDeskOrder input type is used when sorting objects of the HelpDesk class.
 */
export enum GQLHelpDeskOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Assignee_ASC = 'Assignee_ASC',
  Assignee_DESC = 'Assignee_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  assignTo_ASC = 'assignTo_ASC',
  assignTo_DESC = 'assignTo_DESC',
  buttonTitle_ASC = 'buttonTitle_ASC',
  buttonTitle_DESC = 'buttonTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  dailyQuoteAuthor_ASC = 'dailyQuoteAuthor_ASC',
  dailyQuoteAuthor_DESC = 'dailyQuoteAuthor_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isDeleted_ASC = 'isDeleted_ASC',
  isDeleted_DESC = 'isDeleted_DESC',
  isPublished_ASC = 'isPublished_ASC',
  isPublished_DESC = 'isPublished_DESC',
  layOutOrder_ASC = 'layOutOrder_ASC',
  layOutOrder_DESC = 'layOutOrder_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The InstallationOrder input type is used when sorting objects of the Installation class.
 */
export enum GQLInstallationOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  GCMSenderId_ASC = 'GCMSenderId_ASC',
  GCMSenderId_DESC = 'GCMSenderId_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  appIdentifier_ASC = 'appIdentifier_ASC',
  appIdentifier_DESC = 'appIdentifier_DESC',
  appName_ASC = 'appName_ASC',
  appName_DESC = 'appName_DESC',
  appVersion_ASC = 'appVersion_ASC',
  appVersion_DESC = 'appVersion_DESC',
  badge_ASC = 'badge_ASC',
  badge_DESC = 'badge_DESC',
  channels_ASC = 'channels_ASC',
  channels_DESC = 'channels_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  deviceToken_ASC = 'deviceToken_ASC',
  deviceToken_DESC = 'deviceToken_DESC',
  deviceType_ASC = 'deviceType_ASC',
  deviceType_DESC = 'deviceType_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  installationId_ASC = 'installationId_ASC',
  installationId_DESC = 'installationId_DESC',
  localeIdentifier_ASC = 'localeIdentifier_ASC',
  localeIdentifier_DESC = 'localeIdentifier_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  parseVersion_ASC = 'parseVersion_ASC',
  parseVersion_DESC = 'parseVersion_DESC',
  pushType_ASC = 'pushType_ASC',
  pushType_DESC = 'pushType_DESC',
  timeZone_ASC = 'timeZone_ASC',
  timeZone_DESC = 'timeZone_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The InvitationOrder input type is used when sorting objects of the Invitation class.
 */
export enum GQLInvitationOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  emailText_ASC = 'emailText_ASC',
  emailText_DESC = 'emailText_DESC',
  email_ASC = 'email_ASC',
  email_DESC = 'email_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  invLink_ASC = 'invLink_ASC',
  invLink_DESC = 'invLink_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The ItemBookingOrder input type is used when sorting objects of the ItemBooking class.
 */
export enum GQLItemBookingOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Item_ASC = 'Item_ASC',
  Item_DESC = 'Item_DESC',
  Order_ASC = 'Order_ASC',
  Order_DESC = 'Order_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  from_ASC = 'from_ASC',
  from_DESC = 'from_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  to_ASC = 'to_ASC',
  to_DESC = 'to_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The ItemOrder input type is used when sorting objects of the Item class.
 */
export enum GQLItemOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  AdmHidden_ASC = 'AdmHidden_ASC',
  AdmHidden_DESC = 'AdmHidden_DESC',
  ApproveReq_ASC = 'ApproveReq_ASC',
  ApproveReq_DESC = 'ApproveReq_DESC',
  Featured_ASC = 'Featured_ASC',
  Featured_DESC = 'Featured_DESC',
  Lister_ASC = 'Lister_ASC',
  Lister_DESC = 'Lister_DESC',
  Location_ASC = 'Location_ASC',
  Location_DESC = 'Location_DESC',
  Published_ASC = 'Published_ASC',
  Published_DESC = 'Published_DESC',
  Reports_ASC = 'Reports_ASC',
  Reports_DESC = 'Reports_DESC',
  Requests_ASC = 'Requests_ASC',
  Requests_DESC = 'Requests_DESC',
  Reviews_ASC = 'Reviews_ASC',
  Reviews_DESC = 'Reviews_DESC',
  Transactions_ASC = 'Transactions_ASC',
  Transactions_DESC = 'Transactions_DESC',
  Updated_ASC = 'Updated_ASC',
  Updated_DESC = 'Updated_DESC',
  Viewers_ASC = 'Viewers_ASC',
  Viewers_DESC = 'Viewers_DESC',
  category_ASC = 'category_ASC',
  category_DESC = 'category_DESC',
  countLikes_ASC = 'countLikes_ASC',
  countLikes_DESC = 'countLikes_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  createdAt_custom_ASC = 'createdAt_custom_ASC',
  createdAt_custom_DESC = 'createdAt_custom_DESC',
  data_ASC = 'data_ASC',
  data_DESC = 'data_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  discountType_ASC = 'discountType_ASC',
  discountType_DESC = 'discountType_DESC',
  discount_ASC = 'discount_ASC',
  discount_DESC = 'discount_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  images_ASC = 'images_ASC',
  images_DESC = 'images_DESC',
  income_ASC = 'income_ASC',
  income_DESC = 'income_DESC',
  isDeleted_ASC = 'isDeleted_ASC',
  isDeleted_DESC = 'isDeleted_DESC',
  isLike_ASC = 'isLike_ASC',
  isLike_DESC = 'isLike_DESC',
  isPublished_ASC = 'isPublished_ASC',
  isPublished_DESC = 'isPublished_DESC',
  isSold_ASC = 'isSold_ASC',
  isSold_DESC = 'isSold_DESC',
  likes_ASC = 'likes_ASC',
  likes_DESC = 'likes_DESC',
  listingType_ASC = 'listingType_ASC',
  listingType_DESC = 'listingType_DESC',
  maxPeriod_ASC = 'maxPeriod_ASC',
  maxPeriod_DESC = 'maxPeriod_DESC',
  minDuration_ASC = 'minDuration_ASC',
  minDuration_DESC = 'minDuration_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  originalPrice_ASC = 'originalPrice_ASC',
  originalPrice_DESC = 'originalPrice_DESC',
  pricePeriod_ASC = 'pricePeriod_ASC',
  pricePeriod_DESC = 'pricePeriod_DESC',
  price_ASC = 'price_ASC',
  price_DESC = 'price_DESC',
  rating_ASC = 'rating_ASC',
  rating_DESC = 'rating_DESC',
  rewardType_ASC = 'rewardType_ASC',
  rewardType_DESC = 'rewardType_DESC',
  sessionToken_ASC = 'sessionToken_ASC',
  sessionToken_DESC = 'sessionToken_DESC',
  totalCompletedOrders_ASC = 'totalCompletedOrders_ASC',
  totalCompletedOrders_DESC = 'totalCompletedOrders_DESC',
  totalRequests_ASC = 'totalRequests_ASC',
  totalRequests_DESC = 'totalRequests_DESC',
  totalViews_ASC = 'totalViews_ASC',
  totalViews_DESC = 'totalViews_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  yearPurchased_ASC = 'yearPurchased_ASC',
  yearPurchased_DESC = 'yearPurchased_DESC'
}

/**
 * The JoinRequestOrder input type is used when sorting objects of the JoinRequest class.
 */
export enum GQLJoinRequestOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Invitation_ASC = 'Invitation_ASC',
  Invitation_DESC = 'Invitation_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  answer_ASC = 'answer_ASC',
  answer_DESC = 'answer_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  request_ASC = 'request_ASC',
  request_DESC = 'request_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The LanguageOrder input type is used when sorting objects of the Language class.
 */
export enum GQLLanguageOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  code_ASC = 'code_ASC',
  code_DESC = 'code_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isDisabled_ASC = 'isDisabled_ASC',
  isDisabled_DESC = 'isDisabled_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLListingType {
  rent = 'rent',
  sell = 'sell',
  service = 'service'
}

/**
 * The LocationOrder input type is used when sorting objects of the Location class.
 */
export enum GQLLocationOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  City_ASC = 'City_ASC',
  City_DESC = 'City_DESC',
  Country_ASC = 'Country_ASC',
  Country_DESC = 'Country_DESC',
  State_ASC = 'State_ASC',
  State_DESC = 'State_DESC',
  code_ASC = 'code_ASC',
  code_DESC = 'code_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  geo_ASC = 'geo_ASC',
  geo_DESC = 'geo_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isDisabled_ASC = 'isDisabled_ASC',
  isDisabled_DESC = 'isDisabled_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLManagerChartTypes {
  averageRating = 'averageRating',
  listingValue = 'listingValue',
  listings = 'listings',
  loopPosts = 'loopPosts',
  members = 'members',
  postLikes = 'postLikes',
  transactionValue = 'transactionValue',
  transactions = 'transactions'
}

/**
 * The MessageOrder input type is used when sorting objects of the Message class.
 */
export enum GQLMessageOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Attachments_ASC = 'Attachments_ASC',
  Attachments_DESC = 'Attachments_DESC',
  Author_ASC = 'Author_ASC',
  Author_DESC = 'Author_DESC',
  Chat_ASC = 'Chat_ASC',
  Chat_DESC = 'Chat_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Order_ASC = 'Order_ASC',
  Order_DESC = 'Order_DESC',
  Seen_ASC = 'Seen_ASC',
  Seen_DESC = 'Seen_DESC',
  ShowTo_ASC = 'ShowTo_ASC',
  ShowTo_DESC = 'ShowTo_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  localRef_ASC = 'localRef_ASC',
  localRef_DESC = 'localRef_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  supportMsgStatus_ASC = 'supportMsgStatus_ASC',
  supportMsgStatus_DESC = 'supportMsgStatus_DESC',
  text_ASC = 'text_ASC',
  text_DESC = 'text_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The MyClassOrder input type is used when sorting objects of the MyClass class.
 */
export enum GQLMyClassOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  myField_ASC = 'myField_ASC',
  myField_DESC = 'myField_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The NotifSendingOrder input type is used when sorting objects of the NotifSending class.
 */
export enum GQLNotifSendingOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  amenityAutoBookedEmailSent_ASC = 'amenityAutoBookedEmailSent_ASC',
  amenityAutoBookedEmailSent_DESC = 'amenityAutoBookedEmailSent_DESC',
  amenityAutoBookedSmsSent_ASC = 'amenityAutoBookedSmsSent_ASC',
  amenityAutoBookedSmsSent_DESC = 'amenityAutoBookedSmsSent_DESC',
  amenityCanceledListerEmailSent_ASC = 'amenityCanceledListerEmailSent_ASC',
  amenityCanceledListerEmailSent_DESC = 'amenityCanceledListerEmailSent_DESC',
  amenityCanceledListerSmsSent_ASC = 'amenityCanceledListerSmsSent_ASC',
  amenityCanceledListerSmsSent_DESC = 'amenityCanceledListerSmsSent_DESC',
  amenityCanceledRequesterEmailSent_ASC = 'amenityCanceledRequesterEmailSent_ASC',
  amenityCanceledRequesterEmailSent_DESC = 'amenityCanceledRequesterEmailSent_DESC',
  amenityCanceledRequesterSmsSent_ASC = 'amenityCanceledRequesterSmsSent_ASC',
  amenityCanceledRequesterSmsSent_DESC = 'amenityCanceledRequesterSmsSent_DESC',
  amenityConfirmationEmailSent_ASC = 'amenityConfirmationEmailSent_ASC',
  amenityConfirmationEmailSent_DESC = 'amenityConfirmationEmailSent_DESC',
  amenityConfirmationSmsSent_ASC = 'amenityConfirmationSmsSent_ASC',
  amenityConfirmationSmsSent_DESC = 'amenityConfirmationSmsSent_DESC',
  amenityOrderBookedEmailSent_ASC = 'amenityOrderBookedEmailSent_ASC',
  amenityOrderBookedEmailSent_DESC = 'amenityOrderBookedEmailSent_DESC',
  amenityOrderBookedSmsSent_ASC = 'amenityOrderBookedSmsSent_ASC',
  amenityOrderBookedSmsSent_DESC = 'amenityOrderBookedSmsSent_DESC',
  amenityOrderCanceledEmailSent_ASC = 'amenityOrderCanceledEmailSent_ASC',
  amenityOrderCanceledEmailSent_DESC = 'amenityOrderCanceledEmailSent_DESC',
  amenityOrderCanceledSmsSent_ASC = 'amenityOrderCanceledSmsSent_ASC',
  amenityOrderCanceledSmsSent_DESC = 'amenityOrderCanceledSmsSent_DESC',
  amenityOrderPendingEmailSent_ASC = 'amenityOrderPendingEmailSent_ASC',
  amenityOrderPendingEmailSent_DESC = 'amenityOrderPendingEmailSent_DESC',
  amenityOrderPendingSmsSent_ASC = 'amenityOrderPendingSmsSent_ASC',
  amenityOrderPendingSmsSent_DESC = 'amenityOrderPendingSmsSent_DESC',
  amenityReminderEmailSent_ASC = 'amenityReminderEmailSent_ASC',
  amenityReminderEmailSent_DESC = 'amenityReminderEmailSent_DESC',
  amenityReminderPushSent_ASC = 'amenityReminderPushSent_ASC',
  amenityReminderPushSent_DESC = 'amenityReminderPushSent_DESC',
  amenityReminderSmsSent_ASC = 'amenityReminderSmsSent_ASC',
  amenityReminderSmsSent_DESC = 'amenityReminderSmsSent_DESC',
  amenityRequestEmailSent_ASC = 'amenityRequestEmailSent_ASC',
  amenityRequestEmailSent_DESC = 'amenityRequestEmailSent_DESC',
  amenityRequestSmsSent_ASC = 'amenityRequestSmsSent_ASC',
  amenityRequestSmsSent_DESC = 'amenityRequestSmsSent_DESC',
  blockUserEmailSent_ASC = 'blockUserEmailSent_ASC',
  blockUserEmailSent_DESC = 'blockUserEmailSent_DESC',
  blockUserSmsSent_ASC = 'blockUserSmsSent_ASC',
  blockUserSmsSent_DESC = 'blockUserSmsSent_DESC',
  companyReportedEmailSent_ASC = 'companyReportedEmailSent_ASC',
  companyReportedEmailSent_DESC = 'companyReportedEmailSent_DESC',
  companyReportedSmsSent_ASC = 'companyReportedSmsSent_ASC',
  companyReportedSmsSent_DESC = 'companyReportedSmsSent_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  eventAttendeesEmailSent_ASC = 'eventAttendeesEmailSent_ASC',
  eventAttendeesEmailSent_DESC = 'eventAttendeesEmailSent_DESC',
  eventAttendeesPushSent_ASC = 'eventAttendeesPushSent_ASC',
  eventAttendeesPushSent_DESC = 'eventAttendeesPushSent_DESC',
  eventAttendeesSmsSent_ASC = 'eventAttendeesSmsSent_ASC',
  eventAttendeesSmsSent_DESC = 'eventAttendeesSmsSent_DESC',
  eventOrderAttendingEmailSent_ASC = 'eventOrderAttendingEmailSent_ASC',
  eventOrderAttendingEmailSent_DESC = 'eventOrderAttendingEmailSent_DESC',
  eventOrderAttendingSmsSent_ASC = 'eventOrderAttendingSmsSent_ASC',
  eventOrderAttendingSmsSent_DESC = 'eventOrderAttendingSmsSent_DESC',
  eventOrderCanceledEmailSent_ASC = 'eventOrderCanceledEmailSent_ASC',
  eventOrderCanceledEmailSent_DESC = 'eventOrderCanceledEmailSent_DESC',
  eventOrderCanceledSmsSent_ASC = 'eventOrderCanceledSmsSent_ASC',
  eventOrderCanceledSmsSent_DESC = 'eventOrderCanceledSmsSent_DESC',
  eventOrderPendingEmailSent_ASC = 'eventOrderPendingEmailSent_ASC',
  eventOrderPendingEmailSent_DESC = 'eventOrderPendingEmailSent_DESC',
  eventOrderPendingSmsSent_ASC = 'eventOrderPendingSmsSent_ASC',
  eventOrderPendingSmsSent_DESC = 'eventOrderPendingSmsSent_DESC',
  eventReminderEmailSent_ASC = 'eventReminderEmailSent_ASC',
  eventReminderEmailSent_DESC = 'eventReminderEmailSent_DESC',
  eventReminderPushSent_ASC = 'eventReminderPushSent_ASC',
  eventReminderPushSent_DESC = 'eventReminderPushSent_DESC',
  eventReminderSmsSent_ASC = 'eventReminderSmsSent_ASC',
  eventReminderSmsSent_DESC = 'eventReminderSmsSent_DESC',
  eventReportedEmailSent_ASC = 'eventReportedEmailSent_ASC',
  eventReportedEmailSent_DESC = 'eventReportedEmailSent_DESC',
  eventReportedSmsSent_ASC = 'eventReportedSmsSent_ASC',
  eventReportedSmsSent_DESC = 'eventReportedSmsSent_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  itemReviewEmailSent_ASC = 'itemReviewEmailSent_ASC',
  itemReviewEmailSent_DESC = 'itemReviewEmailSent_DESC',
  itemReviewSmsSent_ASC = 'itemReviewSmsSent_ASC',
  itemReviewSmsSent_DESC = 'itemReviewSmsSent_DESC',
  itemViewEmailSent_ASC = 'itemViewEmailSent_ASC',
  itemViewEmailSent_DESC = 'itemViewEmailSent_DESC',
  itemViewPushSent_ASC = 'itemViewPushSent_ASC',
  itemViewPushSent_DESC = 'itemViewPushSent_DESC',
  itemViewSmsSent_ASC = 'itemViewSmsSent_ASC',
  itemViewSmsSent_DESC = 'itemViewSmsSent_DESC',
  joinCommunitySmsSent_ASC = 'joinCommunitySmsSent_ASC',
  joinCommunitySmsSent_DESC = 'joinCommunitySmsSent_DESC',
  joinRequestEmailSent_ASC = 'joinRequestEmailSent_ASC',
  joinRequestEmailSent_DESC = 'joinRequestEmailSent_DESC',
  listingApprovedEmailSent_ASC = 'listingApprovedEmailSent_ASC',
  listingApprovedEmailSent_DESC = 'listingApprovedEmailSent_DESC',
  listingApprovedSmsSent_ASC = 'listingApprovedSmsSent_ASC',
  listingApprovedSmsSent_DESC = 'listingApprovedSmsSent_DESC',
  listingPublishRequestEmailSent_ASC = 'listingPublishRequestEmailSent_ASC',
  listingPublishRequestEmailSent_DESC = 'listingPublishRequestEmailSent_DESC',
  listingPublishRequestPushSent_ASC = 'listingPublishRequestPushSent_ASC',
  listingPublishRequestPushSent_DESC = 'listingPublishRequestPushSent_DESC',
  listingPublishRequestSmsSent_ASC = 'listingPublishRequestSmsSent_ASC',
  listingPublishRequestSmsSent_DESC = 'listingPublishRequestSmsSent_DESC',
  listingRemovedEmailSent_ASC = 'listingRemovedEmailSent_ASC',
  listingRemovedEmailSent_DESC = 'listingRemovedEmailSent_DESC',
  listingRemovedSmsSent_ASC = 'listingRemovedSmsSent_ASC',
  listingRemovedSmsSent_DESC = 'listingRemovedSmsSent_DESC',
  listingRemovedSmsSmsSent_ASC = 'listingRemovedSmsSmsSent_ASC',
  listingRemovedSmsSmsSent_DESC = 'listingRemovedSmsSmsSent_DESC',
  managedAmenitiesEmailSent_ASC = 'managedAmenitiesEmailSent_ASC',
  managedAmenitiesEmailSent_DESC = 'managedAmenitiesEmailSent_DESC',
  managedAmenitiesPushSent_ASC = 'managedAmenitiesPushSent_ASC',
  managedAmenitiesPushSent_DESC = 'managedAmenitiesPushSent_DESC',
  managedAmenitiesSmsSent_ASC = 'managedAmenitiesSmsSent_ASC',
  managedAmenitiesSmsSent_DESC = 'managedAmenitiesSmsSent_DESC',
  newCommentEmailSent_ASC = 'newCommentEmailSent_ASC',
  newCommentEmailSent_DESC = 'newCommentEmailSent_DESC',
  newCommentInGroupEmailSent_ASC = 'newCommentInGroupEmailSent_ASC',
  newCommentInGroupEmailSent_DESC = 'newCommentInGroupEmailSent_DESC',
  newCommentPollEmailSent_ASC = 'newCommentPollEmailSent_ASC',
  newCommentPollEmailSent_DESC = 'newCommentPollEmailSent_DESC',
  newCommentPushSent_ASC = 'newCommentPushSent_ASC',
  newCommentPushSent_DESC = 'newCommentPushSent_DESC',
  newCommentSmsSent_ASC = 'newCommentSmsSent_ASC',
  newCommentSmsSent_DESC = 'newCommentSmsSent_DESC',
  newJoinLikeEmailSent_ASC = 'newJoinLikeEmailSent_ASC',
  newJoinLikeEmailSent_DESC = 'newJoinLikeEmailSent_DESC',
  newJoinLikePushSent_ASC = 'newJoinLikePushSent_ASC',
  newJoinLikePushSent_DESC = 'newJoinLikePushSent_DESC',
  newJoinLikeSmsSent_ASC = 'newJoinLikeSmsSent_ASC',
  newJoinLikeSmsSent_DESC = 'newJoinLikeSmsSent_DESC',
  newJoinSmileEmailSent_ASC = 'newJoinSmileEmailSent_ASC',
  newJoinSmileEmailSent_DESC = 'newJoinSmileEmailSent_DESC',
  newJoinSmilePushSent_ASC = 'newJoinSmilePushSent_ASC',
  newJoinSmilePushSent_DESC = 'newJoinSmilePushSent_DESC',
  newJoinSmileSmsSent_ASC = 'newJoinSmileSmsSent_ASC',
  newJoinSmileSmsSent_DESC = 'newJoinSmileSmsSent_DESC',
  newJoinWaveEmailSent_ASC = 'newJoinWaveEmailSent_ASC',
  newJoinWaveEmailSent_DESC = 'newJoinWaveEmailSent_DESC',
  newJoinWavePushSent_ASC = 'newJoinWavePushSent_ASC',
  newJoinWavePushSent_DESC = 'newJoinWavePushSent_DESC',
  newJoinWaveSmsSent_ASC = 'newJoinWaveSmsSent_ASC',
  newJoinWaveSmsSent_DESC = 'newJoinWaveSmsSent_DESC',
  newLikeEmailSent_ASC = 'newLikeEmailSent_ASC',
  newLikeEmailSent_DESC = 'newLikeEmailSent_DESC',
  newLikePollEmailSent_ASC = 'newLikePollEmailSent_ASC',
  newLikePollEmailSent_DESC = 'newLikePollEmailSent_DESC',
  newLikePushSent_ASC = 'newLikePushSent_ASC',
  newLikePushSent_DESC = 'newLikePushSent_DESC',
  newLikeSmsSent_ASC = 'newLikeSmsSent_ASC',
  newLikeSmsSent_DESC = 'newLikeSmsSent_DESC',
  newListingEmailSent_ASC = 'newListingEmailSent_ASC',
  newListingEmailSent_DESC = 'newListingEmailSent_DESC',
  newListingPushSent_ASC = 'newListingPushSent_ASC',
  newListingPushSent_DESC = 'newListingPushSent_DESC',
  newListingSmsSent_ASC = 'newListingSmsSent_ASC',
  newListingSmsSent_DESC = 'newListingSmsSent_DESC',
  newManagerAdminPostEmailSent_ASC = 'newManagerAdminPostEmailSent_ASC',
  newManagerAdminPostEmailSent_DESC = 'newManagerAdminPostEmailSent_DESC',
  newManagerAdminPostPushSent_ASC = 'newManagerAdminPostPushSent_ASC',
  newManagerAdminPostPushSent_DESC = 'newManagerAdminPostPushSent_DESC',
  newManagerAdminPostSmsSent_ASC = 'newManagerAdminPostSmsSent_ASC',
  newManagerAdminPostSmsSent_DESC = 'newManagerAdminPostSmsSent_DESC',
  newMessageEmailSent_ASC = 'newMessageEmailSent_ASC',
  newMessageEmailSent_DESC = 'newMessageEmailSent_DESC',
  newMessagePushSent_ASC = 'newMessagePushSent_ASC',
  newMessagePushSent_DESC = 'newMessagePushSent_DESC',
  newMessageSmsSent_ASC = 'newMessageSmsSent_ASC',
  newMessageSmsSent_DESC = 'newMessageSmsSent_DESC',
  newNoticeEmailSent_ASC = 'newNoticeEmailSent_ASC',
  newNoticeEmailSent_DESC = 'newNoticeEmailSent_DESC',
  newNoticeSmsSent_ASC = 'newNoticeSmsSent_ASC',
  newNoticeSmsSent_DESC = 'newNoticeSmsSent_DESC',
  newPostEmailSent_ASC = 'newPostEmailSent_ASC',
  newPostEmailSent_DESC = 'newPostEmailSent_DESC',
  newPostPushSent_ASC = 'newPostPushSent_ASC',
  newPostPushSent_DESC = 'newPostPushSent_DESC',
  newPostSmsSent_ASC = 'newPostSmsSent_ASC',
  newPostSmsSent_DESC = 'newPostSmsSent_DESC',
  newResidentEmailSent_ASC = 'newResidentEmailSent_ASC',
  newResidentEmailSent_DESC = 'newResidentEmailSent_DESC',
  newResidentPushSent_ASC = 'newResidentPushSent_ASC',
  newResidentPushSent_DESC = 'newResidentPushSent_DESC',
  newResidentSmsSent_ASC = 'newResidentSmsSent_ASC',
  newResidentSmsSent_DESC = 'newResidentSmsSent_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  orderBuyAcceptedEmailSent_ASC = 'orderBuyAcceptedEmailSent_ASC',
  orderBuyAcceptedEmailSent_DESC = 'orderBuyAcceptedEmailSent_DESC',
  orderBuyAcceptedSmsSent_ASC = 'orderBuyAcceptedSmsSent_ASC',
  orderBuyAcceptedSmsSent_DESC = 'orderBuyAcceptedSmsSent_DESC',
  orderBuyRejectedEmailSent_ASC = 'orderBuyRejectedEmailSent_ASC',
  orderBuyRejectedEmailSent_DESC = 'orderBuyRejectedEmailSent_DESC',
  orderBuyRejectedSmsSent_ASC = 'orderBuyRejectedSmsSent_ASC',
  orderBuyRejectedSmsSent_DESC = 'orderBuyRejectedSmsSent_DESC',
  orderRentAcceptedEmailSent_ASC = 'orderRentAcceptedEmailSent_ASC',
  orderRentAcceptedEmailSent_DESC = 'orderRentAcceptedEmailSent_DESC',
  orderRentAcceptedSmsSent_ASC = 'orderRentAcceptedSmsSent_ASC',
  orderRentAcceptedSmsSent_DESC = 'orderRentAcceptedSmsSent_DESC',
  orderRentRejectedEmailSent_ASC = 'orderRentRejectedEmailSent_ASC',
  orderRentRejectedEmailSent_DESC = 'orderRentRejectedEmailSent_DESC',
  orderRentRejectedSmsSent_ASC = 'orderRentRejectedSmsSent_ASC',
  orderRentRejectedSmsSent_DESC = 'orderRentRejectedSmsSent_DESC',
  orderRequestEmailSent_ASC = 'orderRequestEmailSent_ASC',
  orderRequestEmailSent_DESC = 'orderRequestEmailSent_DESC',
  orderRequestSmsSent_ASC = 'orderRequestSmsSent_ASC',
  orderRequestSmsSent_DESC = 'orderRequestSmsSent_DESC',
  orderServiceAcceptedEmailSent_ASC = 'orderServiceAcceptedEmailSent_ASC',
  orderServiceAcceptedEmailSent_DESC = 'orderServiceAcceptedEmailSent_DESC',
  orderServiceAcceptedSmsSent_ASC = 'orderServiceAcceptedSmsSent_ASC',
  orderServiceAcceptedSmsSent_DESC = 'orderServiceAcceptedSmsSent_DESC',
  orderServiceRejectedEmailSent_ASC = 'orderServiceRejectedEmailSent_ASC',
  orderServiceRejectedEmailSent_DESC = 'orderServiceRejectedEmailSent_DESC',
  orderServiceRejectedSmsSent_ASC = 'orderServiceRejectedSmsSent_ASC',
  orderServiceRejectedSmsSent_DESC = 'orderServiceRejectedSmsSent_DESC',
  rejectedRequestEmailSent_ASC = 'rejectedRequestEmailSent_ASC',
  rejectedRequestEmailSent_DESC = 'rejectedRequestEmailSent_DESC',
  reportListingEmailSent_ASC = 'reportListingEmailSent_ASC',
  reportListingEmailSent_DESC = 'reportListingEmailSent_DESC',
  reportListingSmsSent_ASC = 'reportListingSmsSent_ASC',
  reportListingSmsSent_DESC = 'reportListingSmsSent_DESC',
  reportPostEmailSent_ASC = 'reportPostEmailSent_ASC',
  reportPostEmailSent_DESC = 'reportPostEmailSent_DESC',
  reportPostSmsSent_ASC = 'reportPostSmsSent_ASC',
  reportPostSmsSent_DESC = 'reportPostSmsSent_DESC',
  reportUserEmailSent_ASC = 'reportUserEmailSent_ASC',
  reportUserEmailSent_DESC = 'reportUserEmailSent_DESC',
  reportUserSmsSent_ASC = 'reportUserSmsSent_ASC',
  reportUserSmsSent_DESC = 'reportUserSmsSent_DESC',
  residentRemovedEmailSent_ASC = 'residentRemovedEmailSent_ASC',
  residentRemovedEmailSent_DESC = 'residentRemovedEmailSent_DESC',
  residentRemovedSmsSent_ASC = 'residentRemovedSmsSent_ASC',
  residentRemovedSmsSent_DESC = 'residentRemovedSmsSent_DESC',
  unmanagedAmenitiesEmailSent_ASC = 'unmanagedAmenitiesEmailSent_ASC',
  unmanagedAmenitiesEmailSent_DESC = 'unmanagedAmenitiesEmailSent_DESC',
  unmanagedAmenitiesPushSent_ASC = 'unmanagedAmenitiesPushSent_ASC',
  unmanagedAmenitiesPushSent_DESC = 'unmanagedAmenitiesPushSent_DESC',
  unmanagedAmenitiesSmsSent_ASC = 'unmanagedAmenitiesSmsSent_ASC',
  unmanagedAmenitiesSmsSent_DESC = 'unmanagedAmenitiesSmsSent_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userViewEmailSent_ASC = 'userViewEmailSent_ASC',
  userViewEmailSent_DESC = 'userViewEmailSent_DESC',
  userViewPushSent_ASC = 'userViewPushSent_ASC',
  userViewPushSent_DESC = 'userViewPushSent_DESC',
  userViewSmsSent_ASC = 'userViewSmsSent_ASC',
  userViewSmsSent_DESC = 'userViewSmsSent_DESC'
}

/**
 * The NotificationOrder input type is used when sorting objects of the Notification class.
 */
export enum GQLNotificationOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  data_ASC = 'data_ASC',
  data_DESC = 'data_DESC',
  event_ASC = 'event_ASC',
  event_DESC = 'event_DESC',
  from_ASC = 'from_ASC',
  from_DESC = 'from_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  notifTypes_ASC = 'notifTypes_ASC',
  notifTypes_DESC = 'notifTypes_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  seenDate_ASC = 'seenDate_ASC',
  seenDate_DESC = 'seenDate_DESC',
  sendAt_ASC = 'sendAt_ASC',
  sendAt_DESC = 'sendAt_DESC',
  sentIn_ASC = 'sentIn_ASC',
  sentIn_DESC = 'sentIn_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  to_ASC = 'to_ASC',
  to_DESC = 'to_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The OrderOrder input type is used when sorting objects of the Order class.
 */
export enum GQLOrderOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Amenity_ASC = 'Amenity_ASC',
  Amenity_DESC = 'Amenity_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Currency_ASC = 'Currency_ASC',
  Currency_DESC = 'Currency_DESC',
  Event_ASC = 'Event_ASC',
  Event_DESC = 'Event_DESC',
  Item_ASC = 'Item_ASC',
  Item_DESC = 'Item_DESC',
  Lister_ASC = 'Lister_ASC',
  Lister_DESC = 'Lister_DESC',
  Location_ASC = 'Location_ASC',
  Location_DESC = 'Location_DESC',
  Requester_ASC = 'Requester_ASC',
  Requester_DESC = 'Requester_DESC',
  acceptedByLister_ASC = 'acceptedByLister_ASC',
  acceptedByLister_DESC = 'acceptedByLister_DESC',
  acceptedByRequester_ASC = 'acceptedByRequester_ASC',
  acceptedByRequester_DESC = 'acceptedByRequester_DESC',
  attendeeGuests_ASC = 'attendeeGuests_ASC',
  attendeeGuests_DESC = 'attendeeGuests_DESC',
  cfListerAbs_ASC = 'cfListerAbs_ASC',
  cfListerAbs_DESC = 'cfListerAbs_DESC',
  cfListerAmt_ASC = 'cfListerAmt_ASC',
  cfListerAmt_DESC = 'cfListerAmt_DESC',
  cfListerPrc_ASC = 'cfListerPrc_ASC',
  cfListerPrc_DESC = 'cfListerPrc_DESC',
  cfRequesterAbs_ASC = 'cfRequesterAbs_ASC',
  cfRequesterAbs_DESC = 'cfRequesterAbs_DESC',
  cfRequesterAmt_ASC = 'cfRequesterAmt_ASC',
  cfRequesterAmt_DESC = 'cfRequesterAmt_DESC',
  cfRequesterPrc_ASC = 'cfRequesterPrc_ASC',
  cfRequesterPrc_DESC = 'cfRequesterPrc_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  discountAmount_ASC = 'discountAmount_ASC',
  discountAmount_DESC = 'discountAmount_DESC',
  discountType_ASC = 'discountType_ASC',
  discountType_DESC = 'discountType_DESC',
  discount_ASC = 'discount_ASC',
  discount_DESC = 'discount_DESC',
  endTime_ASC = 'endTime_ASC',
  endTime_DESC = 'endTime_DESC',
  externalPayments_ASC = 'externalPayments_ASC',
  externalPayments_DESC = 'externalPayments_DESC',
  hangehDiscount_ASC = 'hangehDiscount_ASC',
  hangehDiscount_DESC = 'hangehDiscount_DESC',
  hfListerAbs_ASC = 'hfListerAbs_ASC',
  hfListerAbs_DESC = 'hfListerAbs_DESC',
  hfListerAmt_ASC = 'hfListerAmt_ASC',
  hfListerAmt_DESC = 'hfListerAmt_DESC',
  hfListerPrc_ASC = 'hfListerPrc_ASC',
  hfListerPrc_DESC = 'hfListerPrc_DESC',
  hfRequesterAbs_ASC = 'hfRequesterAbs_ASC',
  hfRequesterAbs_DESC = 'hfRequesterAbs_DESC',
  hfRequesterAmt_ASC = 'hfRequesterAmt_ASC',
  hfRequesterAmt_DESC = 'hfRequesterAmt_DESC',
  hfRequesterPrc_ASC = 'hfRequesterPrc_ASC',
  hfRequesterPrc_DESC = 'hfRequesterPrc_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  itemAmount_ASC = 'itemAmount_ASC',
  itemAmount_DESC = 'itemAmount_DESC',
  listerTotalAmt_ASC = 'listerTotalAmt_ASC',
  listerTotalAmt_DESC = 'listerTotalAmt_DESC',
  listingType_ASC = 'listingType_ASC',
  listingType_DESC = 'listingType_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  oldStatus_ASC = 'oldStatus_ASC',
  oldStatus_DESC = 'oldStatus_DESC',
  orderType_ASC = 'orderType_ASC',
  orderType_DESC = 'orderType_DESC',
  payMethod_ASC = 'payMethod_ASC',
  payMethod_DESC = 'payMethod_DESC',
  period_ASC = 'period_ASC',
  period_DESC = 'period_DESC',
  ppListerAbs_ASC = 'ppListerAbs_ASC',
  ppListerAbs_DESC = 'ppListerAbs_DESC',
  ppListerAmt_ASC = 'ppListerAmt_ASC',
  ppListerAmt_DESC = 'ppListerAmt_DESC',
  ppListerPrc_ASC = 'ppListerPrc_ASC',
  ppListerPrc_DESC = 'ppListerPrc_DESC',
  ppRequesterAbs_ASC = 'ppRequesterAbs_ASC',
  ppRequesterAbs_DESC = 'ppRequesterAbs_DESC',
  ppRequesterAmt_ASC = 'ppRequesterAmt_ASC',
  ppRequesterAmt_DESC = 'ppRequesterAmt_DESC',
  ppRequesterPrc_ASC = 'ppRequesterPrc_ASC',
  ppRequesterPrc_DESC = 'ppRequesterPrc_DESC',
  pricePeriod_ASC = 'pricePeriod_ASC',
  pricePeriod_DESC = 'pricePeriod_DESC',
  price_ASC = 'price_ASC',
  price_DESC = 'price_DESC',
  recurringEvent_ASC = 'recurringEvent_ASC',
  recurringEvent_DESC = 'recurringEvent_DESC',
  reminder6atMorningSent_ASC = 'reminder6atMorningSent_ASC',
  reminder6atMorningSent_DESC = 'reminder6atMorningSent_DESC',
  reminderSent_ASC = 'reminderSent_ASC',
  reminderSent_DESC = 'reminderSent_DESC',
  requesterTotalAmt_ASC = 'requesterTotalAmt_ASC',
  requesterTotalAmt_DESC = 'requesterTotalAmt_DESC',
  rewardType_ASC = 'rewardType_ASC',
  rewardType_DESC = 'rewardType_DESC',
  sfListerAmt_ASC = 'sfListerAmt_ASC',
  sfListerAmt_DESC = 'sfListerAmt_DESC',
  sfRequesterAmt_ASC = 'sfRequesterAmt_ASC',
  sfRequesterAmt_DESC = 'sfRequesterAmt_DESC',
  startTime_ASC = 'startTime_ASC',
  startTime_DESC = 'startTime_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLOrderStatuses {
  accepted = 'accepted',
  attending = 'attending',
  booked = 'booked',
  canceled = 'canceled',
  completed = 'completed',
  draft = 'draft',
  failed = 'failed',
  paid = 'paid',
  pending = 'pending',
  performing = 'performing',
  rejected = 'rejected',
  request = 'request'
}

export enum GQLOrderType {
  amenity = 'amenity',
  event = 'event',
  item = 'item'
}

export enum GQLPayPeriod {
  month = 'month',
  year = 'year'
}

/**
 * The PaymentPlanOrder input type is used when sorting objects of the PaymentPlan class.
 */
export enum GQLPaymentPlanOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Currency_ASC = 'Currency_ASC',
  Currency_DESC = 'Currency_DESC',
  Location_ASC = 'Location_ASC',
  Location_DESC = 'Location_DESC',
  communityFee_ASC = 'communityFee_ASC',
  communityFee_DESC = 'communityFee_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  extraListing_ASC = 'extraListing_ASC',
  extraListing_DESC = 'extraListing_DESC',
  extraResident_ASC = 'extraResident_ASC',
  extraResident_DESC = 'extraResident_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isPublic_ASC = 'isPublic_ASC',
  isPublic_DESC = 'isPublic_DESC',
  listingCap_ASC = 'listingCap_ASC',
  listingCap_DESC = 'listingCap_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  options_ASC = 'options_ASC',
  options_DESC = 'options_DESC',
  priceMonth_ASC = 'priceMonth_ASC',
  priceMonth_DESC = 'priceMonth_DESC',
  priceYear_ASC = 'priceYear_ASC',
  priceYear_DESC = 'priceYear_DESC',
  rentFees_ASC = 'rentFees_ASC',
  rentFees_DESC = 'rentFees_DESC',
  rentalExternal_ASC = 'rentalExternal_ASC',
  rentalExternal_DESC = 'rentalExternal_DESC',
  residentCap_ASC = 'residentCap_ASC',
  residentCap_DESC = 'residentCap_DESC',
  salesExternal_ASC = 'salesExternal_ASC',
  salesExternal_DESC = 'salesExternal_DESC',
  salesFees_ASC = 'salesFees_ASC',
  salesFees_DESC = 'salesFees_DESC',
  serviceExternal_ASC = 'serviceExternal_ASC',
  serviceExternal_DESC = 'serviceExternal_DESC',
  serviceFees_ASC = 'serviceFees_ASC',
  serviceFees_DESC = 'serviceFees_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLPermissionTypes {
  edit = 'edit',
  view = 'view'
}

/**
 * The PhoneVerificationOrder input type is used when sorting objects of the PhoneVerification class.
 */
export enum GQLPhoneVerificationOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  verificationCode_ASC = 'verificationCode_ASC',
  verificationCode_DESC = 'verificationCode_DESC'
}

/**
 * The PollOptionOrder input type is used when sorting objects of the PollOption class.
 */
export enum GQLPollOptionOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Post_ASC = 'Post_ASC',
  Post_DESC = 'Post_DESC',
  Translate_ASC = 'Translate_ASC',
  Translate_DESC = 'Translate_DESC',
  Voted_ASC = 'Voted_ASC',
  Voted_DESC = 'Voted_DESC',
  countVotes_ASC = 'countVotes_ASC',
  countVotes_DESC = 'countVotes_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isVoted_ASC = 'isVoted_ASC',
  isVoted_DESC = 'isVoted_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC',
  text_ASC = 'text_ASC',
  text_DESC = 'text_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The PostOrder input type is used when sorting objects of the Post class.
 */
export enum GQLPostOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Attachments_ASC = 'Attachments_ASC',
  Attachments_DESC = 'Attachments_DESC',
  Author_ASC = 'Author_ASC',
  Author_DESC = 'Author_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Group_ASC = 'Group_ASC',
  Group_DESC = 'Group_DESC',
  Hide_ASC = 'Hide_ASC',
  Hide_DESC = 'Hide_DESC',
  Items_ASC = 'Items_ASC',
  Items_DESC = 'Items_DESC',
  Options_ASC = 'Options_ASC',
  Options_DESC = 'Options_DESC',
  Parent_ASC = 'Parent_ASC',
  Parent_DESC = 'Parent_DESC',
  Pin_ASC = 'Pin_ASC',
  Pin_DESC = 'Pin_DESC',
  Reports_ASC = 'Reports_ASC',
  Reports_DESC = 'Reports_DESC',
  Seen_ASC = 'Seen_ASC',
  Seen_DESC = 'Seen_DESC',
  Translate_ASC = 'Translate_ASC',
  Translate_DESC = 'Translate_DESC',
  comments_ASC = 'comments_ASC',
  comments_DESC = 'comments_DESC',
  countComments_ASC = 'countComments_ASC',
  countComments_DESC = 'countComments_DESC',
  countHides_ASC = 'countHides_ASC',
  countHides_DESC = 'countHides_DESC',
  countLikes_ASC = 'countLikes_ASC',
  countLikes_DESC = 'countLikes_DESC',
  countSmiles_ASC = 'countSmiles_ASC',
  countSmiles_DESC = 'countSmiles_DESC',
  countWaves_ASC = 'countWaves_ASC',
  countWaves_DESC = 'countWaves_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  data_ASC = 'data_ASC',
  data_DESC = 'data_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isComment_ASC = 'isComment_ASC',
  isComment_DESC = 'isComment_DESC',
  isDeleted_ASC = 'isDeleted_ASC',
  isDeleted_DESC = 'isDeleted_DESC',
  isHidden_ASC = 'isHidden_ASC',
  isHidden_DESC = 'isHidden_DESC',
  isLike_ASC = 'isLike_ASC',
  isLike_DESC = 'isLike_DESC',
  isMulti_ASC = 'isMulti_ASC',
  isMulti_DESC = 'isMulti_DESC',
  isSmile_ASC = 'isSmile_ASC',
  isSmile_DESC = 'isSmile_DESC',
  isWave_ASC = 'isWave_ASC',
  isWave_DESC = 'isWave_DESC',
  likes_ASC = 'likes_ASC',
  likes_DESC = 'likes_DESC',
  localRef_ASC = 'localRef_ASC',
  localRef_DESC = 'localRef_DESC',
  medium_ASC = 'medium_ASC',
  medium_DESC = 'medium_DESC',
  notShow_ASC = 'notShow_ASC',
  notShow_DESC = 'notShow_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  pollOptions_ASC = 'pollOptions_ASC',
  pollOptions_DESC = 'pollOptions_DESC',
  sentAs_ASC = 'sentAs_ASC',
  sentAs_DESC = 'sentAs_DESC',
  smiles_ASC = 'smiles_ASC',
  smiles_DESC = 'smiles_DESC',
  text_ASC = 'text_ASC',
  text_DESC = 'text_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  waves_ASC = 'waves_ASC',
  waves_DESC = 'waves_DESC'
}

/**
 * The PostTranslateOrder input type is used when sorting objects of the PostTranslate class.
 */
export enum GQLPostTranslateOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  PollOption_ASC = 'PollOption_ASC',
  PollOption_DESC = 'PollOption_DESC',
  Post_ASC = 'Post_ASC',
  Post_DESC = 'Post_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  en_ASC = 'en_ASC',
  en_DESC = 'en_DESC',
  fr_ASC = 'fr_ASC',
  fr_DESC = 'fr_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  originalLang_ASC = 'originalLang_ASC',
  originalLang_DESC = 'originalLang_DESC',
  ru_ASC = 'ru_ASC',
  ru_DESC = 'ru_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The PromoOrder input type is used when sorting objects of the Promo class.
 */
export enum GQLPromoOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Communities_ASC = 'Communities_ASC',
  Communities_DESC = 'Communities_DESC',
  Currency_ASC = 'Currency_ASC',
  Currency_DESC = 'Currency_DESC',
  Location_ASC = 'Location_ASC',
  Location_DESC = 'Location_DESC',
  code_ASC = 'code_ASC',
  code_DESC = 'code_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  endDate_ASC = 'endDate_ASC',
  endDate_DESC = 'endDate_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isCommunity_ASC = 'isCommunity_ASC',
  isCommunity_DESC = 'isCommunity_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  startDate_ASC = 'startDate_ASC',
  startDate_DESC = 'startDate_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  usageLimit_ASC = 'usageLimit_ASC',
  usageLimit_DESC = 'usageLimit_DESC',
  valueType_ASC = 'valueType_ASC',
  valueType_DESC = 'valueType_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

/**
 * The PushNotificationLogOrder input type is used when sorting objects of the PushNotificationLog class.
 */
export enum GQLPushNotificationLogOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  error_ASC = 'error_ASC',
  error_DESC = 'error_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  result_ASC = 'result_ASC',
  result_DESC = 'result_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  user_ASC = 'user_ASC',
  user_DESC = 'user_DESC'
}

export enum GQLReactionHandlerTypes {
  smile = 'smile',
  wave = 'wave'
}

/**
 * The ReadPreference enum type is used in queries in order to select in which database replica the operation must run.
 */
export enum GQLReadPreference {
  NEAREST = 'NEAREST',
  PRIMARY = 'PRIMARY',
  PRIMARY_PREFERRED = 'PRIMARY_PREFERRED',
  SECONDARY = 'SECONDARY',
  SECONDARY_PREFERRED = 'SECONDARY_PREFERRED'
}

/**
 * The ReferralOrder input type is used when sorting objects of the Referral class.
 */
export enum GQLReferralOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  ReferralBy_ASC = 'ReferralBy_ASC',
  ReferralBy_DESC = 'ReferralBy_DESC',
  ReferralsCount_ASC = 'ReferralsCount_ASC',
  ReferralsCount_DESC = 'ReferralsCount_DESC',
  Referrals_ASC = 'Referrals_ASC',
  Referrals_DESC = 'Referrals_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  accumulatedDiscount_ASC = 'accumulatedDiscount_ASC',
  accumulatedDiscount_DESC = 'accumulatedDiscount_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  data_ASC = 'data_ASC',
  data_DESC = 'data_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  userMadeTransaction_ASC = 'userMadeTransaction_ASC',
  userMadeTransaction_DESC = 'userMadeTransaction_DESC'
}

/**
 * The ReportOrder input type is used when sorting objects of the Report class.
 */
export enum GQLReportOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Company_ASC = 'Company_ASC',
  Company_DESC = 'Company_DESC',
  Event_ASC = 'Event_ASC',
  Event_DESC = 'Event_DESC',
  Group_ASC = 'Group_ASC',
  Group_DESC = 'Group_DESC',
  Item_ASC = 'Item_ASC',
  Item_DESC = 'Item_DESC',
  Post_ASC = 'Post_ASC',
  Post_DESC = 'Post_DESC',
  Reporter_ASC = 'Reporter_ASC',
  Reporter_DESC = 'Reporter_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  blockUserText_ASC = 'blockUserText_ASC',
  blockUserText_DESC = 'blockUserText_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  reportText_ASC = 'reportText_ASC',
  reportText_DESC = 'reportText_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The ReviewOrder input type is used when sorting objects of the Review class.
 */
export enum GQLReviewOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Amenity_ASC = 'Amenity_ASC',
  Amenity_DESC = 'Amenity_DESC',
  Author_ASC = 'Author_ASC',
  Author_DESC = 'Author_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Event_ASC = 'Event_ASC',
  Event_DESC = 'Event_DESC',
  Item_ASC = 'Item_ASC',
  Item_DESC = 'Item_DESC',
  Order_ASC = 'Order_ASC',
  Order_DESC = 'Order_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  stars_ASC = 'stars_ASC',
  stars_DESC = 'stars_DESC',
  subject_ASC = 'subject_ASC',
  subject_DESC = 'subject_DESC',
  text_ASC = 'text_ASC',
  text_DESC = 'text_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLRewardType {
  coffee = 'coffee',
  fee = 'fee',
  free = 'free'
}

/**
 * The RoleOrder input type is used when sorting objects of the Role class.
 */
export enum GQLRoleOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  roles_ASC = 'roles_ASC',
  roles_DESC = 'roles_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  users_ASC = 'users_ASC',
  users_DESC = 'users_DESC'
}

/**
 * The SessionOrder input type is used when sorting objects of the Session class.
 */
export enum GQLSessionOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  createdWith_ASC = 'createdWith_ASC',
  createdWith_DESC = 'createdWith_DESC',
  expiresAt_ASC = 'expiresAt_ASC',
  expiresAt_DESC = 'expiresAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  installationId_ASC = 'installationId_ASC',
  installationId_DESC = 'installationId_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  restricted_ASC = 'restricted_ASC',
  restricted_DESC = 'restricted_DESC',
  sessionToken_ASC = 'sessionToken_ASC',
  sessionToken_DESC = 'sessionToken_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  user_ASC = 'user_ASC',
  user_DESC = 'user_DESC'
}

/**
 * The SubscrOrder input type is used when sorting objects of the Subscr class.
 */
export enum GQLSubscrOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Communities_ASC = 'Communities_ASC',
  Communities_DESC = 'Communities_DESC',
  Owner_ASC = 'Owner_ASC',
  Owner_DESC = 'Owner_DESC',
  PaymentPlan_ASC = 'PaymentPlan_ASC',
  PaymentPlan_DESC = 'PaymentPlan_DESC',
  SubscrPayments_ASC = 'SubscrPayments_ASC',
  SubscrPayments_DESC = 'SubscrPayments_DESC',
  beginAt_ASC = 'beginAt_ASC',
  beginAt_DESC = 'beginAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  expireAt_ASC = 'expireAt_ASC',
  expireAt_DESC = 'expireAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  netPaid_ASC = 'netPaid_ASC',
  netPaid_DESC = 'netPaid_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  paymentPeriod_ASC = 'paymentPeriod_ASC',
  paymentPeriod_DESC = 'paymentPeriod_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The SubscrPaymentOrder input type is used when sorting objects of the SubscrPayment class.
 */
export enum GQLSubscrPaymentOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Subscr_ASC = 'Subscr_ASC',
  Subscr_DESC = 'Subscr_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  amount_ASC = 'amount_ASC',
  amount_DESC = 'amount_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  data_ASC = 'data_ASC',
  data_DESC = 'data_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  outerId_ASC = 'outerId_ASC',
  outerId_DESC = 'outerId_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The TaskOrder input type is used when sorting objects of the Task class.
 */
export enum GQLTaskOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  File_ASC = 'File_ASC',
  File_DESC = 'File_DESC',
  Owner_ASC = 'Owner_ASC',
  Owner_DESC = 'Owner_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  error_ASC = 'error_ASC',
  error_DESC = 'error_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  options_ASC = 'options_ASC',
  options_DESC = 'options_DESC',
  processedRow_ASC = 'processedRow_ASC',
  processedRow_DESC = 'processedRow_DESC',
  result_ASC = 'result_ASC',
  result_DESC = 'result_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The TransactionOrder input type is used when sorting objects of the Transaction class.
 */
export enum GQLTransactionOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Community_ASC = 'Community_ASC',
  Community_DESC = 'Community_DESC',
  Order_ASC = 'Order_ASC',
  Order_DESC = 'Order_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  amount_ASC = 'amount_ASC',
  amount_DESC = 'amount_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  data_ASC = 'data_ASC',
  data_DESC = 'data_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  descr_ASC = 'descr_ASC',
  descr_DESC = 'descr_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  outerId_ASC = 'outerId_ASC',
  outerId_DESC = 'outerId_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  transferDest_ASC = 'transferDest_ASC',
  transferDest_DESC = 'transferDest_DESC',
  transferGroup_ASC = 'transferGroup_ASC',
  transferGroup_DESC = 'transferGroup_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The UserOrder input type is used when sorting objects of the User class.
 */
export enum GQLUserOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Avatar_ASC = 'Avatar_ASC',
  Avatar_DESC = 'Avatar_DESC',
  Blocked_ASC = 'Blocked_ASC',
  Blocked_DESC = 'Blocked_DESC',
  Communities_ASC = 'Communities_ASC',
  Communities_DESC = 'Communities_DESC',
  Country_ASC = 'Country_ASC',
  Country_DESC = 'Country_DESC',
  Currency_ASC = 'Currency_ASC',
  Currency_DESC = 'Currency_DESC',
  Language_ASC = 'Language_ASC',
  Language_DESC = 'Language_DESC',
  Location_ASC = 'Location_ASC',
  Location_DESC = 'Location_DESC',
  Orders_ASC = 'Orders_ASC',
  Orders_DESC = 'Orders_DESC',
  ReferralCode_ASC = 'ReferralCode_ASC',
  ReferralCode_DESC = 'ReferralCode_DESC',
  Reports_ASC = 'Reports_ASC',
  Reports_DESC = 'Reports_DESC',
  Reviews_ASC = 'Reviews_ASC',
  Reviews_DESC = 'Reviews_DESC',
  Viewers_ASC = 'Viewers_ASC',
  Viewers_DESC = 'Viewers_DESC',
  address_ASC = 'address_ASC',
  address_DESC = 'address_DESC',
  aptSuite_ASC = 'aptSuite_ASC',
  aptSuite_DESC = 'aptSuite_DESC',
  authData_ASC = 'authData_ASC',
  authData_DESC = 'authData_DESC',
  bio_ASC = 'bio_ASC',
  bio_DESC = 'bio_DESC',
  birthDate_ASC = 'birthDate_ASC',
  birthDate_DESC = 'birthDate_DESC',
  cardInfo_ASC = 'cardInfo_ASC',
  cardInfo_DESC = 'cardInfo_DESC',
  checkListSeen_ASC = 'checkListSeen_ASC',
  checkListSeen_DESC = 'checkListSeen_DESC',
  checkList_ASC = 'checkList_ASC',
  checkList_DESC = 'checkList_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  distance_ASC = 'distance_ASC',
  distance_DESC = 'distance_DESC',
  earned_ASC = 'earned_ASC',
  earned_DESC = 'earned_DESC',
  emailVerified_ASC = 'emailVerified_ASC',
  emailVerified_DESC = 'emailVerified_DESC',
  email_ASC = 'email_ASC',
  email_DESC = 'email_DESC',
  firstLetter_ASC = 'firstLetter_ASC',
  firstLetter_DESC = 'firstLetter_DESC',
  firstName_ASC = 'firstName_ASC',
  firstName_DESC = 'firstName_DESC',
  gender_ASC = 'gender_ASC',
  gender_DESC = 'gender_DESC',
  geo_ASC = 'geo_ASC',
  geo_DESC = 'geo_DESC',
  homepage_ASC = 'homepage_ASC',
  homepage_DESC = 'homepage_DESC',
  howDidYouHear_ASC = 'howDidYouHear_ASC',
  howDidYouHear_DESC = 'howDidYouHear_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  identityData_ASC = 'identityData_ASC',
  identityData_DESC = 'identityData_DESC',
  interests_ASC = 'interests_ASC',
  interests_DESC = 'interests_DESC',
  isDeleted_ASC = 'isDeleted_ASC',
  isDeleted_DESC = 'isDeleted_DESC',
  isInvited_ASC = 'isInvited_ASC',
  isInvited_DESC = 'isInvited_DESC',
  isOnline_ASC = 'isOnline_ASC',
  isOnline_DESC = 'isOnline_DESC',
  isSupport_ASC = 'isSupport_ASC',
  isSupport_DESC = 'isSupport_DESC',
  isVerified_ASC = 'isVerified_ASC',
  isVerified_DESC = 'isVerified_DESC',
  isWaved_ASC = 'isWaved_ASC',
  isWaved_DESC = 'isWaved_DESC',
  languages_ASC = 'languages_ASC',
  languages_DESC = 'languages_DESC',
  lastName_ASC = 'lastName_ASC',
  lastName_DESC = 'lastName_DESC',
  lastVisitedCommunity_ASC = 'lastVisitedCommunity_ASC',
  lastVisitedCommunity_DESC = 'lastVisitedCommunity_DESC',
  listingCount_ASC = 'listingCount_ASC',
  listingCount_DESC = 'listingCount_DESC',
  livingWith_ASC = 'livingWith_ASC',
  livingWith_DESC = 'livingWith_DESC',
  mobilePushEnabled_ASC = 'mobilePushEnabled_ASC',
  mobilePushEnabled_DESC = 'mobilePushEnabled_DESC',
  msgIncoming_ASC = 'msgIncoming_ASC',
  msgIncoming_DESC = 'msgIncoming_DESC',
  notifyAmenityReminder_ASC = 'notifyAmenityReminder_ASC',
  notifyAmenityReminder_DESC = 'notifyAmenityReminder_DESC',
  notifyDigest_ASC = 'notifyDigest_ASC',
  notifyDigest_DESC = 'notifyDigest_DESC',
  notifyEventAttendees_ASC = 'notifyEventAttendees_ASC',
  notifyEventAttendees_DESC = 'notifyEventAttendees_DESC',
  notifyEventReminder_ASC = 'notifyEventReminder_ASC',
  notifyEventReminder_DESC = 'notifyEventReminder_DESC',
  notifyHelpCentre_ASC = 'notifyHelpCentre_ASC',
  notifyHelpCentre_DESC = 'notifyHelpCentre_DESC',
  notifyJoinRequest_ASC = 'notifyJoinRequest_ASC',
  notifyJoinRequest_DESC = 'notifyJoinRequest_DESC',
  notifyLikeOrComment_ASC = 'notifyLikeOrComment_ASC',
  notifyLikeOrComment_DESC = 'notifyLikeOrComment_DESC',
  notifyListingView_ASC = 'notifyListingView_ASC',
  notifyListingView_DESC = 'notifyListingView_DESC',
  notifyListingsRequest_ASC = 'notifyListingsRequest_ASC',
  notifyListingsRequest_DESC = 'notifyListingsRequest_DESC',
  notifyLoopPost_ASC = 'notifyLoopPost_ASC',
  notifyLoopPost_DESC = 'notifyLoopPost_DESC',
  notifyManagedAmenities_ASC = 'notifyManagedAmenities_ASC',
  notifyManagedAmenities_DESC = 'notifyManagedAmenities_DESC',
  notifyManagerAdminPost_ASC = 'notifyManagerAdminPost_ASC',
  notifyManagerAdminPost_DESC = 'notifyManagerAdminPost_DESC',
  notifyMarketingAndFeatures_ASC = 'notifyMarketingAndFeatures_ASC',
  notifyMarketingAndFeatures_DESC = 'notifyMarketingAndFeatures_DESC',
  notifyMessage_ASC = 'notifyMessage_ASC',
  notifyMessage_DESC = 'notifyMessage_DESC',
  notifyNewCommunities_ASC = 'notifyNewCommunities_ASC',
  notifyNewCommunities_DESC = 'notifyNewCommunities_DESC',
  notifyNewListing_ASC = 'notifyNewListing_ASC',
  notifyNewListing_DESC = 'notifyNewListing_DESC',
  notifyNewListings_ASC = 'notifyNewListings_ASC',
  notifyNewListings_DESC = 'notifyNewListings_DESC',
  notifyNewMember_ASC = 'notifyNewMember_ASC',
  notifyNewMember_DESC = 'notifyNewMember_DESC',
  notifyNewMembers_ASC = 'notifyNewMembers_ASC',
  notifyNewMembers_DESC = 'notifyNewMembers_DESC',
  notifyNewRequests_ASC = 'notifyNewRequests_ASC',
  notifyNewRequests_DESC = 'notifyNewRequests_DESC',
  notifyNewResidentListings_ASC = 'notifyNewResidentListings_ASC',
  notifyNewResidentListings_DESC = 'notifyNewResidentListings_DESC',
  notifyNewResidents_ASC = 'notifyNewResidents_ASC',
  notifyNewResidents_DESC = 'notifyNewResidents_DESC',
  notifyNewTransaction_ASC = 'notifyNewTransaction_ASC',
  notifyNewTransaction_DESC = 'notifyNewTransaction_DESC',
  notifyOrderRequest_ASC = 'notifyOrderRequest_ASC',
  notifyOrderRequest_DESC = 'notifyOrderRequest_DESC',
  notifyProfileView_ASC = 'notifyProfileView_ASC',
  notifyProfileView_DESC = 'notifyProfileView_DESC',
  notifyUnmanagedAmenities_ASC = 'notifyUnmanagedAmenities_ASC',
  notifyUnmanagedAmenities_DESC = 'notifyUnmanagedAmenities_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  occupation_ASC = 'occupation_ASC',
  occupation_DESC = 'occupation_DESC',
  onlineDate_ASC = 'onlineDate_ASC',
  onlineDate_DESC = 'onlineDate_DESC',
  password_ASC = 'password_ASC',
  password_DESC = 'password_DESC',
  personInterests_ASC = 'personInterests_ASC',
  personInterests_DESC = 'personInterests_DESC',
  phoneVerified_ASC = 'phoneVerified_ASC',
  phoneVerified_DESC = 'phoneVerified_DESC',
  phone_ASC = 'phone_ASC',
  phone_DESC = 'phone_DESC',
  platformStripeId_ASC = 'platformStripeId_ASC',
  platformStripeId_DESC = 'platformStripeId_DESC',
  profileViewOff_ASC = 'profileViewOff_ASC',
  profileViewOff_DESC = 'profileViewOff_DESC',
  rating_ASC = 'rating_ASC',
  rating_DESC = 'rating_DESC',
  recommendations_ASC = 'recommendations_ASC',
  recommendations_DESC = 'recommendations_DESC',
  spent_ASC = 'spent_ASC',
  spent_DESC = 'spent_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  stripeConnectedId_ASC = 'stripeConnectedId_ASC',
  stripeConnectedId_DESC = 'stripeConnectedId_DESC',
  stripeId_ASC = 'stripeId_ASC',
  stripeId_DESC = 'stripeId_DESC',
  study_ASC = 'study_ASC',
  study_DESC = 'study_DESC',
  tips_ASC = 'tips_ASC',
  tips_DESC = 'tips_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  username_ASC = 'username_ASC',
  username_DESC = 'username_DESC',
  work_ASC = 'work_ASC',
  work_DESC = 'work_DESC',
  zip_ASC = 'zip_ASC',
  zip_DESC = 'zip_DESC'
}

export enum GQLUserStatuses {
  active = 'active',
  block = 'block',
  new = 'new'
}

export enum GQLViewObjectTypes {
  Amenity = 'Amenity',
  Company = 'Company',
  Event = 'Event',
  Item = 'Item',
  User = 'User'
}

export enum GQL_SessionOrder {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  expiresAt_ASC = 'expiresAt_ASC',
  expiresAt_DESC = 'expiresAt_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  user_ASC = 'user_ASC',
  user_DESC = 'user_DESC'
}

/**
 * The Any scalar type is used in operations and types that involve any type of value.
 */
export type GQLAny = any;

/**
 * The Bytes scalar type is used in operations and types that involve base 64 binary data.
 */
export type GQLBytes = any;

/**
 * The Date scalar type is used in operations and types that involve dates.
 */
export type GQLDate = any;

/**
 * The File scalar type is used in operations and types that involve files.
 */
export type GQLFile = any;

/**
 * The Object scalar type is used in operations and types that involve objects.
 */
export type GQLObject = any;

/**
 * The `Upload` scalar type represents a file upload.
 */
export type GQLUpload = any;

/**
 * Allow to manage access rights. If not provided object will be publicly readable and writable
 */
export interface GQLACLInput {
  
  /**
   * Public access control list.
   */
  public?: GQLPublicACLInput;
  
  /**
   * Access control list for roles.
   */
  roles?: Array<GQLRoleACLInput>;
  
  /**
   * Access control list for users.
   */
  users?: Array<GQLUserACLInput>;
}

export interface GQLAccountTransferInp {
  adminId: string;
  communityId: string;
}

export interface GQLAddCardToUserInp {
  cardNumber: string;
  country?: string;
  cvc?: string;
  expiryDate: string;
  nameOnCard?: string;
  saveCard?: boolean;
  zipCode?: string;
}

export interface GQLAdminCreateInp {
  communities?: GQLPermissionTypes;
  configurations?: GQLPermissionTypes;
  email: string;
  helpCentre?: GQLPermissionTypes;
  listings?: GQLPermissionTypes;
  members?: GQLPermissionTypes;
  name: string;
  phone: string;
  promotions?: GQLPermissionTypes;
  requests?: GQLPermissionTypes;
  settings?: GQLPermissionTypes;
  transactions?: GQLPermissionTypes;
}

export interface GQLAdminCreateUserFieldsInput {
  email: string;
  emailVerified?: boolean;
  password: string;
  roles?: GQLRoleRelationInput;
  status?: GQLUserStatuses;
  username: string;
}

export interface GQLAdminCreateUserInput {
  clientMutationId?: string;
  fields?: GQLAdminCreateUserFieldsInput;
}

export interface GQLAdminDashboardChartInp {
  endDate?: string;
  startDate?: string;
  type: GQLAdminChartTypes;
}

export interface GQLAdminDashboardInput {
  endDate?: string;
  locationId?: string;
  startDate?: string;
}

export interface GQLAdminDeleteUserInput {
  clientMutationId?: string;
  id: string;
}

export interface GQLAdminEditInp {
  adminId: string;
  communities?: GQLPermissionTypes;
  configurations?: GQLPermissionTypes;
  helpCentre?: GQLPermissionTypes;
  listings?: GQLPermissionTypes;
  members?: GQLPermissionTypes;
  name?: string;
  phone?: string;
  promotions?: GQLPermissionTypes;
  requests?: GQLPermissionTypes;
  settings?: GQLPermissionTypes;
  transactions?: GQLPermissionTypes;
}

/**
 * Allow to link OR add and link an object of the Admin class.
 */
export interface GQLAdminPointerInput {
  
  /**
   * Create and link an object from Admin class.
   */
  createAndLink?: GQLCreateAdminFieldsInput;
  
  /**
   * Link an existing object from Admin class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Admin class into a relation field.
 */
export interface GQLAdminRelationInput {
  
  /**
   * Add existing objects from the Admin class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Admin class into the relation.
   */
  createAndAdd?: Array<GQLCreateAdminFieldsInput>;
  
  /**
   * Remove existing objects from the Admin class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The AdminRelationWhereInput input type is used in operations that involve filtering objects of Admin class.
 */
export interface GQLAdminRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLAdminWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLAdminWhereInput;
}

export interface GQLAdminRemoveInp {
  userId: string;
}

export interface GQLAdminUpdateUserFieldsInput {
  email?: string;
  emailVerified?: boolean;
  password?: string;
  roles?: GQLRoleRelationInput;
  status?: GQLUserStatuses;
  username?: string;
}

export interface GQLAdminUpdateUserInput {
  clientMutationId?: string;
  fields: GQLAdminUpdateUserFieldsInput;
  id: string;
}

/**
 * The AdminWhereInput input type is used in operations that involve filtering objects of Admin class.
 */
export interface GQLAdminWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLAdminWhereInput>;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLStringWhereInput;
  
  /**
   * This is the object Configurations.
   */
  Configurations?: GQLStringWhereInput;
  
  /**
   * This is the object HelpCentre.
   */
  HelpCentre?: GQLStringWhereInput;
  
  /**
   * This is the object Listings.
   */
  Listings?: GQLStringWhereInput;
  
  /**
   * This is the object Members.
   */
  Members?: GQLStringWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLAdminWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLAdminWhereInput>;
  
  /**
   * This is the object Promotions.
   */
  Promotions?: GQLStringWhereInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLStringWhereInput;
  
  /**
   * This is the object Settings.
   */
  Settings?: GQLStringWhereInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLStringWhereInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isFullAccess.
   */
  isFullAccess?: GQLBooleanWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLAmenityManageButtonsInp {
  action: GQLAmenityManageAction;
  amenityId: string;
  communityIdList: Array<string | null>;
}

/**
 * Allow to link OR add and link an object of the Amenity class.
 */
export interface GQLAmenityPointerInput {
  
  /**
   * Create and link an object from Amenity class.
   */
  createAndLink?: GQLCreateAmenityFieldsInput;
  
  /**
   * Link an existing object from Amenity class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Amenity class into a relation field.
 */
export interface GQLAmenityRelationInput {
  
  /**
   * Add existing objects from the Amenity class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Amenity class into the relation.
   */
  createAndAdd?: Array<GQLCreateAmenityFieldsInput>;
  
  /**
   * Remove existing objects from the Amenity class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The AmenityRelationWhereInput input type is used in operations that involve filtering objects of Amenity class.
 */
export interface GQLAmenityRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLAmenityWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLAmenityWhereInput;
}

/**
 * The AmenityWhereInput input type is used in operations that involve filtering objects of Amenity class.
 */
export interface GQLAmenityWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLAmenityWhereInput>;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: GQLArrayWhereInput;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: GQLArrayWhereInput;
  
  /**
   * This is the object Bookings.
   */
  Bookings?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: GQLArrayWhereInput;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLAmenityWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLAmenityWhereInput>;
  
  /**
   * This is the object Published.
   */
  Published?: GQLArrayWhereInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationWhereInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationWhereInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: GQLArrayWhereInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationWhereInput;
  
  /**
   * This is the object allowGuests.
   */
  allowGuests?: GQLBooleanWhereInput;
  
  /**
   * This is the object autoBooking.
   */
  autoBooking?: GQLBooleanWhereInput;
  
  /**
   * This is the object availabilityOverride.
   */
  availabilityOverride?: GQLArrayWhereInput;
  
  /**
   * This is the object bookingPeriod.
   */
  bookingPeriod?: GQLStringWhereInput;
  
  /**
   * This is the object bookingSlots.
   */
  bookingSlots?: GQLStringWhereInput;
  
  /**
   * This is the object bookingTiming.
   */
  bookingTiming?: GQLObjectWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object images.
   */
  images?: GQLArrayWhereInput;
  
  /**
   * This is the object isBookable.
   */
  isBookable?: GQLBooleanWhereInput;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: GQLBooleanWhereInput;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: GQLBooleanWhereInput;
  
  /**
   * This is the object maxBookingPerSlot.
   */
  maxBookingPerSlot?: GQLNumberWhereInput;
  
  /**
   * This is the object maxBookingsPerDay.
   */
  maxBookingsPerDay?: GQLNumberWhereInput;
  
  /**
   * This is the object maxResidentsPerBooking.
   */
  maxResidentsPerBooking?: GQLNumberWhereInput;
  
  /**
   * This is the object messageAssignees.
   */
  messageAssignees?: GQLArrayWhereInput;
  
  /**
   * This is the object multipleFutureBookings.
   */
  multipleFutureBookings?: GQLBooleanWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object popularDay.
   */
  popularDay?: GQLStringWhereInput;
  
  /**
   * This is the object popularTime.
   */
  popularTime?: GQLDateWhereInput;
  
  /**
   * This is the object rating.
   */
  rating?: GQLNumberWhereInput;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: GQLStringWhereInput;
  
  /**
   * This is the object totalBookings.
   */
  totalBookings?: GQLNumberWhereInput;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: GQLNumberWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the AppFile class.
 */
export interface GQLAppFilePointerInput {
  
  /**
   * Create and link an object from AppFile class.
   */
  createAndLink?: GQLCreateAppFileFieldsInput;
  
  /**
   * Link an existing object from AppFile class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the AppFile class into a relation field.
 */
export interface GQLAppFileRelationInput {
  
  /**
   * Add existing objects from the AppFile class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the AppFile class into the relation.
   */
  createAndAdd?: Array<GQLCreateAppFileFieldsInput>;
  
  /**
   * Remove existing objects from the AppFile class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The AppFileRelationWhereInput input type is used in operations that involve filtering objects of AppFile class.
 */
export interface GQLAppFileRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLAppFileWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLAppFileWhereInput;
}

/**
 * The AppFileWhereInput input type is used in operations that involve filtering objects of AppFile class.
 */
export interface GQLAppFileWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLAppFileWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLAppFileWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLAppFileWhereInput>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object file.
   */
  file?: GQLFileWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object mime.
   */
  mime?: GQLStringWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLArchiveNotificationsInp {
  communityId: string;
}

/**
 * The ArrayWhereInput input type is used in operations that involve filtering objects by a field of type Array.
 */
export interface GQLArrayWhereInput {
  
  /**
   * This is the containedBy operator to specify a constraint to select the objects where the values of an array field is contained by another specified array.
   */
  containedBy?: Array<GQLAny | null>;
  
  /**
   * This is the contains operator to specify a constraint to select the objects where the values of an array field contain all elements of another specified array.
   */
  contains?: Array<GQLAny | null>;
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLAny;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLAny;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLAny;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLAny | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLAny;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLAny;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLAny;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLAny | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

export interface GQLBookAmenityInp {
  amenityId: string;
  communityId: string;
  date: string;
  guests?: number;
}

export interface GQLBookEventInp {
  communityId: string;
  eventId: string;
  guests?: number;
}

/**
 * The BooleanWhereInput input type is used in operations that involve filtering objects by a field of type Boolean.
 */
export interface GQLBooleanWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: boolean;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: boolean;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * The BoxInput type is used to specifiy a box operation on a within geo query.
 */
export interface GQLBoxInput {
  
  /**
   * This is the bottom left coordinates of the box.
   */
  bottomLeft: GQLGeoPointInput;
  
  /**
   * This is the upper right coordinates of the box.
   */
  upperRight: GQLGeoPointInput;
}

export interface GQLButtonsManagerInp {
  communityId: string;
  itemId: string;
  type: GQLButtonsManagerTypes;
}

export interface GQLButtonsResidentInp {
  communityIDs: Array<string | null>;
  itemId: string;
  type: GQLButtonsResidentTypes;
}

/**
 * The BytesWhereInput input type is used in operations that involve filtering objects by a field of type Bytes.
 */
export interface GQLBytesWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLBytes;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLBytes;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLBytes;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLBytes | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLBytes;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLBytes;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLBytes;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLBytes | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

export interface GQLCalcOrderDataInp {
  orderId: string;
}

export interface GQLCallCloudCodeInput {
  clientMutationId?: string;
  
  /**
   * This is the function to be called.
   */
  functionName: GQLCloudCodeFunction;
  
  /**
   * These are the params to be passed to the function.
   */
  params?: GQLObject;
}

export interface GQLCardIdInp {
  cardId: string;
}

/**
 * Allow to link OR add and link an object of the Category class.
 */
export interface GQLCategoryPointerInput {
  
  /**
   * Create and link an object from Category class.
   */
  createAndLink?: GQLCreateCategoryFieldsInput;
  
  /**
   * Link an existing object from Category class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Category class into a relation field.
 */
export interface GQLCategoryRelationInput {
  
  /**
   * Add existing objects from the Category class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Category class into the relation.
   */
  createAndAdd?: Array<GQLCreateCategoryFieldsInput>;
  
  /**
   * Remove existing objects from the Category class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The CategoryRelationWhereInput input type is used in operations that involve filtering objects of Category class.
 */
export interface GQLCategoryRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLCategoryWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLCategoryWhereInput;
}

/**
 * The CategoryWhereInput input type is used in operations that involve filtering objects of Category class.
 */
export interface GQLCategoryWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLCategoryWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLCategoryWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLCategoryWhereInput>;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * The CenterSphereInput type is used to specifiy a centerSphere operation on a geoWithin query.
 */
export interface GQLCenterSphereInput {
  
  /**
   * This is the center of the sphere.
   */
  center: GQLGeoPointInput;
  
  /**
   * This is the radius of the sphere.
   */
  distance: number;
}

export interface GQLChangePasswordInput {
  clientMutationId?: string;
  id: string;
  password: string;
  token: string;
}

export interface GQLChangeSubscrPlanInp {
  newPayPeriod: GQLPayPeriod;
  newPayPlanId: string;
  subscrId: string;
}

/**
 * Allow to link OR add and link an object of the Chat class.
 */
export interface GQLChatPointerInput {
  
  /**
   * Create and link an object from Chat class.
   */
  createAndLink?: GQLCreateChatFieldsInput;
  
  /**
   * Link an existing object from Chat class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Chat class into a relation field.
 */
export interface GQLChatRelationInput {
  
  /**
   * Add existing objects from the Chat class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Chat class into the relation.
   */
  createAndAdd?: Array<GQLCreateChatFieldsInput>;
  
  /**
   * Remove existing objects from the Chat class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The ChatRelationWhereInput input type is used in operations that involve filtering objects of Chat class.
 */
export interface GQLChatRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLChatWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLChatWhereInput;
}

/**
 * The ChatWhereInput input type is used in operations that involve filtering objects of Chat class.
 */
export interface GQLChatWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLChatWhereInput>;
  
  /**
   * This is the object Members.
   */
  Members?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Messages.
   */
  Messages?: GQLMessageRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLChatWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLChatWhereInput>;
  
  /**
   * This is the object Support.
   */
  Support?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isArchived.
   */
  isArchived?: GQLBooleanWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLCommExternalPaymentsInp {
  communityId: string;
  listingType: GQLListingType;
  rewardType: GQLRewardType;
}

export interface GQLCommunityAdminInp {
  communityId: string;
  label?: string;
  permissionList?: Array<string | null>;
  userId: string;
}

/**
 * Allow to link OR add and link an object of the CommunityAdmin class.
 */
export interface GQLCommunityAdminPointerInput {
  
  /**
   * Create and link an object from CommunityAdmin class.
   */
  createAndLink?: GQLCreateCommunityAdminFieldsInput;
  
  /**
   * Link an existing object from CommunityAdmin class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the CommunityAdmin class into a relation field.
 */
export interface GQLCommunityAdminRelationInput {
  
  /**
   * Add existing objects from the CommunityAdmin class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the CommunityAdmin class into the relation.
   */
  createAndAdd?: Array<GQLCreateCommunityAdminFieldsInput>;
  
  /**
   * Remove existing objects from the CommunityAdmin class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The CommunityAdminRelationWhereInput input type is used in operations that involve filtering objects of CommunityAdmin class.
 */
export interface GQLCommunityAdminRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLCommunityAdminWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLCommunityAdminWhereInput;
}

/**
 * The CommunityAdminWhereInput input type is used in operations that involve filtering objects of CommunityAdmin class.
 */
export interface GQLCommunityAdminWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLCommunityAdminWhereInput>;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLStringWhereInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Configurations.
   */
  Configurations?: GQLStringWhereInput;
  
  /**
   * This is the object HelpCentre.
   */
  HelpCentre?: GQLStringWhereInput;
  
  /**
   * This is the object Listings.
   */
  Listings?: GQLStringWhereInput;
  
  /**
   * This is the object Members.
   */
  Members?: GQLStringWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLCommunityAdminWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLCommunityAdminWhereInput>;
  
  /**
   * This is the object Promotions.
   */
  Promotions?: GQLStringWhereInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLStringWhereInput;
  
  /**
   * This is the object Settings.
   */
  Settings?: GQLStringWhereInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLStringWhereInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object label.
   */
  label?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the Community class.
 */
export interface GQLCommunityPointerInput {
  
  /**
   * Create and link an object from Community class.
   */
  createAndLink?: GQLCreateCommunityFieldsInput;
  
  /**
   * Link an existing object from Community class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Community class into a relation field.
 */
export interface GQLCommunityRelationInput {
  
  /**
   * Add existing objects from the Community class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Community class into the relation.
   */
  createAndAdd?: Array<GQLCreateCommunityFieldsInput>;
  
  /**
   * Remove existing objects from the Community class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The CommunityRelationWhereInput input type is used in operations that involve filtering objects of Community class.
 */
export interface GQLCommunityRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLCommunityWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLCommunityWhereInput;
}

/**
 * The CommunityWhereInput input type is used in operations that involve filtering objects of Community class.
 */
export interface GQLCommunityWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLCommunityWhereInput>;
  
  /**
   * This is the object Admins.
   */
  Admins?: GQLCommunityAdminRelationWhereInput;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFileRelationWhereInput;
  
  /**
   * This is the object Invitations.
   */
  Invitations?: GQLInvitationRelationWhereInput;
  
  /**
   * This is the object Items.
   */
  Items?: GQLItemRelationWhereInput;
  
  /**
   * This is the object JoinRequests.
   */
  JoinRequests?: GQLJoinRequestRelationWhereInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLCommunityWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLCommunityWhereInput>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Residents.
   */
  Residents?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Subscr.
   */
  Subscr?: GQLSubscrRelationWhereInput;
  
  /**
   * This is the object accessType.
   */
  accessType?: GQLStringWhereInput;
  
  /**
   * This is the object address.
   */
  address?: GQLStringWhereInput;
  
  /**
   * This is the object address_add.
   */
  address_add?: GQLArrayWhereInput;
  
  /**
   * This is the object alias.
   */
  alias?: GQLStringWhereInput;
  
  /**
   * This is the object allowChat.
   */
  allowChat?: GQLBooleanWhereInput;
  
  /**
   * This is the object allowEvents.
   */
  allowEvents?: GQLBooleanWhereInput;
  
  /**
   * This is the object allowPosts.
   */
  allowPosts?: GQLBooleanWhereInput;
  
  /**
   * This is the object buildings.
   */
  buildings?: GQLStringWhereInput;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObjectWhereInput;
  
  /**
   * This is the object countItems.
   */
  countItems?: GQLNumberWhereInput;
  
  /**
   * This is the object countMembers.
   */
  countMembers?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObjectWhereInput;
  
  /**
   * This is the object invitation.
   */
  invitation?: GQLStringWhereInput;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: GQLBooleanWhereInput;
  
  /**
   * This is the object listingApproval.
   */
  listingApproval?: GQLStringWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object neighbourhood.
   */
  neighbourhood?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object options.
   */
  options?: GQLObjectWhereInput;
  
  /**
   * This is the object passCode.
   */
  passCode?: GQLStringWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object totalMessages.
   */
  totalMessages?: GQLNumberWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object units.
   */
  units?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object zip.
   */
  zip?: GQLStringWhereInput;
  
  /**
   * This is the object zip_add.
   */
  zip_add?: GQLArrayWhereInput;
}

export interface GQLCompanyManageButtonsInp {
  action: GQLCompanyManageAction;
  communityIdList: Array<string | null>;
  companyId: string;
}

/**
 * Allow to link OR add and link an object of the Company class.
 */
export interface GQLCompanyPointerInput {
  
  /**
   * Create and link an object from Company class.
   */
  createAndLink?: GQLCreateCompanyFieldsInput;
  
  /**
   * Link an existing object from Company class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Company class into a relation field.
 */
export interface GQLCompanyRelationInput {
  
  /**
   * Add existing objects from the Company class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Company class into the relation.
   */
  createAndAdd?: Array<GQLCreateCompanyFieldsInput>;
  
  /**
   * Remove existing objects from the Company class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The CompanyRelationWhereInput input type is used in operations that involve filtering objects of Company class.
 */
export interface GQLCompanyRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLCompanyWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLCompanyWhereInput;
}

/**
 * The CompanyWhereInput input type is used in operations that involve filtering objects of Company class.
 */
export interface GQLCompanyWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLCompanyWhereInput>;
  
  /**
   * This is the object Featured.
   */
  Featured?: GQLArrayWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLCompanyWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLCompanyWhereInput>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Published.
   */
  Published?: GQLArrayWhereInput;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationWhereInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationWhereInput;
  
  /**
   * This is the object category.
   */
  category?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object description.
   */
  description?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object images.
   */
  images?: GQLArrayWhereInput;
  
  /**
   * This is the object interestedUsers.
   */
  interestedUsers?: GQLArrayWhereInput;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: GQLBooleanWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object phone.
   */
  phone?: GQLStringWhereInput;
  
  /**
   * This is the object promoCTA.
   */
  promoCTA?: GQLStringWhereInput;
  
  /**
   * This is the object promoDescr.
   */
  promoDescr?: GQLStringWhereInput;
  
  /**
   * This is the object promoTagline.
   */
  promoTagline?: GQLStringWhereInput;
  
  /**
   * This is the object promotion.
   */
  promotion?: GQLBooleanWhereInput;
  
  /**
   * This is the object revealCode.
   */
  revealCode?: GQLStringWhereInput;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: GQLStringWhereInput;
  
  /**
   * This is the object totalClicks.
   */
  totalClicks?: GQLNumberWhereInput;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: GQLNumberWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object visitedWebsite.
   */
  visitedWebsite?: GQLStringWhereInput;
  
  /**
   * This is the object website.
   */
  website?: GQLStringWhereInput;
}

export interface GQLConnectStripeAccountInp {
  returnUrl?: string;
}

export interface GQLCountTotalClicksInp {
  companyId: string;
}

/**
 * The CreateAdminFieldsInput input type is used in operations that involve creation of objects in the Admin class.
 */
export interface GQLCreateAdminFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: string;
  
  /**
   * This is the object Configurations.
   */
  Configurations?: string;
  
  /**
   * This is the object HelpCentre.
   */
  HelpCentre?: string;
  
  /**
   * This is the object Listings.
   */
  Listings?: string;
  
  /**
   * This is the object Members.
   */
  Members?: string;
  
  /**
   * This is the object Promotions.
   */
  Promotions?: string;
  
  /**
   * This is the object Requests.
   */
  Requests?: string;
  
  /**
   * This is the object Settings.
   */
  Settings?: string;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object isFullAccess.
   */
  isFullAccess?: boolean;
}

export interface GQLCreateAdminInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateAdminFieldsInput;
}

/**
 * The CreateAmenityFieldsInput input type is used in operations that involve creation of objects in the Amenity class.
 */
export interface GQLCreateAmenityFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: Array<GQLAny | null>;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: Array<GQLAny | null>;
  
  /**
   * This is the object Bookings.
   */
  Bookings?: GQLOrderRelationInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Published.
   */
  Published?: Array<GQLAny | null>;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: Array<GQLAny | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object allowGuests.
   */
  allowGuests?: boolean;
  
  /**
   * This is the object autoBooking.
   */
  autoBooking?: boolean;
  
  /**
   * This is the object availabilityOverride.
   */
  availabilityOverride?: Array<GQLAny | null>;
  
  /**
   * This is the object bookingPeriod.
   */
  bookingPeriod: string;
  
  /**
   * This is the object bookingSlots.
   */
  bookingSlots: string;
  
  /**
   * This is the object bookingTiming.
   */
  bookingTiming?: GQLObject;
  
  /**
   * This is the object descr.
   */
  descr: string;
  
  /**
   * This is the object images.
   */
  images?: Array<GQLAny | null>;
  
  /**
   * This is the object isBookable.
   */
  isBookable?: boolean;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object maxBookingPerSlot.
   */
  maxBookingPerSlot: number;
  
  /**
   * This is the object maxBookingsPerDay.
   */
  maxBookingsPerDay: number;
  
  /**
   * This is the object maxResidentsPerBooking.
   */
  maxResidentsPerBooking: number;
  
  /**
   * This is the object messageAssignees.
   */
  messageAssignees?: Array<GQLAny | null>;
  
  /**
   * This is the object multipleFutureBookings.
   */
  multipleFutureBookings?: boolean;
  
  /**
   * This is the object name.
   */
  name: string;
  
  /**
   * This is the object popularDay.
   */
  popularDay?: string;
  
  /**
   * This is the object popularTime.
   */
  popularTime?: GQLDate;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType: string;
  
  /**
   * This is the object totalBookings.
   */
  totalBookings?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
}

export interface GQLCreateAmenityInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateAmenityFieldsInput;
}

/**
 * The CreateAppFileFieldsInput input type is used in operations that involve creation of objects in the AppFile class.
 */
export interface GQLCreateAppFileFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object file.
   */
  file?: GQLFileInput;
  
  /**
   * This is the object mime.
   */
  mime?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLCreateAppFileInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateAppFileFieldsInput;
}

/**
 * The CreateCategoryFieldsInput input type is used in operations that involve creation of objects in the Category class.
 */
export interface GQLCreateCategoryFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
}

export interface GQLCreateCategoryInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateCategoryFieldsInput;
}

/**
 * The CreateChatFieldsInput input type is used in operations that involve creation of objects in the Chat class.
 */
export interface GQLCreateChatFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Members.
   */
  Members?: GQLUserRelationInput;
  
  /**
   * This is the object Messages.
   */
  Messages?: GQLMessageRelationInput;
  
  /**
   * This is the object Support.
   */
  Support?: GQLUserPointerInput;
  
  /**
   * This is the object isArchived.
   */
  isArchived?: boolean;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLCreateChatInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateChatFieldsInput;
}

export interface GQLCreateClassInput {
  clientMutationId?: string;
  
  /**
   * This is the name of the object class.
   */
  name: string;
  
  /**
   * These are the schema's fields of the object class.
   */
  schemaFields?: GQLSchemaFieldsInput;
}

/**
 * The CreateCommunityAdminFieldsInput input type is used in operations that involve creation of objects in the CommunityAdmin class.
 */
export interface GQLCreateCommunityAdminFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: string;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Configurations.
   */
  Configurations?: string;
  
  /**
   * This is the object HelpCentre.
   */
  HelpCentre?: string;
  
  /**
   * This is the object Listings.
   */
  Listings?: string;
  
  /**
   * This is the object Members.
   */
  Members?: string;
  
  /**
   * This is the object Promotions.
   */
  Promotions?: string;
  
  /**
   * This is the object Requests.
   */
  Requests?: string;
  
  /**
   * This is the object Settings.
   */
  Settings?: string;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object label.
   */
  label?: string;
}

export interface GQLCreateCommunityAdminInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateCommunityAdminFieldsInput;
}

/**
 * The CreateCommunityFieldsInput input type is used in operations that involve creation of objects in the Community class.
 */
export interface GQLCreateCommunityFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Admins.
   */
  Admins?: GQLCommunityAdminRelationInput;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFilePointerInput;
  
  /**
   * This is the object Invitations.
   */
  Invitations?: GQLInvitationRelationInput;
  
  /**
   * This is the object Items.
   */
  Items?: GQLItemRelationInput;
  
  /**
   * This is the object JoinRequests.
   */
  JoinRequests?: GQLJoinRequestRelationInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object Residents.
   */
  Residents?: GQLUserRelationInput;
  
  /**
   * This is the object Subscr.
   */
  Subscr?: GQLSubscrPointerInput;
  
  /**
   * This is the object accessType.
   */
  accessType?: string;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object address_add.
   */
  address_add?: Array<GQLAny | null>;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the object allowChat.
   */
  allowChat?: boolean;
  
  /**
   * This is the object allowEvents.
   */
  allowEvents?: boolean;
  
  /**
   * This is the object allowPosts.
   */
  allowPosts?: boolean;
  
  /**
   * This is the object buildings.
   */
  buildings?: string;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObject;
  
  /**
   * This is the object countItems.
   */
  countItems?: number;
  
  /**
   * This is the object countMembers.
   */
  countMembers?: number;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObject;
  
  /**
   * This is the object invitation.
   */
  invitation?: string;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object listingApproval.
   */
  listingApproval?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object neighbourhood.
   */
  neighbourhood?: string;
  
  /**
   * This is the object options.
   */
  options?: GQLObject;
  
  /**
   * This is the object passCode.
   */
  passCode?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object totalMessages.
   */
  totalMessages?: number;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object units.
   */
  units?: string;
  
  /**
   * This is the object zip.
   */
  zip?: string;
  
  /**
   * This is the object zip_add.
   */
  zip_add?: Array<GQLAny | null>;
}

export interface GQLCreateCommunityInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateCommunityFieldsInput;
}

/**
 * The CreateCompanyFieldsInput input type is used in operations that involve creation of objects in the Company class.
 */
export interface GQLCreateCompanyFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object Published.
   */
  Published?: Array<GQLAny | null>;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object category.
   */
  category?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object images.
   */
  images?: Array<GQLAny | null>;
  
  /**
   * This is the object interestedUsers.
   */
  interestedUsers?: Array<GQLAny | null>;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object phone.
   */
  phone?: string;
  
  /**
   * This is the object promoCTA.
   */
  promoCTA?: string;
  
  /**
   * This is the object promoDescr.
   */
  promoDescr?: string;
  
  /**
   * This is the object promoTagline.
   */
  promoTagline?: string;
  
  /**
   * This is the object promotion.
   */
  promotion?: boolean;
  
  /**
   * This is the object revealCode.
   */
  revealCode?: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object totalClicks.
   */
  totalClicks?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
  
  /**
   * This is the object visitedWebsite.
   */
  visitedWebsite?: string;
  
  /**
   * This is the object website.
   */
  website?: string;
}

export interface GQLCreateCompanyInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateCompanyFieldsInput;
}

export interface GQLCreateCompanyReportInp {
  communityId: string;
  companyId: string;
  reportText: string;
}

/**
 * The CreateCurrencyFieldsInput input type is used in operations that involve creation of objects in the Currency class.
 */
export interface GQLCreateCurrencyFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object sign.
   */
  sign?: string;
}

export interface GQLCreateCurrencyInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateCurrencyFieldsInput;
}

/**
 * The CreateDocumentFieldsInput input type is used in operations that involve creation of objects in the Document class.
 */
export interface GQLCreateDocumentFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Cover.
   */
  Cover?: GQLAppFilePointerInput;
  
  /**
   * This is the object DocFile.
   */
  DocFile?: GQLAppFilePointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLCreateDocumentInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateDocumentFieldsInput;
}

/**
 * The CreateEventFieldsInput input type is used in operations that involve creation of objects in the Event class.
 */
export interface GQLCreateEventFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: Array<GQLAny | null>;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: Array<GQLAny | null>;
  
  /**
   * This is the object Attendees.
   */
  Attendees?: GQLUserRelationInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Published.
   */
  Published?: Array<GQLAny | null>;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: Array<GQLAny | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object allowGuests.
   */
  allowGuests?: boolean;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the object descr.
   */
  descr: string;
  
  /**
   * This is the object endTime.
   */
  endTime?: GQLDate;
  
  /**
   * This is the object eventType.
   */
  eventType?: string;
  
  /**
   * This is the object expiresDate.
   */
  expiresDate?: GQLDate;
  
  /**
   * This is the object images.
   */
  images?: Array<GQLAny | null>;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationInput;
  
  /**
   * This is the object listerReminded.
   */
  listerReminded?: boolean;
  
  /**
   * This is the object listerReminded6am.
   */
  listerReminded6am?: boolean;
  
  /**
   * This is the object locationDetails.
   */
  locationDetails?: string;
  
  /**
   * This is the object maxAttendees.
   */
  maxAttendees: number;
  
  /**
   * This is the object maxGuestsPerAttendee.
   */
  maxGuestsPerAttendee: number;
  
  /**
   * This is the object name.
   */
  name: string;
  
  /**
   * This is the object openTo.
   */
  openTo?: string;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: number;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType: string;
  
  /**
   * This is the object showAttendees.
   */
  showAttendees?: boolean;
  
  /**
   * This is the object startTime.
   */
  startTime?: GQLDate;
  
  /**
   * This is the object totalAttendees.
   */
  totalAttendees?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
}

export interface GQLCreateEventInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateEventFieldsInput;
}

export interface GQLCreateFileInput {
  clientMutationId?: string;
  
  /**
   * This is the new file to be created and uploaded.
   */
  upload: GQLUpload;
}

/**
 * The CreateGroupFieldsInput input type is used in operations that involve creation of objects in the Group class.
 */
export interface GQLCreateGroupFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFilePointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Members.
   */
  Members?: GQLUserRelationInput;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLCreateGroupInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateGroupFieldsInput;
}

/**
 * The CreateHelpDeskFieldsInput input type is used in operations that involve creation of objects in the HelpDesk class.
 */
export interface GQLCreateHelpDeskFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Assignee.
   */
  Assignee?: GQLUserPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object assignTo.
   */
  assignTo?: string;
  
  /**
   * This is the object buttonTitle.
   */
  buttonTitle?: string;
  
  /**
   * This is the object dailyQuoteAuthor.
   */
  dailyQuoteAuthor?: string;
  
  /**
   * This is the object descr.
   */
  descr: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object layOutOrder.
   */
  layOutOrder?: number;
  
  /**
   * This is the object title.
   */
  title: string;
  
  /**
   * This is the object type.
   */
  type: string;
}

export interface GQLCreateHelpDeskInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateHelpDeskFieldsInput;
}

/**
 * The CreateInstallationFieldsInput input type is used in operations that involve creation of objects in the Installation class.
 */
export interface GQLCreateInstallationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object GCMSenderId.
   */
  GCMSenderId?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object appIdentifier.
   */
  appIdentifier?: string;
  
  /**
   * This is the object appName.
   */
  appName?: string;
  
  /**
   * This is the object appVersion.
   */
  appVersion?: string;
  
  /**
   * This is the object badge.
   */
  badge?: number;
  
  /**
   * This is the object channels.
   */
  channels?: Array<GQLAny | null>;
  
  /**
   * This is the object deviceToken.
   */
  deviceToken?: string;
  
  /**
   * This is the object deviceType.
   */
  deviceType?: string;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object localeIdentifier.
   */
  localeIdentifier?: string;
  
  /**
   * This is the object parseVersion.
   */
  parseVersion?: string;
  
  /**
   * This is the object pushType.
   */
  pushType?: string;
  
  /**
   * This is the object timeZone.
   */
  timeZone?: string;
}

export interface GQLCreateInstallationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateInstallationFieldsInput;
}

/**
 * The CreateInvitationFieldsInput input type is used in operations that involve creation of objects in the Invitation class.
 */
export interface GQLCreateInvitationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailText.
   */
  emailText?: string;
  
  /**
   * This is the object invLink.
   */
  invLink?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLCreateInvitationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateInvitationFieldsInput;
}

/**
 * The CreateItemBookingFieldsInput input type is used in operations that involve creation of objects in the ItemBooking class.
 */
export interface GQLCreateItemBookingFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemPointerInput;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderPointerInput;
  
  /**
   * This is the object from.
   */
  from?: GQLDate;
  
  /**
   * This is the object to.
   */
  to?: GQLDate;
}

export interface GQLCreateItemBookingInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateItemBookingFieldsInput;
}

/**
 * The CreateItemFieldsInput input type is used in operations that involve creation of objects in the Item class.
 */
export interface GQLCreateItemFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: Array<GQLAny | null>;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: Array<GQLAny | null>;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Published.
   */
  Published?: Array<GQLAny | null>;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: Array<GQLAny | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object category.
   */
  category?: string;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the object createdAt_custom.
   */
  createdAt_custom?: GQLDate;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object discount.
   */
  discount?: number;
  
  /**
   * This is the object discountType.
   */
  discountType?: string;
  
  /**
   * This is the object images.
   */
  images?: Array<GQLAny | null>;
  
  /**
   * This is the object income.
   */
  income?: number;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object isSold.
   */
  isSold?: boolean;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationInput;
  
  /**
   * This is the object listingType.
   */
  listingType?: string;
  
  /**
   * This is the object maxPeriod.
   */
  maxPeriod?: number;
  
  /**
   * This is the object minDuration.
   */
  minDuration?: number;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object originalPrice.
   */
  originalPrice?: number;
  
  /**
   * This is the object price.
   */
  price?: number;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: string;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object totalCompletedOrders.
   */
  totalCompletedOrders?: number;
  
  /**
   * This is the object totalRequests.
   */
  totalRequests?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
  
  /**
   * This is the object yearPurchased.
   */
  yearPurchased?: string;
}

export interface GQLCreateItemInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateItemFieldsInput;
}

/**
 * The CreateJoinRequestFieldsInput input type is used in operations that involve creation of objects in the JoinRequest class.
 */
export interface GQLCreateJoinRequestFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Invitation.
   */
  Invitation?: GQLInvitationPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object answer.
   */
  answer?: string;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * This is the object request.
   */
  request?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLCreateJoinRequestInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateJoinRequestFieldsInput;
}

/**
 * The CreateLanguageFieldsInput input type is used in operations that involve creation of objects in the Language class.
 */
export interface GQLCreateLanguageFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the object isDisabled.
   */
  isDisabled?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
}

export interface GQLCreateLanguageInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateLanguageFieldsInput;
}

/**
 * The CreateLocationFieldsInput input type is used in operations that involve creation of objects in the Location class.
 */
export interface GQLCreateLocationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object City.
   */
  City?: GQLLocationPointerInput;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocationPointerInput;
  
  /**
   * This is the object State.
   */
  State?: GQLLocationPointerInput;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPointInput;
  
  /**
   * This is the object isDisabled.
   */
  isDisabled?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLCreateLocationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateLocationFieldsInput;
}

/**
 * The CreateMessageFieldsInput input type is used in operations that involve creation of objects in the Message class.
 */
export interface GQLCreateMessageFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Attachments.
   */
  Attachments?: Array<GQLAny | null>;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserPointerInput;
  
  /**
   * This is the object Chat.
   */
  Chat?: GQLChatPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderPointerInput;
  
  /**
   * This is the object Seen.
   */
  Seen?: Array<GQLAny | null>;
  
  /**
   * This is the object ShowTo.
   */
  ShowTo?: Array<GQLAny | null>;
  
  /**
   * This is the object localRef.
   */
  localRef?: string;
  
  /**
   * This is the object supportMsgStatus.
   */
  supportMsgStatus?: string;
  
  /**
   * This is the object text.
   */
  text?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLCreateMessageInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateMessageFieldsInput;
}

export interface GQLCreateMultiplyItemsInput {
  communityIds?: Array<string | null>;
  items?: Array<GQLObject | null>;
}

/**
 * The CreateMyClassFieldsInput input type is used in operations that involve creation of objects in the MyClass class.
 */
export interface GQLCreateMyClassFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object myField.
   */
  myField?: string;
}

export interface GQLCreateMyClassInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateMyClassFieldsInput;
}

/**
 * The CreateNotifSendingFieldsInput input type is used in operations that involve creation of objects in the NotifSending class.
 */
export interface GQLCreateNotifSendingFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object amenityAutoBookedEmailSent.
   */
  amenityAutoBookedEmailSent?: GQLDate;
  
  /**
   * This is the object amenityAutoBookedSmsSent.
   */
  amenityAutoBookedSmsSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledListerEmailSent.
   */
  amenityCanceledListerEmailSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledListerSmsSent.
   */
  amenityCanceledListerSmsSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledRequesterEmailSent.
   */
  amenityCanceledRequesterEmailSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledRequesterSmsSent.
   */
  amenityCanceledRequesterSmsSent?: GQLDate;
  
  /**
   * This is the object amenityConfirmationEmailSent.
   */
  amenityConfirmationEmailSent?: GQLDate;
  
  /**
   * This is the object amenityConfirmationSmsSent.
   */
  amenityConfirmationSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderBookedEmailSent.
   */
  amenityOrderBookedEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderBookedSmsSent.
   */
  amenityOrderBookedSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderCanceledEmailSent.
   */
  amenityOrderCanceledEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderCanceledSmsSent.
   */
  amenityOrderCanceledSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderPendingEmailSent.
   */
  amenityOrderPendingEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderPendingSmsSent.
   */
  amenityOrderPendingSmsSent?: GQLDate;
  
  /**
   * This is the object amenityReminderEmailSent.
   */
  amenityReminderEmailSent?: GQLDate;
  
  /**
   * This is the object amenityReminderPushSent.
   */
  amenityReminderPushSent?: GQLDate;
  
  /**
   * This is the object amenityReminderSmsSent.
   */
  amenityReminderSmsSent?: GQLDate;
  
  /**
   * This is the object amenityRequestEmailSent.
   */
  amenityRequestEmailSent?: GQLDate;
  
  /**
   * This is the object amenityRequestSmsSent.
   */
  amenityRequestSmsSent?: GQLDate;
  
  /**
   * This is the object blockUserEmailSent.
   */
  blockUserEmailSent?: GQLDate;
  
  /**
   * This is the object blockUserSmsSent.
   */
  blockUserSmsSent?: GQLDate;
  
  /**
   * This is the object companyReportedEmailSent.
   */
  companyReportedEmailSent?: GQLDate;
  
  /**
   * This is the object companyReportedSmsSent.
   */
  companyReportedSmsSent?: GQLDate;
  
  /**
   * This is the object eventAttendeesEmailSent.
   */
  eventAttendeesEmailSent?: GQLDate;
  
  /**
   * This is the object eventAttendeesPushSent.
   */
  eventAttendeesPushSent?: GQLDate;
  
  /**
   * This is the object eventAttendeesSmsSent.
   */
  eventAttendeesSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderAttendingEmailSent.
   */
  eventOrderAttendingEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderAttendingSmsSent.
   */
  eventOrderAttendingSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderCanceledEmailSent.
   */
  eventOrderCanceledEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderCanceledSmsSent.
   */
  eventOrderCanceledSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderPendingEmailSent.
   */
  eventOrderPendingEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderPendingSmsSent.
   */
  eventOrderPendingSmsSent?: GQLDate;
  
  /**
   * This is the object eventReminderEmailSent.
   */
  eventReminderEmailSent?: GQLDate;
  
  /**
   * This is the object eventReminderPushSent.
   */
  eventReminderPushSent?: GQLDate;
  
  /**
   * This is the object eventReminderSmsSent.
   */
  eventReminderSmsSent?: GQLDate;
  
  /**
   * This is the object eventReportedEmailSent.
   */
  eventReportedEmailSent?: GQLDate;
  
  /**
   * This is the object eventReportedSmsSent.
   */
  eventReportedSmsSent?: GQLDate;
  
  /**
   * This is the object itemReviewEmailSent.
   */
  itemReviewEmailSent?: GQLDate;
  
  /**
   * This is the object itemReviewSmsSent.
   */
  itemReviewSmsSent?: GQLDate;
  
  /**
   * This is the object itemViewEmailSent.
   */
  itemViewEmailSent?: GQLDate;
  
  /**
   * This is the object itemViewPushSent.
   */
  itemViewPushSent?: GQLDate;
  
  /**
   * This is the object itemViewSmsSent.
   */
  itemViewSmsSent?: GQLDate;
  
  /**
   * This is the object joinCommunitySmsSent.
   */
  joinCommunitySmsSent?: GQLDate;
  
  /**
   * This is the object joinRequestEmailSent.
   */
  joinRequestEmailSent?: GQLDate;
  
  /**
   * This is the object listingApprovedEmailSent.
   */
  listingApprovedEmailSent?: GQLDate;
  
  /**
   * This is the object listingApprovedSmsSent.
   */
  listingApprovedSmsSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestEmailSent.
   */
  listingPublishRequestEmailSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestPushSent.
   */
  listingPublishRequestPushSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestSmsSent.
   */
  listingPublishRequestSmsSent?: GQLDate;
  
  /**
   * This is the object listingRemovedEmailSent.
   */
  listingRemovedEmailSent?: GQLDate;
  
  /**
   * This is the object listingRemovedSmsSent.
   */
  listingRemovedSmsSent?: GQLDate;
  
  /**
   * This is the object listingRemovedSmsSmsSent.
   */
  listingRemovedSmsSmsSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesEmailSent.
   */
  managedAmenitiesEmailSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesPushSent.
   */
  managedAmenitiesPushSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesSmsSent.
   */
  managedAmenitiesSmsSent?: GQLDate;
  
  /**
   * This is the object newCommentEmailSent.
   */
  newCommentEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentInGroupEmailSent.
   */
  newCommentInGroupEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentPollEmailSent.
   */
  newCommentPollEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentPushSent.
   */
  newCommentPushSent?: GQLDate;
  
  /**
   * This is the object newCommentSmsSent.
   */
  newCommentSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinLikeEmailSent.
   */
  newJoinLikeEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinLikePushSent.
   */
  newJoinLikePushSent?: GQLDate;
  
  /**
   * This is the object newJoinLikeSmsSent.
   */
  newJoinLikeSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinSmileEmailSent.
   */
  newJoinSmileEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinSmilePushSent.
   */
  newJoinSmilePushSent?: GQLDate;
  
  /**
   * This is the object newJoinSmileSmsSent.
   */
  newJoinSmileSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinWaveEmailSent.
   */
  newJoinWaveEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinWavePushSent.
   */
  newJoinWavePushSent?: GQLDate;
  
  /**
   * This is the object newJoinWaveSmsSent.
   */
  newJoinWaveSmsSent?: GQLDate;
  
  /**
   * This is the object newLikeEmailSent.
   */
  newLikeEmailSent?: GQLDate;
  
  /**
   * This is the object newLikePollEmailSent.
   */
  newLikePollEmailSent?: GQLDate;
  
  /**
   * This is the object newLikePushSent.
   */
  newLikePushSent?: GQLDate;
  
  /**
   * This is the object newLikeSmsSent.
   */
  newLikeSmsSent?: GQLDate;
  
  /**
   * This is the object newListingEmailSent.
   */
  newListingEmailSent?: GQLDate;
  
  /**
   * This is the object newListingPushSent.
   */
  newListingPushSent?: GQLDate;
  
  /**
   * This is the object newListingSmsSent.
   */
  newListingSmsSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostEmailSent.
   */
  newManagerAdminPostEmailSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostPushSent.
   */
  newManagerAdminPostPushSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostSmsSent.
   */
  newManagerAdminPostSmsSent?: GQLDate;
  
  /**
   * This is the object newMessageEmailSent.
   */
  newMessageEmailSent?: GQLDate;
  
  /**
   * This is the object newMessagePushSent.
   */
  newMessagePushSent?: GQLDate;
  
  /**
   * This is the object newMessageSmsSent.
   */
  newMessageSmsSent?: GQLDate;
  
  /**
   * This is the object newNoticeEmailSent.
   */
  newNoticeEmailSent?: GQLDate;
  
  /**
   * This is the object newNoticeSmsSent.
   */
  newNoticeSmsSent?: GQLDate;
  
  /**
   * This is the object newPostEmailSent.
   */
  newPostEmailSent?: GQLDate;
  
  /**
   * This is the object newPostPushSent.
   */
  newPostPushSent?: GQLDate;
  
  /**
   * This is the object newPostSmsSent.
   */
  newPostSmsSent?: GQLDate;
  
  /**
   * This is the object newResidentEmailSent.
   */
  newResidentEmailSent?: GQLDate;
  
  /**
   * This is the object newResidentPushSent.
   */
  newResidentPushSent?: GQLDate;
  
  /**
   * This is the object newResidentSmsSent.
   */
  newResidentSmsSent?: GQLDate;
  
  /**
   * This is the object orderBuyAcceptedEmailSent.
   */
  orderBuyAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderBuyAcceptedSmsSent.
   */
  orderBuyAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderBuyRejectedEmailSent.
   */
  orderBuyRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderBuyRejectedSmsSent.
   */
  orderBuyRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRentAcceptedEmailSent.
   */
  orderRentAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderRentAcceptedSmsSent.
   */
  orderRentAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRentRejectedEmailSent.
   */
  orderRentRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderRentRejectedSmsSent.
   */
  orderRentRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRequestEmailSent.
   */
  orderRequestEmailSent?: GQLDate;
  
  /**
   * This is the object orderRequestSmsSent.
   */
  orderRequestSmsSent?: GQLDate;
  
  /**
   * This is the object orderServiceAcceptedEmailSent.
   */
  orderServiceAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderServiceAcceptedSmsSent.
   */
  orderServiceAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderServiceRejectedEmailSent.
   */
  orderServiceRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderServiceRejectedSmsSent.
   */
  orderServiceRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object rejectedRequestEmailSent.
   */
  rejectedRequestEmailSent?: GQLDate;
  
  /**
   * This is the object reportListingEmailSent.
   */
  reportListingEmailSent?: GQLDate;
  
  /**
   * This is the object reportListingSmsSent.
   */
  reportListingSmsSent?: GQLDate;
  
  /**
   * This is the object reportPostEmailSent.
   */
  reportPostEmailSent?: GQLDate;
  
  /**
   * This is the object reportPostSmsSent.
   */
  reportPostSmsSent?: GQLDate;
  
  /**
   * This is the object reportUserEmailSent.
   */
  reportUserEmailSent?: GQLDate;
  
  /**
   * This is the object reportUserSmsSent.
   */
  reportUserSmsSent?: GQLDate;
  
  /**
   * This is the object residentRemovedEmailSent.
   */
  residentRemovedEmailSent?: GQLDate;
  
  /**
   * This is the object residentRemovedSmsSent.
   */
  residentRemovedSmsSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesEmailSent.
   */
  unmanagedAmenitiesEmailSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesPushSent.
   */
  unmanagedAmenitiesPushSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesSmsSent.
   */
  unmanagedAmenitiesSmsSent?: GQLDate;
  
  /**
   * This is the object userViewEmailSent.
   */
  userViewEmailSent?: GQLDate;
  
  /**
   * This is the object userViewPushSent.
   */
  userViewPushSent?: GQLDate;
  
  /**
   * This is the object userViewSmsSent.
   */
  userViewSmsSent?: GQLDate;
}

export interface GQLCreateNotifSendingInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateNotifSendingFieldsInput;
}

/**
 * The CreateNotificationFieldsInput input type is used in operations that involve creation of objects in the Notification class.
 */
export interface GQLCreateNotificationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object event.
   */
  event?: string;
  
  /**
   * This is the object from.
   */
  from?: GQLUserPointerInput;
  
  /**
   * This is the object notifTypes.
   */
  notifTypes?: Array<GQLAny | null>;
  
  /**
   * This is the object seenDate.
   */
  seenDate?: GQLDate;
  
  /**
   * This is the object sendAt.
   */
  sendAt?: GQLDate;
  
  /**
   * This is the object sentIn.
   */
  sentIn?: GQLObject;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object to.
   */
  to?: GQLUserPointerInput;
}

export interface GQLCreateNotificationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateNotificationFieldsInput;
}

/**
 * The CreateOrderFieldsInput input type is used in operations that involve creation of objects in the Order class.
 */
export interface GQLCreateOrderFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Amenity.
   */
  Amenity?: GQLAmenityPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventPointerInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemPointerInput;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Requester.
   */
  Requester?: GQLUserPointerInput;
  
  /**
   * This is the object acceptedByLister.
   */
  acceptedByLister?: GQLDate;
  
  /**
   * This is the object acceptedByRequester.
   */
  acceptedByRequester?: GQLDate;
  
  /**
   * This is the object attendeeGuests.
   */
  attendeeGuests?: number;
  
  /**
   * This is the object cfListerAbs.
   */
  cfListerAbs?: number;
  
  /**
   * This is the object cfListerAmt.
   */
  cfListerAmt?: number;
  
  /**
   * This is the object cfListerPrc.
   */
  cfListerPrc?: number;
  
  /**
   * This is the object cfRequesterAbs.
   */
  cfRequesterAbs?: number;
  
  /**
   * This is the object cfRequesterAmt.
   */
  cfRequesterAmt?: number;
  
  /**
   * This is the object cfRequesterPrc.
   */
  cfRequesterPrc?: number;
  
  /**
   * This is the object discount.
   */
  discount?: number;
  
  /**
   * This is the object discountAmount.
   */
  discountAmount?: number;
  
  /**
   * This is the object discountType.
   */
  discountType?: string;
  
  /**
   * This is the object endTime.
   */
  endTime?: GQLDate;
  
  /**
   * This is the object externalPayments.
   */
  externalPayments?: boolean;
  
  /**
   * This is the object hangehDiscount.
   */
  hangehDiscount?: number;
  
  /**
   * This is the object hfListerAbs.
   */
  hfListerAbs?: number;
  
  /**
   * This is the object hfListerAmt.
   */
  hfListerAmt?: number;
  
  /**
   * This is the object hfListerPrc.
   */
  hfListerPrc?: number;
  
  /**
   * This is the object hfRequesterAbs.
   */
  hfRequesterAbs?: number;
  
  /**
   * This is the object hfRequesterAmt.
   */
  hfRequesterAmt?: number;
  
  /**
   * This is the object hfRequesterPrc.
   */
  hfRequesterPrc?: number;
  
  /**
   * This is the object itemAmount.
   */
  itemAmount?: number;
  
  /**
   * This is the object listerTotalAmt.
   */
  listerTotalAmt?: number;
  
  /**
   * This is the object listingType.
   */
  listingType?: string;
  
  /**
   * This is the object oldStatus.
   */
  oldStatus?: string;
  
  /**
   * This is the object orderType.
   */
  orderType?: string;
  
  /**
   * This is the object payMethod.
   */
  payMethod?: string;
  
  /**
   * This is the object period.
   */
  period?: number;
  
  /**
   * This is the object ppListerAbs.
   */
  ppListerAbs?: number;
  
  /**
   * This is the object ppListerAmt.
   */
  ppListerAmt?: number;
  
  /**
   * This is the object ppListerPrc.
   */
  ppListerPrc?: number;
  
  /**
   * This is the object ppRequesterAbs.
   */
  ppRequesterAbs?: number;
  
  /**
   * This is the object ppRequesterAmt.
   */
  ppRequesterAmt?: number;
  
  /**
   * This is the object ppRequesterPrc.
   */
  ppRequesterPrc?: number;
  
  /**
   * This is the object price.
   */
  price?: number;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: string;
  
  /**
   * This is the object recurringEvent.
   */
  recurringEvent?: boolean;
  
  /**
   * This is the object reminder6atMorningSent.
   */
  reminder6atMorningSent?: boolean;
  
  /**
   * This is the object reminderSent.
   */
  reminderSent?: boolean;
  
  /**
   * This is the object requesterTotalAmt.
   */
  requesterTotalAmt?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: string;
  
  /**
   * This is the object sfListerAmt.
   */
  sfListerAmt?: number;
  
  /**
   * This is the object sfRequesterAmt.
   */
  sfRequesterAmt?: number;
  
  /**
   * This is the object startTime.
   */
  startTime?: GQLDate;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLCreateOrderInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateOrderFieldsInput;
}

/**
 * The CreatePaymentPlanFieldsInput input type is used in operations that involve creation of objects in the PaymentPlan class.
 */
export interface GQLCreatePaymentPlanFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object communityFee.
   */
  communityFee?: boolean;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object extraListing.
   */
  extraListing?: number;
  
  /**
   * This is the object extraResident.
   */
  extraResident?: number;
  
  /**
   * This is the object isPublic.
   */
  isPublic?: boolean;
  
  /**
   * This is the object listingCap.
   */
  listingCap?: number;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object options.
   */
  options?: Array<GQLAny | null>;
  
  /**
   * This is the object priceMonth.
   */
  priceMonth?: number;
  
  /**
   * This is the object priceYear.
   */
  priceYear?: number;
  
  /**
   * This is the object rentFees.
   */
  rentFees?: GQLObject;
  
  /**
   * This is the object rentalExternal.
   */
  rentalExternal?: boolean;
  
  /**
   * This is the object residentCap.
   */
  residentCap?: number;
  
  /**
   * This is the object salesExternal.
   */
  salesExternal?: boolean;
  
  /**
   * This is the object salesFees.
   */
  salesFees?: GQLObject;
  
  /**
   * This is the object serviceExternal.
   */
  serviceExternal?: boolean;
  
  /**
   * This is the object serviceFees.
   */
  serviceFees?: GQLObject;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLCreatePaymentPlanInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreatePaymentPlanFieldsInput;
}

/**
 * The CreatePhoneVerificationFieldsInput input type is used in operations that involve creation of objects in the PhoneVerification class.
 */
export interface GQLCreatePhoneVerificationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object verificationCode.
   */
  verificationCode?: string;
}

export interface GQLCreatePhoneVerificationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreatePhoneVerificationFieldsInput;
}

/**
 * The CreatePollOptionFieldsInput input type is used in operations that involve creation of objects in the PollOption class.
 */
export interface GQLCreatePollOptionFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostPointerInput;
  
  /**
   * This is the object Translate.
   */
  Translate?: GQLPostTranslatePointerInput;
  
  /**
   * This is the object Voted.
   */
  Voted?: GQLUserRelationInput;
  
  /**
   * This is the object countVotes.
   */
  countVotes?: number;
  
  /**
   * This is the object isVoted.
   */
  isVoted?: boolean;
  
  /**
   * This is the object position.
   */
  position?: number;
  
  /**
   * This is the object text.
   */
  text?: string;
}

export interface GQLCreatePollOptionInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreatePollOptionFieldsInput;
}

/**
 * The CreatePostFieldsInput input type is used in operations that involve creation of objects in the Post class.
 */
export interface GQLCreatePostFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Attachments.
   */
  Attachments?: Array<GQLAny | null>;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Group.
   */
  Group?: GQLGroupPointerInput;
  
  /**
   * This is the object Hide.
   */
  Hide?: GQLUserRelationInput;
  
  /**
   * This is the object Items.
   */
  Items?: Array<GQLAny | null>;
  
  /**
   * This is the object Options.
   */
  Options?: GQLPollOptionRelationInput;
  
  /**
   * This is the object Parent.
   */
  Parent?: GQLPostPointerInput;
  
  /**
   * This is the object Pin.
   */
  Pin?: Array<GQLAny | null>;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Seen.
   */
  Seen?: Array<GQLAny | null>;
  
  /**
   * This is the object Translate.
   */
  Translate?: GQLPostTranslatePointerInput;
  
  /**
   * This is the object comments.
   */
  comments?: GQLPostRelationInput;
  
  /**
   * This is the object countComments.
   */
  countComments?: number;
  
  /**
   * This is the object countHides.
   */
  countHides?: number;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the object countSmiles.
   */
  countSmiles?: number;
  
  /**
   * This is the object countWaves.
   */
  countWaves?: number;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object isComment.
   */
  isComment?: boolean;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isHidden.
   */
  isHidden?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isMulti.
   */
  isMulti?: boolean;
  
  /**
   * This is the object isSmile.
   */
  isSmile?: boolean;
  
  /**
   * This is the object isWave.
   */
  isWave?: boolean;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationInput;
  
  /**
   * This is the object localRef.
   */
  localRef?: string;
  
  /**
   * This is the object medium.
   */
  medium?: Array<GQLAny | null>;
  
  /**
   * This is the object notShow.
   */
  notShow?: boolean;
  
  /**
   * This is the object pollOptions.
   */
  pollOptions?: Array<GQLAny | null>;
  
  /**
   * This is the object sentAs.
   */
  sentAs?: string;
  
  /**
   * This is the object smiles.
   */
  smiles?: GQLUserRelationInput;
  
  /**
   * This is the object text.
   */
  text?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object waves.
   */
  waves?: GQLUserRelationInput;
}

export interface GQLCreatePostInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreatePostFieldsInput;
}

/**
 * The CreatePostTranslateFieldsInput input type is used in operations that involve creation of objects in the PostTranslate class.
 */
export interface GQLCreatePostTranslateFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object PollOption.
   */
  PollOption?: GQLPollOptionPointerInput;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostPointerInput;
  
  /**
   * This is the object en.
   */
  en?: string;
  
  /**
   * This is the object fr.
   */
  fr?: string;
  
  /**
   * This is the object originalLang.
   */
  originalLang?: string;
  
  /**
   * This is the object ru.
   */
  ru?: string;
}

export interface GQLCreatePostTranslateInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreatePostTranslateFieldsInput;
}

/**
 * The CreatePromoFieldsInput input type is used in operations that involve creation of objects in the Promo class.
 */
export interface GQLCreatePromoFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: Array<GQLAny | null>;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object endDate.
   */
  endDate?: GQLDate;
  
  /**
   * This is the object isCommunity.
   */
  isCommunity?: boolean;
  
  /**
   * This is the object startDate.
   */
  startDate?: GQLDate;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object usageLimit.
   */
  usageLimit?: number;
  
  /**
   * This is the object value.
   */
  value?: number;
  
  /**
   * This is the object valueType.
   */
  valueType?: string;
}

export interface GQLCreatePromoInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreatePromoFieldsInput;
}

/**
 * The CreatePushNotificationLogFieldsInput input type is used in operations that involve creation of objects in the PushNotificationLog class.
 */
export interface GQLCreatePushNotificationLogFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * This is the object message.
   */
  message?: string;
  
  /**
   * This is the object result.
   */
  result?: boolean;
  
  /**
   * This is the object user.
   */
  user?: GQLUserPointerInput;
}

export interface GQLCreatePushNotificationLogInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreatePushNotificationLogFieldsInput;
}

/**
 * The CreateReferralFieldsInput input type is used in operations that involve creation of objects in the Referral class.
 */
export interface GQLCreateReferralFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object ReferralBy.
   */
  ReferralBy?: GQLUserPointerInput;
  
  /**
   * This is the object Referrals.
   */
  Referrals?: GQLUserRelationInput;
  
  /**
   * This is the object ReferralsCount.
   */
  ReferralsCount?: number;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object accumulatedDiscount.
   */
  accumulatedDiscount?: number;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object userMadeTransaction.
   */
  userMadeTransaction?: boolean;
}

export interface GQLCreateReferralInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateReferralFieldsInput;
}

/**
 * The CreateReportFieldsInput input type is used in operations that involve creation of objects in the Report class.
 */
export interface GQLCreateReportFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community: GQLCommunityPointerInput;
  
  /**
   * This is the object Company.
   */
  Company?: GQLCompanyPointerInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventPointerInput;
  
  /**
   * This is the object Group.
   */
  Group?: GQLGroupPointerInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemPointerInput;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostPointerInput;
  
  /**
   * This is the object Reporter.
   */
  Reporter?: GQLUserPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object blockUserText.
   */
  blockUserText?: string;
  
  /**
   * This is the object reportText.
   */
  reportText?: string;
}

export interface GQLCreateReportInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateReportFieldsInput;
}

/**
 * The CreateReviewFieldsInput input type is used in operations that involve creation of objects in the Review class.
 */
export interface GQLCreateReviewFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Amenity.
   */
  Amenity?: GQLAmenityPointerInput;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventPointerInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemPointerInput;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object stars.
   */
  stars?: number;
  
  /**
   * This is the object subject.
   */
  subject?: string;
  
  /**
   * This is the object text.
   */
  text?: string;
}

export interface GQLCreateReviewInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateReviewFieldsInput;
}

/**
 * The CreateRoleFieldsInput input type is used in operations that involve creation of objects in the Role class.
 */
export interface GQLCreateRoleFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object roles.
   */
  roles?: GQLRoleRelationInput;
  
  /**
   * This is the object users.
   */
  users?: GQLUserRelationInput;
}

export interface GQLCreateRoleInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateRoleFieldsInput;
}

/**
 * The CreateSessionFieldsInput input type is used in operations that involve creation of objects in the Session class.
 */
export interface GQLCreateSessionFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object createdWith.
   */
  createdWith?: GQLObject;
  
  /**
   * This is the object expiresAt.
   */
  expiresAt?: GQLDate;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object restricted.
   */
  restricted?: boolean;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object user.
   */
  user?: GQLUserPointerInput;
}

export interface GQLCreateSessionInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateSessionFieldsInput;
}

/**
 * The CreateSubscrFieldsInput input type is used in operations that involve creation of objects in the Subscr class.
 */
export interface GQLCreateSubscrFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLCommunityRelationInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object PaymentPlan.
   */
  PaymentPlan?: GQLPaymentPlanPointerInput;
  
  /**
   * This is the object SubscrPayments.
   */
  SubscrPayments?: GQLSubscrPaymentRelationInput;
  
  /**
   * This is the object beginAt.
   */
  beginAt?: GQLDate;
  
  /**
   * This is the object expireAt.
   */
  expireAt?: GQLDate;
  
  /**
   * This is the object netPaid.
   */
  netPaid?: number;
  
  /**
   * This is the object paymentPeriod.
   */
  paymentPeriod?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLCreateSubscrInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateSubscrFieldsInput;
}

/**
 * The CreateSubscrPaymentFieldsInput input type is used in operations that involve creation of objects in the SubscrPayment class.
 */
export interface GQLCreateSubscrPaymentFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Subscr.
   */
  Subscr?: GQLSubscrPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object amount.
   */
  amount?: number;
  
  /**
   * This is the object data.
   */
  data?: string;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLCreateSubscrPaymentInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateSubscrPaymentFieldsInput;
}

/**
 * The CreateTaskFieldsInput input type is used in operations that involve creation of objects in the Task class.
 */
export interface GQLCreateTaskFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object File.
   */
  File?: GQLAppFilePointerInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * This is the object options.
   */
  options?: Array<GQLAny | null>;
  
  /**
   * This is the object processedRow.
   */
  processedRow?: number;
  
  /**
   * This is the object result.
   */
  result?: string;
}

export interface GQLCreateTaskInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateTaskFieldsInput;
}

/**
 * The CreateTransactionFieldsInput input type is used in operations that involve creation of objects in the Transaction class.
 */
export interface GQLCreateTransactionFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object amount.
   */
  amount?: number;
  
  /**
   * This is the object data.
   */
  data?: string;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object transferDest.
   */
  transferDest?: string;
  
  /**
   * This is the object transferGroup.
   */
  transferGroup?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLCreateTransactionInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateTransactionFieldsInput;
}

/**
 * The CreateUserFieldsInput input type is used in operations that involve creation of objects in the User class.
 */
export interface GQLCreateUserFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFilePointerInput;
  
  /**
   * This is the object Blocked.
   */
  Blocked?: Array<GQLAny | null>;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLCommunityRelationInput;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocationPointerInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Language.
   */
  Language?: GQLLanguagePointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Orders.
   */
  Orders?: GQLOrderRelationInput;
  
  /**
   * This is the object ReferralCode.
   */
  ReferralCode?: string;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object aptSuite.
   */
  aptSuite?: string;
  
  /**
   * This is the object authData.
   */
  authData?: GQLObject;
  
  /**
   * This is the object bio.
   */
  bio?: string;
  
  /**
   * This is the object birthDate.
   */
  birthDate?: GQLDate;
  
  /**
   * This is the object cardInfo.
   */
  cardInfo?: Array<GQLAny | null>;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObject;
  
  /**
   * This is the object checkListSeen.
   */
  checkListSeen?: boolean;
  
  /**
   * This is the object distance.
   */
  distance?: string;
  
  /**
   * This is the object earned.
   */
  earned?: number;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: boolean;
  
  /**
   * This is the object firstLetter.
   */
  firstLetter?: string;
  
  /**
   * This is the object firstName.
   */
  firstName?: string;
  
  /**
   * This is the object gender.
   */
  gender?: string;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPointInput;
  
  /**
   * This is the object homepage.
   */
  homepage?: string;
  
  /**
   * This is the object howDidYouHear.
   */
  howDidYouHear?: string;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObject;
  
  /**
   * This is the object interests.
   */
  interests?: Array<GQLAny | null>;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isInvited.
   */
  isInvited?: boolean;
  
  /**
   * This is the object isOnline.
   */
  isOnline?: boolean;
  
  /**
   * This is the object isSupport.
   */
  isSupport?: boolean;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object isWaved.
   */
  isWaved?: boolean;
  
  /**
   * This is the object languages.
   */
  languages?: string;
  
  /**
   * This is the object lastName.
   */
  lastName?: string;
  
  /**
   * This is the object lastVisitedCommunity.
   */
  lastVisitedCommunity?: string;
  
  /**
   * This is the object listingCount.
   */
  listingCount?: number;
  
  /**
   * This is the object livingWith.
   */
  livingWith?: string;
  
  /**
   * This is the object mobilePushEnabled.
   */
  mobilePushEnabled?: boolean;
  
  /**
   * This is the object msgIncoming.
   */
  msgIncoming?: string;
  
  /**
   * This is the object notifyAmenityReminder.
   */
  notifyAmenityReminder?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyDigest.
   */
  notifyDigest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyEventAttendees.
   */
  notifyEventAttendees?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyEventReminder.
   */
  notifyEventReminder?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyHelpCentre.
   */
  notifyHelpCentre?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyJoinRequest.
   */
  notifyJoinRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyLikeOrComment.
   */
  notifyLikeOrComment?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyListingView.
   */
  notifyListingView?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyListingsRequest.
   */
  notifyListingsRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyLoopPost.
   */
  notifyLoopPost?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyManagedAmenities.
   */
  notifyManagedAmenities?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyManagerAdminPost.
   */
  notifyManagerAdminPost?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyMarketingAndFeatures.
   */
  notifyMarketingAndFeatures?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyMessage.
   */
  notifyMessage?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewCommunities.
   */
  notifyNewCommunities?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewListing.
   */
  notifyNewListing?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewListings.
   */
  notifyNewListings?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewMember.
   */
  notifyNewMember?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewMembers.
   */
  notifyNewMembers?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewRequests.
   */
  notifyNewRequests?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewResidentListings.
   */
  notifyNewResidentListings?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewResidents.
   */
  notifyNewResidents?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewTransaction.
   */
  notifyNewTransaction?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyOrderRequest.
   */
  notifyOrderRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyProfileView.
   */
  notifyProfileView?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyUnmanagedAmenities.
   */
  notifyUnmanagedAmenities?: Array<GQLAny | null>;
  
  /**
   * This is the object occupation.
   */
  occupation?: string;
  
  /**
   * This is the object onlineDate.
   */
  onlineDate?: GQLDate;
  
  /**
   * This is the object password.
   */
  password: string;
  
  /**
   * This is the object personInterests.
   */
  personInterests?: Array<GQLAny | null>;
  
  /**
   * This is the object phone.
   */
  phone?: string;
  
  /**
   * This is the object phoneVerified.
   */
  phoneVerified?: boolean;
  
  /**
   * This is the object platformStripeId.
   */
  platformStripeId?: string;
  
  /**
   * This is the object profileViewOff.
   */
  profileViewOff?: boolean;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object recommendations.
   */
  recommendations?: GQLObject;
  
  /**
   * This is the object spent.
   */
  spent?: number;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeConnectedId.
   */
  stripeConnectedId?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object study.
   */
  study?: string;
  
  /**
   * This is the object tips.
   */
  tips?: GQLObject;
  
  /**
   * This is the object username.
   */
  username: string;
  
  /**
   * This is the object work.
   */
  work?: string;
  
  /**
   * This is the object zip.
   */
  zip?: string;
}

export interface GQLCreateUserInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateUserFieldsInput;
}

export interface GQLCreateUserReferralInput {
  referralCode: string;
  userId: string;
}

/**
 * Allow to link OR add and link an object of the Currency class.
 */
export interface GQLCurrencyPointerInput {
  
  /**
   * Create and link an object from Currency class.
   */
  createAndLink?: GQLCreateCurrencyFieldsInput;
  
  /**
   * Link an existing object from Currency class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Currency class into a relation field.
 */
export interface GQLCurrencyRelationInput {
  
  /**
   * Add existing objects from the Currency class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Currency class into the relation.
   */
  createAndAdd?: Array<GQLCreateCurrencyFieldsInput>;
  
  /**
   * Remove existing objects from the Currency class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The CurrencyRelationWhereInput input type is used in operations that involve filtering objects of Currency class.
 */
export interface GQLCurrencyRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLCurrencyWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLCurrencyWhereInput;
}

/**
 * The CurrencyWhereInput input type is used in operations that involve filtering objects of Currency class.
 */
export interface GQLCurrencyWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLCurrencyWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLCurrencyWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLCurrencyWhereInput>;
  
  /**
   * This is the object code.
   */
  code?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object sign.
   */
  sign?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * The DateWhereInput input type is used in operations that involve filtering objects by a field of type Date.
 */
export interface GQLDateWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLDate;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLDate;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLDate;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLDate | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLDate;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLDate;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLDate;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLDate | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

export interface GQLDeleteAdminInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteAmenityInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteAppFileInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteCategoryInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteChatInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteClassInput {
  clientMutationId?: string;
  
  /**
   * This is the name of the object class.
   */
  name: string;
}

export interface GQLDeleteCommunityAdminInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteCommunityInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteCompanyInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteCurrencyInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteDocumentInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteEventInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteGroupInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteHelpDeskInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteInstallationInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteInvitationInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteItemBookingInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteItemInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteJoinRequestInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteLanguageInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteLocationInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteMessageInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteMyClassInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteNotifSendingInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteNotificationInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteOrderInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeletePaymentPlanInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeletePhoneVerificationInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeletePollOptionInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeletePostInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeletePostTranslateInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeletePromoInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeletePushNotificationLogInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteReferralInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteReportInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteReviewInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteRoleInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteSessionInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteSubscrInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteSubscrPaymentInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteTaskInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteTransactionInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteUserInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDirectAddMemberInp {
  autoAddKey: string;
}

/**
 * Allow to link OR add and link an object of the Document class.
 */
export interface GQLDocumentPointerInput {
  
  /**
   * Create and link an object from Document class.
   */
  createAndLink?: GQLCreateDocumentFieldsInput;
  
  /**
   * Link an existing object from Document class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Document class into a relation field.
 */
export interface GQLDocumentRelationInput {
  
  /**
   * Add existing objects from the Document class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Document class into the relation.
   */
  createAndAdd?: Array<GQLCreateDocumentFieldsInput>;
  
  /**
   * Remove existing objects from the Document class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The DocumentRelationWhereInput input type is used in operations that involve filtering objects of Document class.
 */
export interface GQLDocumentRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLDocumentWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLDocumentWhereInput;
}

export interface GQLDocumentStatusInp {
  docId: string;
  type: GQLDocumentActions;
}

/**
 * The DocumentWhereInput input type is used in operations that involve filtering objects of Document class.
 */
export interface GQLDocumentWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLDocumentWhereInput>;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Cover.
   */
  Cover?: GQLAppFileRelationWhereInput;
  
  /**
   * This is the object DocFile.
   */
  DocFile?: GQLAppFileRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLDocumentWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLDocumentWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object alias.
   */
  alias?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: GQLBooleanWhereInput;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: GQLBooleanWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLEventManageButtonsInp {
  action: GQLEventManageAction;
  communityIdList: Array<string | null>;
  eventId: string;
}

/**
 * Allow to link OR add and link an object of the Event class.
 */
export interface GQLEventPointerInput {
  
  /**
   * Create and link an object from Event class.
   */
  createAndLink?: GQLCreateEventFieldsInput;
  
  /**
   * Link an existing object from Event class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Event class into a relation field.
 */
export interface GQLEventRelationInput {
  
  /**
   * Add existing objects from the Event class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Event class into the relation.
   */
  createAndAdd?: Array<GQLCreateEventFieldsInput>;
  
  /**
   * Remove existing objects from the Event class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The EventRelationWhereInput input type is used in operations that involve filtering objects of Event class.
 */
export interface GQLEventRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLEventWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLEventWhereInput;
}

/**
 * The EventWhereInput input type is used in operations that involve filtering objects of Event class.
 */
export interface GQLEventWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLEventWhereInput>;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: GQLArrayWhereInput;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: GQLArrayWhereInput;
  
  /**
   * This is the object Attendees.
   */
  Attendees?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: GQLArrayWhereInput;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLEventWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLEventWhereInput>;
  
  /**
   * This is the object Published.
   */
  Published?: GQLArrayWhereInput;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationWhereInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationWhereInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationWhereInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: GQLArrayWhereInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationWhereInput;
  
  /**
   * This is the object allowGuests.
   */
  allowGuests?: GQLBooleanWhereInput;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object endTime.
   */
  endTime?: GQLDateWhereInput;
  
  /**
   * This is the object eventType.
   */
  eventType?: GQLStringWhereInput;
  
  /**
   * This is the object expiresDate.
   */
  expiresDate?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object images.
   */
  images?: GQLArrayWhereInput;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: GQLBooleanWhereInput;
  
  /**
   * This is the object isLike.
   */
  isLike?: GQLBooleanWhereInput;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: GQLBooleanWhereInput;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationWhereInput;
  
  /**
   * This is the object listerReminded.
   */
  listerReminded?: GQLBooleanWhereInput;
  
  /**
   * This is the object listerReminded6am.
   */
  listerReminded6am?: GQLBooleanWhereInput;
  
  /**
   * This is the object locationDetails.
   */
  locationDetails?: GQLStringWhereInput;
  
  /**
   * This is the object maxAttendees.
   */
  maxAttendees?: GQLNumberWhereInput;
  
  /**
   * This is the object maxGuestsPerAttendee.
   */
  maxGuestsPerAttendee?: GQLNumberWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object openTo.
   */
  openTo?: GQLStringWhereInput;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: GQLNumberWhereInput;
  
  /**
   * This is the object rating.
   */
  rating?: GQLNumberWhereInput;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: GQLStringWhereInput;
  
  /**
   * This is the object showAttendees.
   */
  showAttendees?: GQLBooleanWhereInput;
  
  /**
   * This is the object startTime.
   */
  startTime?: GQLDateWhereInput;
  
  /**
   * This is the object totalAttendees.
   */
  totalAttendees?: GQLNumberWhereInput;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: GQLNumberWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLFileInput {
  
  /**
   * A File Scalar can be an url or a FileInfo object. If this field is set to null the file will be unlinked.
   */
  file?: GQLFile;
  
  /**
   * Use this field if you want to unlink the file (the file will not be deleted on cloud storage)
   */
  unlink?: boolean;
  
  /**
   * Use this field if you want to create a new file.
   */
  upload?: GQLUpload;
}

/**
 * The FileWhereInput input type is used in operations that involve filtering objects by a field of type File.
 */
export interface GQLFileWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLFile;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLFile;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLFile;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLFile | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLFile;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLFile;
  
  /**
   * This is the matchesRegex operator to specify a constraint to select the objects where the value of a field matches a specified regular expression.
   */
  matchesRegex?: string;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLFile;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLFile | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
  
  /**
   * This is the options operator to specify optional flags (such as "i" and "m") to be added to a matchesRegex operation in the same set of constraints.
   */
  options?: string;
}

export interface GQLGenerateAiOpenApiTextInput {
  promptData?: Array<GQLObject | null>;
  textType?: string;
}

export interface GQLGenerateUsernameInp {
  name: string;
}

/**
 * The GeoIntersectsInput type is used to specify a geoIntersects operation on a constraint.
 */
export interface GQLGeoIntersectsInput {
  
  /**
   * This is the point to be specified.
   */
  point?: GQLGeoPointInput;
}

/**
 * The GeoPointInput type is used in operations that involve inputting fields of type geo point.
 */
export interface GQLGeoPointInput {
  
  /**
   * This is the latitude.
   */
  latitude: number;
  
  /**
   * This is the longitude.
   */
  longitude: number;
}

/**
 * The GeoPointWhereInput input type is used in operations that involve filtering objects by a field of type GeoPoint.
 */
export interface GQLGeoPointWhereInput {
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the geoWithin operator to specify a constraint to select the objects where the values of a geo point field is within a specified polygon or sphere.
   */
  geoWithin?: GQLGeoWithinInput;
  
  /**
   * This is the maxDistance operator to specify a constraint to select the objects where the values of a geo point field is at a max distance (in radians) from the geo point specified in the $nearSphere operator.
   */
  maxDistance?: number;
  
  /**
   * This is the maxDistanceInKilometers operator to specify a constraint to select the objects where the values of a geo point field is at a max distance (in kilometers) from the geo point specified in the $nearSphere operator.
   */
  maxDistanceInKilometers?: number;
  
  /**
   * This is the maxDistanceInMiles operator to specify a constraint to select the objects where the values of a geo point field is at a max distance (in miles) from the geo point specified in the $nearSphere operator.
   */
  maxDistanceInMiles?: number;
  
  /**
   * This is the maxDistanceInRadians operator to specify a constraint to select the objects where the values of a geo point field is at a max distance (in radians) from the geo point specified in the $nearSphere operator.
   */
  maxDistanceInRadians?: number;
  
  /**
   * This is the nearSphere operator to specify a constraint to select the objects where the values of a geo point field is near to another geo point.
   */
  nearSphere?: GQLGeoPointInput;
  
  /**
   * This is the within operator to specify a constraint to select the objects where the values of a geo point field is within a specified box.
   */
  within?: GQLWithinInput;
}

/**
 * The GeoWithinInput type is used to specify a geoWithin operation on a constraint.
 */
export interface GQLGeoWithinInput {
  
  /**
   * This is the sphere to be specified.
   */
  centerSphere?: GQLCenterSphereInput;
  
  /**
   * This is the polygon to be specified.
   */
  polygon?: Array<GQLGeoPointInput>;
}

export interface GQLGetItemArraysInput {
  communityId?: string;
}

export interface GQLGetManagersListInp {
  communityId: string;
}

export interface GQLGetNewPasswordInp {
  userId: string;
}

export interface GQLGetResidentsAvatarInput {
  communityId?: string;
}

export interface GQLGetUserByReferralInput {
  referralCode: string;
}

export interface GQLGetUserCardsInp {
  userId?: string;
}

export interface GQLGetUserPermissionsListInp {
  communityId: string;
  userId: string;
}

export interface GQLGroupInp {
  groupId: string;
}

export interface GQLGroupManageButtonsInpInp {
  action: GQLGroupManageAction;
  communityIdList: Array<string | null>;
  groupId: string;
}

/**
 * Allow to link OR add and link an object of the Group class.
 */
export interface GQLGroupPointerInput {
  
  /**
   * Create and link an object from Group class.
   */
  createAndLink?: GQLCreateGroupFieldsInput;
  
  /**
   * Link an existing object from Group class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Group class into a relation field.
 */
export interface GQLGroupRelationInput {
  
  /**
   * Add existing objects from the Group class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Group class into the relation.
   */
  createAndAdd?: Array<GQLCreateGroupFieldsInput>;
  
  /**
   * Remove existing objects from the Group class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The GroupRelationWhereInput input type is used in operations that involve filtering objects of Group class.
 */
export interface GQLGroupRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLGroupWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLGroupWhereInput;
}

/**
 * The GroupWhereInput input type is used in operations that involve filtering objects of Group class.
 */
export interface GQLGroupWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLGroupWhereInput>;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFileRelationWhereInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: GQLArrayWhereInput;
  
  /**
   * This is the object Members.
   */
  Members?: GQLUserRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLGroupWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLGroupWhereInput>;
  
  /**
   * This is the object alias.
   */
  alias?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object description.
   */
  description?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: GQLBooleanWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLHelpDeskListOrderInp {
  orderList: Array<string | null>;
}

/**
 * Allow to link OR add and link an object of the HelpDesk class.
 */
export interface GQLHelpDeskPointerInput {
  
  /**
   * Create and link an object from HelpDesk class.
   */
  createAndLink?: GQLCreateHelpDeskFieldsInput;
  
  /**
   * Link an existing object from HelpDesk class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the HelpDesk class into a relation field.
 */
export interface GQLHelpDeskRelationInput {
  
  /**
   * Add existing objects from the HelpDesk class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the HelpDesk class into the relation.
   */
  createAndAdd?: Array<GQLCreateHelpDeskFieldsInput>;
  
  /**
   * Remove existing objects from the HelpDesk class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The HelpDeskRelationWhereInput input type is used in operations that involve filtering objects of HelpDesk class.
 */
export interface GQLHelpDeskRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLHelpDeskWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLHelpDeskWhereInput;
}

/**
 * The HelpDeskWhereInput input type is used in operations that involve filtering objects of HelpDesk class.
 */
export interface GQLHelpDeskWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLHelpDeskWhereInput>;
  
  /**
   * This is the object Assignee.
   */
  Assignee?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLHelpDeskWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLHelpDeskWhereInput>;
  
  /**
   * This is the object assignTo.
   */
  assignTo?: GQLStringWhereInput;
  
  /**
   * This is the object buttonTitle.
   */
  buttonTitle?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object dailyQuoteAuthor.
   */
  dailyQuoteAuthor?: GQLStringWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: GQLBooleanWhereInput;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: GQLBooleanWhereInput;
  
  /**
   * This is the object layOutOrder.
   */
  layOutOrder?: GQLNumberWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object title.
   */
  title?: GQLStringWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLHidePostInput {
  postID: string;
}

/**
 * The IdWhereInput input type is used in operations that involve filtering objects by an id.
 */
export interface GQLIdWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: string;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: string;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: string;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<string | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: string;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: string;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: string;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<string | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * Allow to link OR add and link an object of the Installation class.
 */
export interface GQLInstallationPointerInput {
  
  /**
   * Create and link an object from Installation class.
   */
  createAndLink?: GQLCreateInstallationFieldsInput;
  
  /**
   * Link an existing object from Installation class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Installation class into a relation field.
 */
export interface GQLInstallationRelationInput {
  
  /**
   * Add existing objects from the Installation class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Installation class into the relation.
   */
  createAndAdd?: Array<GQLCreateInstallationFieldsInput>;
  
  /**
   * Remove existing objects from the Installation class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The InstallationRelationWhereInput input type is used in operations that involve filtering objects of Installation class.
 */
export interface GQLInstallationRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLInstallationWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLInstallationWhereInput;
}

/**
 * The InstallationWhereInput input type is used in operations that involve filtering objects of Installation class.
 */
export interface GQLInstallationWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLInstallationWhereInput>;
  
  /**
   * This is the object GCMSenderId.
   */
  GCMSenderId?: GQLStringWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLInstallationWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLInstallationWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object appIdentifier.
   */
  appIdentifier?: GQLStringWhereInput;
  
  /**
   * This is the object appName.
   */
  appName?: GQLStringWhereInput;
  
  /**
   * This is the object appVersion.
   */
  appVersion?: GQLStringWhereInput;
  
  /**
   * This is the object badge.
   */
  badge?: GQLNumberWhereInput;
  
  /**
   * This is the object channels.
   */
  channels?: GQLArrayWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object deviceToken.
   */
  deviceToken?: GQLStringWhereInput;
  
  /**
   * This is the object deviceType.
   */
  deviceType?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object installationId.
   */
  installationId?: GQLStringWhereInput;
  
  /**
   * This is the object localeIdentifier.
   */
  localeIdentifier?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object parseVersion.
   */
  parseVersion?: GQLStringWhereInput;
  
  /**
   * This is the object pushType.
   */
  pushType?: GQLStringWhereInput;
  
  /**
   * This is the object timeZone.
   */
  timeZone?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the Invitation class.
 */
export interface GQLInvitationPointerInput {
  
  /**
   * Create and link an object from Invitation class.
   */
  createAndLink?: GQLCreateInvitationFieldsInput;
  
  /**
   * Link an existing object from Invitation class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Invitation class into a relation field.
 */
export interface GQLInvitationRelationInput {
  
  /**
   * Add existing objects from the Invitation class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Invitation class into the relation.
   */
  createAndAdd?: Array<GQLCreateInvitationFieldsInput>;
  
  /**
   * Remove existing objects from the Invitation class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The InvitationRelationWhereInput input type is used in operations that involve filtering objects of Invitation class.
 */
export interface GQLInvitationRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLInvitationWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLInvitationWhereInput;
}

/**
 * The InvitationWhereInput input type is used in operations that involve filtering objects of Invitation class.
 */
export interface GQLInvitationWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLInvitationWhereInput>;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLInvitationWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLInvitationWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object email.
   */
  email?: GQLStringWhereInput;
  
  /**
   * This is the object emailText.
   */
  emailText?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object invLink.
   */
  invLink?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the ItemBooking class.
 */
export interface GQLItemBookingPointerInput {
  
  /**
   * Create and link an object from ItemBooking class.
   */
  createAndLink?: GQLCreateItemBookingFieldsInput;
  
  /**
   * Link an existing object from ItemBooking class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the ItemBooking class into a relation field.
 */
export interface GQLItemBookingRelationInput {
  
  /**
   * Add existing objects from the ItemBooking class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the ItemBooking class into the relation.
   */
  createAndAdd?: Array<GQLCreateItemBookingFieldsInput>;
  
  /**
   * Remove existing objects from the ItemBooking class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The ItemBookingRelationWhereInput input type is used in operations that involve filtering objects of ItemBooking class.
 */
export interface GQLItemBookingRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLItemBookingWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLItemBookingWhereInput;
}

/**
 * The ItemBookingWhereInput input type is used in operations that involve filtering objects of ItemBooking class.
 */
export interface GQLItemBookingWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLItemBookingWhereInput>;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLItemBookingWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLItemBookingWhereInput>;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object from.
   */
  from?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object to.
   */
  to?: GQLDateWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLItemOrderInp {
  orderId: string;
}

/**
 * Allow to link OR add and link an object of the Item class.
 */
export interface GQLItemPointerInput {
  
  /**
   * Create and link an object from Item class.
   */
  createAndLink?: GQLCreateItemFieldsInput;
  
  /**
   * Link an existing object from Item class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Item class into a relation field.
 */
export interface GQLItemRelationInput {
  
  /**
   * Add existing objects from the Item class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Item class into the relation.
   */
  createAndAdd?: Array<GQLCreateItemFieldsInput>;
  
  /**
   * Remove existing objects from the Item class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The ItemRelationWhereInput input type is used in operations that involve filtering objects of Item class.
 */
export interface GQLItemRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLItemWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLItemWhereInput;
}

/**
 * The ItemWhereInput input type is used in operations that involve filtering objects of Item class.
 */
export interface GQLItemWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLItemWhereInput>;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: GQLArrayWhereInput;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: GQLArrayWhereInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: GQLArrayWhereInput;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLItemWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLItemWhereInput>;
  
  /**
   * This is the object Published.
   */
  Published?: GQLArrayWhereInput;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationWhereInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationWhereInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationWhereInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: GQLArrayWhereInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationWhereInput;
  
  /**
   * This is the object category.
   */
  category?: GQLStringWhereInput;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object createdAt_custom.
   */
  createdAt_custom?: GQLDateWhereInput;
  
  /**
   * This is the object data.
   */
  data?: GQLObjectWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object description.
   */
  description?: GQLStringWhereInput;
  
  /**
   * This is the object discount.
   */
  discount?: GQLNumberWhereInput;
  
  /**
   * This is the object discountType.
   */
  discountType?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object images.
   */
  images?: GQLArrayWhereInput;
  
  /**
   * This is the object income.
   */
  income?: GQLNumberWhereInput;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: GQLBooleanWhereInput;
  
  /**
   * This is the object isLike.
   */
  isLike?: GQLBooleanWhereInput;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: GQLBooleanWhereInput;
  
  /**
   * This is the object isSold.
   */
  isSold?: GQLBooleanWhereInput;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationWhereInput;
  
  /**
   * This is the object listingType.
   */
  listingType?: GQLStringWhereInput;
  
  /**
   * This is the object maxPeriod.
   */
  maxPeriod?: GQLNumberWhereInput;
  
  /**
   * This is the object minDuration.
   */
  minDuration?: GQLNumberWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object originalPrice.
   */
  originalPrice?: GQLNumberWhereInput;
  
  /**
   * This is the object price.
   */
  price?: GQLNumberWhereInput;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: GQLStringWhereInput;
  
  /**
   * This is the object rating.
   */
  rating?: GQLNumberWhereInput;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: GQLStringWhereInput;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: GQLStringWhereInput;
  
  /**
   * This is the object totalCompletedOrders.
   */
  totalCompletedOrders?: GQLNumberWhereInput;
  
  /**
   * This is the object totalRequests.
   */
  totalRequests?: GQLNumberWhereInput;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: GQLNumberWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object yearPurchased.
   */
  yearPurchased?: GQLStringWhereInput;
}

/**
 * Allow to link OR add and link an object of the JoinRequest class.
 */
export interface GQLJoinRequestPointerInput {
  
  /**
   * Create and link an object from JoinRequest class.
   */
  createAndLink?: GQLCreateJoinRequestFieldsInput;
  
  /**
   * Link an existing object from JoinRequest class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the JoinRequest class into a relation field.
 */
export interface GQLJoinRequestRelationInput {
  
  /**
   * Add existing objects from the JoinRequest class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the JoinRequest class into the relation.
   */
  createAndAdd?: Array<GQLCreateJoinRequestFieldsInput>;
  
  /**
   * Remove existing objects from the JoinRequest class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The JoinRequestRelationWhereInput input type is used in operations that involve filtering objects of JoinRequest class.
 */
export interface GQLJoinRequestRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLJoinRequestWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLJoinRequestWhereInput;
}

/**
 * The JoinRequestWhereInput input type is used in operations that involve filtering objects of JoinRequest class.
 */
export interface GQLJoinRequestWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLJoinRequestWhereInput>;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Invitation.
   */
  Invitation?: GQLInvitationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLJoinRequestWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLJoinRequestWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object answer.
   */
  answer?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object date.
   */
  date?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object request.
   */
  request?: GQLStringWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * An entry from an object, i.e., a pair of key and value.
 */
export interface GQLKeyValueInput {
  
  /**
   * The key used to retrieve the value of this entry.
   */
  key: string;
  
  /**
   * The value of the entry. Could be any type of scalar data.
   */
  value: GQLAny;
}

/**
 * Allow to link OR add and link an object of the Language class.
 */
export interface GQLLanguagePointerInput {
  
  /**
   * Create and link an object from Language class.
   */
  createAndLink?: GQLCreateLanguageFieldsInput;
  
  /**
   * Link an existing object from Language class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Language class into a relation field.
 */
export interface GQLLanguageRelationInput {
  
  /**
   * Add existing objects from the Language class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Language class into the relation.
   */
  createAndAdd?: Array<GQLCreateLanguageFieldsInput>;
  
  /**
   * Remove existing objects from the Language class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The LanguageRelationWhereInput input type is used in operations that involve filtering objects of Language class.
 */
export interface GQLLanguageRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLLanguageWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLLanguageWhereInput;
}

/**
 * The LanguageWhereInput input type is used in operations that involve filtering objects of Language class.
 */
export interface GQLLanguageWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLLanguageWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLLanguageWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLLanguageWhereInput>;
  
  /**
   * This is the object code.
   */
  code?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isDisabled.
   */
  isDisabled?: GQLBooleanWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLLeaveCommunityInp {
  communityId: string;
}

export interface GQLLikeEventInp {
  eventId: string;
}

export interface GQLLikeListingInp {
  listingId: string;
}

export interface GQLLikePostInp {
  newResident?: boolean;
  postId: string;
}

export interface GQLLinkWithSocialInput {
  authData: GQLObject;
  provider: string;
}

/**
 * Allow to link OR add and link an object of the Location class.
 */
export interface GQLLocationPointerInput {
  
  /**
   * Create and link an object from Location class.
   */
  createAndLink?: GQLCreateLocationFieldsInput;
  
  /**
   * Link an existing object from Location class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Location class into a relation field.
 */
export interface GQLLocationRelationInput {
  
  /**
   * Add existing objects from the Location class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Location class into the relation.
   */
  createAndAdd?: Array<GQLCreateLocationFieldsInput>;
  
  /**
   * Remove existing objects from the Location class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The LocationRelationWhereInput input type is used in operations that involve filtering objects of Location class.
 */
export interface GQLLocationRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLLocationWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLLocationWhereInput;
}

/**
 * The LocationWhereInput input type is used in operations that involve filtering objects of Location class.
 */
export interface GQLLocationWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLLocationWhereInput>;
  
  /**
   * This is the object City.
   */
  City?: GQLLocationRelationWhereInput;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLLocationWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLLocationWhereInput>;
  
  /**
   * This is the object State.
   */
  State?: GQLLocationRelationWhereInput;
  
  /**
   * This is the object code.
   */
  code?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPointWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isDisabled.
   */
  isDisabled?: GQLBooleanWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLLogInInput {
  clientMutationId?: string;
  
  /**
   * This is the password used to log in the user.
   */
  password: string;
  
  /**
   * This is the username used to log in the user.
   */
  username: string;
}

export interface GQLLogInWithInput {
  authData: GQLObject;
  clientMutationId?: string;
  fields?: GQLUserLoginWithInput;
}

export interface GQLLogOutInput {
  clientMutationId?: string;
}

export interface GQLMakeOrderInp {
  communityId: string;
  endTime?: string;
  guests?: number;
  objectId: string;
  orderType: GQLOrderType;
  recurringEvent?: boolean;
  startTime: string;
}

export interface GQLManageOrderInp {
  orderId: string;
  status: GQLOrderStatuses;
}

export interface GQLManagerDashboardChartInp {
  communityId: string;
  endDate?: string;
  startDate?: string;
  type: GQLManagerChartTypes;
}

export interface GQLManagerDashboardInp {
  communityId: string;
  endDate?: string;
  locationId?: string;
  startDate?: string;
}

export interface GQLManagerRemoveResInp {
  communityId: string;
  residentId: string;
}

/**
 * Allow to link OR add and link an object of the Message class.
 */
export interface GQLMessagePointerInput {
  
  /**
   * Create and link an object from Message class.
   */
  createAndLink?: GQLCreateMessageFieldsInput;
  
  /**
   * Link an existing object from Message class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Message class into a relation field.
 */
export interface GQLMessageRelationInput {
  
  /**
   * Add existing objects from the Message class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Message class into the relation.
   */
  createAndAdd?: Array<GQLCreateMessageFieldsInput>;
  
  /**
   * Remove existing objects from the Message class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The MessageRelationWhereInput input type is used in operations that involve filtering objects of Message class.
 */
export interface GQLMessageRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLMessageWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLMessageWhereInput;
}

/**
 * The MessageWhereInput input type is used in operations that involve filtering objects of Message class.
 */
export interface GQLMessageWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLMessageWhereInput>;
  
  /**
   * This is the object Attachments.
   */
  Attachments?: GQLArrayWhereInput;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Chat.
   */
  Chat?: GQLChatRelationWhereInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLMessageWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLMessageWhereInput>;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object Seen.
   */
  Seen?: GQLArrayWhereInput;
  
  /**
   * This is the object ShowTo.
   */
  ShowTo?: GQLArrayWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object localRef.
   */
  localRef?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object supportMsgStatus.
   */
  supportMsgStatus?: GQLStringWhereInput;
  
  /**
   * This is the object text.
   */
  text?: GQLStringWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the MyClass class.
 */
export interface GQLMyClassPointerInput {
  
  /**
   * Create and link an object from MyClass class.
   */
  createAndLink?: GQLCreateMyClassFieldsInput;
  
  /**
   * Link an existing object from MyClass class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the MyClass class into a relation field.
 */
export interface GQLMyClassRelationInput {
  
  /**
   * Add existing objects from the MyClass class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the MyClass class into the relation.
   */
  createAndAdd?: Array<GQLCreateMyClassFieldsInput>;
  
  /**
   * Remove existing objects from the MyClass class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The MyClassRelationWhereInput input type is used in operations that involve filtering objects of MyClass class.
 */
export interface GQLMyClassRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLMyClassWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLMyClassWhereInput;
}

/**
 * The MyClassWhereInput input type is used in operations that involve filtering objects of MyClass class.
 */
export interface GQLMyClassWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLMyClassWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLMyClassWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLMyClassWhereInput>;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object myField.
   */
  myField?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the NotifSending class.
 */
export interface GQLNotifSendingPointerInput {
  
  /**
   * Create and link an object from NotifSending class.
   */
  createAndLink?: GQLCreateNotifSendingFieldsInput;
  
  /**
   * Link an existing object from NotifSending class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the NotifSending class into a relation field.
 */
export interface GQLNotifSendingRelationInput {
  
  /**
   * Add existing objects from the NotifSending class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the NotifSending class into the relation.
   */
  createAndAdd?: Array<GQLCreateNotifSendingFieldsInput>;
  
  /**
   * Remove existing objects from the NotifSending class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The NotifSendingRelationWhereInput input type is used in operations that involve filtering objects of NotifSending class.
 */
export interface GQLNotifSendingRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLNotifSendingWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLNotifSendingWhereInput;
}

/**
 * The NotifSendingWhereInput input type is used in operations that involve filtering objects of NotifSending class.
 */
export interface GQLNotifSendingWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLNotifSendingWhereInput>;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLNotifSendingWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLNotifSendingWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object amenityAutoBookedEmailSent.
   */
  amenityAutoBookedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityAutoBookedSmsSent.
   */
  amenityAutoBookedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityCanceledListerEmailSent.
   */
  amenityCanceledListerEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityCanceledListerSmsSent.
   */
  amenityCanceledListerSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityCanceledRequesterEmailSent.
   */
  amenityCanceledRequesterEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityCanceledRequesterSmsSent.
   */
  amenityCanceledRequesterSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityConfirmationEmailSent.
   */
  amenityConfirmationEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityConfirmationSmsSent.
   */
  amenityConfirmationSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityOrderBookedEmailSent.
   */
  amenityOrderBookedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityOrderBookedSmsSent.
   */
  amenityOrderBookedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityOrderCanceledEmailSent.
   */
  amenityOrderCanceledEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityOrderCanceledSmsSent.
   */
  amenityOrderCanceledSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityOrderPendingEmailSent.
   */
  amenityOrderPendingEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityOrderPendingSmsSent.
   */
  amenityOrderPendingSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityReminderEmailSent.
   */
  amenityReminderEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityReminderPushSent.
   */
  amenityReminderPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityReminderSmsSent.
   */
  amenityReminderSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityRequestEmailSent.
   */
  amenityRequestEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object amenityRequestSmsSent.
   */
  amenityRequestSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object blockUserEmailSent.
   */
  blockUserEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object blockUserSmsSent.
   */
  blockUserSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object companyReportedEmailSent.
   */
  companyReportedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object companyReportedSmsSent.
   */
  companyReportedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object eventAttendeesEmailSent.
   */
  eventAttendeesEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventAttendeesPushSent.
   */
  eventAttendeesPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventAttendeesSmsSent.
   */
  eventAttendeesSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventOrderAttendingEmailSent.
   */
  eventOrderAttendingEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventOrderAttendingSmsSent.
   */
  eventOrderAttendingSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventOrderCanceledEmailSent.
   */
  eventOrderCanceledEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventOrderCanceledSmsSent.
   */
  eventOrderCanceledSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventOrderPendingEmailSent.
   */
  eventOrderPendingEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventOrderPendingSmsSent.
   */
  eventOrderPendingSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventReminderEmailSent.
   */
  eventReminderEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventReminderPushSent.
   */
  eventReminderPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventReminderSmsSent.
   */
  eventReminderSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventReportedEmailSent.
   */
  eventReportedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object eventReportedSmsSent.
   */
  eventReportedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object itemReviewEmailSent.
   */
  itemReviewEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object itemReviewSmsSent.
   */
  itemReviewSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object itemViewEmailSent.
   */
  itemViewEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object itemViewPushSent.
   */
  itemViewPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object itemViewSmsSent.
   */
  itemViewSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object joinCommunitySmsSent.
   */
  joinCommunitySmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object joinRequestEmailSent.
   */
  joinRequestEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object listingApprovedEmailSent.
   */
  listingApprovedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object listingApprovedSmsSent.
   */
  listingApprovedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object listingPublishRequestEmailSent.
   */
  listingPublishRequestEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object listingPublishRequestPushSent.
   */
  listingPublishRequestPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object listingPublishRequestSmsSent.
   */
  listingPublishRequestSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object listingRemovedEmailSent.
   */
  listingRemovedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object listingRemovedSmsSent.
   */
  listingRemovedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object listingRemovedSmsSmsSent.
   */
  listingRemovedSmsSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object managedAmenitiesEmailSent.
   */
  managedAmenitiesEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object managedAmenitiesPushSent.
   */
  managedAmenitiesPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object managedAmenitiesSmsSent.
   */
  managedAmenitiesSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newCommentEmailSent.
   */
  newCommentEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newCommentInGroupEmailSent.
   */
  newCommentInGroupEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newCommentPollEmailSent.
   */
  newCommentPollEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newCommentPushSent.
   */
  newCommentPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newCommentSmsSent.
   */
  newCommentSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinLikeEmailSent.
   */
  newJoinLikeEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinLikePushSent.
   */
  newJoinLikePushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinLikeSmsSent.
   */
  newJoinLikeSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinSmileEmailSent.
   */
  newJoinSmileEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinSmilePushSent.
   */
  newJoinSmilePushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinSmileSmsSent.
   */
  newJoinSmileSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinWaveEmailSent.
   */
  newJoinWaveEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinWavePushSent.
   */
  newJoinWavePushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newJoinWaveSmsSent.
   */
  newJoinWaveSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newLikeEmailSent.
   */
  newLikeEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newLikePollEmailSent.
   */
  newLikePollEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newLikePushSent.
   */
  newLikePushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newLikeSmsSent.
   */
  newLikeSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newListingEmailSent.
   */
  newListingEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newListingPushSent.
   */
  newListingPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newListingSmsSent.
   */
  newListingSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newManagerAdminPostEmailSent.
   */
  newManagerAdminPostEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newManagerAdminPostPushSent.
   */
  newManagerAdminPostPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newManagerAdminPostSmsSent.
   */
  newManagerAdminPostSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newMessageEmailSent.
   */
  newMessageEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newMessagePushSent.
   */
  newMessagePushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newMessageSmsSent.
   */
  newMessageSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newNoticeEmailSent.
   */
  newNoticeEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newNoticeSmsSent.
   */
  newNoticeSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newPostEmailSent.
   */
  newPostEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newPostPushSent.
   */
  newPostPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newPostSmsSent.
   */
  newPostSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object newResidentEmailSent.
   */
  newResidentEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object newResidentPushSent.
   */
  newResidentPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object newResidentSmsSent.
   */
  newResidentSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object orderBuyAcceptedEmailSent.
   */
  orderBuyAcceptedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderBuyAcceptedSmsSent.
   */
  orderBuyAcceptedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderBuyRejectedEmailSent.
   */
  orderBuyRejectedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderBuyRejectedSmsSent.
   */
  orderBuyRejectedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderRentAcceptedEmailSent.
   */
  orderRentAcceptedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderRentAcceptedSmsSent.
   */
  orderRentAcceptedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderRentRejectedEmailSent.
   */
  orderRentRejectedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderRentRejectedSmsSent.
   */
  orderRentRejectedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderRequestEmailSent.
   */
  orderRequestEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderRequestSmsSent.
   */
  orderRequestSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderServiceAcceptedEmailSent.
   */
  orderServiceAcceptedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderServiceAcceptedSmsSent.
   */
  orderServiceAcceptedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderServiceRejectedEmailSent.
   */
  orderServiceRejectedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object orderServiceRejectedSmsSent.
   */
  orderServiceRejectedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object rejectedRequestEmailSent.
   */
  rejectedRequestEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object reportListingEmailSent.
   */
  reportListingEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object reportListingSmsSent.
   */
  reportListingSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object reportPostEmailSent.
   */
  reportPostEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object reportPostSmsSent.
   */
  reportPostSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object reportUserEmailSent.
   */
  reportUserEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object reportUserSmsSent.
   */
  reportUserSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object residentRemovedEmailSent.
   */
  residentRemovedEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object residentRemovedSmsSent.
   */
  residentRemovedSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object unmanagedAmenitiesEmailSent.
   */
  unmanagedAmenitiesEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object unmanagedAmenitiesPushSent.
   */
  unmanagedAmenitiesPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object unmanagedAmenitiesSmsSent.
   */
  unmanagedAmenitiesSmsSent?: GQLDateWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object userViewEmailSent.
   */
  userViewEmailSent?: GQLDateWhereInput;
  
  /**
   * This is the object userViewPushSent.
   */
  userViewPushSent?: GQLDateWhereInput;
  
  /**
   * This is the object userViewSmsSent.
   */
  userViewSmsSent?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the Notification class.
 */
export interface GQLNotificationPointerInput {
  
  /**
   * Create and link an object from Notification class.
   */
  createAndLink?: GQLCreateNotificationFieldsInput;
  
  /**
   * Link an existing object from Notification class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Notification class into a relation field.
 */
export interface GQLNotificationRelationInput {
  
  /**
   * Add existing objects from the Notification class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Notification class into the relation.
   */
  createAndAdd?: Array<GQLCreateNotificationFieldsInput>;
  
  /**
   * Remove existing objects from the Notification class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The NotificationRelationWhereInput input type is used in operations that involve filtering objects of Notification class.
 */
export interface GQLNotificationRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLNotificationWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLNotificationWhereInput;
}

/**
 * The NotificationWhereInput input type is used in operations that involve filtering objects of Notification class.
 */
export interface GQLNotificationWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLNotificationWhereInput>;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLNotificationWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLNotificationWhereInput>;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object data.
   */
  data?: GQLObjectWhereInput;
  
  /**
   * This is the object event.
   */
  event?: GQLStringWhereInput;
  
  /**
   * This is the object from.
   */
  from?: GQLUserRelationWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object notifTypes.
   */
  notifTypes?: GQLArrayWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object seenDate.
   */
  seenDate?: GQLDateWhereInput;
  
  /**
   * This is the object sendAt.
   */
  sendAt?: GQLDateWhereInput;
  
  /**
   * This is the object sentIn.
   */
  sentIn?: GQLObjectWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object to.
   */
  to?: GQLUserRelationWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLNotifyManagerInp {
  email: string;
  emailText: string;
}

/**
 * The NumberWhereInput input type is used in operations that involve filtering objects by a field of type Number.
 */
export interface GQLNumberWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: number;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: number;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: number;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<number | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: number;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: number;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: number;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<number | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * The ObjectWhereInput input type is used in operations that involve filtering result by a field of type Object.
 */
export interface GQLObjectWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLKeyValueInput;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLKeyValueInput;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLKeyValueInput;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLKeyValueInput | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLKeyValueInput;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLKeyValueInput;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLKeyValueInput;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLKeyValueInput | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * Allow to link OR add and link an object of the Order class.
 */
export interface GQLOrderPointerInput {
  
  /**
   * Create and link an object from Order class.
   */
  createAndLink?: GQLCreateOrderFieldsInput;
  
  /**
   * Link an existing object from Order class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Order class into a relation field.
 */
export interface GQLOrderRelationInput {
  
  /**
   * Add existing objects from the Order class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Order class into the relation.
   */
  createAndAdd?: Array<GQLCreateOrderFieldsInput>;
  
  /**
   * Remove existing objects from the Order class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The OrderRelationWhereInput input type is used in operations that involve filtering objects of Order class.
 */
export interface GQLOrderRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLOrderWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLOrderWhereInput;
}

/**
 * The OrderWhereInput input type is used in operations that involve filtering objects of Order class.
 */
export interface GQLOrderWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLOrderWhereInput>;
  
  /**
   * This is the object Amenity.
   */
  Amenity?: GQLAmenityRelationWhereInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyRelationWhereInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventRelationWhereInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemRelationWhereInput;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLOrderWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLOrderWhereInput>;
  
  /**
   * This is the object Requester.
   */
  Requester?: GQLUserRelationWhereInput;
  
  /**
   * This is the object acceptedByLister.
   */
  acceptedByLister?: GQLDateWhereInput;
  
  /**
   * This is the object acceptedByRequester.
   */
  acceptedByRequester?: GQLDateWhereInput;
  
  /**
   * This is the object attendeeGuests.
   */
  attendeeGuests?: GQLNumberWhereInput;
  
  /**
   * This is the object cfListerAbs.
   */
  cfListerAbs?: GQLNumberWhereInput;
  
  /**
   * This is the object cfListerAmt.
   */
  cfListerAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object cfListerPrc.
   */
  cfListerPrc?: GQLNumberWhereInput;
  
  /**
   * This is the object cfRequesterAbs.
   */
  cfRequesterAbs?: GQLNumberWhereInput;
  
  /**
   * This is the object cfRequesterAmt.
   */
  cfRequesterAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object cfRequesterPrc.
   */
  cfRequesterPrc?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object discount.
   */
  discount?: GQLNumberWhereInput;
  
  /**
   * This is the object discountAmount.
   */
  discountAmount?: GQLNumberWhereInput;
  
  /**
   * This is the object discountType.
   */
  discountType?: GQLStringWhereInput;
  
  /**
   * This is the object endTime.
   */
  endTime?: GQLDateWhereInput;
  
  /**
   * This is the object externalPayments.
   */
  externalPayments?: GQLBooleanWhereInput;
  
  /**
   * This is the object hangehDiscount.
   */
  hangehDiscount?: GQLNumberWhereInput;
  
  /**
   * This is the object hfListerAbs.
   */
  hfListerAbs?: GQLNumberWhereInput;
  
  /**
   * This is the object hfListerAmt.
   */
  hfListerAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object hfListerPrc.
   */
  hfListerPrc?: GQLNumberWhereInput;
  
  /**
   * This is the object hfRequesterAbs.
   */
  hfRequesterAbs?: GQLNumberWhereInput;
  
  /**
   * This is the object hfRequesterAmt.
   */
  hfRequesterAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object hfRequesterPrc.
   */
  hfRequesterPrc?: GQLNumberWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object itemAmount.
   */
  itemAmount?: GQLNumberWhereInput;
  
  /**
   * This is the object listerTotalAmt.
   */
  listerTotalAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object listingType.
   */
  listingType?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object oldStatus.
   */
  oldStatus?: GQLStringWhereInput;
  
  /**
   * This is the object orderType.
   */
  orderType?: GQLStringWhereInput;
  
  /**
   * This is the object payMethod.
   */
  payMethod?: GQLStringWhereInput;
  
  /**
   * This is the object period.
   */
  period?: GQLNumberWhereInput;
  
  /**
   * This is the object ppListerAbs.
   */
  ppListerAbs?: GQLNumberWhereInput;
  
  /**
   * This is the object ppListerAmt.
   */
  ppListerAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object ppListerPrc.
   */
  ppListerPrc?: GQLNumberWhereInput;
  
  /**
   * This is the object ppRequesterAbs.
   */
  ppRequesterAbs?: GQLNumberWhereInput;
  
  /**
   * This is the object ppRequesterAmt.
   */
  ppRequesterAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object ppRequesterPrc.
   */
  ppRequesterPrc?: GQLNumberWhereInput;
  
  /**
   * This is the object price.
   */
  price?: GQLNumberWhereInput;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: GQLStringWhereInput;
  
  /**
   * This is the object recurringEvent.
   */
  recurringEvent?: GQLBooleanWhereInput;
  
  /**
   * This is the object reminder6atMorningSent.
   */
  reminder6atMorningSent?: GQLBooleanWhereInput;
  
  /**
   * This is the object reminderSent.
   */
  reminderSent?: GQLBooleanWhereInput;
  
  /**
   * This is the object requesterTotalAmt.
   */
  requesterTotalAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: GQLStringWhereInput;
  
  /**
   * This is the object sfListerAmt.
   */
  sfListerAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object sfRequesterAmt.
   */
  sfRequesterAmt?: GQLNumberWhereInput;
  
  /**
   * This is the object startTime.
   */
  startTime?: GQLDateWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLPaySubscrInp {
  subscrPaymentId: string;
}

/**
 * Allow to link OR add and link an object of the PaymentPlan class.
 */
export interface GQLPaymentPlanPointerInput {
  
  /**
   * Create and link an object from PaymentPlan class.
   */
  createAndLink?: GQLCreatePaymentPlanFieldsInput;
  
  /**
   * Link an existing object from PaymentPlan class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the PaymentPlan class into a relation field.
 */
export interface GQLPaymentPlanRelationInput {
  
  /**
   * Add existing objects from the PaymentPlan class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the PaymentPlan class into the relation.
   */
  createAndAdd?: Array<GQLCreatePaymentPlanFieldsInput>;
  
  /**
   * Remove existing objects from the PaymentPlan class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The PaymentPlanRelationWhereInput input type is used in operations that involve filtering objects of PaymentPlan class.
 */
export interface GQLPaymentPlanRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLPaymentPlanWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLPaymentPlanWhereInput;
}

/**
 * The PaymentPlanWhereInput input type is used in operations that involve filtering objects of PaymentPlan class.
 */
export interface GQLPaymentPlanWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLPaymentPlanWhereInput>;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyRelationWhereInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLPaymentPlanWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLPaymentPlanWhereInput>;
  
  /**
   * This is the object communityFee.
   */
  communityFee?: GQLBooleanWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object extraListing.
   */
  extraListing?: GQLNumberWhereInput;
  
  /**
   * This is the object extraResident.
   */
  extraResident?: GQLNumberWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isPublic.
   */
  isPublic?: GQLBooleanWhereInput;
  
  /**
   * This is the object listingCap.
   */
  listingCap?: GQLNumberWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object options.
   */
  options?: GQLArrayWhereInput;
  
  /**
   * This is the object priceMonth.
   */
  priceMonth?: GQLNumberWhereInput;
  
  /**
   * This is the object priceYear.
   */
  priceYear?: GQLNumberWhereInput;
  
  /**
   * This is the object rentFees.
   */
  rentFees?: GQLObjectWhereInput;
  
  /**
   * This is the object rentalExternal.
   */
  rentalExternal?: GQLBooleanWhereInput;
  
  /**
   * This is the object residentCap.
   */
  residentCap?: GQLNumberWhereInput;
  
  /**
   * This is the object salesExternal.
   */
  salesExternal?: GQLBooleanWhereInput;
  
  /**
   * This is the object salesFees.
   */
  salesFees?: GQLObjectWhereInput;
  
  /**
   * This is the object serviceExternal.
   */
  serviceExternal?: GQLBooleanWhereInput;
  
  /**
   * This is the object serviceFees.
   */
  serviceFees?: GQLObjectWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the PhoneVerification class.
 */
export interface GQLPhoneVerificationPointerInput {
  
  /**
   * Create and link an object from PhoneVerification class.
   */
  createAndLink?: GQLCreatePhoneVerificationFieldsInput;
  
  /**
   * Link an existing object from PhoneVerification class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the PhoneVerification class into a relation field.
 */
export interface GQLPhoneVerificationRelationInput {
  
  /**
   * Add existing objects from the PhoneVerification class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the PhoneVerification class into the relation.
   */
  createAndAdd?: Array<GQLCreatePhoneVerificationFieldsInput>;
  
  /**
   * Remove existing objects from the PhoneVerification class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The PhoneVerificationRelationWhereInput input type is used in operations that involve filtering objects of PhoneVerification class.
 */
export interface GQLPhoneVerificationRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLPhoneVerificationWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLPhoneVerificationWhereInput;
}

/**
 * The PhoneVerificationWhereInput input type is used in operations that involve filtering objects of PhoneVerification class.
 */
export interface GQLPhoneVerificationWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLPhoneVerificationWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLPhoneVerificationWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLPhoneVerificationWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object verificationCode.
   */
  verificationCode?: GQLStringWhereInput;
}

export interface GQLPinUnpinPostInp {
  postID: string;
}

/**
 * The PointerFieldInput is used to specify a field of type pointer for an object class schema.
 */
export interface GQLPointerFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
  
  /**
   * This is the name of the target class for the field.
   */
  targetClassName: string;
}

/**
 * Allow to link OR add and link an object of the PollOption class.
 */
export interface GQLPollOptionPointerInput {
  
  /**
   * Create and link an object from PollOption class.
   */
  createAndLink?: GQLCreatePollOptionFieldsInput;
  
  /**
   * Link an existing object from PollOption class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the PollOption class into a relation field.
 */
export interface GQLPollOptionRelationInput {
  
  /**
   * Add existing objects from the PollOption class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the PollOption class into the relation.
   */
  createAndAdd?: Array<GQLCreatePollOptionFieldsInput>;
  
  /**
   * Remove existing objects from the PollOption class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The PollOptionRelationWhereInput input type is used in operations that involve filtering objects of PollOption class.
 */
export interface GQLPollOptionRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLPollOptionWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLPollOptionWhereInput;
}

/**
 * The PollOptionWhereInput input type is used in operations that involve filtering objects of PollOption class.
 */
export interface GQLPollOptionWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLPollOptionWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLPollOptionWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLPollOptionWhereInput>;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostRelationWhereInput;
  
  /**
   * This is the object Translate.
   */
  Translate?: GQLPostTranslateRelationWhereInput;
  
  /**
   * This is the object Voted.
   */
  Voted?: GQLUserRelationWhereInput;
  
  /**
   * This is the object countVotes.
   */
  countVotes?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isVoted.
   */
  isVoted?: GQLBooleanWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object position.
   */
  position?: GQLNumberWhereInput;
  
  /**
   * This is the object text.
   */
  text?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * The PolygonWhereInput input type is used in operations that involve filtering objects by a field of type Polygon.
 */
export interface GQLPolygonWhereInput {
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the geoIntersects operator to specify a constraint to select the objects where the values of a polygon field intersect a specified point.
   */
  geoIntersects?: GQLGeoIntersectsInput;
}

/**
 * Allow to link OR add and link an object of the Post class.
 */
export interface GQLPostPointerInput {
  
  /**
   * Create and link an object from Post class.
   */
  createAndLink?: GQLCreatePostFieldsInput;
  
  /**
   * Link an existing object from Post class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Post class into a relation field.
 */
export interface GQLPostRelationInput {
  
  /**
   * Add existing objects from the Post class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Post class into the relation.
   */
  createAndAdd?: Array<GQLCreatePostFieldsInput>;
  
  /**
   * Remove existing objects from the Post class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The PostRelationWhereInput input type is used in operations that involve filtering objects of Post class.
 */
export interface GQLPostRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLPostWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLPostWhereInput;
}

/**
 * Allow to link OR add and link an object of the PostTranslate class.
 */
export interface GQLPostTranslatePointerInput {
  
  /**
   * Create and link an object from PostTranslate class.
   */
  createAndLink?: GQLCreatePostTranslateFieldsInput;
  
  /**
   * Link an existing object from PostTranslate class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the PostTranslate class into a relation field.
 */
export interface GQLPostTranslateRelationInput {
  
  /**
   * Add existing objects from the PostTranslate class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the PostTranslate class into the relation.
   */
  createAndAdd?: Array<GQLCreatePostTranslateFieldsInput>;
  
  /**
   * Remove existing objects from the PostTranslate class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The PostTranslateRelationWhereInput input type is used in operations that involve filtering objects of PostTranslate class.
 */
export interface GQLPostTranslateRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLPostTranslateWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLPostTranslateWhereInput;
}

/**
 * The PostTranslateWhereInput input type is used in operations that involve filtering objects of PostTranslate class.
 */
export interface GQLPostTranslateWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLPostTranslateWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLPostTranslateWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLPostTranslateWhereInput>;
  
  /**
   * This is the object PollOption.
   */
  PollOption?: GQLPollOptionRelationWhereInput;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object en.
   */
  en?: GQLStringWhereInput;
  
  /**
   * This is the object fr.
   */
  fr?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object originalLang.
   */
  originalLang?: GQLStringWhereInput;
  
  /**
   * This is the object ru.
   */
  ru?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * The PostWhereInput input type is used in operations that involve filtering objects of Post class.
 */
export interface GQLPostWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLPostWhereInput>;
  
  /**
   * This is the object Attachments.
   */
  Attachments?: GQLArrayWhereInput;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Group.
   */
  Group?: GQLGroupRelationWhereInput;
  
  /**
   * This is the object Hide.
   */
  Hide?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Items.
   */
  Items?: GQLArrayWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLPostWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLPostWhereInput>;
  
  /**
   * This is the object Options.
   */
  Options?: GQLPollOptionRelationWhereInput;
  
  /**
   * This is the object Parent.
   */
  Parent?: GQLPostRelationWhereInput;
  
  /**
   * This is the object Pin.
   */
  Pin?: GQLArrayWhereInput;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationWhereInput;
  
  /**
   * This is the object Seen.
   */
  Seen?: GQLArrayWhereInput;
  
  /**
   * This is the object Translate.
   */
  Translate?: GQLPostTranslateRelationWhereInput;
  
  /**
   * This is the object comments.
   */
  comments?: GQLPostRelationWhereInput;
  
  /**
   * This is the object countComments.
   */
  countComments?: GQLNumberWhereInput;
  
  /**
   * This is the object countHides.
   */
  countHides?: GQLNumberWhereInput;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: GQLNumberWhereInput;
  
  /**
   * This is the object countSmiles.
   */
  countSmiles?: GQLNumberWhereInput;
  
  /**
   * This is the object countWaves.
   */
  countWaves?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object data.
   */
  data?: GQLObjectWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isComment.
   */
  isComment?: GQLBooleanWhereInput;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: GQLBooleanWhereInput;
  
  /**
   * This is the object isHidden.
   */
  isHidden?: GQLBooleanWhereInput;
  
  /**
   * This is the object isLike.
   */
  isLike?: GQLBooleanWhereInput;
  
  /**
   * This is the object isMulti.
   */
  isMulti?: GQLBooleanWhereInput;
  
  /**
   * This is the object isSmile.
   */
  isSmile?: GQLBooleanWhereInput;
  
  /**
   * This is the object isWave.
   */
  isWave?: GQLBooleanWhereInput;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationWhereInput;
  
  /**
   * This is the object localRef.
   */
  localRef?: GQLStringWhereInput;
  
  /**
   * This is the object medium.
   */
  medium?: GQLArrayWhereInput;
  
  /**
   * This is the object notShow.
   */
  notShow?: GQLBooleanWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object pollOptions.
   */
  pollOptions?: GQLArrayWhereInput;
  
  /**
   * This is the object sentAs.
   */
  sentAs?: GQLStringWhereInput;
  
  /**
   * This is the object smiles.
   */
  smiles?: GQLUserRelationWhereInput;
  
  /**
   * This is the object text.
   */
  text?: GQLStringWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object waves.
   */
  waves?: GQLUserRelationWhereInput;
}

/**
 * Allow to link OR add and link an object of the Promo class.
 */
export interface GQLPromoPointerInput {
  
  /**
   * Create and link an object from Promo class.
   */
  createAndLink?: GQLCreatePromoFieldsInput;
  
  /**
   * Link an existing object from Promo class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Promo class into a relation field.
 */
export interface GQLPromoRelationInput {
  
  /**
   * Add existing objects from the Promo class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Promo class into the relation.
   */
  createAndAdd?: Array<GQLCreatePromoFieldsInput>;
  
  /**
   * Remove existing objects from the Promo class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The PromoRelationWhereInput input type is used in operations that involve filtering objects of Promo class.
 */
export interface GQLPromoRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLPromoWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLPromoWhereInput;
}

/**
 * The PromoWhereInput input type is used in operations that involve filtering objects of Promo class.
 */
export interface GQLPromoWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLPromoWhereInput>;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLArrayWhereInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyRelationWhereInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLPromoWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLPromoWhereInput>;
  
  /**
   * This is the object code.
   */
  code?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object endDate.
   */
  endDate?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isCommunity.
   */
  isCommunity?: GQLBooleanWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object startDate.
   */
  startDate?: GQLDateWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object usageLimit.
   */
  usageLimit?: GQLNumberWhereInput;
  
  /**
   * This is the object value.
   */
  value?: GQLNumberWhereInput;
  
  /**
   * This is the object valueType.
   */
  valueType?: GQLStringWhereInput;
}

/**
 * Allow to manage public rights.
 */
export interface GQLPublicACLInput {
  
  /**
   * Allow anyone to read the current object.
   */
  read: boolean;
  
  /**
   * Allow anyone to write on the current object.
   */
  write: boolean;
}

/**
 * Allow to link OR add and link an object of the PushNotificationLog class.
 */
export interface GQLPushNotificationLogPointerInput {
  
  /**
   * Create and link an object from PushNotificationLog class.
   */
  createAndLink?: GQLCreatePushNotificationLogFieldsInput;
  
  /**
   * Link an existing object from PushNotificationLog class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the PushNotificationLog class into a relation field.
 */
export interface GQLPushNotificationLogRelationInput {
  
  /**
   * Add existing objects from the PushNotificationLog class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the PushNotificationLog class into the relation.
   */
  createAndAdd?: Array<GQLCreatePushNotificationLogFieldsInput>;
  
  /**
   * Remove existing objects from the PushNotificationLog class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The PushNotificationLogRelationWhereInput input type is used in operations that involve filtering objects of PushNotificationLog class.
 */
export interface GQLPushNotificationLogRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLPushNotificationLogWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLPushNotificationLogWhereInput;
}

/**
 * The PushNotificationLogWhereInput input type is used in operations that involve filtering objects of PushNotificationLog class.
 */
export interface GQLPushNotificationLogWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLPushNotificationLogWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLPushNotificationLogWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLPushNotificationLogWhereInput>;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object error.
   */
  error?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object message.
   */
  message?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object result.
   */
  result?: GQLBooleanWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object user.
   */
  user?: GQLUserRelationWhereInput;
}

export interface GQLReactionHandlerInp {
  postId: string;
  type: GQLReactionHandlerTypes;
}

/**
 * The ReadOptionsInputt type is used in queries in order to set the read preferences.
 */
export interface GQLReadOptionsInput {
  
  /**
   * The read preference for the queries to be executed to include fields.
   */
  includeReadPreference?: GQLReadPreference;
  
  /**
   * The read preference for the main query to be executed.
   */
  readPreference?: GQLReadPreference;
  
  /**
   * The read preference for the subqueries that may be required.
   */
  subqueryReadPreference?: GQLReadPreference;
}

/**
 * Allow to link OR add and link an object of the Referral class.
 */
export interface GQLReferralPointerInput {
  
  /**
   * Create and link an object from Referral class.
   */
  createAndLink?: GQLCreateReferralFieldsInput;
  
  /**
   * Link an existing object from Referral class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Referral class into a relation field.
 */
export interface GQLReferralRelationInput {
  
  /**
   * Add existing objects from the Referral class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Referral class into the relation.
   */
  createAndAdd?: Array<GQLCreateReferralFieldsInput>;
  
  /**
   * Remove existing objects from the Referral class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The ReferralRelationWhereInput input type is used in operations that involve filtering objects of Referral class.
 */
export interface GQLReferralRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLReferralWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLReferralWhereInput;
}

/**
 * The ReferralWhereInput input type is used in operations that involve filtering objects of Referral class.
 */
export interface GQLReferralWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLReferralWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLReferralWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLReferralWhereInput>;
  
  /**
   * This is the object ReferralBy.
   */
  ReferralBy?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Referrals.
   */
  Referrals?: GQLUserRelationWhereInput;
  
  /**
   * This is the object ReferralsCount.
   */
  ReferralsCount?: GQLNumberWhereInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object accumulatedDiscount.
   */
  accumulatedDiscount?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object data.
   */
  data?: GQLObjectWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object userMadeTransaction.
   */
  userMadeTransaction?: GQLBooleanWhereInput;
}

export interface GQLRegisterPushNotificationInp {
  id: string;
  os: string;
  token: string;
}

/**
 * The RelationFieldInput is used to specify a field of type relation for an object class schema.
 */
export interface GQLRelationFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
  
  /**
   * This is the name of the target class for the field.
   */
  targetClassName: string;
}

export interface GQLRemoveUserInput {
  email: string;
  token: string;
}

/**
 * Allow to link OR add and link an object of the Report class.
 */
export interface GQLReportPointerInput {
  
  /**
   * Create and link an object from Report class.
   */
  createAndLink?: GQLCreateReportFieldsInput;
  
  /**
   * Link an existing object from Report class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Report class into a relation field.
 */
export interface GQLReportRelationInput {
  
  /**
   * Add existing objects from the Report class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Report class into the relation.
   */
  createAndAdd?: Array<GQLCreateReportFieldsInput>;
  
  /**
   * Remove existing objects from the Report class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The ReportRelationWhereInput input type is used in operations that involve filtering objects of Report class.
 */
export interface GQLReportRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLReportWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLReportWhereInput;
}

/**
 * The ReportWhereInput input type is used in operations that involve filtering objects of Report class.
 */
export interface GQLReportWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLReportWhereInput>;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Company.
   */
  Company?: GQLCompanyRelationWhereInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventRelationWhereInput;
  
  /**
   * This is the object Group.
   */
  Group?: GQLGroupRelationWhereInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLReportWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLReportWhereInput>;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostRelationWhereInput;
  
  /**
   * This is the object Reporter.
   */
  Reporter?: GQLUserRelationWhereInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object blockUserText.
   */
  blockUserText?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object reportText.
   */
  reportText?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLResetPasswordInput {
  clientMutationId?: string;
  email: string;
}

export interface GQLResidentDashboardInp {
  endDate?: string;
  locationId?: string;
  startDate?: string;
  userId?: string;
}

/**
 * Allow to link OR add and link an object of the Review class.
 */
export interface GQLReviewPointerInput {
  
  /**
   * Create and link an object from Review class.
   */
  createAndLink?: GQLCreateReviewFieldsInput;
  
  /**
   * Link an existing object from Review class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Review class into a relation field.
 */
export interface GQLReviewRelationInput {
  
  /**
   * Add existing objects from the Review class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Review class into the relation.
   */
  createAndAdd?: Array<GQLCreateReviewFieldsInput>;
  
  /**
   * Remove existing objects from the Review class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The ReviewRelationWhereInput input type is used in operations that involve filtering objects of Review class.
 */
export interface GQLReviewRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLReviewWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLReviewWhereInput;
}

/**
 * The ReviewWhereInput input type is used in operations that involve filtering objects of Review class.
 */
export interface GQLReviewWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLReviewWhereInput>;
  
  /**
   * This is the object Amenity.
   */
  Amenity?: GQLAmenityRelationWhereInput;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventRelationWhereInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLReviewWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLReviewWhereInput>;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object stars.
   */
  stars?: GQLNumberWhereInput;
  
  /**
   * This is the object subject.
   */
  subject?: GQLStringWhereInput;
  
  /**
   * This is the object text.
   */
  text?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLRmUserPushNotificationInp {
  token: string;
}

/**
 * Allow to manage roles in ACL.
 */
export interface GQLRoleACLInput {
  
  /**
   * Allow users who are members of the role to read the current object.
   */
  read: boolean;
  
  /**
   * Name of the targetted Role.
   */
  roleName: string;
  
  /**
   * Allow users who are members of the role to write on the current object.
   */
  write: boolean;
}

/**
 * Allow to link OR add and link an object of the Role class.
 */
export interface GQLRolePointerInput {
  
  /**
   * Create and link an object from Role class.
   */
  createAndLink?: GQLCreateRoleFieldsInput;
  
  /**
   * Link an existing object from Role class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Role class into a relation field.
 */
export interface GQLRoleRelationInput {
  
  /**
   * Add existing objects from the Role class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Role class into the relation.
   */
  createAndAdd?: Array<GQLCreateRoleFieldsInput>;
  
  /**
   * Remove existing objects from the Role class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The RoleRelationWhereInput input type is used in operations that involve filtering objects of Role class.
 */
export interface GQLRoleRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLRoleWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLRoleWhereInput;
}

/**
 * The RoleWhereInput input type is used in operations that involve filtering objects of Role class.
 */
export interface GQLRoleWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLRoleWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLRoleWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLRoleWhereInput>;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object roles.
   */
  roles?: GQLRoleRelationWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object users.
   */
  users?: GQLUserRelationWhereInput;
}

/**
 * The SchemaArrayFieldInput is used to specify a field of type array for an object class schema.
 */
export interface GQLSchemaArrayFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaBooleanFieldInput is used to specify a field of type boolean for an object class schema.
 */
export interface GQLSchemaBooleanFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaBytesFieldInput is used to specify a field of type bytes for an object class schema.
 */
export interface GQLSchemaBytesFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaDateFieldInput is used to specify a field of type date for an object class schema.
 */
export interface GQLSchemaDateFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaFieldInput is used to specify a field of an object class schema.
 */
export interface GQLSchemaFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The CreateClassSchemaInput type is used to specify the schema for a new object class to be created.
 */
export interface GQLSchemaFieldsInput {
  
  /**
   * These are the Array fields to be added to the class schema.
   */
  addArrays?: Array<GQLSchemaArrayFieldInput>;
  
  /**
   * These are the Boolean fields to be added to the class schema.
   */
  addBooleans?: Array<GQLSchemaBooleanFieldInput>;
  
  /**
   * These are the Bytes fields to be added to the class schema.
   */
  addBytes?: Array<GQLSchemaBytesFieldInput>;
  
  /**
   * These are the Date fields to be added to the class schema.
   */
  addDates?: Array<GQLSchemaDateFieldInput>;
  
  /**
   * These are the File fields to be added to the class schema.
   */
  addFiles?: Array<GQLSchemaFileFieldInput>;
  
  /**
   * This is the Geo Point field to be added to the class schema. Currently it is supported only one GeoPoint field per Class.
   */
  addGeoPoint?: GQLSchemaGeoPointFieldInput;
  
  /**
   * These are the Number fields to be added to the class schema.
   */
  addNumbers?: Array<GQLSchemaNumberFieldInput>;
  
  /**
   * These are the Object fields to be added to the class schema.
   */
  addObjects?: Array<GQLSchemaObjectFieldInput>;
  
  /**
   * These are the Pointer fields to be added to the class schema.
   */
  addPointers?: Array<GQLPointerFieldInput>;
  
  /**
   * These are the Polygon fields to be added to the class schema.
   */
  addPolygons?: Array<GQLSchemaPolygonFieldInput>;
  
  /**
   * These are the Relation fields to be added to the class schema.
   */
  addRelations?: Array<GQLRelationFieldInput>;
  
  /**
   * These are the String fields to be added to the class schema.
   */
  addStrings?: Array<GQLSchemaStringFieldInput>;
  
  /**
   * These are the fields to be removed from the class schema.
   */
  remove?: Array<GQLSchemaFieldInput>;
}

/**
 * The SchemaFileFieldInput is used to specify a field of type file for an object class schema.
 */
export interface GQLSchemaFileFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaGeoPointFieldInput is used to specify a field of type geo point for an object class schema.
 */
export interface GQLSchemaGeoPointFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaNumberFieldInput is used to specify a field of type number for an object class schema.
 */
export interface GQLSchemaNumberFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaObjectFieldInput is used to specify a field of type object for an object class schema.
 */
export interface GQLSchemaObjectFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaPolygonFieldInput is used to specify a field of type polygon for an object class schema.
 */
export interface GQLSchemaPolygonFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaStringFieldInput is used to specify a field of type string for an object class schema.
 */
export interface GQLSchemaStringFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SearchInput type is used to specifiy a search operation on a full text search.
 */
export interface GQLSearchInput {
  
  /**
   * This is the flag to enable or disable case sensitive search.
   */
  caseSensitive?: boolean;
  
  /**
   * This is the flag to enable or disable diacritic sensitive search.
   */
  diacriticSensitive?: boolean;
  
  /**
   * This is the language to tetermine the list of stop words and the rules for tokenizer.
   */
  language?: string;
  
  /**
   * This is the term to be searched.
   */
  term: string;
}

/**
 * The SelectInput type is used to specify an inQueryKey or a notInQueryKey operation on a constraint.
 */
export interface GQLSelectInput {
  
  /**
   * This is the key in the result of the subquery that must match (not match) the field.
   */
  key: string;
  
  /**
   * This is the subquery to be executed.
   */
  query: GQLSubqueryInput;
}

export interface GQLSendResidentInvitationsInp {
  communityId: string;
  emailText: string;
  emailsList: Array<string | null>;
}

export interface GQLSendVerificationEmailInput {
  clientMutationId?: string;
  email: string;
}

/**
 * Allow to link OR add and link an object of the Session class.
 */
export interface GQLSessionPointerInput {
  
  /**
   * Create and link an object from Session class.
   */
  createAndLink?: GQLCreateSessionFieldsInput;
  
  /**
   * Link an existing object from Session class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Session class into a relation field.
 */
export interface GQLSessionRelationInput {
  
  /**
   * Add existing objects from the Session class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Session class into the relation.
   */
  createAndAdd?: Array<GQLCreateSessionFieldsInput>;
  
  /**
   * Remove existing objects from the Session class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The SessionRelationWhereInput input type is used in operations that involve filtering objects of Session class.
 */
export interface GQLSessionRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLSessionWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLSessionWhereInput;
}

/**
 * The SessionWhereInput input type is used in operations that involve filtering objects of Session class.
 */
export interface GQLSessionWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLSessionWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLSessionWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLSessionWhereInput>;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object createdWith.
   */
  createdWith?: GQLObjectWhereInput;
  
  /**
   * This is the object expiresAt.
   */
  expiresAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object installationId.
   */
  installationId?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object restricted.
   */
  restricted?: GQLBooleanWhereInput;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object user.
   */
  user?: GQLUserRelationWhereInput;
}

export interface GQLSetDevicePushInput {
  enabled: boolean;
  userId: string;
}

export interface GQLSetSeenInp {
  messageIds: Array<string | null>;
}

export interface GQLSignUpInput {
  clientMutationId?: string;
  fields?: GQLCreateUserFieldsInput;
}

/**
 * The StringWhereInput input type is used in operations that involve filtering objects by a field of type String.
 */
export interface GQLStringWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: string;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: string;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: string;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<string | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: string;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: string;
  
  /**
   * This is the matchesRegex operator to specify a constraint to select the objects where the value of a field matches a specified regular expression.
   */
  matchesRegex?: string;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: string;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<string | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
  
  /**
   * This is the options operator to specify optional flags (such as "i" and "m") to be added to a matchesRegex operation in the same set of constraints.
   */
  options?: string;
  
  /**
   * This is the $text operator to specify a full text search constraint.
   */
  text?: GQLTextInput;
}

/**
 * The SubqueryInput type is used to specify a sub query to another class.
 */
export interface GQLSubqueryInput {
  
  /**
   * This is the class name of the object.
   */
  className: string;
  
  /**
   * These are the conditions that the objects need to match in order to be found
   */
  where: GQLObject;
}

/**
 * Allow to link OR add and link an object of the SubscrPayment class.
 */
export interface GQLSubscrPaymentPointerInput {
  
  /**
   * Create and link an object from SubscrPayment class.
   */
  createAndLink?: GQLCreateSubscrPaymentFieldsInput;
  
  /**
   * Link an existing object from SubscrPayment class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the SubscrPayment class into a relation field.
 */
export interface GQLSubscrPaymentRelationInput {
  
  /**
   * Add existing objects from the SubscrPayment class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the SubscrPayment class into the relation.
   */
  createAndAdd?: Array<GQLCreateSubscrPaymentFieldsInput>;
  
  /**
   * Remove existing objects from the SubscrPayment class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The SubscrPaymentRelationWhereInput input type is used in operations that involve filtering objects of SubscrPayment class.
 */
export interface GQLSubscrPaymentRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLSubscrPaymentWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLSubscrPaymentWhereInput;
}

/**
 * The SubscrPaymentWhereInput input type is used in operations that involve filtering objects of SubscrPayment class.
 */
export interface GQLSubscrPaymentWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLSubscrPaymentWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLSubscrPaymentWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLSubscrPaymentWhereInput>;
  
  /**
   * This is the object Subscr.
   */
  Subscr?: GQLSubscrRelationWhereInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object amount.
   */
  amount?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object data.
   */
  data?: GQLStringWhereInput;
  
  /**
   * This is the object date.
   */
  date?: GQLDateWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object outerId.
   */
  outerId?: GQLStringWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the Subscr class.
 */
export interface GQLSubscrPointerInput {
  
  /**
   * Create and link an object from Subscr class.
   */
  createAndLink?: GQLCreateSubscrFieldsInput;
  
  /**
   * Link an existing object from Subscr class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Subscr class into a relation field.
 */
export interface GQLSubscrRelationInput {
  
  /**
   * Add existing objects from the Subscr class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Subscr class into the relation.
   */
  createAndAdd?: Array<GQLCreateSubscrFieldsInput>;
  
  /**
   * Remove existing objects from the Subscr class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The SubscrRelationWhereInput input type is used in operations that involve filtering objects of Subscr class.
 */
export interface GQLSubscrRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLSubscrWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLSubscrWhereInput;
}

/**
 * The SubscrWhereInput input type is used in operations that involve filtering objects of Subscr class.
 */
export interface GQLSubscrWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLSubscrWhereInput>;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLSubscrWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLSubscrWhereInput>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserRelationWhereInput;
  
  /**
   * This is the object PaymentPlan.
   */
  PaymentPlan?: GQLPaymentPlanRelationWhereInput;
  
  /**
   * This is the object SubscrPayments.
   */
  SubscrPayments?: GQLSubscrPaymentRelationWhereInput;
  
  /**
   * This is the object beginAt.
   */
  beginAt?: GQLDateWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object expireAt.
   */
  expireAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object netPaid.
   */
  netPaid?: GQLNumberWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object paymentPeriod.
   */
  paymentPeriod?: GQLStringWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLSupportInsightInp {
  residentId: string;
}

/**
 * Allow to link OR add and link an object of the Task class.
 */
export interface GQLTaskPointerInput {
  
  /**
   * Create and link an object from Task class.
   */
  createAndLink?: GQLCreateTaskFieldsInput;
  
  /**
   * Link an existing object from Task class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Task class into a relation field.
 */
export interface GQLTaskRelationInput {
  
  /**
   * Add existing objects from the Task class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Task class into the relation.
   */
  createAndAdd?: Array<GQLCreateTaskFieldsInput>;
  
  /**
   * Remove existing objects from the Task class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The TaskRelationWhereInput input type is used in operations that involve filtering objects of Task class.
 */
export interface GQLTaskRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLTaskWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLTaskWhereInput;
}

/**
 * The TaskWhereInput input type is used in operations that involve filtering objects of Task class.
 */
export interface GQLTaskWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLTaskWhereInput>;
  
  /**
   * This is the object File.
   */
  File?: GQLAppFileRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLTaskWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLTaskWhereInput>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object error.
   */
  error?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object options.
   */
  options?: GQLArrayWhereInput;
  
  /**
   * This is the object processedRow.
   */
  processedRow?: GQLNumberWhereInput;
  
  /**
   * This is the object result.
   */
  result?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * The TextInput type is used to specify a text operation on a constraint.
 */
export interface GQLTextInput {
  
  /**
   * This is the search to be executed.
   */
  search: GQLSearchInput;
}

/**
 * Allow to link OR add and link an object of the Transaction class.
 */
export interface GQLTransactionPointerInput {
  
  /**
   * Create and link an object from Transaction class.
   */
  createAndLink?: GQLCreateTransactionFieldsInput;
  
  /**
   * Link an existing object from Transaction class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Transaction class into a relation field.
 */
export interface GQLTransactionRelationInput {
  
  /**
   * Add existing objects from the Transaction class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Transaction class into the relation.
   */
  createAndAdd?: Array<GQLCreateTransactionFieldsInput>;
  
  /**
   * Remove existing objects from the Transaction class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The TransactionRelationWhereInput input type is used in operations that involve filtering objects of Transaction class.
 */
export interface GQLTransactionRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLTransactionWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLTransactionWhereInput;
}

/**
 * The TransactionWhereInput input type is used in operations that involve filtering objects of Transaction class.
 */
export interface GQLTransactionWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLTransactionWhereInput>;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLTransactionWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLTransactionWhereInput>;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object amount.
   */
  amount?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object data.
   */
  data?: GQLStringWhereInput;
  
  /**
   * This is the object date.
   */
  date?: GQLDateWhereInput;
  
  /**
   * This is the object descr.
   */
  descr?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object outerId.
   */
  outerId?: GQLStringWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object transferDest.
   */
  transferDest?: GQLStringWhereInput;
  
  /**
   * This is the object transferGroup.
   */
  transferGroup?: GQLStringWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

export interface GQLUnlinkWithSocialInput {
  provider: string;
}

/**
 * The UpdateAdminFieldsInput input type is used in operations that involve creation of objects in the Admin class.
 */
export interface GQLUpdateAdminFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: string;
  
  /**
   * This is the object Configurations.
   */
  Configurations?: string;
  
  /**
   * This is the object HelpCentre.
   */
  HelpCentre?: string;
  
  /**
   * This is the object Listings.
   */
  Listings?: string;
  
  /**
   * This is the object Members.
   */
  Members?: string;
  
  /**
   * This is the object Promotions.
   */
  Promotions?: string;
  
  /**
   * This is the object Requests.
   */
  Requests?: string;
  
  /**
   * This is the object Settings.
   */
  Settings?: string;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object isFullAccess.
   */
  isFullAccess?: boolean;
}

export interface GQLUpdateAdminInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateAdminFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateAmenityFieldsInput input type is used in operations that involve creation of objects in the Amenity class.
 */
export interface GQLUpdateAmenityFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: Array<GQLAny | null>;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: Array<GQLAny | null>;
  
  /**
   * This is the object Bookings.
   */
  Bookings?: GQLOrderRelationInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Published.
   */
  Published?: Array<GQLAny | null>;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: Array<GQLAny | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object allowGuests.
   */
  allowGuests?: boolean;
  
  /**
   * This is the object autoBooking.
   */
  autoBooking?: boolean;
  
  /**
   * This is the object availabilityOverride.
   */
  availabilityOverride?: Array<GQLAny | null>;
  
  /**
   * This is the object bookingPeriod.
   */
  bookingPeriod?: string;
  
  /**
   * This is the object bookingSlots.
   */
  bookingSlots?: string;
  
  /**
   * This is the object bookingTiming.
   */
  bookingTiming?: GQLObject;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object images.
   */
  images?: Array<GQLAny | null>;
  
  /**
   * This is the object isBookable.
   */
  isBookable?: boolean;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object maxBookingPerSlot.
   */
  maxBookingPerSlot?: number;
  
  /**
   * This is the object maxBookingsPerDay.
   */
  maxBookingsPerDay?: number;
  
  /**
   * This is the object maxResidentsPerBooking.
   */
  maxResidentsPerBooking?: number;
  
  /**
   * This is the object messageAssignees.
   */
  messageAssignees?: Array<GQLAny | null>;
  
  /**
   * This is the object multipleFutureBookings.
   */
  multipleFutureBookings?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object popularDay.
   */
  popularDay?: string;
  
  /**
   * This is the object popularTime.
   */
  popularTime?: GQLDate;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: string;
  
  /**
   * This is the object totalBookings.
   */
  totalBookings?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
}

export interface GQLUpdateAmenityInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateAmenityFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateAppFileFieldsInput input type is used in operations that involve creation of objects in the AppFile class.
 */
export interface GQLUpdateAppFileFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object file.
   */
  file?: GQLFileInput;
  
  /**
   * This is the object mime.
   */
  mime?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateAppFileInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateAppFileFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateCategoryFieldsInput input type is used in operations that involve creation of objects in the Category class.
 */
export interface GQLUpdateCategoryFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
}

export interface GQLUpdateCategoryInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateCategoryFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateChatFieldsInput input type is used in operations that involve creation of objects in the Chat class.
 */
export interface GQLUpdateChatFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Members.
   */
  Members?: GQLUserRelationInput;
  
  /**
   * This is the object Messages.
   */
  Messages?: GQLMessageRelationInput;
  
  /**
   * This is the object Support.
   */
  Support?: GQLUserPointerInput;
  
  /**
   * This is the object isArchived.
   */
  isArchived?: boolean;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLUpdateChatInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateChatFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLUpdateClassInput {
  clientMutationId?: string;
  
  /**
   * This is the name of the object class.
   */
  name: string;
  
  /**
   * These are the schema's fields of the object class.
   */
  schemaFields?: GQLSchemaFieldsInput;
}

/**
 * The UpdateCommunityAdminFieldsInput input type is used in operations that involve creation of objects in the CommunityAdmin class.
 */
export interface GQLUpdateCommunityAdminFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: string;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Configurations.
   */
  Configurations?: string;
  
  /**
   * This is the object HelpCentre.
   */
  HelpCentre?: string;
  
  /**
   * This is the object Listings.
   */
  Listings?: string;
  
  /**
   * This is the object Members.
   */
  Members?: string;
  
  /**
   * This is the object Promotions.
   */
  Promotions?: string;
  
  /**
   * This is the object Requests.
   */
  Requests?: string;
  
  /**
   * This is the object Settings.
   */
  Settings?: string;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object label.
   */
  label?: string;
}

export interface GQLUpdateCommunityAdminInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateCommunityAdminFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateCommunityFieldsInput input type is used in operations that involve creation of objects in the Community class.
 */
export interface GQLUpdateCommunityFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Admins.
   */
  Admins?: GQLCommunityAdminRelationInput;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFilePointerInput;
  
  /**
   * This is the object Invitations.
   */
  Invitations?: GQLInvitationRelationInput;
  
  /**
   * This is the object Items.
   */
  Items?: GQLItemRelationInput;
  
  /**
   * This is the object JoinRequests.
   */
  JoinRequests?: GQLJoinRequestRelationInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object Residents.
   */
  Residents?: GQLUserRelationInput;
  
  /**
   * This is the object Subscr.
   */
  Subscr?: GQLSubscrPointerInput;
  
  /**
   * This is the object accessType.
   */
  accessType?: string;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object address_add.
   */
  address_add?: Array<GQLAny | null>;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the object allowChat.
   */
  allowChat?: boolean;
  
  /**
   * This is the object allowEvents.
   */
  allowEvents?: boolean;
  
  /**
   * This is the object allowPosts.
   */
  allowPosts?: boolean;
  
  /**
   * This is the object buildings.
   */
  buildings?: string;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObject;
  
  /**
   * This is the object countItems.
   */
  countItems?: number;
  
  /**
   * This is the object countMembers.
   */
  countMembers?: number;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObject;
  
  /**
   * This is the object invitation.
   */
  invitation?: string;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object listingApproval.
   */
  listingApproval?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object neighbourhood.
   */
  neighbourhood?: string;
  
  /**
   * This is the object options.
   */
  options?: GQLObject;
  
  /**
   * This is the object passCode.
   */
  passCode?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object totalMessages.
   */
  totalMessages?: number;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object units.
   */
  units?: string;
  
  /**
   * This is the object zip.
   */
  zip?: string;
  
  /**
   * This is the object zip_add.
   */
  zip_add?: Array<GQLAny | null>;
}

export interface GQLUpdateCommunityInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateCommunityFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateCompanyFieldsInput input type is used in operations that involve creation of objects in the Company class.
 */
export interface GQLUpdateCompanyFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object Published.
   */
  Published?: Array<GQLAny | null>;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object category.
   */
  category?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object images.
   */
  images?: Array<GQLAny | null>;
  
  /**
   * This is the object interestedUsers.
   */
  interestedUsers?: Array<GQLAny | null>;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object phone.
   */
  phone?: string;
  
  /**
   * This is the object promoCTA.
   */
  promoCTA?: string;
  
  /**
   * This is the object promoDescr.
   */
  promoDescr?: string;
  
  /**
   * This is the object promoTagline.
   */
  promoTagline?: string;
  
  /**
   * This is the object promotion.
   */
  promotion?: boolean;
  
  /**
   * This is the object revealCode.
   */
  revealCode?: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object totalClicks.
   */
  totalClicks?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
  
  /**
   * This is the object visitedWebsite.
   */
  visitedWebsite?: string;
  
  /**
   * This is the object website.
   */
  website?: string;
}

export interface GQLUpdateCompanyInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateCompanyFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateCurrencyFieldsInput input type is used in operations that involve creation of objects in the Currency class.
 */
export interface GQLUpdateCurrencyFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object sign.
   */
  sign?: string;
}

export interface GQLUpdateCurrencyInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateCurrencyFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateDocumentFieldsInput input type is used in operations that involve creation of objects in the Document class.
 */
export interface GQLUpdateDocumentFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Cover.
   */
  Cover?: GQLAppFilePointerInput;
  
  /**
   * This is the object DocFile.
   */
  DocFile?: GQLAppFilePointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateDocumentInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateDocumentFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateEventFieldsInput input type is used in operations that involve creation of objects in the Event class.
 */
export interface GQLUpdateEventFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: Array<GQLAny | null>;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: Array<GQLAny | null>;
  
  /**
   * This is the object Attendees.
   */
  Attendees?: GQLUserRelationInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Published.
   */
  Published?: Array<GQLAny | null>;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: Array<GQLAny | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object allowGuests.
   */
  allowGuests?: boolean;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object endTime.
   */
  endTime?: GQLDate;
  
  /**
   * This is the object eventType.
   */
  eventType?: string;
  
  /**
   * This is the object expiresDate.
   */
  expiresDate?: GQLDate;
  
  /**
   * This is the object images.
   */
  images?: Array<GQLAny | null>;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationInput;
  
  /**
   * This is the object listerReminded.
   */
  listerReminded?: boolean;
  
  /**
   * This is the object listerReminded6am.
   */
  listerReminded6am?: boolean;
  
  /**
   * This is the object locationDetails.
   */
  locationDetails?: string;
  
  /**
   * This is the object maxAttendees.
   */
  maxAttendees?: number;
  
  /**
   * This is the object maxGuestsPerAttendee.
   */
  maxGuestsPerAttendee?: number;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object openTo.
   */
  openTo?: string;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: number;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: string;
  
  /**
   * This is the object showAttendees.
   */
  showAttendees?: boolean;
  
  /**
   * This is the object startTime.
   */
  startTime?: GQLDate;
  
  /**
   * This is the object totalAttendees.
   */
  totalAttendees?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
}

export interface GQLUpdateEventInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateEventFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateGroupFieldsInput input type is used in operations that involve creation of objects in the Group class.
 */
export interface GQLUpdateGroupFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFilePointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Members.
   */
  Members?: GQLUserRelationInput;
  
  /**
   * This is the object alias.
   */
  alias?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateGroupInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateGroupFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateHelpDeskFieldsInput input type is used in operations that involve creation of objects in the HelpDesk class.
 */
export interface GQLUpdateHelpDeskFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Assignee.
   */
  Assignee?: GQLUserPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object assignTo.
   */
  assignTo?: string;
  
  /**
   * This is the object buttonTitle.
   */
  buttonTitle?: string;
  
  /**
   * This is the object dailyQuoteAuthor.
   */
  dailyQuoteAuthor?: string;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object layOutOrder.
   */
  layOutOrder?: number;
  
  /**
   * This is the object title.
   */
  title?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateHelpDeskInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateHelpDeskFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateInstallationFieldsInput input type is used in operations that involve creation of objects in the Installation class.
 */
export interface GQLUpdateInstallationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object GCMSenderId.
   */
  GCMSenderId?: string;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object appIdentifier.
   */
  appIdentifier?: string;
  
  /**
   * This is the object appName.
   */
  appName?: string;
  
  /**
   * This is the object appVersion.
   */
  appVersion?: string;
  
  /**
   * This is the object badge.
   */
  badge?: number;
  
  /**
   * This is the object channels.
   */
  channels?: Array<GQLAny | null>;
  
  /**
   * This is the object deviceToken.
   */
  deviceToken?: string;
  
  /**
   * This is the object deviceType.
   */
  deviceType?: string;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object localeIdentifier.
   */
  localeIdentifier?: string;
  
  /**
   * This is the object parseVersion.
   */
  parseVersion?: string;
  
  /**
   * This is the object pushType.
   */
  pushType?: string;
  
  /**
   * This is the object timeZone.
   */
  timeZone?: string;
}

export interface GQLUpdateInstallationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateInstallationFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateInvitationFieldsInput input type is used in operations that involve creation of objects in the Invitation class.
 */
export interface GQLUpdateInvitationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailText.
   */
  emailText?: string;
  
  /**
   * This is the object invLink.
   */
  invLink?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLUpdateInvitationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateInvitationFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateItemBookingFieldsInput input type is used in operations that involve creation of objects in the ItemBooking class.
 */
export interface GQLUpdateItemBookingFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemPointerInput;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderPointerInput;
  
  /**
   * This is the object from.
   */
  from?: GQLDate;
  
  /**
   * This is the object to.
   */
  to?: GQLDate;
}

export interface GQLUpdateItemBookingInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateItemBookingFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateItemFieldsInput input type is used in operations that involve creation of objects in the Item class.
 */
export interface GQLUpdateItemFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object AdmHidden.
   */
  AdmHidden?: Array<GQLAny | null>;
  
  /**
   * This is the object ApproveReq.
   */
  ApproveReq?: Array<GQLAny | null>;
  
  /**
   * This is the object Featured.
   */
  Featured?: Array<GQLAny | null>;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Published.
   */
  Published?: Array<GQLAny | null>;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Requests.
   */
  Requests?: GQLOrderRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Transactions.
   */
  Transactions?: GQLTransactionRelationInput;
  
  /**
   * This is the object Updated.
   */
  Updated?: Array<GQLAny | null>;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object category.
   */
  category?: string;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the object createdAt_custom.
   */
  createdAt_custom?: GQLDate;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object discount.
   */
  discount?: number;
  
  /**
   * This is the object discountType.
   */
  discountType?: string;
  
  /**
   * This is the object images.
   */
  images?: Array<GQLAny | null>;
  
  /**
   * This is the object income.
   */
  income?: number;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isPublished.
   */
  isPublished?: boolean;
  
  /**
   * This is the object isSold.
   */
  isSold?: boolean;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationInput;
  
  /**
   * This is the object listingType.
   */
  listingType?: string;
  
  /**
   * This is the object maxPeriod.
   */
  maxPeriod?: number;
  
  /**
   * This is the object minDuration.
   */
  minDuration?: number;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object originalPrice.
   */
  originalPrice?: number;
  
  /**
   * This is the object price.
   */
  price?: number;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: string;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object totalCompletedOrders.
   */
  totalCompletedOrders?: number;
  
  /**
   * This is the object totalRequests.
   */
  totalRequests?: number;
  
  /**
   * This is the object totalViews.
   */
  totalViews?: number;
  
  /**
   * This is the object yearPurchased.
   */
  yearPurchased?: string;
}

export interface GQLUpdateItemInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateItemFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateJoinRequestFieldsInput input type is used in operations that involve creation of objects in the JoinRequest class.
 */
export interface GQLUpdateJoinRequestFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Invitation.
   */
  Invitation?: GQLInvitationPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object answer.
   */
  answer?: string;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * This is the object request.
   */
  request?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLUpdateJoinRequestInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateJoinRequestFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateLanguageFieldsInput input type is used in operations that involve creation of objects in the Language class.
 */
export interface GQLUpdateLanguageFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the object isDisabled.
   */
  isDisabled?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
}

export interface GQLUpdateLanguageInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateLanguageFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateLocationFieldsInput input type is used in operations that involve creation of objects in the Location class.
 */
export interface GQLUpdateLocationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object City.
   */
  City?: GQLLocationPointerInput;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocationPointerInput;
  
  /**
   * This is the object State.
   */
  State?: GQLLocationPointerInput;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPointInput;
  
  /**
   * This is the object isDisabled.
   */
  isDisabled?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateLocationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateLocationFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateMessageFieldsInput input type is used in operations that involve creation of objects in the Message class.
 */
export interface GQLUpdateMessageFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Attachments.
   */
  Attachments?: Array<GQLAny | null>;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserPointerInput;
  
  /**
   * This is the object Chat.
   */
  Chat?: GQLChatPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderPointerInput;
  
  /**
   * This is the object Seen.
   */
  Seen?: Array<GQLAny | null>;
  
  /**
   * This is the object ShowTo.
   */
  ShowTo?: Array<GQLAny | null>;
  
  /**
   * This is the object localRef.
   */
  localRef?: string;
  
  /**
   * This is the object supportMsgStatus.
   */
  supportMsgStatus?: string;
  
  /**
   * This is the object text.
   */
  text?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateMessageInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateMessageFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateMyClassFieldsInput input type is used in operations that involve creation of objects in the MyClass class.
 */
export interface GQLUpdateMyClassFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object myField.
   */
  myField?: string;
}

export interface GQLUpdateMyClassInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateMyClassFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateNotifSendingFieldsInput input type is used in operations that involve creation of objects in the NotifSending class.
 */
export interface GQLUpdateNotifSendingFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object amenityAutoBookedEmailSent.
   */
  amenityAutoBookedEmailSent?: GQLDate;
  
  /**
   * This is the object amenityAutoBookedSmsSent.
   */
  amenityAutoBookedSmsSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledListerEmailSent.
   */
  amenityCanceledListerEmailSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledListerSmsSent.
   */
  amenityCanceledListerSmsSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledRequesterEmailSent.
   */
  amenityCanceledRequesterEmailSent?: GQLDate;
  
  /**
   * This is the object amenityCanceledRequesterSmsSent.
   */
  amenityCanceledRequesterSmsSent?: GQLDate;
  
  /**
   * This is the object amenityConfirmationEmailSent.
   */
  amenityConfirmationEmailSent?: GQLDate;
  
  /**
   * This is the object amenityConfirmationSmsSent.
   */
  amenityConfirmationSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderBookedEmailSent.
   */
  amenityOrderBookedEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderBookedSmsSent.
   */
  amenityOrderBookedSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderCanceledEmailSent.
   */
  amenityOrderCanceledEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderCanceledSmsSent.
   */
  amenityOrderCanceledSmsSent?: GQLDate;
  
  /**
   * This is the object amenityOrderPendingEmailSent.
   */
  amenityOrderPendingEmailSent?: GQLDate;
  
  /**
   * This is the object amenityOrderPendingSmsSent.
   */
  amenityOrderPendingSmsSent?: GQLDate;
  
  /**
   * This is the object amenityReminderEmailSent.
   */
  amenityReminderEmailSent?: GQLDate;
  
  /**
   * This is the object amenityReminderPushSent.
   */
  amenityReminderPushSent?: GQLDate;
  
  /**
   * This is the object amenityReminderSmsSent.
   */
  amenityReminderSmsSent?: GQLDate;
  
  /**
   * This is the object amenityRequestEmailSent.
   */
  amenityRequestEmailSent?: GQLDate;
  
  /**
   * This is the object amenityRequestSmsSent.
   */
  amenityRequestSmsSent?: GQLDate;
  
  /**
   * This is the object blockUserEmailSent.
   */
  blockUserEmailSent?: GQLDate;
  
  /**
   * This is the object blockUserSmsSent.
   */
  blockUserSmsSent?: GQLDate;
  
  /**
   * This is the object companyReportedEmailSent.
   */
  companyReportedEmailSent?: GQLDate;
  
  /**
   * This is the object companyReportedSmsSent.
   */
  companyReportedSmsSent?: GQLDate;
  
  /**
   * This is the object eventAttendeesEmailSent.
   */
  eventAttendeesEmailSent?: GQLDate;
  
  /**
   * This is the object eventAttendeesPushSent.
   */
  eventAttendeesPushSent?: GQLDate;
  
  /**
   * This is the object eventAttendeesSmsSent.
   */
  eventAttendeesSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderAttendingEmailSent.
   */
  eventOrderAttendingEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderAttendingSmsSent.
   */
  eventOrderAttendingSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderCanceledEmailSent.
   */
  eventOrderCanceledEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderCanceledSmsSent.
   */
  eventOrderCanceledSmsSent?: GQLDate;
  
  /**
   * This is the object eventOrderPendingEmailSent.
   */
  eventOrderPendingEmailSent?: GQLDate;
  
  /**
   * This is the object eventOrderPendingSmsSent.
   */
  eventOrderPendingSmsSent?: GQLDate;
  
  /**
   * This is the object eventReminderEmailSent.
   */
  eventReminderEmailSent?: GQLDate;
  
  /**
   * This is the object eventReminderPushSent.
   */
  eventReminderPushSent?: GQLDate;
  
  /**
   * This is the object eventReminderSmsSent.
   */
  eventReminderSmsSent?: GQLDate;
  
  /**
   * This is the object eventReportedEmailSent.
   */
  eventReportedEmailSent?: GQLDate;
  
  /**
   * This is the object eventReportedSmsSent.
   */
  eventReportedSmsSent?: GQLDate;
  
  /**
   * This is the object itemReviewEmailSent.
   */
  itemReviewEmailSent?: GQLDate;
  
  /**
   * This is the object itemReviewSmsSent.
   */
  itemReviewSmsSent?: GQLDate;
  
  /**
   * This is the object itemViewEmailSent.
   */
  itemViewEmailSent?: GQLDate;
  
  /**
   * This is the object itemViewPushSent.
   */
  itemViewPushSent?: GQLDate;
  
  /**
   * This is the object itemViewSmsSent.
   */
  itemViewSmsSent?: GQLDate;
  
  /**
   * This is the object joinCommunitySmsSent.
   */
  joinCommunitySmsSent?: GQLDate;
  
  /**
   * This is the object joinRequestEmailSent.
   */
  joinRequestEmailSent?: GQLDate;
  
  /**
   * This is the object listingApprovedEmailSent.
   */
  listingApprovedEmailSent?: GQLDate;
  
  /**
   * This is the object listingApprovedSmsSent.
   */
  listingApprovedSmsSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestEmailSent.
   */
  listingPublishRequestEmailSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestPushSent.
   */
  listingPublishRequestPushSent?: GQLDate;
  
  /**
   * This is the object listingPublishRequestSmsSent.
   */
  listingPublishRequestSmsSent?: GQLDate;
  
  /**
   * This is the object listingRemovedEmailSent.
   */
  listingRemovedEmailSent?: GQLDate;
  
  /**
   * This is the object listingRemovedSmsSent.
   */
  listingRemovedSmsSent?: GQLDate;
  
  /**
   * This is the object listingRemovedSmsSmsSent.
   */
  listingRemovedSmsSmsSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesEmailSent.
   */
  managedAmenitiesEmailSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesPushSent.
   */
  managedAmenitiesPushSent?: GQLDate;
  
  /**
   * This is the object managedAmenitiesSmsSent.
   */
  managedAmenitiesSmsSent?: GQLDate;
  
  /**
   * This is the object newCommentEmailSent.
   */
  newCommentEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentInGroupEmailSent.
   */
  newCommentInGroupEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentPollEmailSent.
   */
  newCommentPollEmailSent?: GQLDate;
  
  /**
   * This is the object newCommentPushSent.
   */
  newCommentPushSent?: GQLDate;
  
  /**
   * This is the object newCommentSmsSent.
   */
  newCommentSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinLikeEmailSent.
   */
  newJoinLikeEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinLikePushSent.
   */
  newJoinLikePushSent?: GQLDate;
  
  /**
   * This is the object newJoinLikeSmsSent.
   */
  newJoinLikeSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinSmileEmailSent.
   */
  newJoinSmileEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinSmilePushSent.
   */
  newJoinSmilePushSent?: GQLDate;
  
  /**
   * This is the object newJoinSmileSmsSent.
   */
  newJoinSmileSmsSent?: GQLDate;
  
  /**
   * This is the object newJoinWaveEmailSent.
   */
  newJoinWaveEmailSent?: GQLDate;
  
  /**
   * This is the object newJoinWavePushSent.
   */
  newJoinWavePushSent?: GQLDate;
  
  /**
   * This is the object newJoinWaveSmsSent.
   */
  newJoinWaveSmsSent?: GQLDate;
  
  /**
   * This is the object newLikeEmailSent.
   */
  newLikeEmailSent?: GQLDate;
  
  /**
   * This is the object newLikePollEmailSent.
   */
  newLikePollEmailSent?: GQLDate;
  
  /**
   * This is the object newLikePushSent.
   */
  newLikePushSent?: GQLDate;
  
  /**
   * This is the object newLikeSmsSent.
   */
  newLikeSmsSent?: GQLDate;
  
  /**
   * This is the object newListingEmailSent.
   */
  newListingEmailSent?: GQLDate;
  
  /**
   * This is the object newListingPushSent.
   */
  newListingPushSent?: GQLDate;
  
  /**
   * This is the object newListingSmsSent.
   */
  newListingSmsSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostEmailSent.
   */
  newManagerAdminPostEmailSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostPushSent.
   */
  newManagerAdminPostPushSent?: GQLDate;
  
  /**
   * This is the object newManagerAdminPostSmsSent.
   */
  newManagerAdminPostSmsSent?: GQLDate;
  
  /**
   * This is the object newMessageEmailSent.
   */
  newMessageEmailSent?: GQLDate;
  
  /**
   * This is the object newMessagePushSent.
   */
  newMessagePushSent?: GQLDate;
  
  /**
   * This is the object newMessageSmsSent.
   */
  newMessageSmsSent?: GQLDate;
  
  /**
   * This is the object newNoticeEmailSent.
   */
  newNoticeEmailSent?: GQLDate;
  
  /**
   * This is the object newNoticeSmsSent.
   */
  newNoticeSmsSent?: GQLDate;
  
  /**
   * This is the object newPostEmailSent.
   */
  newPostEmailSent?: GQLDate;
  
  /**
   * This is the object newPostPushSent.
   */
  newPostPushSent?: GQLDate;
  
  /**
   * This is the object newPostSmsSent.
   */
  newPostSmsSent?: GQLDate;
  
  /**
   * This is the object newResidentEmailSent.
   */
  newResidentEmailSent?: GQLDate;
  
  /**
   * This is the object newResidentPushSent.
   */
  newResidentPushSent?: GQLDate;
  
  /**
   * This is the object newResidentSmsSent.
   */
  newResidentSmsSent?: GQLDate;
  
  /**
   * This is the object orderBuyAcceptedEmailSent.
   */
  orderBuyAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderBuyAcceptedSmsSent.
   */
  orderBuyAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderBuyRejectedEmailSent.
   */
  orderBuyRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderBuyRejectedSmsSent.
   */
  orderBuyRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRentAcceptedEmailSent.
   */
  orderRentAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderRentAcceptedSmsSent.
   */
  orderRentAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRentRejectedEmailSent.
   */
  orderRentRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderRentRejectedSmsSent.
   */
  orderRentRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object orderRequestEmailSent.
   */
  orderRequestEmailSent?: GQLDate;
  
  /**
   * This is the object orderRequestSmsSent.
   */
  orderRequestSmsSent?: GQLDate;
  
  /**
   * This is the object orderServiceAcceptedEmailSent.
   */
  orderServiceAcceptedEmailSent?: GQLDate;
  
  /**
   * This is the object orderServiceAcceptedSmsSent.
   */
  orderServiceAcceptedSmsSent?: GQLDate;
  
  /**
   * This is the object orderServiceRejectedEmailSent.
   */
  orderServiceRejectedEmailSent?: GQLDate;
  
  /**
   * This is the object orderServiceRejectedSmsSent.
   */
  orderServiceRejectedSmsSent?: GQLDate;
  
  /**
   * This is the object rejectedRequestEmailSent.
   */
  rejectedRequestEmailSent?: GQLDate;
  
  /**
   * This is the object reportListingEmailSent.
   */
  reportListingEmailSent?: GQLDate;
  
  /**
   * This is the object reportListingSmsSent.
   */
  reportListingSmsSent?: GQLDate;
  
  /**
   * This is the object reportPostEmailSent.
   */
  reportPostEmailSent?: GQLDate;
  
  /**
   * This is the object reportPostSmsSent.
   */
  reportPostSmsSent?: GQLDate;
  
  /**
   * This is the object reportUserEmailSent.
   */
  reportUserEmailSent?: GQLDate;
  
  /**
   * This is the object reportUserSmsSent.
   */
  reportUserSmsSent?: GQLDate;
  
  /**
   * This is the object residentRemovedEmailSent.
   */
  residentRemovedEmailSent?: GQLDate;
  
  /**
   * This is the object residentRemovedSmsSent.
   */
  residentRemovedSmsSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesEmailSent.
   */
  unmanagedAmenitiesEmailSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesPushSent.
   */
  unmanagedAmenitiesPushSent?: GQLDate;
  
  /**
   * This is the object unmanagedAmenitiesSmsSent.
   */
  unmanagedAmenitiesSmsSent?: GQLDate;
  
  /**
   * This is the object userViewEmailSent.
   */
  userViewEmailSent?: GQLDate;
  
  /**
   * This is the object userViewPushSent.
   */
  userViewPushSent?: GQLDate;
  
  /**
   * This is the object userViewSmsSent.
   */
  userViewSmsSent?: GQLDate;
}

export interface GQLUpdateNotifSendingInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateNotifSendingFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateNotificationFieldsInput input type is used in operations that involve creation of objects in the Notification class.
 */
export interface GQLUpdateNotificationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object event.
   */
  event?: string;
  
  /**
   * This is the object from.
   */
  from?: GQLUserPointerInput;
  
  /**
   * This is the object notifTypes.
   */
  notifTypes?: Array<GQLAny | null>;
  
  /**
   * This is the object seenDate.
   */
  seenDate?: GQLDate;
  
  /**
   * This is the object sendAt.
   */
  sendAt?: GQLDate;
  
  /**
   * This is the object sentIn.
   */
  sentIn?: GQLObject;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object to.
   */
  to?: GQLUserPointerInput;
}

export interface GQLUpdateNotificationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateNotificationFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateOrderFieldsInput input type is used in operations that involve creation of objects in the Order class.
 */
export interface GQLUpdateOrderFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Amenity.
   */
  Amenity?: GQLAmenityPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventPointerInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemPointerInput;
  
  /**
   * This is the object Lister.
   */
  Lister?: GQLUserPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Requester.
   */
  Requester?: GQLUserPointerInput;
  
  /**
   * This is the object acceptedByLister.
   */
  acceptedByLister?: GQLDate;
  
  /**
   * This is the object acceptedByRequester.
   */
  acceptedByRequester?: GQLDate;
  
  /**
   * This is the object attendeeGuests.
   */
  attendeeGuests?: number;
  
  /**
   * This is the object cfListerAbs.
   */
  cfListerAbs?: number;
  
  /**
   * This is the object cfListerAmt.
   */
  cfListerAmt?: number;
  
  /**
   * This is the object cfListerPrc.
   */
  cfListerPrc?: number;
  
  /**
   * This is the object cfRequesterAbs.
   */
  cfRequesterAbs?: number;
  
  /**
   * This is the object cfRequesterAmt.
   */
  cfRequesterAmt?: number;
  
  /**
   * This is the object cfRequesterPrc.
   */
  cfRequesterPrc?: number;
  
  /**
   * This is the object discount.
   */
  discount?: number;
  
  /**
   * This is the object discountAmount.
   */
  discountAmount?: number;
  
  /**
   * This is the object discountType.
   */
  discountType?: string;
  
  /**
   * This is the object endTime.
   */
  endTime?: GQLDate;
  
  /**
   * This is the object externalPayments.
   */
  externalPayments?: boolean;
  
  /**
   * This is the object hangehDiscount.
   */
  hangehDiscount?: number;
  
  /**
   * This is the object hfListerAbs.
   */
  hfListerAbs?: number;
  
  /**
   * This is the object hfListerAmt.
   */
  hfListerAmt?: number;
  
  /**
   * This is the object hfListerPrc.
   */
  hfListerPrc?: number;
  
  /**
   * This is the object hfRequesterAbs.
   */
  hfRequesterAbs?: number;
  
  /**
   * This is the object hfRequesterAmt.
   */
  hfRequesterAmt?: number;
  
  /**
   * This is the object hfRequesterPrc.
   */
  hfRequesterPrc?: number;
  
  /**
   * This is the object itemAmount.
   */
  itemAmount?: number;
  
  /**
   * This is the object listerTotalAmt.
   */
  listerTotalAmt?: number;
  
  /**
   * This is the object listingType.
   */
  listingType?: string;
  
  /**
   * This is the object oldStatus.
   */
  oldStatus?: string;
  
  /**
   * This is the object orderType.
   */
  orderType?: string;
  
  /**
   * This is the object payMethod.
   */
  payMethod?: string;
  
  /**
   * This is the object period.
   */
  period?: number;
  
  /**
   * This is the object ppListerAbs.
   */
  ppListerAbs?: number;
  
  /**
   * This is the object ppListerAmt.
   */
  ppListerAmt?: number;
  
  /**
   * This is the object ppListerPrc.
   */
  ppListerPrc?: number;
  
  /**
   * This is the object ppRequesterAbs.
   */
  ppRequesterAbs?: number;
  
  /**
   * This is the object ppRequesterAmt.
   */
  ppRequesterAmt?: number;
  
  /**
   * This is the object ppRequesterPrc.
   */
  ppRequesterPrc?: number;
  
  /**
   * This is the object price.
   */
  price?: number;
  
  /**
   * This is the object pricePeriod.
   */
  pricePeriod?: string;
  
  /**
   * This is the object recurringEvent.
   */
  recurringEvent?: boolean;
  
  /**
   * This is the object reminder6atMorningSent.
   */
  reminder6atMorningSent?: boolean;
  
  /**
   * This is the object reminderSent.
   */
  reminderSent?: boolean;
  
  /**
   * This is the object requesterTotalAmt.
   */
  requesterTotalAmt?: number;
  
  /**
   * This is the object rewardType.
   */
  rewardType?: string;
  
  /**
   * This is the object sfListerAmt.
   */
  sfListerAmt?: number;
  
  /**
   * This is the object sfRequesterAmt.
   */
  sfRequesterAmt?: number;
  
  /**
   * This is the object startTime.
   */
  startTime?: GQLDate;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLUpdateOrderInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateOrderFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdatePaymentPlanFieldsInput input type is used in operations that involve creation of objects in the PaymentPlan class.
 */
export interface GQLUpdatePaymentPlanFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object communityFee.
   */
  communityFee?: boolean;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object extraListing.
   */
  extraListing?: number;
  
  /**
   * This is the object extraResident.
   */
  extraResident?: number;
  
  /**
   * This is the object isPublic.
   */
  isPublic?: boolean;
  
  /**
   * This is the object listingCap.
   */
  listingCap?: number;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object options.
   */
  options?: Array<GQLAny | null>;
  
  /**
   * This is the object priceMonth.
   */
  priceMonth?: number;
  
  /**
   * This is the object priceYear.
   */
  priceYear?: number;
  
  /**
   * This is the object rentFees.
   */
  rentFees?: GQLObject;
  
  /**
   * This is the object rentalExternal.
   */
  rentalExternal?: boolean;
  
  /**
   * This is the object residentCap.
   */
  residentCap?: number;
  
  /**
   * This is the object salesExternal.
   */
  salesExternal?: boolean;
  
  /**
   * This is the object salesFees.
   */
  salesFees?: GQLObject;
  
  /**
   * This is the object serviceExternal.
   */
  serviceExternal?: boolean;
  
  /**
   * This is the object serviceFees.
   */
  serviceFees?: GQLObject;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLUpdatePaymentPlanInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdatePaymentPlanFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdatePhoneVerificationFieldsInput input type is used in operations that involve creation of objects in the PhoneVerification class.
 */
export interface GQLUpdatePhoneVerificationFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object verificationCode.
   */
  verificationCode?: string;
}

export interface GQLUpdatePhoneVerificationInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdatePhoneVerificationFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdatePollOptionFieldsInput input type is used in operations that involve creation of objects in the PollOption class.
 */
export interface GQLUpdatePollOptionFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostPointerInput;
  
  /**
   * This is the object Translate.
   */
  Translate?: GQLPostTranslatePointerInput;
  
  /**
   * This is the object Voted.
   */
  Voted?: GQLUserRelationInput;
  
  /**
   * This is the object countVotes.
   */
  countVotes?: number;
  
  /**
   * This is the object isVoted.
   */
  isVoted?: boolean;
  
  /**
   * This is the object position.
   */
  position?: number;
  
  /**
   * This is the object text.
   */
  text?: string;
}

export interface GQLUpdatePollOptionInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdatePollOptionFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdatePostFieldsInput input type is used in operations that involve creation of objects in the Post class.
 */
export interface GQLUpdatePostFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Attachments.
   */
  Attachments?: Array<GQLAny | null>;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Group.
   */
  Group?: GQLGroupPointerInput;
  
  /**
   * This is the object Hide.
   */
  Hide?: GQLUserRelationInput;
  
  /**
   * This is the object Items.
   */
  Items?: Array<GQLAny | null>;
  
  /**
   * This is the object Options.
   */
  Options?: GQLPollOptionRelationInput;
  
  /**
   * This is the object Parent.
   */
  Parent?: GQLPostPointerInput;
  
  /**
   * This is the object Pin.
   */
  Pin?: Array<GQLAny | null>;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Seen.
   */
  Seen?: Array<GQLAny | null>;
  
  /**
   * This is the object Translate.
   */
  Translate?: GQLPostTranslatePointerInput;
  
  /**
   * This is the object comments.
   */
  comments?: GQLPostRelationInput;
  
  /**
   * This is the object countComments.
   */
  countComments?: number;
  
  /**
   * This is the object countHides.
   */
  countHides?: number;
  
  /**
   * This is the object countLikes.
   */
  countLikes?: number;
  
  /**
   * This is the object countSmiles.
   */
  countSmiles?: number;
  
  /**
   * This is the object countWaves.
   */
  countWaves?: number;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object isComment.
   */
  isComment?: boolean;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isHidden.
   */
  isHidden?: boolean;
  
  /**
   * This is the object isLike.
   */
  isLike?: boolean;
  
  /**
   * This is the object isMulti.
   */
  isMulti?: boolean;
  
  /**
   * This is the object isSmile.
   */
  isSmile?: boolean;
  
  /**
   * This is the object isWave.
   */
  isWave?: boolean;
  
  /**
   * This is the object likes.
   */
  likes?: GQLUserRelationInput;
  
  /**
   * This is the object localRef.
   */
  localRef?: string;
  
  /**
   * This is the object medium.
   */
  medium?: Array<GQLAny | null>;
  
  /**
   * This is the object notShow.
   */
  notShow?: boolean;
  
  /**
   * This is the object pollOptions.
   */
  pollOptions?: Array<GQLAny | null>;
  
  /**
   * This is the object sentAs.
   */
  sentAs?: string;
  
  /**
   * This is the object smiles.
   */
  smiles?: GQLUserRelationInput;
  
  /**
   * This is the object text.
   */
  text?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object waves.
   */
  waves?: GQLUserRelationInput;
}

export interface GQLUpdatePostInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdatePostFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdatePostTranslateFieldsInput input type is used in operations that involve creation of objects in the PostTranslate class.
 */
export interface GQLUpdatePostTranslateFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object PollOption.
   */
  PollOption?: GQLPollOptionPointerInput;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostPointerInput;
  
  /**
   * This is the object en.
   */
  en?: string;
  
  /**
   * This is the object fr.
   */
  fr?: string;
  
  /**
   * This is the object originalLang.
   */
  originalLang?: string;
  
  /**
   * This is the object ru.
   */
  ru?: string;
}

export interface GQLUpdatePostTranslateInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdatePostTranslateFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdatePromoFieldsInput input type is used in operations that involve creation of objects in the Promo class.
 */
export interface GQLUpdatePromoFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: Array<GQLAny | null>;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object code.
   */
  code?: string;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object endDate.
   */
  endDate?: GQLDate;
  
  /**
   * This is the object isCommunity.
   */
  isCommunity?: boolean;
  
  /**
   * This is the object startDate.
   */
  startDate?: GQLDate;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object usageLimit.
   */
  usageLimit?: number;
  
  /**
   * This is the object value.
   */
  value?: number;
  
  /**
   * This is the object valueType.
   */
  valueType?: string;
}

export interface GQLUpdatePromoInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdatePromoFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLUpdatePushNotificationInp {
  token: string;
  userId: string;
}

/**
 * The UpdatePushNotificationLogFieldsInput input type is used in operations that involve creation of objects in the PushNotificationLog class.
 */
export interface GQLUpdatePushNotificationLogFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * This is the object message.
   */
  message?: string;
  
  /**
   * This is the object result.
   */
  result?: boolean;
  
  /**
   * This is the object user.
   */
  user?: GQLUserPointerInput;
}

export interface GQLUpdatePushNotificationLogInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdatePushNotificationLogFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateReferralFieldsInput input type is used in operations that involve creation of objects in the Referral class.
 */
export interface GQLUpdateReferralFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object ReferralBy.
   */
  ReferralBy?: GQLUserPointerInput;
  
  /**
   * This is the object Referrals.
   */
  Referrals?: GQLUserRelationInput;
  
  /**
   * This is the object ReferralsCount.
   */
  ReferralsCount?: number;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object accumulatedDiscount.
   */
  accumulatedDiscount?: number;
  
  /**
   * This is the object data.
   */
  data?: GQLObject;
  
  /**
   * This is the object userMadeTransaction.
   */
  userMadeTransaction?: boolean;
}

export interface GQLUpdateReferralInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateReferralFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateReportFieldsInput input type is used in operations that involve creation of objects in the Report class.
 */
export interface GQLUpdateReportFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Company.
   */
  Company?: GQLCompanyPointerInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventPointerInput;
  
  /**
   * This is the object Group.
   */
  Group?: GQLGroupPointerInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemPointerInput;
  
  /**
   * This is the object Post.
   */
  Post?: GQLPostPointerInput;
  
  /**
   * This is the object Reporter.
   */
  Reporter?: GQLUserPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object blockUserText.
   */
  blockUserText?: string;
  
  /**
   * This is the object reportText.
   */
  reportText?: string;
}

export interface GQLUpdateReportInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateReportFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateReviewFieldsInput input type is used in operations that involve creation of objects in the Review class.
 */
export interface GQLUpdateReviewFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Amenity.
   */
  Amenity?: GQLAmenityPointerInput;
  
  /**
   * This is the object Author.
   */
  Author?: GQLUserPointerInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Event.
   */
  Event?: GQLEventPointerInput;
  
  /**
   * This is the object Item.
   */
  Item?: GQLItemPointerInput;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object stars.
   */
  stars?: number;
  
  /**
   * This is the object subject.
   */
  subject?: string;
  
  /**
   * This is the object text.
   */
  text?: string;
}

export interface GQLUpdateReviewInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateReviewFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateRoleFieldsInput input type is used in operations that involve creation of objects in the Role class.
 */
export interface GQLUpdateRoleFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object roles.
   */
  roles?: GQLRoleRelationInput;
  
  /**
   * This is the object users.
   */
  users?: GQLUserRelationInput;
}

export interface GQLUpdateRoleInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateRoleFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateSessionFieldsInput input type is used in operations that involve creation of objects in the Session class.
 */
export interface GQLUpdateSessionFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object createdWith.
   */
  createdWith?: GQLObject;
  
  /**
   * This is the object expiresAt.
   */
  expiresAt?: GQLDate;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object restricted.
   */
  restricted?: boolean;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object user.
   */
  user?: GQLUserPointerInput;
}

export interface GQLUpdateSessionInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateSessionFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateSubscrFieldsInput input type is used in operations that involve creation of objects in the Subscr class.
 */
export interface GQLUpdateSubscrFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLCommunityRelationInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object PaymentPlan.
   */
  PaymentPlan?: GQLPaymentPlanPointerInput;
  
  /**
   * This is the object SubscrPayments.
   */
  SubscrPayments?: GQLSubscrPaymentRelationInput;
  
  /**
   * This is the object beginAt.
   */
  beginAt?: GQLDate;
  
  /**
   * This is the object expireAt.
   */
  expireAt?: GQLDate;
  
  /**
   * This is the object netPaid.
   */
  netPaid?: number;
  
  /**
   * This is the object paymentPeriod.
   */
  paymentPeriod?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLUpdateSubscrInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateSubscrFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateSubscrPaymentFieldsInput input type is used in operations that involve creation of objects in the SubscrPayment class.
 */
export interface GQLUpdateSubscrPaymentFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Subscr.
   */
  Subscr?: GQLSubscrPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object amount.
   */
  amount?: number;
  
  /**
   * This is the object data.
   */
  data?: string;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateSubscrPaymentInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateSubscrPaymentFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateTaskFieldsInput input type is used in operations that involve creation of objects in the Task class.
 */
export interface GQLUpdateTaskFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object File.
   */
  File?: GQLAppFilePointerInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * This is the object options.
   */
  options?: Array<GQLAny | null>;
  
  /**
   * This is the object processedRow.
   */
  processedRow?: number;
  
  /**
   * This is the object result.
   */
  result?: string;
}

export interface GQLUpdateTaskInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateTaskFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateTransactionFieldsInput input type is used in operations that involve creation of objects in the Transaction class.
 */
export interface GQLUpdateTransactionFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Community.
   */
  Community?: GQLCommunityPointerInput;
  
  /**
   * This is the object Order.
   */
  Order?: GQLOrderPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object amount.
   */
  amount?: number;
  
  /**
   * This is the object data.
   */
  data?: string;
  
  /**
   * This is the object date.
   */
  date?: GQLDate;
  
  /**
   * This is the object descr.
   */
  descr?: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object transferDest.
   */
  transferDest?: string;
  
  /**
   * This is the object transferGroup.
   */
  transferGroup?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateTransactionInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateTransactionFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateUserFieldsInput input type is used in operations that involve creation of objects in the User class.
 */
export interface GQLUpdateUserFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFilePointerInput;
  
  /**
   * This is the object Blocked.
   */
  Blocked?: Array<GQLAny | null>;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLCommunityRelationInput;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocationPointerInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Language.
   */
  Language?: GQLLanguagePointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Orders.
   */
  Orders?: GQLOrderRelationInput;
  
  /**
   * This is the object ReferralCode.
   */
  ReferralCode?: string;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object aptSuite.
   */
  aptSuite?: string;
  
  /**
   * This is the object authData.
   */
  authData?: GQLObject;
  
  /**
   * This is the object bio.
   */
  bio?: string;
  
  /**
   * This is the object birthDate.
   */
  birthDate?: GQLDate;
  
  /**
   * This is the object cardInfo.
   */
  cardInfo?: Array<GQLAny | null>;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObject;
  
  /**
   * This is the object checkListSeen.
   */
  checkListSeen?: boolean;
  
  /**
   * This is the object distance.
   */
  distance?: string;
  
  /**
   * This is the object earned.
   */
  earned?: number;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: boolean;
  
  /**
   * This is the object firstLetter.
   */
  firstLetter?: string;
  
  /**
   * This is the object firstName.
   */
  firstName?: string;
  
  /**
   * This is the object gender.
   */
  gender?: string;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPointInput;
  
  /**
   * This is the object homepage.
   */
  homepage?: string;
  
  /**
   * This is the object howDidYouHear.
   */
  howDidYouHear?: string;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObject;
  
  /**
   * This is the object interests.
   */
  interests?: Array<GQLAny | null>;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isInvited.
   */
  isInvited?: boolean;
  
  /**
   * This is the object isOnline.
   */
  isOnline?: boolean;
  
  /**
   * This is the object isSupport.
   */
  isSupport?: boolean;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object isWaved.
   */
  isWaved?: boolean;
  
  /**
   * This is the object languages.
   */
  languages?: string;
  
  /**
   * This is the object lastName.
   */
  lastName?: string;
  
  /**
   * This is the object lastVisitedCommunity.
   */
  lastVisitedCommunity?: string;
  
  /**
   * This is the object listingCount.
   */
  listingCount?: number;
  
  /**
   * This is the object livingWith.
   */
  livingWith?: string;
  
  /**
   * This is the object mobilePushEnabled.
   */
  mobilePushEnabled?: boolean;
  
  /**
   * This is the object msgIncoming.
   */
  msgIncoming?: string;
  
  /**
   * This is the object notifyAmenityReminder.
   */
  notifyAmenityReminder?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyDigest.
   */
  notifyDigest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyEventAttendees.
   */
  notifyEventAttendees?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyEventReminder.
   */
  notifyEventReminder?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyHelpCentre.
   */
  notifyHelpCentre?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyJoinRequest.
   */
  notifyJoinRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyLikeOrComment.
   */
  notifyLikeOrComment?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyListingView.
   */
  notifyListingView?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyListingsRequest.
   */
  notifyListingsRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyLoopPost.
   */
  notifyLoopPost?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyManagedAmenities.
   */
  notifyManagedAmenities?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyManagerAdminPost.
   */
  notifyManagerAdminPost?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyMarketingAndFeatures.
   */
  notifyMarketingAndFeatures?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyMessage.
   */
  notifyMessage?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewCommunities.
   */
  notifyNewCommunities?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewListing.
   */
  notifyNewListing?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewListings.
   */
  notifyNewListings?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewMember.
   */
  notifyNewMember?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewMembers.
   */
  notifyNewMembers?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewRequests.
   */
  notifyNewRequests?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewResidentListings.
   */
  notifyNewResidentListings?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewResidents.
   */
  notifyNewResidents?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewTransaction.
   */
  notifyNewTransaction?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyOrderRequest.
   */
  notifyOrderRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyProfileView.
   */
  notifyProfileView?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyUnmanagedAmenities.
   */
  notifyUnmanagedAmenities?: Array<GQLAny | null>;
  
  /**
   * This is the object occupation.
   */
  occupation?: string;
  
  /**
   * This is the object onlineDate.
   */
  onlineDate?: GQLDate;
  
  /**
   * This is the object password.
   */
  password?: string;
  
  /**
   * This is the object personInterests.
   */
  personInterests?: Array<GQLAny | null>;
  
  /**
   * This is the object phone.
   */
  phone?: string;
  
  /**
   * This is the object phoneVerified.
   */
  phoneVerified?: boolean;
  
  /**
   * This is the object platformStripeId.
   */
  platformStripeId?: string;
  
  /**
   * This is the object profileViewOff.
   */
  profileViewOff?: boolean;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object recommendations.
   */
  recommendations?: GQLObject;
  
  /**
   * This is the object spent.
   */
  spent?: number;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeConnectedId.
   */
  stripeConnectedId?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object study.
   */
  study?: string;
  
  /**
   * This is the object tips.
   */
  tips?: GQLObject;
  
  /**
   * This is the object username.
   */
  username?: string;
  
  /**
   * This is the object work.
   */
  work?: string;
  
  /**
   * This is the object zip.
   */
  zip?: string;
}

export interface GQLUpdateUserInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateUserFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * Allow to manage users in ACL.
 */
export interface GQLUserACLInput {
  
  /**
   * Allow the user to read the current object.
   */
  read: boolean;
  
  /**
   * ID of the targetted User.
   */
  userId: string;
  
  /**
   * Allow the user to write on the current object.
   */
  write: boolean;
}

export interface GQLUserLoginWithInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFilePointerInput;
  
  /**
   * This is the object Blocked.
   */
  Blocked?: Array<GQLAny | null>;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLCommunityRelationInput;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocationPointerInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyPointerInput;
  
  /**
   * This is the object Language.
   */
  Language?: GQLLanguagePointerInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationPointerInput;
  
  /**
   * This is the object Orders.
   */
  Orders?: GQLOrderRelationInput;
  
  /**
   * This is the object ReferralCode.
   */
  ReferralCode?: string;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationInput;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object aptSuite.
   */
  aptSuite?: string;
  
  /**
   * This is the object bio.
   */
  bio?: string;
  
  /**
   * This is the object birthDate.
   */
  birthDate?: GQLDate;
  
  /**
   * This is the object cardInfo.
   */
  cardInfo?: Array<GQLAny | null>;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObject;
  
  /**
   * This is the object checkListSeen.
   */
  checkListSeen?: boolean;
  
  /**
   * This is the object distance.
   */
  distance?: string;
  
  /**
   * This is the object earned.
   */
  earned?: number;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: boolean;
  
  /**
   * This is the object firstLetter.
   */
  firstLetter?: string;
  
  /**
   * This is the object firstName.
   */
  firstName?: string;
  
  /**
   * This is the object gender.
   */
  gender?: string;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPointInput;
  
  /**
   * This is the object homepage.
   */
  homepage?: string;
  
  /**
   * This is the object howDidYouHear.
   */
  howDidYouHear?: string;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObject;
  
  /**
   * This is the object interests.
   */
  interests?: Array<GQLAny | null>;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: boolean;
  
  /**
   * This is the object isInvited.
   */
  isInvited?: boolean;
  
  /**
   * This is the object isOnline.
   */
  isOnline?: boolean;
  
  /**
   * This is the object isSupport.
   */
  isSupport?: boolean;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object isWaved.
   */
  isWaved?: boolean;
  
  /**
   * This is the object languages.
   */
  languages?: string;
  
  /**
   * This is the object lastName.
   */
  lastName?: string;
  
  /**
   * This is the object lastVisitedCommunity.
   */
  lastVisitedCommunity?: string;
  
  /**
   * This is the object listingCount.
   */
  listingCount?: number;
  
  /**
   * This is the object livingWith.
   */
  livingWith?: string;
  
  /**
   * This is the object mobilePushEnabled.
   */
  mobilePushEnabled?: boolean;
  
  /**
   * This is the object msgIncoming.
   */
  msgIncoming?: string;
  
  /**
   * This is the object notifyAmenityReminder.
   */
  notifyAmenityReminder?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyDigest.
   */
  notifyDigest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyEventAttendees.
   */
  notifyEventAttendees?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyEventReminder.
   */
  notifyEventReminder?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyHelpCentre.
   */
  notifyHelpCentre?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyJoinRequest.
   */
  notifyJoinRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyLikeOrComment.
   */
  notifyLikeOrComment?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyListingView.
   */
  notifyListingView?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyListingsRequest.
   */
  notifyListingsRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyLoopPost.
   */
  notifyLoopPost?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyManagedAmenities.
   */
  notifyManagedAmenities?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyManagerAdminPost.
   */
  notifyManagerAdminPost?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyMarketingAndFeatures.
   */
  notifyMarketingAndFeatures?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyMessage.
   */
  notifyMessage?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewCommunities.
   */
  notifyNewCommunities?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewListing.
   */
  notifyNewListing?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewListings.
   */
  notifyNewListings?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewMember.
   */
  notifyNewMember?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewMembers.
   */
  notifyNewMembers?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewRequests.
   */
  notifyNewRequests?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewResidentListings.
   */
  notifyNewResidentListings?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewResidents.
   */
  notifyNewResidents?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyNewTransaction.
   */
  notifyNewTransaction?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyOrderRequest.
   */
  notifyOrderRequest?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyProfileView.
   */
  notifyProfileView?: Array<GQLAny | null>;
  
  /**
   * This is the object notifyUnmanagedAmenities.
   */
  notifyUnmanagedAmenities?: Array<GQLAny | null>;
  
  /**
   * This is the object occupation.
   */
  occupation?: string;
  
  /**
   * This is the object onlineDate.
   */
  onlineDate?: GQLDate;
  
  /**
   * This is the object personInterests.
   */
  personInterests?: Array<GQLAny | null>;
  
  /**
   * This is the object phone.
   */
  phone?: string;
  
  /**
   * This is the object phoneVerified.
   */
  phoneVerified?: boolean;
  
  /**
   * This is the object platformStripeId.
   */
  platformStripeId?: string;
  
  /**
   * This is the object profileViewOff.
   */
  profileViewOff?: boolean;
  
  /**
   * This is the object rating.
   */
  rating?: number;
  
  /**
   * This is the object recommendations.
   */
  recommendations?: GQLObject;
  
  /**
   * This is the object spent.
   */
  spent?: number;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeConnectedId.
   */
  stripeConnectedId?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object study.
   */
  study?: string;
  
  /**
   * This is the object tips.
   */
  tips?: GQLObject;
  
  /**
   * This is the object work.
   */
  work?: string;
  
  /**
   * This is the object zip.
   */
  zip?: string;
}

/**
 * Allow to link OR add and link an object of the User class.
 */
export interface GQLUserPointerInput {
  
  /**
   * Create and link an object from User class.
   */
  createAndLink?: GQLCreateUserFieldsInput;
  
  /**
   * Link an existing object from User class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the User class into a relation field.
 */
export interface GQLUserRelationInput {
  
  /**
   * Add existing objects from the User class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the User class into the relation.
   */
  createAndAdd?: Array<GQLCreateUserFieldsInput>;
  
  /**
   * Remove existing objects from the User class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The UserRelationWhereInput input type is used in operations that involve filtering objects of User class.
 */
export interface GQLUserRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLUserWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLUserWhereInput;
}

/**
 * The UserWhereInput input type is used in operations that involve filtering objects of User class.
 */
export interface GQLUserWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLUserWhereInput>;
  
  /**
   * This is the object Avatar.
   */
  Avatar?: GQLAppFileRelationWhereInput;
  
  /**
   * This is the object Blocked.
   */
  Blocked?: GQLArrayWhereInput;
  
  /**
   * This is the object Communities.
   */
  Communities?: GQLCommunityRelationWhereInput;
  
  /**
   * This is the object Country.
   */
  Country?: GQLLocationRelationWhereInput;
  
  /**
   * This is the object Currency.
   */
  Currency?: GQLCurrencyRelationWhereInput;
  
  /**
   * This is the object Language.
   */
  Language?: GQLLanguageRelationWhereInput;
  
  /**
   * This is the object Location.
   */
  Location?: GQLLocationRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLUserWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLUserWhereInput>;
  
  /**
   * This is the object Orders.
   */
  Orders?: GQLOrderRelationWhereInput;
  
  /**
   * This is the object ReferralCode.
   */
  ReferralCode?: GQLStringWhereInput;
  
  /**
   * This is the object Reports.
   */
  Reports?: GQLReportRelationWhereInput;
  
  /**
   * This is the object Reviews.
   */
  Reviews?: GQLReviewRelationWhereInput;
  
  /**
   * This is the object Viewers.
   */
  Viewers?: GQLUserRelationWhereInput;
  
  /**
   * This is the object address.
   */
  address?: GQLStringWhereInput;
  
  /**
   * This is the object aptSuite.
   */
  aptSuite?: GQLStringWhereInput;
  
  /**
   * This is the object authData.
   */
  authData?: GQLObjectWhereInput;
  
  /**
   * This is the object bio.
   */
  bio?: GQLStringWhereInput;
  
  /**
   * This is the object birthDate.
   */
  birthDate?: GQLDateWhereInput;
  
  /**
   * This is the object cardInfo.
   */
  cardInfo?: GQLArrayWhereInput;
  
  /**
   * This is the object checkList.
   */
  checkList?: GQLObjectWhereInput;
  
  /**
   * This is the object checkListSeen.
   */
  checkListSeen?: GQLBooleanWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object distance.
   */
  distance?: GQLStringWhereInput;
  
  /**
   * This is the object earned.
   */
  earned?: GQLNumberWhereInput;
  
  /**
   * This is the object email.
   */
  email?: GQLStringWhereInput;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: GQLBooleanWhereInput;
  
  /**
   * This is the object firstLetter.
   */
  firstLetter?: GQLStringWhereInput;
  
  /**
   * This is the object firstName.
   */
  firstName?: GQLStringWhereInput;
  
  /**
   * This is the object gender.
   */
  gender?: GQLStringWhereInput;
  
  /**
   * This is the object geo.
   */
  geo?: GQLGeoPointWhereInput;
  
  /**
   * This is the object homepage.
   */
  homepage?: GQLStringWhereInput;
  
  /**
   * This is the object howDidYouHear.
   */
  howDidYouHear?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object identityData.
   */
  identityData?: GQLObjectWhereInput;
  
  /**
   * This is the object interests.
   */
  interests?: GQLArrayWhereInput;
  
  /**
   * This is the object isDeleted.
   */
  isDeleted?: GQLBooleanWhereInput;
  
  /**
   * This is the object isInvited.
   */
  isInvited?: GQLBooleanWhereInput;
  
  /**
   * This is the object isOnline.
   */
  isOnline?: GQLBooleanWhereInput;
  
  /**
   * This is the object isSupport.
   */
  isSupport?: GQLBooleanWhereInput;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: GQLBooleanWhereInput;
  
  /**
   * This is the object isWaved.
   */
  isWaved?: GQLBooleanWhereInput;
  
  /**
   * This is the object languages.
   */
  languages?: GQLStringWhereInput;
  
  /**
   * This is the object lastName.
   */
  lastName?: GQLStringWhereInput;
  
  /**
   * This is the object lastVisitedCommunity.
   */
  lastVisitedCommunity?: GQLStringWhereInput;
  
  /**
   * This is the object listingCount.
   */
  listingCount?: GQLNumberWhereInput;
  
  /**
   * This is the object livingWith.
   */
  livingWith?: GQLStringWhereInput;
  
  /**
   * This is the object mobilePushEnabled.
   */
  mobilePushEnabled?: GQLBooleanWhereInput;
  
  /**
   * This is the object msgIncoming.
   */
  msgIncoming?: GQLStringWhereInput;
  
  /**
   * This is the object notifyAmenityReminder.
   */
  notifyAmenityReminder?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyDigest.
   */
  notifyDigest?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyEventAttendees.
   */
  notifyEventAttendees?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyEventReminder.
   */
  notifyEventReminder?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyHelpCentre.
   */
  notifyHelpCentre?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyJoinRequest.
   */
  notifyJoinRequest?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyLikeOrComment.
   */
  notifyLikeOrComment?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyListingView.
   */
  notifyListingView?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyListingsRequest.
   */
  notifyListingsRequest?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyLoopPost.
   */
  notifyLoopPost?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyManagedAmenities.
   */
  notifyManagedAmenities?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyManagerAdminPost.
   */
  notifyManagerAdminPost?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyMarketingAndFeatures.
   */
  notifyMarketingAndFeatures?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyMessage.
   */
  notifyMessage?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewCommunities.
   */
  notifyNewCommunities?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewListing.
   */
  notifyNewListing?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewListings.
   */
  notifyNewListings?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewMember.
   */
  notifyNewMember?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewMembers.
   */
  notifyNewMembers?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewRequests.
   */
  notifyNewRequests?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewResidentListings.
   */
  notifyNewResidentListings?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewResidents.
   */
  notifyNewResidents?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyNewTransaction.
   */
  notifyNewTransaction?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyOrderRequest.
   */
  notifyOrderRequest?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyProfileView.
   */
  notifyProfileView?: GQLArrayWhereInput;
  
  /**
   * This is the object notifyUnmanagedAmenities.
   */
  notifyUnmanagedAmenities?: GQLArrayWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object occupation.
   */
  occupation?: GQLStringWhereInput;
  
  /**
   * This is the object onlineDate.
   */
  onlineDate?: GQLDateWhereInput;
  
  /**
   * This is the object password.
   */
  password?: GQLStringWhereInput;
  
  /**
   * This is the object personInterests.
   */
  personInterests?: GQLArrayWhereInput;
  
  /**
   * This is the object phone.
   */
  phone?: GQLStringWhereInput;
  
  /**
   * This is the object phoneVerified.
   */
  phoneVerified?: GQLBooleanWhereInput;
  
  /**
   * This is the object platformStripeId.
   */
  platformStripeId?: GQLStringWhereInput;
  
  /**
   * This is the object profileViewOff.
   */
  profileViewOff?: GQLBooleanWhereInput;
  
  /**
   * This is the object rating.
   */
  rating?: GQLNumberWhereInput;
  
  /**
   * This is the object recommendations.
   */
  recommendations?: GQLObjectWhereInput;
  
  /**
   * This is the object spent.
   */
  spent?: GQLNumberWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object stripeConnectedId.
   */
  stripeConnectedId?: GQLStringWhereInput;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: GQLStringWhereInput;
  
  /**
   * This is the object study.
   */
  study?: GQLStringWhereInput;
  
  /**
   * This is the object tips.
   */
  tips?: GQLObjectWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object username.
   */
  username?: GQLStringWhereInput;
  
  /**
   * This is the object work.
   */
  work?: GQLStringWhereInput;
  
  /**
   * This is the object zip.
   */
  zip?: GQLStringWhereInput;
}

export interface GQLVerifyCodeInp {
  clientMutationId?: string;
  code?: string;
  phone?: string;
  resendCode?: boolean;
}

export interface GQLVerifyEmailInput {
  clientMutationId?: string;
  id: string;
  token: string;
}

export interface GQLVerifyPhoneInp {
  clientMutationId?: string;
  phone?: string;
}

export interface GQLViewObjectInp {
  clientMutationId?: string;
  id: string;
  objectType: GQLViewObjectTypes;
}

export interface GQLVoteInPollInp {
  optionId: string;
  postId: string;
}

export interface GQLWaveUserInp {
  communityId: string;
  userId: string;
}

/**
 * The WithinInput type is used to specify a within operation on a constraint.
 */
export interface GQLWithinInput {
  
  /**
   * This is the box to be specified.
   */
  box: GQLBoxInput;
}

export interface GQLbadgeClearInp {
  deviceToken: string;
}

export interface GQLgetEventInp {
  eventId: string;
}

export interface GQLgetSeoOrderItemDataInp {
  orderId: string;
}

/*********************************
 *                               *
 *         TYPE RESOLVERS        *
 *                               *
 *********************************/
/**
 * This interface define the shape of your resolver
 * Note that this type is designed to be compatible with graphql-tools resolvers
 * However, you can still use other generated interfaces to make your resolver type-safed
 */
export interface GQLResolver {
  Node?: {
    __resolveType: GQLNodeTypeResolver
  };
  
  ParseObject?: {
    __resolveType: GQLParseObjectTypeResolver
  };
  
  SchemaField?: {
    __resolveType: GQLSchemaFieldTypeResolver
  };
  
  ArrayResult?: {
    __resolveType: GQLArrayResultTypeResolver
  };
  
  ACL?: GQLACLTypeResolver;
  AccountTransferPayload?: GQLAccountTransferPayloadTypeResolver;
  Admin?: GQLAdminTypeResolver;
  AdminConnection?: GQLAdminConnectionTypeResolver;
  AdminCreatePayload?: GQLAdminCreatePayloadTypeResolver;
  AdminDashboardPayload?: GQLAdminDashboardPayloadTypeResolver;
  AdminEdge?: GQLAdminEdgeTypeResolver;
  Amenity?: GQLAmenityTypeResolver;
  AmenityConnection?: GQLAmenityConnectionTypeResolver;
  AmenityEdge?: GQLAmenityEdgeTypeResolver;
  AppFile?: GQLAppFileTypeResolver;
  AppFileConnection?: GQLAppFileConnectionTypeResolver;
  AppFileEdge?: GQLAppFileEdgeTypeResolver;
  BookAmenityPayload?: GQLBookAmenityPayloadTypeResolver;
  BookEventPayload?: GQLBookEventPayloadTypeResolver;
  CalcOrderDataPayload?: GQLCalcOrderDataPayloadTypeResolver;
  CallCloudCodePayload?: GQLCallCloudCodePayloadTypeResolver;
  CardInfoPayload?: GQLCardInfoPayloadTypeResolver;
  Category?: GQLCategoryTypeResolver;
  CategoryConnection?: GQLCategoryConnectionTypeResolver;
  CategoryEdge?: GQLCategoryEdgeTypeResolver;
  ChangePasswordPayload?: GQLChangePasswordPayloadTypeResolver;
  ChartDataPayload?: GQLChartDataPayloadTypeResolver;
  Chat?: GQLChatTypeResolver;
  ChatConnection?: GQLChatConnectionTypeResolver;
  ChatEdge?: GQLChatEdgeTypeResolver;
  Class?: GQLClassTypeResolver;
  Community?: GQLCommunityTypeResolver;
  CommunityAdmin?: GQLCommunityAdminTypeResolver;
  CommunityAdminConnection?: GQLCommunityAdminConnectionTypeResolver;
  CommunityAdminEdge?: GQLCommunityAdminEdgeTypeResolver;
  CommunityAdminPayload?: GQLCommunityAdminPayloadTypeResolver;
  CommunityConnection?: GQLCommunityConnectionTypeResolver;
  CommunityEdge?: GQLCommunityEdgeTypeResolver;
  CommunityForNewUserPayload?: GQLCommunityForNewUserPayloadTypeResolver;
  Company?: GQLCompanyTypeResolver;
  CompanyConnection?: GQLCompanyConnectionTypeResolver;
  CompanyEdge?: GQLCompanyEdgeTypeResolver;
  ConnectStripeAccPayload?: GQLConnectStripeAccPayloadTypeResolver;
  CreateAdminPayload?: GQLCreateAdminPayloadTypeResolver;
  CreateAmenityPayload?: GQLCreateAmenityPayloadTypeResolver;
  CreateAppFilePayload?: GQLCreateAppFilePayloadTypeResolver;
  CreateCategoryPayload?: GQLCreateCategoryPayloadTypeResolver;
  CreateChatPayload?: GQLCreateChatPayloadTypeResolver;
  CreateClassPayload?: GQLCreateClassPayloadTypeResolver;
  CreateCommunityAdminPayload?: GQLCreateCommunityAdminPayloadTypeResolver;
  CreateCommunityPayload?: GQLCreateCommunityPayloadTypeResolver;
  CreateCompanyPayload?: GQLCreateCompanyPayloadTypeResolver;
  CreateCurrencyPayload?: GQLCreateCurrencyPayloadTypeResolver;
  CreateDocumentPayload?: GQLCreateDocumentPayloadTypeResolver;
  CreateEventPayload?: GQLCreateEventPayloadTypeResolver;
  CreateFilePayload?: GQLCreateFilePayloadTypeResolver;
  CreateGroupPayload?: GQLCreateGroupPayloadTypeResolver;
  CreateHelpDeskPayload?: GQLCreateHelpDeskPayloadTypeResolver;
  CreateInstallationPayload?: GQLCreateInstallationPayloadTypeResolver;
  CreateInvitationPayload?: GQLCreateInvitationPayloadTypeResolver;
  CreateItemBookingPayload?: GQLCreateItemBookingPayloadTypeResolver;
  CreateItemPayload?: GQLCreateItemPayloadTypeResolver;
  CreateJoinRequestPayload?: GQLCreateJoinRequestPayloadTypeResolver;
  CreateLanguagePayload?: GQLCreateLanguagePayloadTypeResolver;
  CreateLocationPayload?: GQLCreateLocationPayloadTypeResolver;
  CreateMessagePayload?: GQLCreateMessagePayloadTypeResolver;
  CreateMultiplyItemsPayload?: GQLCreateMultiplyItemsPayloadTypeResolver;
  CreateMyClassPayload?: GQLCreateMyClassPayloadTypeResolver;
  CreateNotifSendingPayload?: GQLCreateNotifSendingPayloadTypeResolver;
  CreateNotificationPayload?: GQLCreateNotificationPayloadTypeResolver;
  CreateOrderPayload?: GQLCreateOrderPayloadTypeResolver;
  CreatePaymentPlanPayload?: GQLCreatePaymentPlanPayloadTypeResolver;
  CreatePhoneVerificationPayload?: GQLCreatePhoneVerificationPayloadTypeResolver;
  CreatePollOptionPayload?: GQLCreatePollOptionPayloadTypeResolver;
  CreatePostPayload?: GQLCreatePostPayloadTypeResolver;
  CreatePostTranslatePayload?: GQLCreatePostTranslatePayloadTypeResolver;
  CreatePromoPayload?: GQLCreatePromoPayloadTypeResolver;
  CreatePushNotificationLogPayload?: GQLCreatePushNotificationLogPayloadTypeResolver;
  CreateReferralPayload?: GQLCreateReferralPayloadTypeResolver;
  CreateReportPayload?: GQLCreateReportPayloadTypeResolver;
  CreateReviewPayload?: GQLCreateReviewPayloadTypeResolver;
  CreateRolePayload?: GQLCreateRolePayloadTypeResolver;
  CreateSessionPayload?: GQLCreateSessionPayloadTypeResolver;
  CreateSubscrPayload?: GQLCreateSubscrPayloadTypeResolver;
  CreateSubscrPaymentPayload?: GQLCreateSubscrPaymentPayloadTypeResolver;
  CreateTaskPayload?: GQLCreateTaskPayloadTypeResolver;
  CreateTransactionPayload?: GQLCreateTransactionPayloadTypeResolver;
  CreateUserPayload?: GQLCreateUserPayloadTypeResolver;
  Currency?: GQLCurrencyTypeResolver;
  CurrencyConnection?: GQLCurrencyConnectionTypeResolver;
  CurrencyEdge?: GQLCurrencyEdgeTypeResolver;
  DashboardChartPayload?: GQLDashboardChartPayloadTypeResolver;
  DeleteAdminPayload?: GQLDeleteAdminPayloadTypeResolver;
  DeleteAmenityPayload?: GQLDeleteAmenityPayloadTypeResolver;
  DeleteAppFilePayload?: GQLDeleteAppFilePayloadTypeResolver;
  DeleteCategoryPayload?: GQLDeleteCategoryPayloadTypeResolver;
  DeleteChatPayload?: GQLDeleteChatPayloadTypeResolver;
  DeleteClassPayload?: GQLDeleteClassPayloadTypeResolver;
  DeleteCommunityAdminPayload?: GQLDeleteCommunityAdminPayloadTypeResolver;
  DeleteCommunityPayload?: GQLDeleteCommunityPayloadTypeResolver;
  DeleteCompanyPayload?: GQLDeleteCompanyPayloadTypeResolver;
  DeleteCurrencyPayload?: GQLDeleteCurrencyPayloadTypeResolver;
  DeleteDocumentPayload?: GQLDeleteDocumentPayloadTypeResolver;
  DeleteEventPayload?: GQLDeleteEventPayloadTypeResolver;
  DeleteGroupPayload?: GQLDeleteGroupPayloadTypeResolver;
  DeleteHelpDeskPayload?: GQLDeleteHelpDeskPayloadTypeResolver;
  DeleteInstallationPayload?: GQLDeleteInstallationPayloadTypeResolver;
  DeleteInvitationPayload?: GQLDeleteInvitationPayloadTypeResolver;
  DeleteItemBookingPayload?: GQLDeleteItemBookingPayloadTypeResolver;
  DeleteItemPayload?: GQLDeleteItemPayloadTypeResolver;
  DeleteJoinRequestPayload?: GQLDeleteJoinRequestPayloadTypeResolver;
  DeleteLanguagePayload?: GQLDeleteLanguagePayloadTypeResolver;
  DeleteLocationPayload?: GQLDeleteLocationPayloadTypeResolver;
  DeleteMessagePayload?: GQLDeleteMessagePayloadTypeResolver;
  DeleteMyClassPayload?: GQLDeleteMyClassPayloadTypeResolver;
  DeleteNotifSendingPayload?: GQLDeleteNotifSendingPayloadTypeResolver;
  DeleteNotificationPayload?: GQLDeleteNotificationPayloadTypeResolver;
  DeleteOrderPayload?: GQLDeleteOrderPayloadTypeResolver;
  DeletePaymentPlanPayload?: GQLDeletePaymentPlanPayloadTypeResolver;
  DeletePhoneVerificationPayload?: GQLDeletePhoneVerificationPayloadTypeResolver;
  DeletePollOptionPayload?: GQLDeletePollOptionPayloadTypeResolver;
  DeletePostPayload?: GQLDeletePostPayloadTypeResolver;
  DeletePostTranslatePayload?: GQLDeletePostTranslatePayloadTypeResolver;
  DeletePromoPayload?: GQLDeletePromoPayloadTypeResolver;
  DeletePushNotificationLogPayload?: GQLDeletePushNotificationLogPayloadTypeResolver;
  DeleteReferralPayload?: GQLDeleteReferralPayloadTypeResolver;
  DeleteReportPayload?: GQLDeleteReportPayloadTypeResolver;
  DeleteReviewPayload?: GQLDeleteReviewPayloadTypeResolver;
  DeleteRolePayload?: GQLDeleteRolePayloadTypeResolver;
  DeleteSessionPayload?: GQLDeleteSessionPayloadTypeResolver;
  DeleteSubscrPayload?: GQLDeleteSubscrPayloadTypeResolver;
  DeleteSubscrPaymentPayload?: GQLDeleteSubscrPaymentPayloadTypeResolver;
  DeleteTaskPayload?: GQLDeleteTaskPayloadTypeResolver;
  DeleteTransactionPayload?: GQLDeleteTransactionPayloadTypeResolver;
  DeleteUserPayload?: GQLDeleteUserPayloadTypeResolver;
  DirectAddMemberPayload?: GQLDirectAddMemberPayloadTypeResolver;
  Document?: GQLDocumentTypeResolver;
  DocumentConnection?: GQLDocumentConnectionTypeResolver;
  DocumentEdge?: GQLDocumentEdgeTypeResolver;
  Element?: GQLElementTypeResolver;
  Event?: GQLEventTypeResolver;
  EventConnection?: GQLEventConnectionTypeResolver;
  EventEdge?: GQLEventEdgeTypeResolver;
  FeeObject?: GQLFeeObjectTypeResolver;
  FileInfo?: GQLFileInfoTypeResolver;
  GenerateAiOpenApiTextPayload?: GQLGenerateAiOpenApiTextPayloadTypeResolver;
  GenerateUsernamePayload?: GQLGenerateUsernamePayloadTypeResolver;
  GeoPoint?: GQLGeoPointTypeResolver;
  GetAccBalancePayload?: GQLGetAccBalancePayloadTypeResolver;
  GetItemArraysPayload?: GQLGetItemArraysPayloadTypeResolver;
  GetManagersListPayload?: GQLGetManagersListPayloadTypeResolver;
  GetResidentsAvatarPayload?: GQLGetResidentsAvatarPayloadTypeResolver;
  GetUserByReferralPayload?: GQLGetUserByReferralPayloadTypeResolver;
  GetUserCardsPayload?: GQLGetUserCardsPayloadTypeResolver;
  Group?: GQLGroupTypeResolver;
  GroupConnection?: GQLGroupConnectionTypeResolver;
  GroupEdge?: GQLGroupEdgeTypeResolver;
  GroupPayload?: GQLGroupPayloadTypeResolver;
  HelpDesk?: GQLHelpDeskTypeResolver;
  HelpDeskConnection?: GQLHelpDeskConnectionTypeResolver;
  HelpDeskEdge?: GQLHelpDeskEdgeTypeResolver;
  HidePostPayload?: GQLHidePostPayloadTypeResolver;
  Installation?: GQLInstallationTypeResolver;
  InstallationConnection?: GQLInstallationConnectionTypeResolver;
  InstallationEdge?: GQLInstallationEdgeTypeResolver;
  Invitation?: GQLInvitationTypeResolver;
  InvitationConnection?: GQLInvitationConnectionTypeResolver;
  InvitationEdge?: GQLInvitationEdgeTypeResolver;
  InvoiceItemOrderPayload?: GQLInvoiceItemOrderPayloadTypeResolver;
  Item?: GQLItemTypeResolver;
  ItemBooking?: GQLItemBookingTypeResolver;
  ItemBookingConnection?: GQLItemBookingConnectionTypeResolver;
  ItemBookingEdge?: GQLItemBookingEdgeTypeResolver;
  ItemConnection?: GQLItemConnectionTypeResolver;
  ItemEdge?: GQLItemEdgeTypeResolver;
  JoinRequest?: GQLJoinRequestTypeResolver;
  JoinRequestConnection?: GQLJoinRequestConnectionTypeResolver;
  JoinRequestEdge?: GQLJoinRequestEdgeTypeResolver;
  Language?: GQLLanguageTypeResolver;
  LanguageConnection?: GQLLanguageConnectionTypeResolver;
  LanguageEdge?: GQLLanguageEdgeTypeResolver;
  LikeEventPayload?: GQLLikeEventPayloadTypeResolver;
  LikeListingPayload?: GQLLikeListingPayloadTypeResolver;
  LikePostPayload?: GQLLikePostPayloadTypeResolver;
  Location?: GQLLocationTypeResolver;
  LocationConnection?: GQLLocationConnectionTypeResolver;
  LocationEdge?: GQLLocationEdgeTypeResolver;
  LogInPayload?: GQLLogInPayloadTypeResolver;
  LogInWithPayload?: GQLLogInWithPayloadTypeResolver;
  LogOutPayload?: GQLLogOutPayloadTypeResolver;
  ManagerDashboardPayload?: GQLManagerDashboardPayloadTypeResolver;
  Message?: GQLMessageTypeResolver;
  MessageConnection?: GQLMessageConnectionTypeResolver;
  MessageEdge?: GQLMessageEdgeTypeResolver;
  Mutation?: GQLMutationTypeResolver;
  MyClass?: GQLMyClassTypeResolver;
  MyClassConnection?: GQLMyClassConnectionTypeResolver;
  MyClassEdge?: GQLMyClassEdgeTypeResolver;
  NotifSending?: GQLNotifSendingTypeResolver;
  NotifSendingConnection?: GQLNotifSendingConnectionTypeResolver;
  NotifSendingEdge?: GQLNotifSendingEdgeTypeResolver;
  Notification?: GQLNotificationTypeResolver;
  NotificationConnection?: GQLNotificationConnectionTypeResolver;
  NotificationEdge?: GQLNotificationEdgeTypeResolver;
  NotifyManagerPayload?: GQLNotifyManagerPayloadTypeResolver;
  Order?: GQLOrderTypeResolver;
  OrderConnection?: GQLOrderConnectionTypeResolver;
  OrderEdge?: GQLOrderEdgeTypeResolver;
  OrderPayload?: GQLOrderPayloadTypeResolver;
  PageInfo?: GQLPageInfoTypeResolver;
  PaySubscrPayload?: GQLPaySubscrPayloadTypeResolver;
  PaymentPlan?: GQLPaymentPlanTypeResolver;
  PaymentPlanConnection?: GQLPaymentPlanConnectionTypeResolver;
  PaymentPlanEdge?: GQLPaymentPlanEdgeTypeResolver;
  PaymentPlatformDashLinkPayload?: GQLPaymentPlatformDashLinkPayloadTypeResolver;
  PermissionsListPayload?: GQLPermissionsListPayloadTypeResolver;
  PhoneVerification?: GQLPhoneVerificationTypeResolver;
  PhoneVerificationConnection?: GQLPhoneVerificationConnectionTypeResolver;
  PhoneVerificationEdge?: GQLPhoneVerificationEdgeTypeResolver;
  PollOption?: GQLPollOptionTypeResolver;
  PollOptionConnection?: GQLPollOptionConnectionTypeResolver;
  PollOptionEdge?: GQLPollOptionEdgeTypeResolver;
  Post?: GQLPostTypeResolver;
  PostConnection?: GQLPostConnectionTypeResolver;
  PostEdge?: GQLPostEdgeTypeResolver;
  PostTranslate?: GQLPostTranslateTypeResolver;
  PostTranslateConnection?: GQLPostTranslateConnectionTypeResolver;
  PostTranslateEdge?: GQLPostTranslateEdgeTypeResolver;
  PreOrderCalcDataPayLoad?: GQLPreOrderCalcDataPayLoadTypeResolver;
  Promo?: GQLPromoTypeResolver;
  PromoConnection?: GQLPromoConnectionTypeResolver;
  PromoEdge?: GQLPromoEdgeTypeResolver;
  PublicACL?: GQLPublicACLTypeResolver;
  PushNotificationLog?: GQLPushNotificationLogTypeResolver;
  PushNotificationLogConnection?: GQLPushNotificationLogConnectionTypeResolver;
  PushNotificationLogEdge?: GQLPushNotificationLogEdgeTypeResolver;
  Query?: GQLQueryTypeResolver;
  ReactionHandlerPayload?: GQLReactionHandlerPayloadTypeResolver;
  Referral?: GQLReferralTypeResolver;
  ReferralConnection?: GQLReferralConnectionTypeResolver;
  ReferralEdge?: GQLReferralEdgeTypeResolver;
  Report?: GQLReportTypeResolver;
  ReportConnection?: GQLReportConnectionTypeResolver;
  ReportEdge?: GQLReportEdgeTypeResolver;
  ResetPasswordPayload?: GQLResetPasswordPayloadTypeResolver;
  ResidentDashboardPayload?: GQLResidentDashboardPayloadTypeResolver;
  Review?: GQLReviewTypeResolver;
  ReviewConnection?: GQLReviewConnectionTypeResolver;
  ReviewEdge?: GQLReviewEdgeTypeResolver;
  Role?: GQLRoleTypeResolver;
  RoleACL?: GQLRoleACLTypeResolver;
  RoleConnection?: GQLRoleConnectionTypeResolver;
  RoleEdge?: GQLRoleEdgeTypeResolver;
  SchemaACLField?: GQLSchemaACLFieldTypeResolver;
  SchemaArrayField?: GQLSchemaArrayFieldTypeResolver;
  SchemaBooleanField?: GQLSchemaBooleanFieldTypeResolver;
  SchemaBytesField?: GQLSchemaBytesFieldTypeResolver;
  SchemaDateField?: GQLSchemaDateFieldTypeResolver;
  SchemaFileField?: GQLSchemaFileFieldTypeResolver;
  SchemaGeoPointField?: GQLSchemaGeoPointFieldTypeResolver;
  SchemaNumberField?: GQLSchemaNumberFieldTypeResolver;
  SchemaObjectField?: GQLSchemaObjectFieldTypeResolver;
  SchemaPointerField?: GQLSchemaPointerFieldTypeResolver;
  SchemaPolygonField?: GQLSchemaPolygonFieldTypeResolver;
  SchemaRelationField?: GQLSchemaRelationFieldTypeResolver;
  SchemaStringField?: GQLSchemaStringFieldTypeResolver;
  SendVerificationEmailPayload?: GQLSendVerificationEmailPayloadTypeResolver;
  Session?: GQLSessionTypeResolver;
  SessionConnection?: GQLSessionConnectionTypeResolver;
  SessionEdge?: GQLSessionEdgeTypeResolver;
  SignUpPayload?: GQLSignUpPayloadTypeResolver;
  Subscr?: GQLSubscrTypeResolver;
  SubscrConnection?: GQLSubscrConnectionTypeResolver;
  SubscrEdge?: GQLSubscrEdgeTypeResolver;
  SubscrPayment?: GQLSubscrPaymentTypeResolver;
  SubscrPaymentConnection?: GQLSubscrPaymentConnectionTypeResolver;
  SubscrPaymentEdge?: GQLSubscrPaymentEdgeTypeResolver;
  SupportInsightPayload?: GQLSupportInsightPayloadTypeResolver;
  Task?: GQLTaskTypeResolver;
  TaskConnection?: GQLTaskConnectionTypeResolver;
  TaskEdge?: GQLTaskEdgeTypeResolver;
  Transaction?: GQLTransactionTypeResolver;
  TransactionConnection?: GQLTransactionConnectionTypeResolver;
  TransactionEdge?: GQLTransactionEdgeTypeResolver;
  UpdateAdminPayload?: GQLUpdateAdminPayloadTypeResolver;
  UpdateAmenityPayload?: GQLUpdateAmenityPayloadTypeResolver;
  UpdateAppFilePayload?: GQLUpdateAppFilePayloadTypeResolver;
  UpdateCategoryPayload?: GQLUpdateCategoryPayloadTypeResolver;
  UpdateChatPayload?: GQLUpdateChatPayloadTypeResolver;
  UpdateClassPayload?: GQLUpdateClassPayloadTypeResolver;
  UpdateCommunityAdminPayload?: GQLUpdateCommunityAdminPayloadTypeResolver;
  UpdateCommunityPayload?: GQLUpdateCommunityPayloadTypeResolver;
  UpdateCompanyPayload?: GQLUpdateCompanyPayloadTypeResolver;
  UpdateCurrencyPayload?: GQLUpdateCurrencyPayloadTypeResolver;
  UpdateDocumentPayload?: GQLUpdateDocumentPayloadTypeResolver;
  UpdateEventPayload?: GQLUpdateEventPayloadTypeResolver;
  UpdateGroupPayload?: GQLUpdateGroupPayloadTypeResolver;
  UpdateHelpDeskPayload?: GQLUpdateHelpDeskPayloadTypeResolver;
  UpdateInstallationPayload?: GQLUpdateInstallationPayloadTypeResolver;
  UpdateInvitationPayload?: GQLUpdateInvitationPayloadTypeResolver;
  UpdateItemBookingPayload?: GQLUpdateItemBookingPayloadTypeResolver;
  UpdateItemPayload?: GQLUpdateItemPayloadTypeResolver;
  UpdateJoinRequestPayload?: GQLUpdateJoinRequestPayloadTypeResolver;
  UpdateLanguagePayload?: GQLUpdateLanguagePayloadTypeResolver;
  UpdateLocationPayload?: GQLUpdateLocationPayloadTypeResolver;
  UpdateMessagePayload?: GQLUpdateMessagePayloadTypeResolver;
  UpdateMyClassPayload?: GQLUpdateMyClassPayloadTypeResolver;
  UpdateNotifSendingPayload?: GQLUpdateNotifSendingPayloadTypeResolver;
  UpdateNotificationPayload?: GQLUpdateNotificationPayloadTypeResolver;
  UpdateOrderPayload?: GQLUpdateOrderPayloadTypeResolver;
  UpdatePaymentPlanPayload?: GQLUpdatePaymentPlanPayloadTypeResolver;
  UpdatePhoneVerificationPayload?: GQLUpdatePhoneVerificationPayloadTypeResolver;
  UpdatePollOptionPayload?: GQLUpdatePollOptionPayloadTypeResolver;
  UpdatePostPayload?: GQLUpdatePostPayloadTypeResolver;
  UpdatePostTranslatePayload?: GQLUpdatePostTranslatePayloadTypeResolver;
  UpdatePromoPayload?: GQLUpdatePromoPayloadTypeResolver;
  UpdatePushNotificationLogPayload?: GQLUpdatePushNotificationLogPayloadTypeResolver;
  UpdateReferralPayload?: GQLUpdateReferralPayloadTypeResolver;
  UpdateReportPayload?: GQLUpdateReportPayloadTypeResolver;
  UpdateReviewPayload?: GQLUpdateReviewPayloadTypeResolver;
  UpdateRolePayload?: GQLUpdateRolePayloadTypeResolver;
  UpdateSessionPayload?: GQLUpdateSessionPayloadTypeResolver;
  UpdateSubscrPayload?: GQLUpdateSubscrPayloadTypeResolver;
  UpdateSubscrPaymentPayload?: GQLUpdateSubscrPaymentPayloadTypeResolver;
  UpdateTaskPayload?: GQLUpdateTaskPayloadTypeResolver;
  UpdateTransactionPayload?: GQLUpdateTransactionPayloadTypeResolver;
  UpdateUserPayload?: GQLUpdateUserPayloadTypeResolver;
  User?: GQLUserTypeResolver;
  UserACL?: GQLUserACLTypeResolver;
  UserConnection?: GQLUserConnectionTypeResolver;
  UserEdge?: GQLUserEdgeTypeResolver;
  VerifyCodePayload?: GQLVerifyCodePayloadTypeResolver;
  VerifyEmailPayload?: GQLVerifyEmailPayloadTypeResolver;
  VerifyPhonePayload?: GQLVerifyPhonePayloadTypeResolver;
  ViewObjectPayload?: GQLViewObjectPayloadTypeResolver;
  Viewer?: GQLViewerTypeResolver;
  WaveUserPayload?: GQLWaveUserPayloadTypeResolver;
  getEventPayload?: GQLgetEventPayloadTypeResolver;
  getSeoOrderItemDataPayload?: GQLgetSeoOrderItemDataPayloadTypeResolver;
  Any?: GraphQLScalarType;
  Bytes?: GraphQLScalarType;
  Date?: GraphQLScalarType;
  File?: GraphQLScalarType;
  Object?: GraphQLScalarType;
  Upload?: GraphQLScalarType;
}
export interface GQLNodeTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'Admin' | 'Amenity' | 'AppFile' | 'Category' | 'Chat' | 'Community' | 'CommunityAdmin' | 'Company' | 'Currency' | 'Document' | 'Event' | 'Group' | 'HelpDesk' | 'Installation' | 'Invitation' | 'Item' | 'ItemBooking' | 'JoinRequest' | 'Language' | 'Location' | 'Message' | 'MyClass' | 'NotifSending' | 'Notification' | 'Order' | 'PaymentPlan' | 'PhoneVerification' | 'PollOption' | 'Post' | 'PostTranslate' | 'Promo' | 'PushNotificationLog' | 'Referral' | 'Report' | 'Review' | 'Role' | 'Session' | 'Subscr' | 'SubscrPayment' | 'Task' | 'Transaction' | 'User' | Promise<'Admin' | 'Amenity' | 'AppFile' | 'Category' | 'Chat' | 'Community' | 'CommunityAdmin' | 'Company' | 'Currency' | 'Document' | 'Event' | 'Group' | 'HelpDesk' | 'Installation' | 'Invitation' | 'Item' | 'ItemBooking' | 'JoinRequest' | 'Language' | 'Location' | 'Message' | 'MyClass' | 'NotifSending' | 'Notification' | 'Order' | 'PaymentPlan' | 'PhoneVerification' | 'PollOption' | 'Post' | 'PostTranslate' | 'Promo' | 'PushNotificationLog' | 'Referral' | 'Report' | 'Review' | 'Role' | 'Session' | 'Subscr' | 'SubscrPayment' | 'Task' | 'Transaction' | 'User'>;
}
export interface GQLParseObjectTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'Admin' | 'Amenity' | 'AppFile' | 'Category' | 'Chat' | 'Community' | 'CommunityAdmin' | 'Company' | 'Currency' | 'Document' | 'Event' | 'Group' | 'HelpDesk' | 'Installation' | 'Invitation' | 'Item' | 'ItemBooking' | 'JoinRequest' | 'Language' | 'Location' | 'Message' | 'MyClass' | 'NotifSending' | 'Notification' | 'Order' | 'PaymentPlan' | 'PhoneVerification' | 'PollOption' | 'Post' | 'PostTranslate' | 'Promo' | 'PushNotificationLog' | 'Referral' | 'Report' | 'Review' | 'Role' | 'Session' | 'Subscr' | 'SubscrPayment' | 'Task' | 'Transaction' | 'User' | Promise<'Admin' | 'Amenity' | 'AppFile' | 'Category' | 'Chat' | 'Community' | 'CommunityAdmin' | 'Company' | 'Currency' | 'Document' | 'Event' | 'Group' | 'HelpDesk' | 'Installation' | 'Invitation' | 'Item' | 'ItemBooking' | 'JoinRequest' | 'Language' | 'Location' | 'Message' | 'MyClass' | 'NotifSending' | 'Notification' | 'Order' | 'PaymentPlan' | 'PhoneVerification' | 'PollOption' | 'Post' | 'PostTranslate' | 'Promo' | 'PushNotificationLog' | 'Referral' | 'Report' | 'Review' | 'Role' | 'Session' | 'Subscr' | 'SubscrPayment' | 'Task' | 'Transaction' | 'User'>;
}
export interface GQLSchemaFieldTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'SchemaACLField' | 'SchemaArrayField' | 'SchemaBooleanField' | 'SchemaBytesField' | 'SchemaDateField' | 'SchemaFileField' | 'SchemaGeoPointField' | 'SchemaNumberField' | 'SchemaObjectField' | 'SchemaPointerField' | 'SchemaPolygonField' | 'SchemaRelationField' | 'SchemaStringField' | Promise<'SchemaACLField' | 'SchemaArrayField' | 'SchemaBooleanField' | 'SchemaBytesField' | 'SchemaDateField' | 'SchemaFileField' | 'SchemaGeoPointField' | 'SchemaNumberField' | 'SchemaObjectField' | 'SchemaPointerField' | 'SchemaPolygonField' | 'SchemaRelationField' | 'SchemaStringField'>;
}
export interface GQLArrayResultTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'Admin' | 'Amenity' | 'AppFile' | 'Category' | 'Chat' | 'Community' | 'CommunityAdmin' | 'Company' | 'Currency' | 'Document' | 'Element' | 'Event' | 'Group' | 'HelpDesk' | 'Installation' | 'Invitation' | 'Item' | 'ItemBooking' | 'JoinRequest' | 'Language' | 'Location' | 'Message' | 'MyClass' | 'NotifSending' | 'Notification' | 'Order' | 'PaymentPlan' | 'PhoneVerification' | 'PollOption' | 'Post' | 'PostTranslate' | 'Promo' | 'PushNotificationLog' | 'Referral' | 'Report' | 'Review' | 'Role' | 'Session' | 'Subscr' | 'SubscrPayment' | 'Task' | 'Transaction' | 'User' | Promise<'Admin' | 'Amenity' | 'AppFile' | 'Category' | 'Chat' | 'Community' | 'CommunityAdmin' | 'Company' | 'Currency' | 'Document' | 'Element' | 'Event' | 'Group' | 'HelpDesk' | 'Installation' | 'Invitation' | 'Item' | 'ItemBooking' | 'JoinRequest' | 'Language' | 'Location' | 'Message' | 'MyClass' | 'NotifSending' | 'Notification' | 'Order' | 'PaymentPlan' | 'PhoneVerification' | 'PollOption' | 'Post' | 'PostTranslate' | 'Promo' | 'PushNotificationLog' | 'Referral' | 'Report' | 'Review' | 'Role' | 'Session' | 'Subscr' | 'SubscrPayment' | 'Task' | 'Transaction' | 'User'>;
}
export interface GQLACLTypeResolver<TParent = any> {
  public?: ACLToPublicResolver<TParent>;
  roles?: ACLToRolesResolver<TParent>;
  users?: ACLToUsersResolver<TParent>;
}

export interface ACLToPublicResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ACLToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ACLToUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAccountTransferPayloadTypeResolver<TParent = any> {
  success?: AccountTransferPayloadToSuccessResolver<TParent>;
}

export interface AccountTransferPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAdminTypeResolver<TParent = any> {
  ACL?: AdminToACLResolver<TParent>;
  Communities?: AdminToCommunitiesResolver<TParent>;
  Configurations?: AdminToConfigurationsResolver<TParent>;
  HelpCentre?: AdminToHelpCentreResolver<TParent>;
  Listings?: AdminToListingsResolver<TParent>;
  Members?: AdminToMembersResolver<TParent>;
  Promotions?: AdminToPromotionsResolver<TParent>;
  Requests?: AdminToRequestsResolver<TParent>;
  Settings?: AdminToSettingsResolver<TParent>;
  Transactions?: AdminToTransactionsResolver<TParent>;
  User?: AdminToUserResolver<TParent>;
  createdAt?: AdminToCreatedAtResolver<TParent>;
  id?: AdminToIdResolver<TParent>;
  isFullAccess?: AdminToIsFullAccessResolver<TParent>;
  objectId?: AdminToObjectIdResolver<TParent>;
  updatedAt?: AdminToUpdatedAtResolver<TParent>;
}

export interface AdminToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToCommunitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToConfigurationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToHelpCentreResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToPromotionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToSettingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToIsFullAccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAdminConnectionTypeResolver<TParent = any> {
  count?: AdminConnectionToCountResolver<TParent>;
  edges?: AdminConnectionToEdgesResolver<TParent>;
  pageInfo?: AdminConnectionToPageInfoResolver<TParent>;
}

export interface AdminConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAdminCreatePayloadTypeResolver<TParent = any> {
  admin?: AdminCreatePayloadToAdminResolver<TParent>;
}

export interface AdminCreatePayloadToAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAdminDashboardPayloadTypeResolver<TParent = any> {
  averageListingPrice?: AdminDashboardPayloadToAverageListingPriceResolver<TParent>;
  averageListingRating?: AdminDashboardPayloadToAverageListingRatingResolver<TParent>;
  averageMemberRating?: AdminDashboardPayloadToAverageMemberRatingResolver<TParent>;
  countActiveListings?: AdminDashboardPayloadToCountActiveListingsResolver<TParent>;
  countCommunities?: AdminDashboardPayloadToCountCommunitiesResolver<TParent>;
  countFreeListings?: AdminDashboardPayloadToCountFreeListingsResolver<TParent>;
  countInactiveListings?: AdminDashboardPayloadToCountInactiveListingsResolver<TParent>;
  countListingMembers?: AdminDashboardPayloadToCountListingMembersResolver<TParent>;
  countListings?: AdminDashboardPayloadToCountListingsResolver<TParent>;
  countListingsRevenue?: AdminDashboardPayloadToCountListingsRevenueResolver<TParent>;
  countManagers?: AdminDashboardPayloadToCountManagersResolver<TParent>;
  countMembers?: AdminDashboardPayloadToCountMembersResolver<TParent>;
  countPaidListings?: AdminDashboardPayloadToCountPaidListingsResolver<TParent>;
  countRentalListings?: AdminDashboardPayloadToCountRentalListingsResolver<TParent>;
  countRequestedListingMembers?: AdminDashboardPayloadToCountRequestedListingMembersResolver<TParent>;
  countRevenue?: AdminDashboardPayloadToCountRevenueResolver<TParent>;
  countReviewsAndRatings?: AdminDashboardPayloadToCountReviewsAndRatingsResolver<TParent>;
  countSellingListings?: AdminDashboardPayloadToCountSellingListingsResolver<TParent>;
  countServiceListings?: AdminDashboardPayloadToCountServiceListingsResolver<TParent>;
  countSubscrRevenue?: AdminDashboardPayloadToCountSubscrRevenueResolver<TParent>;
  countSuccessfulTransactions?: AdminDashboardPayloadToCountSuccessfulTransactionsResolver<TParent>;
}

export interface AdminDashboardPayloadToAverageListingPriceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToAverageListingRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToAverageMemberRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountActiveListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountCommunitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountFreeListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountInactiveListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountListingMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountListingsRevenueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountManagersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountPaidListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountRentalListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountRequestedListingMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountRevenueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountReviewsAndRatingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountSellingListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountServiceListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountSubscrRevenueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminDashboardPayloadToCountSuccessfulTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAdminEdgeTypeResolver<TParent = any> {
  cursor?: AdminEdgeToCursorResolver<TParent>;
  node?: AdminEdgeToNodeResolver<TParent>;
}

export interface AdminEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AdminEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAmenityTypeResolver<TParent = any> {
  ACL?: AmenityToACLResolver<TParent>;
  AdmHidden?: AmenityToAdmHiddenResolver<TParent>;
  ApproveReq?: AmenityToApproveReqResolver<TParent>;
  Bookings?: AmenityToBookingsResolver<TParent>;
  Featured?: AmenityToFeaturedResolver<TParent>;
  Lister?: AmenityToListerResolver<TParent>;
  Location?: AmenityToLocationResolver<TParent>;
  Published?: AmenityToPublishedResolver<TParent>;
  Requests?: AmenityToRequestsResolver<TParent>;
  Reviews?: AmenityToReviewsResolver<TParent>;
  Transactions?: AmenityToTransactionsResolver<TParent>;
  Updated?: AmenityToUpdatedResolver<TParent>;
  Viewers?: AmenityToViewersResolver<TParent>;
  allowGuests?: AmenityToAllowGuestsResolver<TParent>;
  autoBooking?: AmenityToAutoBookingResolver<TParent>;
  availabilityOverride?: AmenityToAvailabilityOverrideResolver<TParent>;
  bookingPeriod?: AmenityToBookingPeriodResolver<TParent>;
  bookingSlots?: AmenityToBookingSlotsResolver<TParent>;
  bookingTiming?: AmenityToBookingTimingResolver<TParent>;
  createdAt?: AmenityToCreatedAtResolver<TParent>;
  descr?: AmenityToDescrResolver<TParent>;
  id?: AmenityToIdResolver<TParent>;
  images?: AmenityToImagesResolver<TParent>;
  isBookable?: AmenityToIsBookableResolver<TParent>;
  isDeleted?: AmenityToIsDeletedResolver<TParent>;
  isPublished?: AmenityToIsPublishedResolver<TParent>;
  maxBookingPerSlot?: AmenityToMaxBookingPerSlotResolver<TParent>;
  maxBookingsPerDay?: AmenityToMaxBookingsPerDayResolver<TParent>;
  maxResidentsPerBooking?: AmenityToMaxResidentsPerBookingResolver<TParent>;
  messageAssignees?: AmenityToMessageAssigneesResolver<TParent>;
  multipleFutureBookings?: AmenityToMultipleFutureBookingsResolver<TParent>;
  name?: AmenityToNameResolver<TParent>;
  objectId?: AmenityToObjectIdResolver<TParent>;
  popularDay?: AmenityToPopularDayResolver<TParent>;
  popularTime?: AmenityToPopularTimeResolver<TParent>;
  rating?: AmenityToRatingResolver<TParent>;
  rewardType?: AmenityToRewardTypeResolver<TParent>;
  totalBookings?: AmenityToTotalBookingsResolver<TParent>;
  totalViews?: AmenityToTotalViewsResolver<TParent>;
  updatedAt?: AmenityToUpdatedAtResolver<TParent>;
}

export interface AmenityToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToAdmHiddenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToApproveReqResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToBookingsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLOrderOrder>;
  skip?: number;
  where?: GQLOrderWhereInput;
}
export interface AmenityToBookingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AmenityToBookingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToListerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToRequestsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLOrderOrder>;
  skip?: number;
  where?: GQLOrderWhereInput;
}
export interface AmenityToRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AmenityToRequestsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToReviewsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReviewOrder>;
  skip?: number;
  where?: GQLReviewWhereInput;
}
export interface AmenityToReviewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AmenityToReviewsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToTransactionsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLTransactionOrder>;
  skip?: number;
  where?: GQLTransactionWhereInput;
}
export interface AmenityToTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AmenityToTransactionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToUpdatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToViewersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface AmenityToViewersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AmenityToViewersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToAllowGuestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToAutoBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToAvailabilityOverrideResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToBookingPeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToBookingSlotsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToBookingTimingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToIsBookableResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToIsDeletedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToIsPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToMaxBookingPerSlotResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToMaxBookingsPerDayResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToMaxResidentsPerBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToMessageAssigneesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToMultipleFutureBookingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToPopularDayResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToPopularTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToRewardTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToTotalBookingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToTotalViewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAmenityConnectionTypeResolver<TParent = any> {
  count?: AmenityConnectionToCountResolver<TParent>;
  edges?: AmenityConnectionToEdgesResolver<TParent>;
  pageInfo?: AmenityConnectionToPageInfoResolver<TParent>;
}

export interface AmenityConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAmenityEdgeTypeResolver<TParent = any> {
  cursor?: AmenityEdgeToCursorResolver<TParent>;
  node?: AmenityEdgeToNodeResolver<TParent>;
}

export interface AmenityEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AmenityEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAppFileTypeResolver<TParent = any> {
  ACL?: AppFileToACLResolver<TParent>;
  Owner?: AppFileToOwnerResolver<TParent>;
  createdAt?: AppFileToCreatedAtResolver<TParent>;
  file?: AppFileToFileResolver<TParent>;
  id?: AppFileToIdResolver<TParent>;
  mime?: AppFileToMimeResolver<TParent>;
  name?: AppFileToNameResolver<TParent>;
  objectId?: AppFileToObjectIdResolver<TParent>;
  type?: AppFileToTypeResolver<TParent>;
  updatedAt?: AppFileToUpdatedAtResolver<TParent>;
}

export interface AppFileToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToMimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAppFileConnectionTypeResolver<TParent = any> {
  count?: AppFileConnectionToCountResolver<TParent>;
  edges?: AppFileConnectionToEdgesResolver<TParent>;
  pageInfo?: AppFileConnectionToPageInfoResolver<TParent>;
}

export interface AppFileConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAppFileEdgeTypeResolver<TParent = any> {
  cursor?: AppFileEdgeToCursorResolver<TParent>;
  node?: AppFileEdgeToNodeResolver<TParent>;
}

export interface AppFileEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBookAmenityPayloadTypeResolver<TParent = any> {
  orderId?: BookAmenityPayloadToOrderIdResolver<TParent>;
}

export interface BookAmenityPayloadToOrderIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBookEventPayloadTypeResolver<TParent = any> {
  orderId?: BookEventPayloadToOrderIdResolver<TParent>;
}

export interface BookEventPayloadToOrderIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCalcOrderDataPayloadTypeResolver<TParent = any> {
  cfListerAbs?: CalcOrderDataPayloadToCfListerAbsResolver<TParent>;
  cfListerAmt?: CalcOrderDataPayloadToCfListerAmtResolver<TParent>;
  cfListerPrc?: CalcOrderDataPayloadToCfListerPrcResolver<TParent>;
  cfRequesterAbs?: CalcOrderDataPayloadToCfRequesterAbsResolver<TParent>;
  cfRequesterAmt?: CalcOrderDataPayloadToCfRequesterAmtResolver<TParent>;
  cfRequesterPrc?: CalcOrderDataPayloadToCfRequesterPrcResolver<TParent>;
  discount?: CalcOrderDataPayloadToDiscountResolver<TParent>;
  discountType?: CalcOrderDataPayloadToDiscountTypeResolver<TParent>;
  endTime?: CalcOrderDataPayloadToEndTimeResolver<TParent>;
  hfListerAbs?: CalcOrderDataPayloadToHfListerAbsResolver<TParent>;
  hfListerAmt?: CalcOrderDataPayloadToHfListerAmtResolver<TParent>;
  hfListerPrc?: CalcOrderDataPayloadToHfListerPrcResolver<TParent>;
  hfRequesterAbs?: CalcOrderDataPayloadToHfRequesterAbsResolver<TParent>;
  hfRequesterAmt?: CalcOrderDataPayloadToHfRequesterAmtResolver<TParent>;
  hfRequesterPrc?: CalcOrderDataPayloadToHfRequesterPrcResolver<TParent>;
  itemAmount?: CalcOrderDataPayloadToItemAmountResolver<TParent>;
  listerTotalAmt?: CalcOrderDataPayloadToListerTotalAmtResolver<TParent>;
  listingType?: CalcOrderDataPayloadToListingTypeResolver<TParent>;
  period?: CalcOrderDataPayloadToPeriodResolver<TParent>;
  ppListerAbs?: CalcOrderDataPayloadToPpListerAbsResolver<TParent>;
  ppListerAmt?: CalcOrderDataPayloadToPpListerAmtResolver<TParent>;
  ppListerPrc?: CalcOrderDataPayloadToPpListerPrcResolver<TParent>;
  ppRequesterAbs?: CalcOrderDataPayloadToPpRequesterAbsResolver<TParent>;
  ppRequesterAmt?: CalcOrderDataPayloadToPpRequesterAmtResolver<TParent>;
  ppRequesterPrc?: CalcOrderDataPayloadToPpRequesterPrcResolver<TParent>;
  price?: CalcOrderDataPayloadToPriceResolver<TParent>;
  pricePeriod?: CalcOrderDataPayloadToPricePeriodResolver<TParent>;
  requesterTotalAmt?: CalcOrderDataPayloadToRequesterTotalAmtResolver<TParent>;
  rewardType?: CalcOrderDataPayloadToRewardTypeResolver<TParent>;
  sfListerAmt?: CalcOrderDataPayloadToSfListerAmtResolver<TParent>;
  sfRequesterAmt?: CalcOrderDataPayloadToSfRequesterAmtResolver<TParent>;
  startTime?: CalcOrderDataPayloadToStartTimeResolver<TParent>;
}

export interface CalcOrderDataPayloadToCfListerAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToCfListerAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToCfListerPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToCfRequesterAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToCfRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToCfRequesterPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToDiscountTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToEndTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToHfListerAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToHfListerAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToHfListerPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToHfRequesterAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToHfRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToHfRequesterPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToItemAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToListerTotalAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToListingTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPpListerAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPpListerAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPpListerPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPpRequesterAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPpRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPpRequesterPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPriceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToPricePeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToRequesterTotalAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToRewardTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToSfListerAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToSfRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CalcOrderDataPayloadToStartTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCallCloudCodePayloadTypeResolver<TParent = any> {
  clientMutationId?: CallCloudCodePayloadToClientMutationIdResolver<TParent>;
  result?: CallCloudCodePayloadToResultResolver<TParent>;
}

export interface CallCloudCodePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CallCloudCodePayloadToResultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCardInfoPayloadTypeResolver<TParent = any> {
  address_zip?: CardInfoPayloadToAddress_zipResolver<TParent>;
  address_zip_check?: CardInfoPayloadToAddress_zip_checkResolver<TParent>;
  brand?: CardInfoPayloadToBrandResolver<TParent>;
  country?: CardInfoPayloadToCountryResolver<TParent>;
  customer?: CardInfoPayloadToCustomerResolver<TParent>;
  cvc_check?: CardInfoPayloadToCvc_checkResolver<TParent>;
  exp_month?: CardInfoPayloadToExp_monthResolver<TParent>;
  exp_year?: CardInfoPayloadToExp_yearResolver<TParent>;
  fingerprint?: CardInfoPayloadToFingerprintResolver<TParent>;
  funding?: CardInfoPayloadToFundingResolver<TParent>;
  id?: CardInfoPayloadToIdResolver<TParent>;
  last4?: CardInfoPayloadToLast4Resolver<TParent>;
  name?: CardInfoPayloadToNameResolver<TParent>;
  object?: CardInfoPayloadToObjectResolver<TParent>;
}

export interface CardInfoPayloadToAddress_zipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToAddress_zip_checkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToBrandResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToCustomerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToCvc_checkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToExp_monthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToExp_yearResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToFingerprintResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToFundingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToLast4Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToObjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCategoryTypeResolver<TParent = any> {
  ACL?: CategoryToACLResolver<TParent>;
  createdAt?: CategoryToCreatedAtResolver<TParent>;
  descr?: CategoryToDescrResolver<TParent>;
  id?: CategoryToIdResolver<TParent>;
  name?: CategoryToNameResolver<TParent>;
  objectId?: CategoryToObjectIdResolver<TParent>;
  updatedAt?: CategoryToUpdatedAtResolver<TParent>;
}

export interface CategoryToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCategoryConnectionTypeResolver<TParent = any> {
  count?: CategoryConnectionToCountResolver<TParent>;
  edges?: CategoryConnectionToEdgesResolver<TParent>;
  pageInfo?: CategoryConnectionToPageInfoResolver<TParent>;
}

export interface CategoryConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCategoryEdgeTypeResolver<TParent = any> {
  cursor?: CategoryEdgeToCursorResolver<TParent>;
  node?: CategoryEdgeToNodeResolver<TParent>;
}

export interface CategoryEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CategoryEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLChangePasswordPayloadTypeResolver<TParent = any> {
  clientMutationId?: ChangePasswordPayloadToClientMutationIdResolver<TParent>;
  ok?: ChangePasswordPayloadToOkResolver<TParent>;
}

export interface ChangePasswordPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChangePasswordPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLChartDataPayloadTypeResolver<TParent = any> {
  date?: ChartDataPayloadToDateResolver<TParent>;
  value?: ChartDataPayloadToValueResolver<TParent>;
}

export interface ChartDataPayloadToDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChartDataPayloadToValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLChatTypeResolver<TParent = any> {
  ACL?: ChatToACLResolver<TParent>;
  Members?: ChatToMembersResolver<TParent>;
  Messages?: ChatToMessagesResolver<TParent>;
  Support?: ChatToSupportResolver<TParent>;
  createdAt?: ChatToCreatedAtResolver<TParent>;
  id?: ChatToIdResolver<TParent>;
  isArchived?: ChatToIsArchivedResolver<TParent>;
  objectId?: ChatToObjectIdResolver<TParent>;
  status?: ChatToStatusResolver<TParent>;
  updatedAt?: ChatToUpdatedAtResolver<TParent>;
}

export interface ChatToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToMembersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface ChatToMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ChatToMembersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToMessagesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLMessageOrder>;
  skip?: number;
  where?: GQLMessageWhereInput;
}
export interface ChatToMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ChatToMessagesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToSupportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToIsArchivedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLChatConnectionTypeResolver<TParent = any> {
  count?: ChatConnectionToCountResolver<TParent>;
  edges?: ChatConnectionToEdgesResolver<TParent>;
  pageInfo?: ChatConnectionToPageInfoResolver<TParent>;
}

export interface ChatConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLChatEdgeTypeResolver<TParent = any> {
  cursor?: ChatEdgeToCursorResolver<TParent>;
  node?: ChatEdgeToNodeResolver<TParent>;
}

export interface ChatEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChatEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLClassTypeResolver<TParent = any> {
  name?: ClassToNameResolver<TParent>;
  schemaFields?: ClassToSchemaFieldsResolver<TParent>;
}

export interface ClassToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ClassToSchemaFieldsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityTypeResolver<TParent = any> {
  ACL?: CommunityToACLResolver<TParent>;
  Admins?: CommunityToAdminsResolver<TParent>;
  Avatar?: CommunityToAvatarResolver<TParent>;
  Invitations?: CommunityToInvitationsResolver<TParent>;
  Items?: CommunityToItemsResolver<TParent>;
  JoinRequests?: CommunityToJoinRequestsResolver<TParent>;
  Location?: CommunityToLocationResolver<TParent>;
  Owner?: CommunityToOwnerResolver<TParent>;
  Residents?: CommunityToResidentsResolver<TParent>;
  Subscr?: CommunityToSubscrResolver<TParent>;
  accessType?: CommunityToAccessTypeResolver<TParent>;
  address?: CommunityToAddressResolver<TParent>;
  address_add?: CommunityToAddress_addResolver<TParent>;
  alias?: CommunityToAliasResolver<TParent>;
  allowChat?: CommunityToAllowChatResolver<TParent>;
  allowEvents?: CommunityToAllowEventsResolver<TParent>;
  allowPosts?: CommunityToAllowPostsResolver<TParent>;
  buildings?: CommunityToBuildingsResolver<TParent>;
  checkList?: CommunityToCheckListResolver<TParent>;
  countItems?: CommunityToCountItemsResolver<TParent>;
  countMembers?: CommunityToCountMembersResolver<TParent>;
  createdAt?: CommunityToCreatedAtResolver<TParent>;
  descr?: CommunityToDescrResolver<TParent>;
  id?: CommunityToIdResolver<TParent>;
  identityData?: CommunityToIdentityDataResolver<TParent>;
  invitation?: CommunityToInvitationResolver<TParent>;
  isVerified?: CommunityToIsVerifiedResolver<TParent>;
  listingApproval?: CommunityToListingApprovalResolver<TParent>;
  name?: CommunityToNameResolver<TParent>;
  neighbourhood?: CommunityToNeighbourhoodResolver<TParent>;
  objectId?: CommunityToObjectIdResolver<TParent>;
  options?: CommunityToOptionsResolver<TParent>;
  passCode?: CommunityToPassCodeResolver<TParent>;
  status?: CommunityToStatusResolver<TParent>;
  totalMessages?: CommunityToTotalMessagesResolver<TParent>;
  type?: CommunityToTypeResolver<TParent>;
  units?: CommunityToUnitsResolver<TParent>;
  updatedAt?: CommunityToUpdatedAtResolver<TParent>;
  zip?: CommunityToZipResolver<TParent>;
  zip_add?: CommunityToZip_addResolver<TParent>;
}

export interface CommunityToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAdminsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLCommunityAdminOrder>;
  skip?: number;
  where?: GQLCommunityAdminWhereInput;
}
export interface CommunityToAdminsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CommunityToAdminsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAvatarResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToInvitationsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLInvitationOrder>;
  skip?: number;
  where?: GQLInvitationWhereInput;
}
export interface CommunityToInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CommunityToInvitationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToItemsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLItemOrder>;
  skip?: number;
  where?: GQLItemWhereInput;
}
export interface CommunityToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CommunityToItemsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToJoinRequestsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLJoinRequestOrder>;
  skip?: number;
  where?: GQLJoinRequestWhereInput;
}
export interface CommunityToJoinRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CommunityToJoinRequestsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToResidentsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface CommunityToResidentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CommunityToResidentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAccessTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAddress_addResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAliasResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAllowChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAllowEventsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToAllowPostsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToBuildingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToCheckListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToCountItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToCountMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToIdentityDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToIsVerifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToListingApprovalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToNeighbourhoodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToOptionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToPassCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToTotalMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToUnitsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToZipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityToZip_addResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityAdminTypeResolver<TParent = any> {
  ACL?: CommunityAdminToACLResolver<TParent>;
  Communities?: CommunityAdminToCommunitiesResolver<TParent>;
  Community?: CommunityAdminToCommunityResolver<TParent>;
  Configurations?: CommunityAdminToConfigurationsResolver<TParent>;
  HelpCentre?: CommunityAdminToHelpCentreResolver<TParent>;
  Listings?: CommunityAdminToListingsResolver<TParent>;
  Members?: CommunityAdminToMembersResolver<TParent>;
  Promotions?: CommunityAdminToPromotionsResolver<TParent>;
  Requests?: CommunityAdminToRequestsResolver<TParent>;
  Settings?: CommunityAdminToSettingsResolver<TParent>;
  Transactions?: CommunityAdminToTransactionsResolver<TParent>;
  User?: CommunityAdminToUserResolver<TParent>;
  createdAt?: CommunityAdminToCreatedAtResolver<TParent>;
  id?: CommunityAdminToIdResolver<TParent>;
  label?: CommunityAdminToLabelResolver<TParent>;
  objectId?: CommunityAdminToObjectIdResolver<TParent>;
  updatedAt?: CommunityAdminToUpdatedAtResolver<TParent>;
}

export interface CommunityAdminToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToCommunitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToConfigurationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToHelpCentreResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToPromotionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToSettingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityAdminConnectionTypeResolver<TParent = any> {
  count?: CommunityAdminConnectionToCountResolver<TParent>;
  edges?: CommunityAdminConnectionToEdgesResolver<TParent>;
  pageInfo?: CommunityAdminConnectionToPageInfoResolver<TParent>;
}

export interface CommunityAdminConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityAdminEdgeTypeResolver<TParent = any> {
  cursor?: CommunityAdminEdgeToCursorResolver<TParent>;
  node?: CommunityAdminEdgeToNodeResolver<TParent>;
}

export interface CommunityAdminEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityAdminPayloadTypeResolver<TParent = any> {
  communityAdminId?: CommunityAdminPayloadToCommunityAdminIdResolver<TParent>;
  success?: CommunityAdminPayloadToSuccessResolver<TParent>;
}

export interface CommunityAdminPayloadToCommunityAdminIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityAdminPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityConnectionTypeResolver<TParent = any> {
  count?: CommunityConnectionToCountResolver<TParent>;
  edges?: CommunityConnectionToEdgesResolver<TParent>;
  pageInfo?: CommunityConnectionToPageInfoResolver<TParent>;
}

export interface CommunityConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityEdgeTypeResolver<TParent = any> {
  cursor?: CommunityEdgeToCursorResolver<TParent>;
  node?: CommunityEdgeToNodeResolver<TParent>;
}

export interface CommunityEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CommunityEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCommunityForNewUserPayloadTypeResolver<TParent = any> {
  communityId?: CommunityForNewUserPayloadToCommunityIdResolver<TParent>;
}

export interface CommunityForNewUserPayloadToCommunityIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCompanyTypeResolver<TParent = any> {
  ACL?: CompanyToACLResolver<TParent>;
  Featured?: CompanyToFeaturedResolver<TParent>;
  Owner?: CompanyToOwnerResolver<TParent>;
  Published?: CompanyToPublishedResolver<TParent>;
  Reports?: CompanyToReportsResolver<TParent>;
  Viewers?: CompanyToViewersResolver<TParent>;
  category?: CompanyToCategoryResolver<TParent>;
  createdAt?: CompanyToCreatedAtResolver<TParent>;
  description?: CompanyToDescriptionResolver<TParent>;
  id?: CompanyToIdResolver<TParent>;
  images?: CompanyToImagesResolver<TParent>;
  interestedUsers?: CompanyToInterestedUsersResolver<TParent>;
  isPublished?: CompanyToIsPublishedResolver<TParent>;
  name?: CompanyToNameResolver<TParent>;
  objectId?: CompanyToObjectIdResolver<TParent>;
  phone?: CompanyToPhoneResolver<TParent>;
  promoCTA?: CompanyToPromoCTAResolver<TParent>;
  promoDescr?: CompanyToPromoDescrResolver<TParent>;
  promoTagline?: CompanyToPromoTaglineResolver<TParent>;
  promotion?: CompanyToPromotionResolver<TParent>;
  revealCode?: CompanyToRevealCodeResolver<TParent>;
  sessionToken?: CompanyToSessionTokenResolver<TParent>;
  totalClicks?: CompanyToTotalClicksResolver<TParent>;
  totalViews?: CompanyToTotalViewsResolver<TParent>;
  updatedAt?: CompanyToUpdatedAtResolver<TParent>;
  visitedWebsite?: CompanyToVisitedWebsiteResolver<TParent>;
  website?: CompanyToWebsiteResolver<TParent>;
}

export interface CompanyToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToReportsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReportOrder>;
  skip?: number;
  where?: GQLReportWhereInput;
}
export interface CompanyToReportsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CompanyToReportsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToViewersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface CompanyToViewersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CompanyToViewersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToInterestedUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToIsPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToPhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToPromoCTAResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToPromoDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToPromoTaglineResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToPromotionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToRevealCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToSessionTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToTotalClicksResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToTotalViewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToVisitedWebsiteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyToWebsiteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCompanyConnectionTypeResolver<TParent = any> {
  count?: CompanyConnectionToCountResolver<TParent>;
  edges?: CompanyConnectionToEdgesResolver<TParent>;
  pageInfo?: CompanyConnectionToPageInfoResolver<TParent>;
}

export interface CompanyConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCompanyEdgeTypeResolver<TParent = any> {
  cursor?: CompanyEdgeToCursorResolver<TParent>;
  node?: CompanyEdgeToNodeResolver<TParent>;
}

export interface CompanyEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CompanyEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLConnectStripeAccPayloadTypeResolver<TParent = any> {
  accountConnected?: ConnectStripeAccPayloadToAccountConnectedResolver<TParent>;
  accountLink?: ConnectStripeAccPayloadToAccountLinkResolver<TParent>;
}

export interface ConnectStripeAccPayloadToAccountConnectedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ConnectStripeAccPayloadToAccountLinkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateAdminPayloadTypeResolver<TParent = any> {
  admin?: CreateAdminPayloadToAdminResolver<TParent>;
  clientMutationId?: CreateAdminPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateAdminPayloadToAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateAdminPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateAmenityPayloadTypeResolver<TParent = any> {
  amenity?: CreateAmenityPayloadToAmenityResolver<TParent>;
  clientMutationId?: CreateAmenityPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateAmenityPayloadToAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateAmenityPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateAppFilePayloadTypeResolver<TParent = any> {
  appFile?: CreateAppFilePayloadToAppFileResolver<TParent>;
  clientMutationId?: CreateAppFilePayloadToClientMutationIdResolver<TParent>;
}

export interface CreateAppFilePayloadToAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateAppFilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCategoryPayloadTypeResolver<TParent = any> {
  category?: CreateCategoryPayloadToCategoryResolver<TParent>;
  clientMutationId?: CreateCategoryPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateCategoryPayloadToCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCategoryPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateChatPayloadTypeResolver<TParent = any> {
  chat?: CreateChatPayloadToChatResolver<TParent>;
  clientMutationId?: CreateChatPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateChatPayloadToChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateChatPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateClassPayloadTypeResolver<TParent = any> {
  class?: CreateClassPayloadToClassResolver<TParent>;
  clientMutationId?: CreateClassPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateClassPayloadToClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCommunityAdminPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateCommunityAdminPayloadToClientMutationIdResolver<TParent>;
  communityAdmin?: CreateCommunityAdminPayloadToCommunityAdminResolver<TParent>;
}

export interface CreateCommunityAdminPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommunityAdminPayloadToCommunityAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCommunityPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateCommunityPayloadToClientMutationIdResolver<TParent>;
  community?: CreateCommunityPayloadToCommunityResolver<TParent>;
}

export interface CreateCommunityPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCommunityPayloadToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCompanyPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateCompanyPayloadToClientMutationIdResolver<TParent>;
  company?: CreateCompanyPayloadToCompanyResolver<TParent>;
}

export interface CreateCompanyPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCompanyPayloadToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateCurrencyPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateCurrencyPayloadToClientMutationIdResolver<TParent>;
  currency?: CreateCurrencyPayloadToCurrencyResolver<TParent>;
}

export interface CreateCurrencyPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateCurrencyPayloadToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateDocumentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateDocumentPayloadToClientMutationIdResolver<TParent>;
  document?: CreateDocumentPayloadToDocumentResolver<TParent>;
}

export interface CreateDocumentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateDocumentPayloadToDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateEventPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateEventPayloadToClientMutationIdResolver<TParent>;
  event?: CreateEventPayloadToEventResolver<TParent>;
}

export interface CreateEventPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateEventPayloadToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateFilePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateFilePayloadToClientMutationIdResolver<TParent>;
  fileInfo?: CreateFilePayloadToFileInfoResolver<TParent>;
}

export interface CreateFilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateFilePayloadToFileInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateGroupPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateGroupPayloadToClientMutationIdResolver<TParent>;
  group?: CreateGroupPayloadToGroupResolver<TParent>;
}

export interface CreateGroupPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateGroupPayloadToGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateHelpDeskPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateHelpDeskPayloadToClientMutationIdResolver<TParent>;
  helpDesk?: CreateHelpDeskPayloadToHelpDeskResolver<TParent>;
}

export interface CreateHelpDeskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateHelpDeskPayloadToHelpDeskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateInstallationPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateInstallationPayloadToClientMutationIdResolver<TParent>;
  installation?: CreateInstallationPayloadToInstallationResolver<TParent>;
}

export interface CreateInstallationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateInstallationPayloadToInstallationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateInvitationPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateInvitationPayloadToClientMutationIdResolver<TParent>;
  invitation?: CreateInvitationPayloadToInvitationResolver<TParent>;
}

export interface CreateInvitationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateInvitationPayloadToInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateItemBookingPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateItemBookingPayloadToClientMutationIdResolver<TParent>;
  itemBooking?: CreateItemBookingPayloadToItemBookingResolver<TParent>;
}

export interface CreateItemBookingPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateItemBookingPayloadToItemBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateItemPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateItemPayloadToClientMutationIdResolver<TParent>;
  item?: CreateItemPayloadToItemResolver<TParent>;
}

export interface CreateItemPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateItemPayloadToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateJoinRequestPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateJoinRequestPayloadToClientMutationIdResolver<TParent>;
  joinRequest?: CreateJoinRequestPayloadToJoinRequestResolver<TParent>;
}

export interface CreateJoinRequestPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateJoinRequestPayloadToJoinRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateLanguagePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateLanguagePayloadToClientMutationIdResolver<TParent>;
  language?: CreateLanguagePayloadToLanguageResolver<TParent>;
}

export interface CreateLanguagePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateLanguagePayloadToLanguageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateLocationPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateLocationPayloadToClientMutationIdResolver<TParent>;
  location?: CreateLocationPayloadToLocationResolver<TParent>;
}

export interface CreateLocationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateLocationPayloadToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateMessagePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateMessagePayloadToClientMutationIdResolver<TParent>;
  message?: CreateMessagePayloadToMessageResolver<TParent>;
}

export interface CreateMessagePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateMessagePayloadToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateMultiplyItemsPayloadTypeResolver<TParent = any> {
  listId?: CreateMultiplyItemsPayloadToListIdResolver<TParent>;
}

export interface CreateMultiplyItemsPayloadToListIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateMyClassPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateMyClassPayloadToClientMutationIdResolver<TParent>;
  myClass?: CreateMyClassPayloadToMyClassResolver<TParent>;
}

export interface CreateMyClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateMyClassPayloadToMyClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateNotifSendingPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateNotifSendingPayloadToClientMutationIdResolver<TParent>;
  notifSending?: CreateNotifSendingPayloadToNotifSendingResolver<TParent>;
}

export interface CreateNotifSendingPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateNotifSendingPayloadToNotifSendingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateNotificationPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateNotificationPayloadToClientMutationIdResolver<TParent>;
  notification?: CreateNotificationPayloadToNotificationResolver<TParent>;
}

export interface CreateNotificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateNotificationPayloadToNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateOrderPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateOrderPayloadToClientMutationIdResolver<TParent>;
  order?: CreateOrderPayloadToOrderResolver<TParent>;
}

export interface CreateOrderPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateOrderPayloadToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreatePaymentPlanPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreatePaymentPlanPayloadToClientMutationIdResolver<TParent>;
  paymentPlan?: CreatePaymentPlanPayloadToPaymentPlanResolver<TParent>;
}

export interface CreatePaymentPlanPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreatePaymentPlanPayloadToPaymentPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreatePhoneVerificationPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreatePhoneVerificationPayloadToClientMutationIdResolver<TParent>;
  phoneVerification?: CreatePhoneVerificationPayloadToPhoneVerificationResolver<TParent>;
}

export interface CreatePhoneVerificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreatePhoneVerificationPayloadToPhoneVerificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreatePollOptionPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreatePollOptionPayloadToClientMutationIdResolver<TParent>;
  pollOption?: CreatePollOptionPayloadToPollOptionResolver<TParent>;
}

export interface CreatePollOptionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreatePollOptionPayloadToPollOptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreatePostPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreatePostPayloadToClientMutationIdResolver<TParent>;
  post?: CreatePostPayloadToPostResolver<TParent>;
}

export interface CreatePostPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreatePostPayloadToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreatePostTranslatePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreatePostTranslatePayloadToClientMutationIdResolver<TParent>;
  postTranslate?: CreatePostTranslatePayloadToPostTranslateResolver<TParent>;
}

export interface CreatePostTranslatePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreatePostTranslatePayloadToPostTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreatePromoPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreatePromoPayloadToClientMutationIdResolver<TParent>;
  promo?: CreatePromoPayloadToPromoResolver<TParent>;
}

export interface CreatePromoPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreatePromoPayloadToPromoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreatePushNotificationLogPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreatePushNotificationLogPayloadToClientMutationIdResolver<TParent>;
  pushNotificationLog?: CreatePushNotificationLogPayloadToPushNotificationLogResolver<TParent>;
}

export interface CreatePushNotificationLogPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreatePushNotificationLogPayloadToPushNotificationLogResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateReferralPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateReferralPayloadToClientMutationIdResolver<TParent>;
  referral?: CreateReferralPayloadToReferralResolver<TParent>;
}

export interface CreateReferralPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateReferralPayloadToReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateReportPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateReportPayloadToClientMutationIdResolver<TParent>;
  report?: CreateReportPayloadToReportResolver<TParent>;
}

export interface CreateReportPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateReportPayloadToReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateReviewPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateReviewPayloadToClientMutationIdResolver<TParent>;
  review?: CreateReviewPayloadToReviewResolver<TParent>;
}

export interface CreateReviewPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateReviewPayloadToReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateRolePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateRolePayloadToClientMutationIdResolver<TParent>;
  role?: CreateRolePayloadToRoleResolver<TParent>;
}

export interface CreateRolePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateRolePayloadToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateSessionPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateSessionPayloadToClientMutationIdResolver<TParent>;
  session?: CreateSessionPayloadToSessionResolver<TParent>;
}

export interface CreateSessionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateSessionPayloadToSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateSubscrPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateSubscrPayloadToClientMutationIdResolver<TParent>;
  subscr?: CreateSubscrPayloadToSubscrResolver<TParent>;
}

export interface CreateSubscrPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateSubscrPayloadToSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateSubscrPaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateSubscrPaymentPayloadToClientMutationIdResolver<TParent>;
  subscrPayment?: CreateSubscrPaymentPayloadToSubscrPaymentResolver<TParent>;
}

export interface CreateSubscrPaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateSubscrPaymentPayloadToSubscrPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateTaskPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateTaskPayloadToClientMutationIdResolver<TParent>;
  task?: CreateTaskPayloadToTaskResolver<TParent>;
}

export interface CreateTaskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateTaskPayloadToTaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateTransactionPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateTransactionPayloadToClientMutationIdResolver<TParent>;
  transaction?: CreateTransactionPayloadToTransactionResolver<TParent>;
}

export interface CreateTransactionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateTransactionPayloadToTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateUserPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateUserPayloadToClientMutationIdResolver<TParent>;
  user?: CreateUserPayloadToUserResolver<TParent>;
}

export interface CreateUserPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateUserPayloadToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCurrencyTypeResolver<TParent = any> {
  ACL?: CurrencyToACLResolver<TParent>;
  code?: CurrencyToCodeResolver<TParent>;
  createdAt?: CurrencyToCreatedAtResolver<TParent>;
  id?: CurrencyToIdResolver<TParent>;
  name?: CurrencyToNameResolver<TParent>;
  objectId?: CurrencyToObjectIdResolver<TParent>;
  sign?: CurrencyToSignResolver<TParent>;
  updatedAt?: CurrencyToUpdatedAtResolver<TParent>;
}

export interface CurrencyToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToSignResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCurrencyConnectionTypeResolver<TParent = any> {
  count?: CurrencyConnectionToCountResolver<TParent>;
  edges?: CurrencyConnectionToEdgesResolver<TParent>;
  pageInfo?: CurrencyConnectionToPageInfoResolver<TParent>;
}

export interface CurrencyConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCurrencyEdgeTypeResolver<TParent = any> {
  cursor?: CurrencyEdgeToCursorResolver<TParent>;
  node?: CurrencyEdgeToNodeResolver<TParent>;
}

export interface CurrencyEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDashboardChartPayloadTypeResolver<TParent = any> {
  data?: DashboardChartPayloadToDataResolver<TParent>;
}

export interface DashboardChartPayloadToDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteAdminPayloadTypeResolver<TParent = any> {
  admin?: DeleteAdminPayloadToAdminResolver<TParent>;
  clientMutationId?: DeleteAdminPayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteAdminPayloadToAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteAdminPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteAmenityPayloadTypeResolver<TParent = any> {
  amenity?: DeleteAmenityPayloadToAmenityResolver<TParent>;
  clientMutationId?: DeleteAmenityPayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteAmenityPayloadToAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteAmenityPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteAppFilePayloadTypeResolver<TParent = any> {
  appFile?: DeleteAppFilePayloadToAppFileResolver<TParent>;
  clientMutationId?: DeleteAppFilePayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteAppFilePayloadToAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteAppFilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteCategoryPayloadTypeResolver<TParent = any> {
  category?: DeleteCategoryPayloadToCategoryResolver<TParent>;
  clientMutationId?: DeleteCategoryPayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteCategoryPayloadToCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteCategoryPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteChatPayloadTypeResolver<TParent = any> {
  chat?: DeleteChatPayloadToChatResolver<TParent>;
  clientMutationId?: DeleteChatPayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteChatPayloadToChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteChatPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteClassPayloadTypeResolver<TParent = any> {
  class?: DeleteClassPayloadToClassResolver<TParent>;
  clientMutationId?: DeleteClassPayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteClassPayloadToClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteCommunityAdminPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteCommunityAdminPayloadToClientMutationIdResolver<TParent>;
  communityAdmin?: DeleteCommunityAdminPayloadToCommunityAdminResolver<TParent>;
}

export interface DeleteCommunityAdminPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteCommunityAdminPayloadToCommunityAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteCommunityPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteCommunityPayloadToClientMutationIdResolver<TParent>;
  community?: DeleteCommunityPayloadToCommunityResolver<TParent>;
}

export interface DeleteCommunityPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteCommunityPayloadToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteCompanyPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteCompanyPayloadToClientMutationIdResolver<TParent>;
  company?: DeleteCompanyPayloadToCompanyResolver<TParent>;
}

export interface DeleteCompanyPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteCompanyPayloadToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteCurrencyPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteCurrencyPayloadToClientMutationIdResolver<TParent>;
  currency?: DeleteCurrencyPayloadToCurrencyResolver<TParent>;
}

export interface DeleteCurrencyPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteCurrencyPayloadToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteDocumentPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteDocumentPayloadToClientMutationIdResolver<TParent>;
  document?: DeleteDocumentPayloadToDocumentResolver<TParent>;
}

export interface DeleteDocumentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteDocumentPayloadToDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteEventPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteEventPayloadToClientMutationIdResolver<TParent>;
  event?: DeleteEventPayloadToEventResolver<TParent>;
}

export interface DeleteEventPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteEventPayloadToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteGroupPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteGroupPayloadToClientMutationIdResolver<TParent>;
  group?: DeleteGroupPayloadToGroupResolver<TParent>;
}

export interface DeleteGroupPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteGroupPayloadToGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteHelpDeskPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteHelpDeskPayloadToClientMutationIdResolver<TParent>;
  helpDesk?: DeleteHelpDeskPayloadToHelpDeskResolver<TParent>;
}

export interface DeleteHelpDeskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteHelpDeskPayloadToHelpDeskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteInstallationPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteInstallationPayloadToClientMutationIdResolver<TParent>;
  installation?: DeleteInstallationPayloadToInstallationResolver<TParent>;
}

export interface DeleteInstallationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteInstallationPayloadToInstallationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteInvitationPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteInvitationPayloadToClientMutationIdResolver<TParent>;
  invitation?: DeleteInvitationPayloadToInvitationResolver<TParent>;
}

export interface DeleteInvitationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteInvitationPayloadToInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteItemBookingPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteItemBookingPayloadToClientMutationIdResolver<TParent>;
  itemBooking?: DeleteItemBookingPayloadToItemBookingResolver<TParent>;
}

export interface DeleteItemBookingPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteItemBookingPayloadToItemBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteItemPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteItemPayloadToClientMutationIdResolver<TParent>;
  item?: DeleteItemPayloadToItemResolver<TParent>;
}

export interface DeleteItemPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteItemPayloadToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteJoinRequestPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteJoinRequestPayloadToClientMutationIdResolver<TParent>;
  joinRequest?: DeleteJoinRequestPayloadToJoinRequestResolver<TParent>;
}

export interface DeleteJoinRequestPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteJoinRequestPayloadToJoinRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteLanguagePayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteLanguagePayloadToClientMutationIdResolver<TParent>;
  language?: DeleteLanguagePayloadToLanguageResolver<TParent>;
}

export interface DeleteLanguagePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteLanguagePayloadToLanguageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteLocationPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteLocationPayloadToClientMutationIdResolver<TParent>;
  location?: DeleteLocationPayloadToLocationResolver<TParent>;
}

export interface DeleteLocationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteLocationPayloadToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteMessagePayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteMessagePayloadToClientMutationIdResolver<TParent>;
  message?: DeleteMessagePayloadToMessageResolver<TParent>;
}

export interface DeleteMessagePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteMessagePayloadToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteMyClassPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteMyClassPayloadToClientMutationIdResolver<TParent>;
  myClass?: DeleteMyClassPayloadToMyClassResolver<TParent>;
}

export interface DeleteMyClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteMyClassPayloadToMyClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteNotifSendingPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteNotifSendingPayloadToClientMutationIdResolver<TParent>;
  notifSending?: DeleteNotifSendingPayloadToNotifSendingResolver<TParent>;
}

export interface DeleteNotifSendingPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteNotifSendingPayloadToNotifSendingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteNotificationPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteNotificationPayloadToClientMutationIdResolver<TParent>;
  notification?: DeleteNotificationPayloadToNotificationResolver<TParent>;
}

export interface DeleteNotificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteNotificationPayloadToNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteOrderPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteOrderPayloadToClientMutationIdResolver<TParent>;
  order?: DeleteOrderPayloadToOrderResolver<TParent>;
}

export interface DeleteOrderPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteOrderPayloadToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeletePaymentPlanPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeletePaymentPlanPayloadToClientMutationIdResolver<TParent>;
  paymentPlan?: DeletePaymentPlanPayloadToPaymentPlanResolver<TParent>;
}

export interface DeletePaymentPlanPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeletePaymentPlanPayloadToPaymentPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeletePhoneVerificationPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeletePhoneVerificationPayloadToClientMutationIdResolver<TParent>;
  phoneVerification?: DeletePhoneVerificationPayloadToPhoneVerificationResolver<TParent>;
}

export interface DeletePhoneVerificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeletePhoneVerificationPayloadToPhoneVerificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeletePollOptionPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeletePollOptionPayloadToClientMutationIdResolver<TParent>;
  pollOption?: DeletePollOptionPayloadToPollOptionResolver<TParent>;
}

export interface DeletePollOptionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeletePollOptionPayloadToPollOptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeletePostPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeletePostPayloadToClientMutationIdResolver<TParent>;
  post?: DeletePostPayloadToPostResolver<TParent>;
}

export interface DeletePostPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeletePostPayloadToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeletePostTranslatePayloadTypeResolver<TParent = any> {
  clientMutationId?: DeletePostTranslatePayloadToClientMutationIdResolver<TParent>;
  postTranslate?: DeletePostTranslatePayloadToPostTranslateResolver<TParent>;
}

export interface DeletePostTranslatePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeletePostTranslatePayloadToPostTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeletePromoPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeletePromoPayloadToClientMutationIdResolver<TParent>;
  promo?: DeletePromoPayloadToPromoResolver<TParent>;
}

export interface DeletePromoPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeletePromoPayloadToPromoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeletePushNotificationLogPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeletePushNotificationLogPayloadToClientMutationIdResolver<TParent>;
  pushNotificationLog?: DeletePushNotificationLogPayloadToPushNotificationLogResolver<TParent>;
}

export interface DeletePushNotificationLogPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeletePushNotificationLogPayloadToPushNotificationLogResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteReferralPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteReferralPayloadToClientMutationIdResolver<TParent>;
  referral?: DeleteReferralPayloadToReferralResolver<TParent>;
}

export interface DeleteReferralPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteReferralPayloadToReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteReportPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteReportPayloadToClientMutationIdResolver<TParent>;
  report?: DeleteReportPayloadToReportResolver<TParent>;
}

export interface DeleteReportPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteReportPayloadToReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteReviewPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteReviewPayloadToClientMutationIdResolver<TParent>;
  review?: DeleteReviewPayloadToReviewResolver<TParent>;
}

export interface DeleteReviewPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteReviewPayloadToReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteRolePayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteRolePayloadToClientMutationIdResolver<TParent>;
  role?: DeleteRolePayloadToRoleResolver<TParent>;
}

export interface DeleteRolePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteRolePayloadToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteSessionPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteSessionPayloadToClientMutationIdResolver<TParent>;
  session?: DeleteSessionPayloadToSessionResolver<TParent>;
}

export interface DeleteSessionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteSessionPayloadToSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteSubscrPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteSubscrPayloadToClientMutationIdResolver<TParent>;
  subscr?: DeleteSubscrPayloadToSubscrResolver<TParent>;
}

export interface DeleteSubscrPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteSubscrPayloadToSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteSubscrPaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteSubscrPaymentPayloadToClientMutationIdResolver<TParent>;
  subscrPayment?: DeleteSubscrPaymentPayloadToSubscrPaymentResolver<TParent>;
}

export interface DeleteSubscrPaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteSubscrPaymentPayloadToSubscrPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteTaskPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteTaskPayloadToClientMutationIdResolver<TParent>;
  task?: DeleteTaskPayloadToTaskResolver<TParent>;
}

export interface DeleteTaskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteTaskPayloadToTaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteTransactionPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteTransactionPayloadToClientMutationIdResolver<TParent>;
  transaction?: DeleteTransactionPayloadToTransactionResolver<TParent>;
}

export interface DeleteTransactionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteTransactionPayloadToTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteUserPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteUserPayloadToClientMutationIdResolver<TParent>;
  user?: DeleteUserPayloadToUserResolver<TParent>;
}

export interface DeleteUserPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteUserPayloadToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDirectAddMemberPayloadTypeResolver<TParent = any> {
  added?: DirectAddMemberPayloadToAddedResolver<TParent>;
}

export interface DirectAddMemberPayloadToAddedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDocumentTypeResolver<TParent = any> {
  ACL?: DocumentToACLResolver<TParent>;
  Community?: DocumentToCommunityResolver<TParent>;
  Cover?: DocumentToCoverResolver<TParent>;
  DocFile?: DocumentToDocFileResolver<TParent>;
  User?: DocumentToUserResolver<TParent>;
  alias?: DocumentToAliasResolver<TParent>;
  createdAt?: DocumentToCreatedAtResolver<TParent>;
  id?: DocumentToIdResolver<TParent>;
  isDeleted?: DocumentToIsDeletedResolver<TParent>;
  isPublished?: DocumentToIsPublishedResolver<TParent>;
  name?: DocumentToNameResolver<TParent>;
  objectId?: DocumentToObjectIdResolver<TParent>;
  type?: DocumentToTypeResolver<TParent>;
  updatedAt?: DocumentToUpdatedAtResolver<TParent>;
}

export interface DocumentToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCoverResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToDocFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToAliasResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToIsDeletedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToIsPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDocumentConnectionTypeResolver<TParent = any> {
  count?: DocumentConnectionToCountResolver<TParent>;
  edges?: DocumentConnectionToEdgesResolver<TParent>;
  pageInfo?: DocumentConnectionToPageInfoResolver<TParent>;
}

export interface DocumentConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDocumentEdgeTypeResolver<TParent = any> {
  cursor?: DocumentEdgeToCursorResolver<TParent>;
  node?: DocumentEdgeToNodeResolver<TParent>;
}

export interface DocumentEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DocumentEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElementTypeResolver<TParent = any> {
  value?: ElementToValueResolver<TParent>;
}

export interface ElementToValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEventTypeResolver<TParent = any> {
  ACL?: EventToACLResolver<TParent>;
  AdmHidden?: EventToAdmHiddenResolver<TParent>;
  ApproveReq?: EventToApproveReqResolver<TParent>;
  Attendees?: EventToAttendeesResolver<TParent>;
  Featured?: EventToFeaturedResolver<TParent>;
  Lister?: EventToListerResolver<TParent>;
  Location?: EventToLocationResolver<TParent>;
  Published?: EventToPublishedResolver<TParent>;
  Reports?: EventToReportsResolver<TParent>;
  Requests?: EventToRequestsResolver<TParent>;
  Reviews?: EventToReviewsResolver<TParent>;
  Transactions?: EventToTransactionsResolver<TParent>;
  Updated?: EventToUpdatedResolver<TParent>;
  Viewers?: EventToViewersResolver<TParent>;
  allowGuests?: EventToAllowGuestsResolver<TParent>;
  countLikes?: EventToCountLikesResolver<TParent>;
  createdAt?: EventToCreatedAtResolver<TParent>;
  descr?: EventToDescrResolver<TParent>;
  endTime?: EventToEndTimeResolver<TParent>;
  eventType?: EventToEventTypeResolver<TParent>;
  expiresDate?: EventToExpiresDateResolver<TParent>;
  id?: EventToIdResolver<TParent>;
  images?: EventToImagesResolver<TParent>;
  isDeleted?: EventToIsDeletedResolver<TParent>;
  isLike?: EventToIsLikeResolver<TParent>;
  isPublished?: EventToIsPublishedResolver<TParent>;
  likes?: EventToLikesResolver<TParent>;
  listerReminded?: EventToListerRemindedResolver<TParent>;
  listerReminded6am?: EventToListerReminded6amResolver<TParent>;
  locationDetails?: EventToLocationDetailsResolver<TParent>;
  maxAttendees?: EventToMaxAttendeesResolver<TParent>;
  maxGuestsPerAttendee?: EventToMaxGuestsPerAttendeeResolver<TParent>;
  name?: EventToNameResolver<TParent>;
  objectId?: EventToObjectIdResolver<TParent>;
  openTo?: EventToOpenToResolver<TParent>;
  pricePeriod?: EventToPricePeriodResolver<TParent>;
  rating?: EventToRatingResolver<TParent>;
  rewardType?: EventToRewardTypeResolver<TParent>;
  showAttendees?: EventToShowAttendeesResolver<TParent>;
  startTime?: EventToStartTimeResolver<TParent>;
  totalAttendees?: EventToTotalAttendeesResolver<TParent>;
  totalViews?: EventToTotalViewsResolver<TParent>;
  updatedAt?: EventToUpdatedAtResolver<TParent>;
}

export interface EventToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToAdmHiddenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToApproveReqResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToAttendeesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface EventToAttendeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventToAttendeesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToListerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToReportsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReportOrder>;
  skip?: number;
  where?: GQLReportWhereInput;
}
export interface EventToReportsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventToReportsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToRequestsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLOrderOrder>;
  skip?: number;
  where?: GQLOrderWhereInput;
}
export interface EventToRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventToRequestsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToReviewsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReviewOrder>;
  skip?: number;
  where?: GQLReviewWhereInput;
}
export interface EventToReviewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventToReviewsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToTransactionsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLTransactionOrder>;
  skip?: number;
  where?: GQLTransactionWhereInput;
}
export interface EventToTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventToTransactionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToUpdatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToViewersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface EventToViewersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventToViewersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToAllowGuestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToCountLikesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToEndTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToEventTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToExpiresDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToIsDeletedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToIsLikeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToIsPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToLikesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface EventToLikesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventToLikesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToListerRemindedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToListerReminded6amResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToLocationDetailsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToMaxAttendeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToMaxGuestsPerAttendeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToOpenToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToPricePeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToRewardTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToShowAttendeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToStartTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToTotalAttendeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToTotalViewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEventConnectionTypeResolver<TParent = any> {
  count?: EventConnectionToCountResolver<TParent>;
  edges?: EventConnectionToEdgesResolver<TParent>;
  pageInfo?: EventConnectionToPageInfoResolver<TParent>;
}

export interface EventConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEventEdgeTypeResolver<TParent = any> {
  cursor?: EventEdgeToCursorResolver<TParent>;
  node?: EventEdgeToNodeResolver<TParent>;
}

export interface EventEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFeeObjectTypeResolver<TParent = any> {
  cfListerAbs?: FeeObjectToCfListerAbsResolver<TParent>;
  cfListerPrc?: FeeObjectToCfListerPrcResolver<TParent>;
  cfRequesterAbs?: FeeObjectToCfRequesterAbsResolver<TParent>;
  cfRequesterPrc?: FeeObjectToCfRequesterPrcResolver<TParent>;
  message?: FeeObjectToMessageResolver<TParent>;
}

export interface FeeObjectToCfListerAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeObjectToCfListerPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeObjectToCfRequesterAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeObjectToCfRequesterPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FeeObjectToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFileInfoTypeResolver<TParent = any> {
  name?: FileInfoToNameResolver<TParent>;
  url?: FileInfoToUrlResolver<TParent>;
}

export interface FileInfoToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileInfoToUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGenerateAiOpenApiTextPayloadTypeResolver<TParent = any> {
  gptResponseText?: GenerateAiOpenApiTextPayloadToGptResponseTextResolver<TParent>;
}

export interface GenerateAiOpenApiTextPayloadToGptResponseTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGenerateUsernamePayloadTypeResolver<TParent = any> {
  name?: GenerateUsernamePayloadToNameResolver<TParent>;
}

export interface GenerateUsernamePayloadToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGeoPointTypeResolver<TParent = any> {
  latitude?: GeoPointToLatitudeResolver<TParent>;
  longitude?: GeoPointToLongitudeResolver<TParent>;
}

export interface GeoPointToLatitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GeoPointToLongitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetAccBalancePayloadTypeResolver<TParent = any> {
  balance?: GetAccBalancePayloadToBalanceResolver<TParent>;
}

export interface GetAccBalancePayloadToBalanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetItemArraysPayloadTypeResolver<TParent = any> {
  approvedItems?: GetItemArraysPayloadToApprovedItemsResolver<TParent>;
  featuredItems?: GetItemArraysPayloadToFeaturedItemsResolver<TParent>;
}

export interface GetItemArraysPayloadToApprovedItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetItemArraysPayloadToFeaturedItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetManagersListPayloadTypeResolver<TParent = any> {
  email?: GetManagersListPayloadToEmailResolver<TParent>;
  fullName?: GetManagersListPayloadToFullNameResolver<TParent>;
  id?: GetManagersListPayloadToIdResolver<TParent>;
  label?: GetManagersListPayloadToLabelResolver<TParent>;
}

export interface GetManagersListPayloadToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetManagersListPayloadToFullNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetManagersListPayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetManagersListPayloadToLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetResidentsAvatarPayloadTypeResolver<TParent = any> {
  users?: GetResidentsAvatarPayloadToUsersResolver<TParent>;
}

export interface GetResidentsAvatarPayloadToUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetUserByReferralPayloadTypeResolver<TParent = any> {
  user?: GetUserByReferralPayloadToUserResolver<TParent>;
}

export interface GetUserByReferralPayloadToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetUserCardsPayloadTypeResolver<TParent = any> {
  cards?: GetUserCardsPayloadToCardsResolver<TParent>;
  defaultCardId?: GetUserCardsPayloadToDefaultCardIdResolver<TParent>;
}

export interface GetUserCardsPayloadToCardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetUserCardsPayloadToDefaultCardIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGroupTypeResolver<TParent = any> {
  ACL?: GroupToACLResolver<TParent>;
  Avatar?: GroupToAvatarResolver<TParent>;
  Community?: GroupToCommunityResolver<TParent>;
  Featured?: GroupToFeaturedResolver<TParent>;
  Members?: GroupToMembersResolver<TParent>;
  alias?: GroupToAliasResolver<TParent>;
  createdAt?: GroupToCreatedAtResolver<TParent>;
  description?: GroupToDescriptionResolver<TParent>;
  id?: GroupToIdResolver<TParent>;
  isDeleted?: GroupToIsDeletedResolver<TParent>;
  name?: GroupToNameResolver<TParent>;
  objectId?: GroupToObjectIdResolver<TParent>;
  type?: GroupToTypeResolver<TParent>;
  updatedAt?: GroupToUpdatedAtResolver<TParent>;
}

export interface GroupToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToAvatarResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToMembersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface GroupToMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: GroupToMembersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToAliasResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToIsDeletedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGroupConnectionTypeResolver<TParent = any> {
  count?: GroupConnectionToCountResolver<TParent>;
  edges?: GroupConnectionToEdgesResolver<TParent>;
  pageInfo?: GroupConnectionToPageInfoResolver<TParent>;
}

export interface GroupConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGroupEdgeTypeResolver<TParent = any> {
  cursor?: GroupEdgeToCursorResolver<TParent>;
  node?: GroupEdgeToNodeResolver<TParent>;
}

export interface GroupEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GroupEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGroupPayloadTypeResolver<TParent = any> {
  success?: GroupPayloadToSuccessResolver<TParent>;
}

export interface GroupPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHelpDeskTypeResolver<TParent = any> {
  ACL?: HelpDeskToACLResolver<TParent>;
  Assignee?: HelpDeskToAssigneeResolver<TParent>;
  Community?: HelpDeskToCommunityResolver<TParent>;
  assignTo?: HelpDeskToAssignToResolver<TParent>;
  buttonTitle?: HelpDeskToButtonTitleResolver<TParent>;
  createdAt?: HelpDeskToCreatedAtResolver<TParent>;
  dailyQuoteAuthor?: HelpDeskToDailyQuoteAuthorResolver<TParent>;
  descr?: HelpDeskToDescrResolver<TParent>;
  id?: HelpDeskToIdResolver<TParent>;
  isDeleted?: HelpDeskToIsDeletedResolver<TParent>;
  isPublished?: HelpDeskToIsPublishedResolver<TParent>;
  layOutOrder?: HelpDeskToLayOutOrderResolver<TParent>;
  objectId?: HelpDeskToObjectIdResolver<TParent>;
  title?: HelpDeskToTitleResolver<TParent>;
  type?: HelpDeskToTypeResolver<TParent>;
  updatedAt?: HelpDeskToUpdatedAtResolver<TParent>;
}

export interface HelpDeskToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToAssigneeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToAssignToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToButtonTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToDailyQuoteAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToIsDeletedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToIsPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToLayOutOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHelpDeskConnectionTypeResolver<TParent = any> {
  count?: HelpDeskConnectionToCountResolver<TParent>;
  edges?: HelpDeskConnectionToEdgesResolver<TParent>;
  pageInfo?: HelpDeskConnectionToPageInfoResolver<TParent>;
}

export interface HelpDeskConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHelpDeskEdgeTypeResolver<TParent = any> {
  cursor?: HelpDeskEdgeToCursorResolver<TParent>;
  node?: HelpDeskEdgeToNodeResolver<TParent>;
}

export interface HelpDeskEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HelpDeskEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHidePostPayloadTypeResolver<TParent = any> {
  post?: HidePostPayloadToPostResolver<TParent>;
}

export interface HidePostPayloadToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstallationTypeResolver<TParent = any> {
  ACL?: InstallationToACLResolver<TParent>;
  GCMSenderId?: InstallationToGCMSenderIdResolver<TParent>;
  User?: InstallationToUserResolver<TParent>;
  appIdentifier?: InstallationToAppIdentifierResolver<TParent>;
  appName?: InstallationToAppNameResolver<TParent>;
  appVersion?: InstallationToAppVersionResolver<TParent>;
  badge?: InstallationToBadgeResolver<TParent>;
  channels?: InstallationToChannelsResolver<TParent>;
  createdAt?: InstallationToCreatedAtResolver<TParent>;
  deviceToken?: InstallationToDeviceTokenResolver<TParent>;
  deviceType?: InstallationToDeviceTypeResolver<TParent>;
  id?: InstallationToIdResolver<TParent>;
  installationId?: InstallationToInstallationIdResolver<TParent>;
  localeIdentifier?: InstallationToLocaleIdentifierResolver<TParent>;
  objectId?: InstallationToObjectIdResolver<TParent>;
  parseVersion?: InstallationToParseVersionResolver<TParent>;
  pushType?: InstallationToPushTypeResolver<TParent>;
  timeZone?: InstallationToTimeZoneResolver<TParent>;
  updatedAt?: InstallationToUpdatedAtResolver<TParent>;
}

export interface InstallationToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToGCMSenderIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToAppIdentifierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToAppNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToAppVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToBadgeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToChannelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToDeviceTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToDeviceTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToInstallationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToLocaleIdentifierResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToParseVersionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToPushTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToTimeZoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstallationConnectionTypeResolver<TParent = any> {
  count?: InstallationConnectionToCountResolver<TParent>;
  edges?: InstallationConnectionToEdgesResolver<TParent>;
  pageInfo?: InstallationConnectionToPageInfoResolver<TParent>;
}

export interface InstallationConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstallationEdgeTypeResolver<TParent = any> {
  cursor?: InstallationEdgeToCursorResolver<TParent>;
  node?: InstallationEdgeToNodeResolver<TParent>;
}

export interface InstallationEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstallationEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvitationTypeResolver<TParent = any> {
  ACL?: InvitationToACLResolver<TParent>;
  Community?: InvitationToCommunityResolver<TParent>;
  User?: InvitationToUserResolver<TParent>;
  createdAt?: InvitationToCreatedAtResolver<TParent>;
  email?: InvitationToEmailResolver<TParent>;
  emailText?: InvitationToEmailTextResolver<TParent>;
  id?: InvitationToIdResolver<TParent>;
  invLink?: InvitationToInvLinkResolver<TParent>;
  objectId?: InvitationToObjectIdResolver<TParent>;
  status?: InvitationToStatusResolver<TParent>;
  updatedAt?: InvitationToUpdatedAtResolver<TParent>;
}

export interface InvitationToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToEmailTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToInvLinkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvitationConnectionTypeResolver<TParent = any> {
  count?: InvitationConnectionToCountResolver<TParent>;
  edges?: InvitationConnectionToEdgesResolver<TParent>;
  pageInfo?: InvitationConnectionToPageInfoResolver<TParent>;
}

export interface InvitationConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvitationEdgeTypeResolver<TParent = any> {
  cursor?: InvitationEdgeToCursorResolver<TParent>;
  node?: InvitationEdgeToNodeResolver<TParent>;
}

export interface InvitationEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvitationEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvoiceItemOrderPayloadTypeResolver<TParent = any> {
  entryFee?: InvoiceItemOrderPayloadToEntryFeeResolver<TParent>;
  serviceCharge?: InvoiceItemOrderPayloadToServiceChargeResolver<TParent>;
  stripeFee?: InvoiceItemOrderPayloadToStripeFeeResolver<TParent>;
  total?: InvoiceItemOrderPayloadToTotalResolver<TParent>;
}

export interface InvoiceItemOrderPayloadToEntryFeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceItemOrderPayloadToServiceChargeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceItemOrderPayloadToStripeFeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceItemOrderPayloadToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLItemTypeResolver<TParent = any> {
  ACL?: ItemToACLResolver<TParent>;
  AdmHidden?: ItemToAdmHiddenResolver<TParent>;
  ApproveReq?: ItemToApproveReqResolver<TParent>;
  Featured?: ItemToFeaturedResolver<TParent>;
  Lister?: ItemToListerResolver<TParent>;
  Location?: ItemToLocationResolver<TParent>;
  Published?: ItemToPublishedResolver<TParent>;
  Reports?: ItemToReportsResolver<TParent>;
  Requests?: ItemToRequestsResolver<TParent>;
  Reviews?: ItemToReviewsResolver<TParent>;
  Transactions?: ItemToTransactionsResolver<TParent>;
  Updated?: ItemToUpdatedResolver<TParent>;
  Viewers?: ItemToViewersResolver<TParent>;
  category?: ItemToCategoryResolver<TParent>;
  countLikes?: ItemToCountLikesResolver<TParent>;
  createdAt?: ItemToCreatedAtResolver<TParent>;
  createdAt_custom?: ItemToCreatedAt_customResolver<TParent>;
  data?: ItemToDataResolver<TParent>;
  descr?: ItemToDescrResolver<TParent>;
  description?: ItemToDescriptionResolver<TParent>;
  discount?: ItemToDiscountResolver<TParent>;
  discountType?: ItemToDiscountTypeResolver<TParent>;
  id?: ItemToIdResolver<TParent>;
  images?: ItemToImagesResolver<TParent>;
  income?: ItemToIncomeResolver<TParent>;
  isDeleted?: ItemToIsDeletedResolver<TParent>;
  isLike?: ItemToIsLikeResolver<TParent>;
  isPublished?: ItemToIsPublishedResolver<TParent>;
  isSold?: ItemToIsSoldResolver<TParent>;
  likes?: ItemToLikesResolver<TParent>;
  listingType?: ItemToListingTypeResolver<TParent>;
  maxPeriod?: ItemToMaxPeriodResolver<TParent>;
  minDuration?: ItemToMinDurationResolver<TParent>;
  name?: ItemToNameResolver<TParent>;
  objectId?: ItemToObjectIdResolver<TParent>;
  originalPrice?: ItemToOriginalPriceResolver<TParent>;
  price?: ItemToPriceResolver<TParent>;
  pricePeriod?: ItemToPricePeriodResolver<TParent>;
  rating?: ItemToRatingResolver<TParent>;
  rewardType?: ItemToRewardTypeResolver<TParent>;
  sessionToken?: ItemToSessionTokenResolver<TParent>;
  totalCompletedOrders?: ItemToTotalCompletedOrdersResolver<TParent>;
  totalRequests?: ItemToTotalRequestsResolver<TParent>;
  totalViews?: ItemToTotalViewsResolver<TParent>;
  updatedAt?: ItemToUpdatedAtResolver<TParent>;
  yearPurchased?: ItemToYearPurchasedResolver<TParent>;
}

export interface ItemToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToAdmHiddenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToApproveReqResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToListerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToReportsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReportOrder>;
  skip?: number;
  where?: GQLReportWhereInput;
}
export interface ItemToReportsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ItemToReportsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToRequestsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLOrderOrder>;
  skip?: number;
  where?: GQLOrderWhereInput;
}
export interface ItemToRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ItemToRequestsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToReviewsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReviewOrder>;
  skip?: number;
  where?: GQLReviewWhereInput;
}
export interface ItemToReviewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ItemToReviewsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToTransactionsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLTransactionOrder>;
  skip?: number;
  where?: GQLTransactionWhereInput;
}
export interface ItemToTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ItemToTransactionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToUpdatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToViewersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface ItemToViewersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ItemToViewersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToCountLikesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToCreatedAt_customResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToDiscountTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToIncomeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToIsDeletedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToIsLikeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToIsPublishedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToIsSoldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToLikesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface ItemToLikesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ItemToLikesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToListingTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToMaxPeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToMinDurationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToOriginalPriceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToPriceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToPricePeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToRewardTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToSessionTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToTotalCompletedOrdersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToTotalRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToTotalViewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemToYearPurchasedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLItemBookingTypeResolver<TParent = any> {
  ACL?: ItemBookingToACLResolver<TParent>;
  Item?: ItemBookingToItemResolver<TParent>;
  Order?: ItemBookingToOrderResolver<TParent>;
  createdAt?: ItemBookingToCreatedAtResolver<TParent>;
  from?: ItemBookingToFromResolver<TParent>;
  id?: ItemBookingToIdResolver<TParent>;
  objectId?: ItemBookingToObjectIdResolver<TParent>;
  to?: ItemBookingToToResolver<TParent>;
  updatedAt?: ItemBookingToUpdatedAtResolver<TParent>;
}

export interface ItemBookingToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingToFromResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingToToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLItemBookingConnectionTypeResolver<TParent = any> {
  count?: ItemBookingConnectionToCountResolver<TParent>;
  edges?: ItemBookingConnectionToEdgesResolver<TParent>;
  pageInfo?: ItemBookingConnectionToPageInfoResolver<TParent>;
}

export interface ItemBookingConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLItemBookingEdgeTypeResolver<TParent = any> {
  cursor?: ItemBookingEdgeToCursorResolver<TParent>;
  node?: ItemBookingEdgeToNodeResolver<TParent>;
}

export interface ItemBookingEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemBookingEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLItemConnectionTypeResolver<TParent = any> {
  count?: ItemConnectionToCountResolver<TParent>;
  edges?: ItemConnectionToEdgesResolver<TParent>;
  pageInfo?: ItemConnectionToPageInfoResolver<TParent>;
}

export interface ItemConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLItemEdgeTypeResolver<TParent = any> {
  cursor?: ItemEdgeToCursorResolver<TParent>;
  node?: ItemEdgeToNodeResolver<TParent>;
}

export interface ItemEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ItemEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJoinRequestTypeResolver<TParent = any> {
  ACL?: JoinRequestToACLResolver<TParent>;
  Community?: JoinRequestToCommunityResolver<TParent>;
  Invitation?: JoinRequestToInvitationResolver<TParent>;
  User?: JoinRequestToUserResolver<TParent>;
  answer?: JoinRequestToAnswerResolver<TParent>;
  createdAt?: JoinRequestToCreatedAtResolver<TParent>;
  date?: JoinRequestToDateResolver<TParent>;
  id?: JoinRequestToIdResolver<TParent>;
  objectId?: JoinRequestToObjectIdResolver<TParent>;
  request?: JoinRequestToRequestResolver<TParent>;
  status?: JoinRequestToStatusResolver<TParent>;
  updatedAt?: JoinRequestToUpdatedAtResolver<TParent>;
}

export interface JoinRequestToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToAnswerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJoinRequestConnectionTypeResolver<TParent = any> {
  count?: JoinRequestConnectionToCountResolver<TParent>;
  edges?: JoinRequestConnectionToEdgesResolver<TParent>;
  pageInfo?: JoinRequestConnectionToPageInfoResolver<TParent>;
}

export interface JoinRequestConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJoinRequestEdgeTypeResolver<TParent = any> {
  cursor?: JoinRequestEdgeToCursorResolver<TParent>;
  node?: JoinRequestEdgeToNodeResolver<TParent>;
}

export interface JoinRequestEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JoinRequestEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLanguageTypeResolver<TParent = any> {
  ACL?: LanguageToACLResolver<TParent>;
  code?: LanguageToCodeResolver<TParent>;
  createdAt?: LanguageToCreatedAtResolver<TParent>;
  id?: LanguageToIdResolver<TParent>;
  isDisabled?: LanguageToIsDisabledResolver<TParent>;
  name?: LanguageToNameResolver<TParent>;
  objectId?: LanguageToObjectIdResolver<TParent>;
  updatedAt?: LanguageToUpdatedAtResolver<TParent>;
}

export interface LanguageToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageToIsDisabledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLanguageConnectionTypeResolver<TParent = any> {
  count?: LanguageConnectionToCountResolver<TParent>;
  edges?: LanguageConnectionToEdgesResolver<TParent>;
  pageInfo?: LanguageConnectionToPageInfoResolver<TParent>;
}

export interface LanguageConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLanguageEdgeTypeResolver<TParent = any> {
  cursor?: LanguageEdgeToCursorResolver<TParent>;
  node?: LanguageEdgeToNodeResolver<TParent>;
}

export interface LanguageEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LanguageEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLikeEventPayloadTypeResolver<TParent = any> {
  success?: LikeEventPayloadToSuccessResolver<TParent>;
}

export interface LikeEventPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLikeListingPayloadTypeResolver<TParent = any> {
  success?: LikeListingPayloadToSuccessResolver<TParent>;
}

export interface LikeListingPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLikePostPayloadTypeResolver<TParent = any> {
  post?: LikePostPayloadToPostResolver<TParent>;
}

export interface LikePostPayloadToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLocationTypeResolver<TParent = any> {
  ACL?: LocationToACLResolver<TParent>;
  City?: LocationToCityResolver<TParent>;
  Country?: LocationToCountryResolver<TParent>;
  State?: LocationToStateResolver<TParent>;
  code?: LocationToCodeResolver<TParent>;
  createdAt?: LocationToCreatedAtResolver<TParent>;
  geo?: LocationToGeoResolver<TParent>;
  id?: LocationToIdResolver<TParent>;
  isDisabled?: LocationToIsDisabledResolver<TParent>;
  name?: LocationToNameResolver<TParent>;
  objectId?: LocationToObjectIdResolver<TParent>;
  type?: LocationToTypeResolver<TParent>;
  updatedAt?: LocationToUpdatedAtResolver<TParent>;
}

export interface LocationToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToCityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToGeoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToIsDisabledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLocationConnectionTypeResolver<TParent = any> {
  count?: LocationConnectionToCountResolver<TParent>;
  edges?: LocationConnectionToEdgesResolver<TParent>;
  pageInfo?: LocationConnectionToPageInfoResolver<TParent>;
}

export interface LocationConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLocationEdgeTypeResolver<TParent = any> {
  cursor?: LocationEdgeToCursorResolver<TParent>;
  node?: LocationEdgeToNodeResolver<TParent>;
}

export interface LocationEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LocationEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLogInPayloadTypeResolver<TParent = any> {
  clientMutationId?: LogInPayloadToClientMutationIdResolver<TParent>;
  viewer?: LogInPayloadToViewerResolver<TParent>;
}

export interface LogInPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LogInPayloadToViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLogInWithPayloadTypeResolver<TParent = any> {
  clientMutationId?: LogInWithPayloadToClientMutationIdResolver<TParent>;
  viewer?: LogInWithPayloadToViewerResolver<TParent>;
}

export interface LogInWithPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LogInWithPayloadToViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLogOutPayloadTypeResolver<TParent = any> {
  clientMutationId?: LogOutPayloadToClientMutationIdResolver<TParent>;
  ok?: LogOutPayloadToOkResolver<TParent>;
}

export interface LogOutPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LogOutPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLManagerDashboardPayloadTypeResolver<TParent = any> {
  averageTransactionRating?: ManagerDashboardPayloadToAverageTransactionRatingResolver<TParent>;
  coffeeTransactions?: ManagerDashboardPayloadToCoffeeTransactionsResolver<TParent>;
  completedInvitations?: ManagerDashboardPayloadToCompletedInvitationsResolver<TParent>;
  countAmenityBooked?: ManagerDashboardPayloadToCountAmenityBookedResolver<TParent>;
  countAmenityViews?: ManagerDashboardPayloadToCountAmenityViewsResolver<TParent>;
  countEventAttended?: ManagerDashboardPayloadToCountEventAttendedResolver<TParent>;
  countEventViews?: ManagerDashboardPayloadToCountEventViewsResolver<TParent>;
  countInternalMessages?: ManagerDashboardPayloadToCountInternalMessagesResolver<TParent>;
  countListingValue?: ManagerDashboardPayloadToCountListingValueResolver<TParent>;
  countListings?: ManagerDashboardPayloadToCountListingsResolver<TParent>;
  countLoopPostComments?: ManagerDashboardPayloadToCountLoopPostCommentsResolver<TParent>;
  countLoopPostLikes?: ManagerDashboardPayloadToCountLoopPostLikesResolver<TParent>;
  countLoopPosts?: ManagerDashboardPayloadToCountLoopPostsResolver<TParent>;
  countMembers?: ManagerDashboardPayloadToCountMembersResolver<TParent>;
  countProfileViews?: ManagerDashboardPayloadToCountProfileViewsResolver<TParent>;
  countReports?: ManagerDashboardPayloadToCountReportsResolver<TParent>;
  countTransactionValue?: ManagerDashboardPayloadToCountTransactionValueResolver<TParent>;
  countTransactions?: ManagerDashboardPayloadToCountTransactionsResolver<TParent>;
  fee?: ManagerDashboardPayloadToFeeResolver<TParent>;
  freeTransactions?: ManagerDashboardPayloadToFreeTransactionsResolver<TParent>;
  incomeGenerated?: ManagerDashboardPayloadToIncomeGeneratedResolver<TParent>;
  rentalTransactions?: ManagerDashboardPayloadToRentalTransactionsResolver<TParent>;
  saleTransactions?: ManagerDashboardPayloadToSaleTransactionsResolver<TParent>;
  serviceTransactions?: ManagerDashboardPayloadToServiceTransactionsResolver<TParent>;
  totalInvitations?: ManagerDashboardPayloadToTotalInvitationsResolver<TParent>;
}

export interface ManagerDashboardPayloadToAverageTransactionRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCoffeeTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCompletedInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountAmenityBookedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountAmenityViewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountEventAttendedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountEventViewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountInternalMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountListingValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountLoopPostCommentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountLoopPostLikesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountLoopPostsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountProfileViewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountReportsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountTransactionValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToCountTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToFeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToFreeTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToIncomeGeneratedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToRentalTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToSaleTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToServiceTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ManagerDashboardPayloadToTotalInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMessageTypeResolver<TParent = any> {
  ACL?: MessageToACLResolver<TParent>;
  Attachments?: MessageToAttachmentsResolver<TParent>;
  Author?: MessageToAuthorResolver<TParent>;
  Chat?: MessageToChatResolver<TParent>;
  Community?: MessageToCommunityResolver<TParent>;
  Order?: MessageToOrderResolver<TParent>;
  Seen?: MessageToSeenResolver<TParent>;
  ShowTo?: MessageToShowToResolver<TParent>;
  createdAt?: MessageToCreatedAtResolver<TParent>;
  id?: MessageToIdResolver<TParent>;
  localRef?: MessageToLocalRefResolver<TParent>;
  objectId?: MessageToObjectIdResolver<TParent>;
  supportMsgStatus?: MessageToSupportMsgStatusResolver<TParent>;
  text?: MessageToTextResolver<TParent>;
  type?: MessageToTypeResolver<TParent>;
  updatedAt?: MessageToUpdatedAtResolver<TParent>;
}

export interface MessageToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToAttachmentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToSeenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToShowToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToLocalRefResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToSupportMsgStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMessageConnectionTypeResolver<TParent = any> {
  count?: MessageConnectionToCountResolver<TParent>;
  edges?: MessageConnectionToEdgesResolver<TParent>;
  pageInfo?: MessageConnectionToPageInfoResolver<TParent>;
}

export interface MessageConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMessageEdgeTypeResolver<TParent = any> {
  cursor?: MessageEdgeToCursorResolver<TParent>;
  node?: MessageEdgeToNodeResolver<TParent>;
}

export interface MessageEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MessageEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMutationTypeResolver<TParent = any> {
  accountTransfer?: MutationToAccountTransferResolver<TParent>;
  adminCreate?: MutationToAdminCreateResolver<TParent>;
  adminCreateUser?: MutationToAdminCreateUserResolver<TParent>;
  adminDashboard?: MutationToAdminDashboardResolver<TParent>;
  adminDashboardChart?: MutationToAdminDashboardChartResolver<TParent>;
  adminDeleteUser?: MutationToAdminDeleteUserResolver<TParent>;
  adminEdit?: MutationToAdminEditResolver<TParent>;
  adminLogin?: MutationToAdminLoginResolver<TParent>;
  adminRemove?: MutationToAdminRemoveResolver<TParent>;
  adminUpdateUser?: MutationToAdminUpdateUserResolver<TParent>;
  amenityManageButtons?: MutationToAmenityManageButtonsResolver<TParent>;
  archiveNotifications?: MutationToArchiveNotificationsResolver<TParent>;
  badgeClear?: MutationToBadgeClearResolver<TParent>;
  bookAmenity?: MutationToBookAmenityResolver<TParent>;
  bookEvent?: MutationToBookEventResolver<TParent>;
  calcOrderData?: MutationToCalcOrderDataResolver<TParent>;
  callCloudCode?: MutationToCallCloudCodeResolver<TParent>;
  changePassword?: MutationToChangePasswordResolver<TParent>;
  changeSubscriptionPlan?: MutationToChangeSubscriptionPlanResolver<TParent>;
  checkCommExternalPayments?: MutationToCheckCommExternalPaymentsResolver<TParent>;
  communityAdminCreate?: MutationToCommunityAdminCreateResolver<TParent>;
  communityAdminEdit?: MutationToCommunityAdminEditResolver<TParent>;
  communityAdminRemove?: MutationToCommunityAdminRemoveResolver<TParent>;
  companyManageButtons?: MutationToCompanyManageButtonsResolver<TParent>;
  confirmUserRemoval?: MutationToConfirmUserRemovalResolver<TParent>;
  connectStripeAccount?: MutationToConnectStripeAccountResolver<TParent>;
  countTotalClicks?: MutationToCountTotalClicksResolver<TParent>;
  createAdmin?: MutationToCreateAdminResolver<TParent>;
  createAmenity?: MutationToCreateAmenityResolver<TParent>;
  createAppFile?: MutationToCreateAppFileResolver<TParent>;
  createCategory?: MutationToCreateCategoryResolver<TParent>;
  createChat?: MutationToCreateChatResolver<TParent>;
  createClass?: MutationToCreateClassResolver<TParent>;
  createCommunity?: MutationToCreateCommunityResolver<TParent>;
  createCommunityAdmin?: MutationToCreateCommunityAdminResolver<TParent>;
  createCommunityForNewUser?: MutationToCreateCommunityForNewUserResolver<TParent>;
  createCompany?: MutationToCreateCompanyResolver<TParent>;
  createCompanyReport?: MutationToCreateCompanyReportResolver<TParent>;
  createCurrency?: MutationToCreateCurrencyResolver<TParent>;
  createDocument?: MutationToCreateDocumentResolver<TParent>;
  createEvent?: MutationToCreateEventResolver<TParent>;
  createFile?: MutationToCreateFileResolver<TParent>;
  createGroup?: MutationToCreateGroupResolver<TParent>;
  createHelpDesk?: MutationToCreateHelpDeskResolver<TParent>;
  createInstallation?: MutationToCreateInstallationResolver<TParent>;
  createInvitation?: MutationToCreateInvitationResolver<TParent>;
  createItem?: MutationToCreateItemResolver<TParent>;
  createItemBooking?: MutationToCreateItemBookingResolver<TParent>;
  createJoinRequest?: MutationToCreateJoinRequestResolver<TParent>;
  createLanguage?: MutationToCreateLanguageResolver<TParent>;
  createLocation?: MutationToCreateLocationResolver<TParent>;
  createMessage?: MutationToCreateMessageResolver<TParent>;
  createMultiplyItems?: MutationToCreateMultiplyItemsResolver<TParent>;
  createMyClass?: MutationToCreateMyClassResolver<TParent>;
  createNotifSending?: MutationToCreateNotifSendingResolver<TParent>;
  createNotification?: MutationToCreateNotificationResolver<TParent>;
  createOrder?: MutationToCreateOrderResolver<TParent>;
  createPaymentPlan?: MutationToCreatePaymentPlanResolver<TParent>;
  createPhoneVerification?: MutationToCreatePhoneVerificationResolver<TParent>;
  createPollOption?: MutationToCreatePollOptionResolver<TParent>;
  createPost?: MutationToCreatePostResolver<TParent>;
  createPostTranslate?: MutationToCreatePostTranslateResolver<TParent>;
  createPromo?: MutationToCreatePromoResolver<TParent>;
  createPushNotificationLog?: MutationToCreatePushNotificationLogResolver<TParent>;
  createReferral?: MutationToCreateReferralResolver<TParent>;
  createReport?: MutationToCreateReportResolver<TParent>;
  createReview?: MutationToCreateReviewResolver<TParent>;
  createRole?: MutationToCreateRoleResolver<TParent>;
  createSession?: MutationToCreateSessionResolver<TParent>;
  createSubscr?: MutationToCreateSubscrResolver<TParent>;
  createSubscrPayment?: MutationToCreateSubscrPaymentResolver<TParent>;
  createTask?: MutationToCreateTaskResolver<TParent>;
  createTransaction?: MutationToCreateTransactionResolver<TParent>;
  createUser?: MutationToCreateUserResolver<TParent>;
  createUserReferral?: MutationToCreateUserReferralResolver<TParent>;
  deactivateUser?: MutationToDeactivateUserResolver<TParent>;
  deleteAdmin?: MutationToDeleteAdminResolver<TParent>;
  deleteAmenity?: MutationToDeleteAmenityResolver<TParent>;
  deleteAppFile?: MutationToDeleteAppFileResolver<TParent>;
  deleteCategory?: MutationToDeleteCategoryResolver<TParent>;
  deleteChat?: MutationToDeleteChatResolver<TParent>;
  deleteClass?: MutationToDeleteClassResolver<TParent>;
  deleteCommunity?: MutationToDeleteCommunityResolver<TParent>;
  deleteCommunityAdmin?: MutationToDeleteCommunityAdminResolver<TParent>;
  deleteCompany?: MutationToDeleteCompanyResolver<TParent>;
  deleteCurrency?: MutationToDeleteCurrencyResolver<TParent>;
  deleteDocument?: MutationToDeleteDocumentResolver<TParent>;
  deleteEvent?: MutationToDeleteEventResolver<TParent>;
  deleteGroup?: MutationToDeleteGroupResolver<TParent>;
  deleteHelpDesk?: MutationToDeleteHelpDeskResolver<TParent>;
  deleteInstallation?: MutationToDeleteInstallationResolver<TParent>;
  deleteInvitation?: MutationToDeleteInvitationResolver<TParent>;
  deleteItem?: MutationToDeleteItemResolver<TParent>;
  deleteItemBooking?: MutationToDeleteItemBookingResolver<TParent>;
  deleteJoinRequest?: MutationToDeleteJoinRequestResolver<TParent>;
  deleteLanguage?: MutationToDeleteLanguageResolver<TParent>;
  deleteLocation?: MutationToDeleteLocationResolver<TParent>;
  deleteMessage?: MutationToDeleteMessageResolver<TParent>;
  deleteMyClass?: MutationToDeleteMyClassResolver<TParent>;
  deleteNotifSending?: MutationToDeleteNotifSendingResolver<TParent>;
  deleteNotification?: MutationToDeleteNotificationResolver<TParent>;
  deleteOrder?: MutationToDeleteOrderResolver<TParent>;
  deletePaymentPlan?: MutationToDeletePaymentPlanResolver<TParent>;
  deletePhoneVerification?: MutationToDeletePhoneVerificationResolver<TParent>;
  deletePollOption?: MutationToDeletePollOptionResolver<TParent>;
  deletePost?: MutationToDeletePostResolver<TParent>;
  deletePostTranslate?: MutationToDeletePostTranslateResolver<TParent>;
  deletePromo?: MutationToDeletePromoResolver<TParent>;
  deletePushNotificationLog?: MutationToDeletePushNotificationLogResolver<TParent>;
  deleteReferral?: MutationToDeleteReferralResolver<TParent>;
  deleteReport?: MutationToDeleteReportResolver<TParent>;
  deleteReview?: MutationToDeleteReviewResolver<TParent>;
  deleteRole?: MutationToDeleteRoleResolver<TParent>;
  deleteSession?: MutationToDeleteSessionResolver<TParent>;
  deleteSubscr?: MutationToDeleteSubscrResolver<TParent>;
  deleteSubscrPayment?: MutationToDeleteSubscrPaymentResolver<TParent>;
  deleteTask?: MutationToDeleteTaskResolver<TParent>;
  deleteTransaction?: MutationToDeleteTransactionResolver<TParent>;
  deleteUser?: MutationToDeleteUserResolver<TParent>;
  directAddMember?: MutationToDirectAddMemberResolver<TParent>;
  eventManageButtons?: MutationToEventManageButtonsResolver<TParent>;
  generateAiOpenApiText?: MutationToGenerateAiOpenApiTextResolver<TParent>;
  generateUsername?: MutationToGenerateUsernameResolver<TParent>;
  getAccountBalance?: MutationToGetAccountBalanceResolver<TParent>;
  getEventItem?: MutationToGetEventItemResolver<TParent>;
  getItemArrays?: MutationToGetItemArraysResolver<TParent>;
  getManagersList?: MutationToGetManagersListResolver<TParent>;
  getNewPassword?: MutationToGetNewPasswordResolver<TParent>;
  getPaymentPlatformDashboardLink?: MutationToGetPaymentPlatformDashboardLinkResolver<TParent>;
  getResidentsAvatar?: MutationToGetResidentsAvatarResolver<TParent>;
  getSeoOrderItemData?: MutationToGetSeoOrderItemDataResolver<TParent>;
  getUserByReferral?: MutationToGetUserByReferralResolver<TParent>;
  getUserInsightsData?: MutationToGetUserInsightsDataResolver<TParent>;
  getUserPermissionsList?: MutationToGetUserPermissionsListResolver<TParent>;
  groupManageButtons?: MutationToGroupManageButtonsResolver<TParent>;
  helpDeskListOrder?: MutationToHelpDeskListOrderResolver<TParent>;
  hidePost?: MutationToHidePostResolver<TParent>;
  itemManagerButtons?: MutationToItemManagerButtonsResolver<TParent>;
  itemResidentButtons?: MutationToItemResidentButtonsResolver<TParent>;
  joinGroup?: MutationToJoinGroupResolver<TParent>;
  leaveCommunity?: MutationToLeaveCommunityResolver<TParent>;
  leaveGroup?: MutationToLeaveGroupResolver<TParent>;
  likeHandler?: MutationToLikeHandlerResolver<TParent>;
  likeHandlerEvent?: MutationToLikeHandlerEventResolver<TParent>;
  likeHandlerListing?: MutationToLikeHandlerListingResolver<TParent>;
  linkWithSocial?: MutationToLinkWithSocialResolver<TParent>;
  logIn?: MutationToLogInResolver<TParent>;
  logInWith?: MutationToLogInWithResolver<TParent>;
  logOut?: MutationToLogOutResolver<TParent>;
  makeOrder?: MutationToMakeOrderResolver<TParent>;
  manageOrder?: MutationToManageOrderResolver<TParent>;
  managerDashboard?: MutationToManagerDashboardResolver<TParent>;
  managerDashboardChart?: MutationToManagerDashboardChartResolver<TParent>;
  managerRemoveResident?: MutationToManagerRemoveResidentResolver<TParent>;
  messageSetSeen?: MutationToMessageSetSeenResolver<TParent>;
  newViewer?: MutationToNewViewerResolver<TParent>;
  notifyManager?: MutationToNotifyManagerResolver<TParent>;
  paySubscription?: MutationToPaySubscriptionResolver<TParent>;
  paymentAddCard?: MutationToPaymentAddCardResolver<TParent>;
  paymentCalculateItemOrder?: MutationToPaymentCalculateItemOrderResolver<TParent>;
  paymentDeleteCard?: MutationToPaymentDeleteCardResolver<TParent>;
  paymentGetUserCards?: MutationToPaymentGetUserCardsResolver<TParent>;
  paymentItemOrder?: MutationToPaymentItemOrderResolver<TParent>;
  paymentSetDefaultCard?: MutationToPaymentSetDefaultCardResolver<TParent>;
  pinUnpinPost?: MutationToPinUnpinPostResolver<TParent>;
  preOrderCalcData?: MutationToPreOrderCalcDataResolver<TParent>;
  reactionHandler?: MutationToReactionHandlerResolver<TParent>;
  registerPushNotification?: MutationToRegisterPushNotificationResolver<TParent>;
  removeUser?: MutationToRemoveUserResolver<TParent>;
  removeVoteInPoll?: MutationToRemoveVoteInPollResolver<TParent>;
  resetPassword?: MutationToResetPasswordResolver<TParent>;
  residentDashboard?: MutationToResidentDashboardResolver<TParent>;
  rmUserPushNotification?: MutationToRmUserPushNotificationResolver<TParent>;
  sendResidentInvitations?: MutationToSendResidentInvitationsResolver<TParent>;
  sendVerificationEmail?: MutationToSendVerificationEmailResolver<TParent>;
  setDevicePush?: MutationToSetDevicePushResolver<TParent>;
  setDocumentStatus?: MutationToSetDocumentStatusResolver<TParent>;
  setOffline?: MutationToSetOfflineResolver<TParent>;
  setOnline?: MutationToSetOnlineResolver<TParent>;
  signUp?: MutationToSignUpResolver<TParent>;
  unlinkWithSocial?: MutationToUnlinkWithSocialResolver<TParent>;
  updateAdmin?: MutationToUpdateAdminResolver<TParent>;
  updateAmenity?: MutationToUpdateAmenityResolver<TParent>;
  updateAppFile?: MutationToUpdateAppFileResolver<TParent>;
  updateCategory?: MutationToUpdateCategoryResolver<TParent>;
  updateChat?: MutationToUpdateChatResolver<TParent>;
  updateClass?: MutationToUpdateClassResolver<TParent>;
  updateCommunity?: MutationToUpdateCommunityResolver<TParent>;
  updateCommunityAdmin?: MutationToUpdateCommunityAdminResolver<TParent>;
  updateCompany?: MutationToUpdateCompanyResolver<TParent>;
  updateCurrency?: MutationToUpdateCurrencyResolver<TParent>;
  updateDocument?: MutationToUpdateDocumentResolver<TParent>;
  updateEvent?: MutationToUpdateEventResolver<TParent>;
  updateGroup?: MutationToUpdateGroupResolver<TParent>;
  updateHelpDesk?: MutationToUpdateHelpDeskResolver<TParent>;
  updateInstallation?: MutationToUpdateInstallationResolver<TParent>;
  updateInvitation?: MutationToUpdateInvitationResolver<TParent>;
  updateItem?: MutationToUpdateItemResolver<TParent>;
  updateItemBooking?: MutationToUpdateItemBookingResolver<TParent>;
  updateJoinRequest?: MutationToUpdateJoinRequestResolver<TParent>;
  updateLanguage?: MutationToUpdateLanguageResolver<TParent>;
  updateLocation?: MutationToUpdateLocationResolver<TParent>;
  updateMessage?: MutationToUpdateMessageResolver<TParent>;
  updateMyClass?: MutationToUpdateMyClassResolver<TParent>;
  updateNotifSending?: MutationToUpdateNotifSendingResolver<TParent>;
  updateNotification?: MutationToUpdateNotificationResolver<TParent>;
  updateOrder?: MutationToUpdateOrderResolver<TParent>;
  updatePaymentPlan?: MutationToUpdatePaymentPlanResolver<TParent>;
  updatePhoneVerification?: MutationToUpdatePhoneVerificationResolver<TParent>;
  updatePollOption?: MutationToUpdatePollOptionResolver<TParent>;
  updatePost?: MutationToUpdatePostResolver<TParent>;
  updatePostTranslate?: MutationToUpdatePostTranslateResolver<TParent>;
  updatePromo?: MutationToUpdatePromoResolver<TParent>;
  updatePushNotification?: MutationToUpdatePushNotificationResolver<TParent>;
  updatePushNotificationLog?: MutationToUpdatePushNotificationLogResolver<TParent>;
  updateReferral?: MutationToUpdateReferralResolver<TParent>;
  updateReport?: MutationToUpdateReportResolver<TParent>;
  updateReview?: MutationToUpdateReviewResolver<TParent>;
  updateRole?: MutationToUpdateRoleResolver<TParent>;
  updateSession?: MutationToUpdateSessionResolver<TParent>;
  updateSubscr?: MutationToUpdateSubscrResolver<TParent>;
  updateSubscrPayment?: MutationToUpdateSubscrPaymentResolver<TParent>;
  updateTask?: MutationToUpdateTaskResolver<TParent>;
  updateTransaction?: MutationToUpdateTransactionResolver<TParent>;
  updateUser?: MutationToUpdateUserResolver<TParent>;
  verifyCode?: MutationToVerifyCodeResolver<TParent>;
  verifyEmail?: MutationToVerifyEmailResolver<TParent>;
  verifyPhone?: MutationToVerifyPhoneResolver<TParent>;
  voteInPoll?: MutationToVoteInPollResolver<TParent>;
  waveHandlerUser?: MutationToWaveHandlerUserResolver<TParent>;
}

export interface MutationToAccountTransferArgs {
  input: GQLAccountTransferInp;
}
export interface MutationToAccountTransferResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAccountTransferArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminCreateArgs {
  input: GQLAdminCreateInp;
}
export interface MutationToAdminCreateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminCreateArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminCreateUserArgs {
  input: GQLAdminCreateUserInput;
}
export interface MutationToAdminCreateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminCreateUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminDashboardArgs {
  input: GQLAdminDashboardInput;
}
export interface MutationToAdminDashboardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminDashboardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminDashboardChartArgs {
  input: GQLAdminDashboardChartInp;
}
export interface MutationToAdminDashboardChartResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminDashboardChartArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminDeleteUserArgs {
  input: GQLAdminDeleteUserInput;
}
export interface MutationToAdminDeleteUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminDeleteUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminEditArgs {
  input: GQLAdminEditInp;
}
export interface MutationToAdminEditResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminEditArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminLoginArgs {
  input: GQLLogInInput;
}
export interface MutationToAdminLoginResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminLoginArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminRemoveArgs {
  input: GQLAdminRemoveInp;
}
export interface MutationToAdminRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminRemoveArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminUpdateUserArgs {
  input: GQLAdminUpdateUserInput;
}
export interface MutationToAdminUpdateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminUpdateUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAmenityManageButtonsArgs {
  input: GQLAmenityManageButtonsInp;
}
export interface MutationToAmenityManageButtonsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAmenityManageButtonsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToArchiveNotificationsArgs {
  input: GQLArchiveNotificationsInp;
}
export interface MutationToArchiveNotificationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToArchiveNotificationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToBadgeClearArgs {
  input: GQLbadgeClearInp;
}
export interface MutationToBadgeClearResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToBadgeClearArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToBookAmenityArgs {
  input: GQLBookAmenityInp;
}
export interface MutationToBookAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToBookAmenityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToBookEventArgs {
  input: GQLBookEventInp;
}
export interface MutationToBookEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToBookEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCalcOrderDataArgs {
  input?: GQLCalcOrderDataInp;
}
export interface MutationToCalcOrderDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCalcOrderDataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCallCloudCodeArgs {
  input: GQLCallCloudCodeInput;
}
export interface MutationToCallCloudCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCallCloudCodeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToChangePasswordArgs {
  input: GQLChangePasswordInput;
}
export interface MutationToChangePasswordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToChangePasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToChangeSubscriptionPlanArgs {
  input: GQLChangeSubscrPlanInp;
}
export interface MutationToChangeSubscriptionPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToChangeSubscriptionPlanArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCheckCommExternalPaymentsArgs {
  input: GQLCommExternalPaymentsInp;
}
export interface MutationToCheckCommExternalPaymentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCheckCommExternalPaymentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCommunityAdminCreateArgs {
  input: GQLCommunityAdminInp;
}
export interface MutationToCommunityAdminCreateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCommunityAdminCreateArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCommunityAdminEditArgs {
  input: GQLCommunityAdminInp;
}
export interface MutationToCommunityAdminEditResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCommunityAdminEditArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCommunityAdminRemoveArgs {
  input: GQLCommunityAdminInp;
}
export interface MutationToCommunityAdminRemoveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCommunityAdminRemoveArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCompanyManageButtonsArgs {
  input: GQLCompanyManageButtonsInp;
}
export interface MutationToCompanyManageButtonsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCompanyManageButtonsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToConfirmUserRemovalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToConnectStripeAccountArgs {
  input?: GQLConnectStripeAccountInp;
}
export interface MutationToConnectStripeAccountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToConnectStripeAccountArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCountTotalClicksArgs {
  input: GQLCountTotalClicksInp;
}
export interface MutationToCountTotalClicksResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCountTotalClicksArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateAdminArgs {
  input: GQLCreateAdminInput;
}
export interface MutationToCreateAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateAdminArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateAmenityArgs {
  input: GQLCreateAmenityInput;
}
export interface MutationToCreateAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateAmenityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateAppFileArgs {
  input: GQLCreateAppFileInput;
}
export interface MutationToCreateAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateAppFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCategoryArgs {
  input: GQLCreateCategoryInput;
}
export interface MutationToCreateCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCategoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateChatArgs {
  input: GQLCreateChatInput;
}
export interface MutationToCreateChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateChatArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateClassArgs {
  input: GQLCreateClassInput;
}
export interface MutationToCreateClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommunityArgs {
  input: GQLCreateCommunityInput;
}
export interface MutationToCreateCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCommunityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommunityAdminArgs {
  input: GQLCreateCommunityAdminInput;
}
export interface MutationToCreateCommunityAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCommunityAdminArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCommunityForNewUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCompanyArgs {
  input: GQLCreateCompanyInput;
}
export interface MutationToCreateCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCompanyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCompanyReportArgs {
  input: GQLCreateCompanyReportInp;
}
export interface MutationToCreateCompanyReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCompanyReportArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateCurrencyArgs {
  input: GQLCreateCurrencyInput;
}
export interface MutationToCreateCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateCurrencyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateDocumentArgs {
  input: GQLCreateDocumentInput;
}
export interface MutationToCreateDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateEventArgs {
  input: GQLCreateEventInput;
}
export interface MutationToCreateEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateFileArgs {
  input: GQLCreateFileInput;
}
export interface MutationToCreateFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateGroupArgs {
  input: GQLCreateGroupInput;
}
export interface MutationToCreateGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateGroupArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateHelpDeskArgs {
  input: GQLCreateHelpDeskInput;
}
export interface MutationToCreateHelpDeskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateHelpDeskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateInstallationArgs {
  input: GQLCreateInstallationInput;
}
export interface MutationToCreateInstallationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateInstallationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateInvitationArgs {
  input: GQLCreateInvitationInput;
}
export interface MutationToCreateInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateItemArgs {
  input: GQLCreateItemInput;
}
export interface MutationToCreateItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateItemArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateItemBookingArgs {
  input: GQLCreateItemBookingInput;
}
export interface MutationToCreateItemBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateItemBookingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateJoinRequestArgs {
  input: GQLCreateJoinRequestInput;
}
export interface MutationToCreateJoinRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateJoinRequestArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateLanguageArgs {
  input: GQLCreateLanguageInput;
}
export interface MutationToCreateLanguageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateLanguageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateLocationArgs {
  input: GQLCreateLocationInput;
}
export interface MutationToCreateLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateLocationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateMessageArgs {
  input: GQLCreateMessageInput;
}
export interface MutationToCreateMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateMultiplyItemsArgs {
  input: GQLCreateMultiplyItemsInput;
}
export interface MutationToCreateMultiplyItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateMultiplyItemsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateMyClassArgs {
  input: GQLCreateMyClassInput;
}
export interface MutationToCreateMyClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateMyClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateNotifSendingArgs {
  input: GQLCreateNotifSendingInput;
}
export interface MutationToCreateNotifSendingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateNotifSendingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateNotificationArgs {
  input: GQLCreateNotificationInput;
}
export interface MutationToCreateNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateNotificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateOrderArgs {
  input: GQLCreateOrderInput;
}
export interface MutationToCreateOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreatePaymentPlanArgs {
  input: GQLCreatePaymentPlanInput;
}
export interface MutationToCreatePaymentPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreatePaymentPlanArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreatePhoneVerificationArgs {
  input: GQLCreatePhoneVerificationInput;
}
export interface MutationToCreatePhoneVerificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreatePhoneVerificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreatePollOptionArgs {
  input: GQLCreatePollOptionInput;
}
export interface MutationToCreatePollOptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreatePollOptionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreatePostArgs {
  input: GQLCreatePostInput;
}
export interface MutationToCreatePostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreatePostArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreatePostTranslateArgs {
  input: GQLCreatePostTranslateInput;
}
export interface MutationToCreatePostTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreatePostTranslateArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreatePromoArgs {
  input: GQLCreatePromoInput;
}
export interface MutationToCreatePromoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreatePromoArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreatePushNotificationLogArgs {
  input: GQLCreatePushNotificationLogInput;
}
export interface MutationToCreatePushNotificationLogResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreatePushNotificationLogArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateReferralArgs {
  input: GQLCreateReferralInput;
}
export interface MutationToCreateReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateReferralArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateReportArgs {
  input: GQLCreateReportInput;
}
export interface MutationToCreateReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateReportArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateReviewArgs {
  input: GQLCreateReviewInput;
}
export interface MutationToCreateReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateReviewArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateRoleArgs {
  input: GQLCreateRoleInput;
}
export interface MutationToCreateRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateSessionArgs {
  input: GQLCreateSessionInput;
}
export interface MutationToCreateSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateSessionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateSubscrArgs {
  input: GQLCreateSubscrInput;
}
export interface MutationToCreateSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateSubscrArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateSubscrPaymentArgs {
  input: GQLCreateSubscrPaymentInput;
}
export interface MutationToCreateSubscrPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateSubscrPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateTaskArgs {
  input: GQLCreateTaskInput;
}
export interface MutationToCreateTaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateTaskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateTransactionArgs {
  input: GQLCreateTransactionInput;
}
export interface MutationToCreateTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateTransactionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateUserArgs {
  input: GQLCreateUserInput;
}
export interface MutationToCreateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateUserReferralArgs {
  input: GQLCreateUserReferralInput;
}
export interface MutationToCreateUserReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateUserReferralArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeactivateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteAdminArgs {
  input: GQLDeleteAdminInput;
}
export interface MutationToDeleteAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteAdminArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteAmenityArgs {
  input: GQLDeleteAmenityInput;
}
export interface MutationToDeleteAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteAmenityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteAppFileArgs {
  input: GQLDeleteAppFileInput;
}
export interface MutationToDeleteAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteAppFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteCategoryArgs {
  input: GQLDeleteCategoryInput;
}
export interface MutationToDeleteCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteCategoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteChatArgs {
  input: GQLDeleteChatInput;
}
export interface MutationToDeleteChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteChatArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteClassArgs {
  input: GQLDeleteClassInput;
}
export interface MutationToDeleteClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteCommunityArgs {
  input: GQLDeleteCommunityInput;
}
export interface MutationToDeleteCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteCommunityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteCommunityAdminArgs {
  input: GQLDeleteCommunityAdminInput;
}
export interface MutationToDeleteCommunityAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteCommunityAdminArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteCompanyArgs {
  input: GQLDeleteCompanyInput;
}
export interface MutationToDeleteCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteCompanyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteCurrencyArgs {
  input: GQLDeleteCurrencyInput;
}
export interface MutationToDeleteCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteCurrencyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteDocumentArgs {
  input: GQLDeleteDocumentInput;
}
export interface MutationToDeleteDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteEventArgs {
  input: GQLDeleteEventInput;
}
export interface MutationToDeleteEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteGroupArgs {
  input: GQLDeleteGroupInput;
}
export interface MutationToDeleteGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteGroupArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteHelpDeskArgs {
  input: GQLDeleteHelpDeskInput;
}
export interface MutationToDeleteHelpDeskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteHelpDeskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteInstallationArgs {
  input: GQLDeleteInstallationInput;
}
export interface MutationToDeleteInstallationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteInstallationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteInvitationArgs {
  input: GQLDeleteInvitationInput;
}
export interface MutationToDeleteInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteItemArgs {
  input: GQLDeleteItemInput;
}
export interface MutationToDeleteItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteItemArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteItemBookingArgs {
  input: GQLDeleteItemBookingInput;
}
export interface MutationToDeleteItemBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteItemBookingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteJoinRequestArgs {
  input: GQLDeleteJoinRequestInput;
}
export interface MutationToDeleteJoinRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteJoinRequestArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteLanguageArgs {
  input: GQLDeleteLanguageInput;
}
export interface MutationToDeleteLanguageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteLanguageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteLocationArgs {
  input: GQLDeleteLocationInput;
}
export interface MutationToDeleteLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteLocationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteMessageArgs {
  input: GQLDeleteMessageInput;
}
export interface MutationToDeleteMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteMyClassArgs {
  input: GQLDeleteMyClassInput;
}
export interface MutationToDeleteMyClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteMyClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteNotifSendingArgs {
  input: GQLDeleteNotifSendingInput;
}
export interface MutationToDeleteNotifSendingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteNotifSendingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteNotificationArgs {
  input: GQLDeleteNotificationInput;
}
export interface MutationToDeleteNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteNotificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteOrderArgs {
  input: GQLDeleteOrderInput;
}
export interface MutationToDeleteOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeletePaymentPlanArgs {
  input: GQLDeletePaymentPlanInput;
}
export interface MutationToDeletePaymentPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeletePaymentPlanArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeletePhoneVerificationArgs {
  input: GQLDeletePhoneVerificationInput;
}
export interface MutationToDeletePhoneVerificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeletePhoneVerificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeletePollOptionArgs {
  input: GQLDeletePollOptionInput;
}
export interface MutationToDeletePollOptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeletePollOptionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeletePostArgs {
  input: GQLDeletePostInput;
}
export interface MutationToDeletePostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeletePostArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeletePostTranslateArgs {
  input: GQLDeletePostTranslateInput;
}
export interface MutationToDeletePostTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeletePostTranslateArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeletePromoArgs {
  input: GQLDeletePromoInput;
}
export interface MutationToDeletePromoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeletePromoArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeletePushNotificationLogArgs {
  input: GQLDeletePushNotificationLogInput;
}
export interface MutationToDeletePushNotificationLogResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeletePushNotificationLogArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteReferralArgs {
  input: GQLDeleteReferralInput;
}
export interface MutationToDeleteReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteReferralArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteReportArgs {
  input: GQLDeleteReportInput;
}
export interface MutationToDeleteReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteReportArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteReviewArgs {
  input: GQLDeleteReviewInput;
}
export interface MutationToDeleteReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteReviewArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteRoleArgs {
  input: GQLDeleteRoleInput;
}
export interface MutationToDeleteRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteSessionArgs {
  input: GQLDeleteSessionInput;
}
export interface MutationToDeleteSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteSessionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteSubscrArgs {
  input: GQLDeleteSubscrInput;
}
export interface MutationToDeleteSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteSubscrArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteSubscrPaymentArgs {
  input: GQLDeleteSubscrPaymentInput;
}
export interface MutationToDeleteSubscrPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteSubscrPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteTaskArgs {
  input: GQLDeleteTaskInput;
}
export interface MutationToDeleteTaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteTaskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteTransactionArgs {
  input: GQLDeleteTransactionInput;
}
export interface MutationToDeleteTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteTransactionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteUserArgs {
  input: GQLDeleteUserInput;
}
export interface MutationToDeleteUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDirectAddMemberArgs {
  input: GQLDirectAddMemberInp;
}
export interface MutationToDirectAddMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDirectAddMemberArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToEventManageButtonsArgs {
  input: GQLEventManageButtonsInp;
}
export interface MutationToEventManageButtonsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToEventManageButtonsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGenerateAiOpenApiTextArgs {
  input: GQLGenerateAiOpenApiTextInput;
}
export interface MutationToGenerateAiOpenApiTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGenerateAiOpenApiTextArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGenerateUsernameArgs {
  input: GQLGenerateUsernameInp;
}
export interface MutationToGenerateUsernameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGenerateUsernameArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetAccountBalanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetEventItemArgs {
  input?: GQLgetEventInp;
}
export interface MutationToGetEventItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetEventItemArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetItemArraysArgs {
  input: GQLGetItemArraysInput;
}
export interface MutationToGetItemArraysResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetItemArraysArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetManagersListArgs {
  input: GQLGetManagersListInp;
}
export interface MutationToGetManagersListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetManagersListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetNewPasswordArgs {
  input: GQLGetNewPasswordInp;
}
export interface MutationToGetNewPasswordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetNewPasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetPaymentPlatformDashboardLinkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetResidentsAvatarArgs {
  input: GQLGetResidentsAvatarInput;
}
export interface MutationToGetResidentsAvatarResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetResidentsAvatarArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetSeoOrderItemDataArgs {
  input?: GQLgetSeoOrderItemDataInp;
}
export interface MutationToGetSeoOrderItemDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetSeoOrderItemDataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetUserByReferralArgs {
  input: GQLGetUserByReferralInput;
}
export interface MutationToGetUserByReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetUserByReferralArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetUserInsightsDataArgs {
  input: GQLSupportInsightInp;
}
export interface MutationToGetUserInsightsDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetUserInsightsDataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetUserPermissionsListArgs {
  input: GQLGetUserPermissionsListInp;
}
export interface MutationToGetUserPermissionsListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetUserPermissionsListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGroupManageButtonsArgs {
  input: GQLGroupManageButtonsInpInp;
}
export interface MutationToGroupManageButtonsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGroupManageButtonsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToHelpDeskListOrderArgs {
  input: GQLHelpDeskListOrderInp;
}
export interface MutationToHelpDeskListOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToHelpDeskListOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToHidePostArgs {
  input: GQLHidePostInput;
}
export interface MutationToHidePostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToHidePostArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToItemManagerButtonsArgs {
  input?: GQLButtonsManagerInp;
}
export interface MutationToItemManagerButtonsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToItemManagerButtonsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToItemResidentButtonsArgs {
  input: GQLButtonsResidentInp;
}
export interface MutationToItemResidentButtonsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToItemResidentButtonsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToJoinGroupArgs {
  input: GQLGroupInp;
}
export interface MutationToJoinGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToJoinGroupArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLeaveCommunityArgs {
  input: GQLLeaveCommunityInp;
}
export interface MutationToLeaveCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLeaveCommunityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLeaveGroupArgs {
  input: GQLGroupInp;
}
export interface MutationToLeaveGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLeaveGroupArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLikeHandlerArgs {
  input?: GQLLikePostInp;
}
export interface MutationToLikeHandlerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLikeHandlerArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLikeHandlerEventArgs {
  input?: GQLLikeEventInp;
}
export interface MutationToLikeHandlerEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLikeHandlerEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLikeHandlerListingArgs {
  input?: GQLLikeListingInp;
}
export interface MutationToLikeHandlerListingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLikeHandlerListingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLinkWithSocialArgs {
  input: GQLLinkWithSocialInput;
}
export interface MutationToLinkWithSocialResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLinkWithSocialArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLogInArgs {
  input: GQLLogInInput;
}
export interface MutationToLogInResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLogInArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLogInWithArgs {
  input: GQLLogInWithInput;
}
export interface MutationToLogInWithResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLogInWithArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLogOutArgs {
  input: GQLLogOutInput;
}
export interface MutationToLogOutResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLogOutArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMakeOrderArgs {
  input?: GQLMakeOrderInp;
}
export interface MutationToMakeOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToMakeOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToManageOrderArgs {
  input?: GQLManageOrderInp;
}
export interface MutationToManageOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToManageOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToManagerDashboardArgs {
  input: GQLManagerDashboardInp;
}
export interface MutationToManagerDashboardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToManagerDashboardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToManagerDashboardChartArgs {
  input: GQLManagerDashboardChartInp;
}
export interface MutationToManagerDashboardChartResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToManagerDashboardChartArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToManagerRemoveResidentArgs {
  input: GQLManagerRemoveResInp;
}
export interface MutationToManagerRemoveResidentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToManagerRemoveResidentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToMessageSetSeenArgs {
  input: GQLSetSeenInp;
}
export interface MutationToMessageSetSeenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToMessageSetSeenArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToNewViewerArgs {
  input?: GQLViewObjectInp;
}
export interface MutationToNewViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToNewViewerArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToNotifyManagerArgs {
  input: GQLNotifyManagerInp;
}
export interface MutationToNotifyManagerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToNotifyManagerArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaySubscriptionArgs {
  input: GQLPaySubscrInp;
}
export interface MutationToPaySubscriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaySubscriptionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentAddCardArgs {
  input: GQLAddCardToUserInp;
}
export interface MutationToPaymentAddCardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentAddCardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentCalculateItemOrderArgs {
  input: GQLItemOrderInp;
}
export interface MutationToPaymentCalculateItemOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentCalculateItemOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentDeleteCardArgs {
  input: GQLCardIdInp;
}
export interface MutationToPaymentDeleteCardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentDeleteCardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentGetUserCardsArgs {
  input: GQLGetUserCardsInp;
}
export interface MutationToPaymentGetUserCardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentGetUserCardsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentItemOrderArgs {
  input: GQLItemOrderInp;
}
export interface MutationToPaymentItemOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentItemOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentSetDefaultCardArgs {
  input: GQLCardIdInp;
}
export interface MutationToPaymentSetDefaultCardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentSetDefaultCardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPinUnpinPostArgs {
  input: GQLPinUnpinPostInp;
}
export interface MutationToPinUnpinPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPinUnpinPostArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPreOrderCalcDataArgs {
  input: GQLMakeOrderInp;
}
export interface MutationToPreOrderCalcDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPreOrderCalcDataArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToReactionHandlerArgs {
  input?: GQLReactionHandlerInp;
}
export interface MutationToReactionHandlerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToReactionHandlerArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRegisterPushNotificationArgs {
  input: GQLRegisterPushNotificationInp;
}
export interface MutationToRegisterPushNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRegisterPushNotificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveUserArgs {
  input: GQLRemoveUserInput;
}
export interface MutationToRemoveUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRemoveVoteInPollArgs {
  input: GQLVoteInPollInp;
}
export interface MutationToRemoveVoteInPollResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRemoveVoteInPollArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToResetPasswordArgs {
  input: GQLResetPasswordInput;
}
export interface MutationToResetPasswordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToResetPasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToResidentDashboardArgs {
  input: GQLResidentDashboardInp;
}
export interface MutationToResidentDashboardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToResidentDashboardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRmUserPushNotificationArgs {
  input: GQLRmUserPushNotificationInp;
}
export interface MutationToRmUserPushNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRmUserPushNotificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSendResidentInvitationsArgs {
  input: GQLSendResidentInvitationsInp;
}
export interface MutationToSendResidentInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSendResidentInvitationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSendVerificationEmailArgs {
  input: GQLSendVerificationEmailInput;
}
export interface MutationToSendVerificationEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSendVerificationEmailArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetDevicePushArgs {
  input: GQLSetDevicePushInput;
}
export interface MutationToSetDevicePushResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetDevicePushArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetDocumentStatusArgs {
  input: GQLDocumentStatusInp;
}
export interface MutationToSetDocumentStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSetDocumentStatusArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetOfflineResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSetOnlineResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSignUpArgs {
  input: GQLSignUpInput;
}
export interface MutationToSignUpResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSignUpArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUnlinkWithSocialArgs {
  input: GQLUnlinkWithSocialInput;
}
export interface MutationToUnlinkWithSocialResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUnlinkWithSocialArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateAdminArgs {
  input: GQLUpdateAdminInput;
}
export interface MutationToUpdateAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateAdminArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateAmenityArgs {
  input: GQLUpdateAmenityInput;
}
export interface MutationToUpdateAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateAmenityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateAppFileArgs {
  input: GQLUpdateAppFileInput;
}
export interface MutationToUpdateAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateAppFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateCategoryArgs {
  input: GQLUpdateCategoryInput;
}
export interface MutationToUpdateCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateCategoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateChatArgs {
  input: GQLUpdateChatInput;
}
export interface MutationToUpdateChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateChatArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateClassArgs {
  input: GQLUpdateClassInput;
}
export interface MutationToUpdateClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateCommunityArgs {
  input: GQLUpdateCommunityInput;
}
export interface MutationToUpdateCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateCommunityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateCommunityAdminArgs {
  input: GQLUpdateCommunityAdminInput;
}
export interface MutationToUpdateCommunityAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateCommunityAdminArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateCompanyArgs {
  input: GQLUpdateCompanyInput;
}
export interface MutationToUpdateCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateCompanyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateCurrencyArgs {
  input: GQLUpdateCurrencyInput;
}
export interface MutationToUpdateCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateCurrencyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateDocumentArgs {
  input: GQLUpdateDocumentInput;
}
export interface MutationToUpdateDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateEventArgs {
  input: GQLUpdateEventInput;
}
export interface MutationToUpdateEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateGroupArgs {
  input: GQLUpdateGroupInput;
}
export interface MutationToUpdateGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateGroupArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateHelpDeskArgs {
  input: GQLUpdateHelpDeskInput;
}
export interface MutationToUpdateHelpDeskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateHelpDeskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateInstallationArgs {
  input: GQLUpdateInstallationInput;
}
export interface MutationToUpdateInstallationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateInstallationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateInvitationArgs {
  input: GQLUpdateInvitationInput;
}
export interface MutationToUpdateInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateItemArgs {
  input: GQLUpdateItemInput;
}
export interface MutationToUpdateItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateItemArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateItemBookingArgs {
  input: GQLUpdateItemBookingInput;
}
export interface MutationToUpdateItemBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateItemBookingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateJoinRequestArgs {
  input: GQLUpdateJoinRequestInput;
}
export interface MutationToUpdateJoinRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateJoinRequestArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateLanguageArgs {
  input: GQLUpdateLanguageInput;
}
export interface MutationToUpdateLanguageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateLanguageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateLocationArgs {
  input: GQLUpdateLocationInput;
}
export interface MutationToUpdateLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateLocationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateMessageArgs {
  input: GQLUpdateMessageInput;
}
export interface MutationToUpdateMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateMyClassArgs {
  input: GQLUpdateMyClassInput;
}
export interface MutationToUpdateMyClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateMyClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateNotifSendingArgs {
  input: GQLUpdateNotifSendingInput;
}
export interface MutationToUpdateNotifSendingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateNotifSendingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateNotificationArgs {
  input: GQLUpdateNotificationInput;
}
export interface MutationToUpdateNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateNotificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateOrderArgs {
  input: GQLUpdateOrderInput;
}
export interface MutationToUpdateOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePaymentPlanArgs {
  input: GQLUpdatePaymentPlanInput;
}
export interface MutationToUpdatePaymentPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePaymentPlanArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePhoneVerificationArgs {
  input: GQLUpdatePhoneVerificationInput;
}
export interface MutationToUpdatePhoneVerificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePhoneVerificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePollOptionArgs {
  input: GQLUpdatePollOptionInput;
}
export interface MutationToUpdatePollOptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePollOptionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePostArgs {
  input: GQLUpdatePostInput;
}
export interface MutationToUpdatePostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePostArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePostTranslateArgs {
  input: GQLUpdatePostTranslateInput;
}
export interface MutationToUpdatePostTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePostTranslateArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePromoArgs {
  input: GQLUpdatePromoInput;
}
export interface MutationToUpdatePromoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePromoArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePushNotificationArgs {
  input: GQLUpdatePushNotificationInp;
}
export interface MutationToUpdatePushNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePushNotificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdatePushNotificationLogArgs {
  input: GQLUpdatePushNotificationLogInput;
}
export interface MutationToUpdatePushNotificationLogResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdatePushNotificationLogArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateReferralArgs {
  input: GQLUpdateReferralInput;
}
export interface MutationToUpdateReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateReferralArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateReportArgs {
  input: GQLUpdateReportInput;
}
export interface MutationToUpdateReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateReportArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateReviewArgs {
  input: GQLUpdateReviewInput;
}
export interface MutationToUpdateReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateReviewArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateRoleArgs {
  input: GQLUpdateRoleInput;
}
export interface MutationToUpdateRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateSessionArgs {
  input: GQLUpdateSessionInput;
}
export interface MutationToUpdateSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateSessionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateSubscrArgs {
  input: GQLUpdateSubscrInput;
}
export interface MutationToUpdateSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateSubscrArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateSubscrPaymentArgs {
  input: GQLUpdateSubscrPaymentInput;
}
export interface MutationToUpdateSubscrPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateSubscrPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateTaskArgs {
  input: GQLUpdateTaskInput;
}
export interface MutationToUpdateTaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateTaskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateTransactionArgs {
  input: GQLUpdateTransactionInput;
}
export interface MutationToUpdateTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateTransactionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUserArgs {
  input: GQLUpdateUserInput;
}
export interface MutationToUpdateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToVerifyCodeArgs {
  input?: GQLVerifyCodeInp;
}
export interface MutationToVerifyCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToVerifyCodeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToVerifyEmailArgs {
  input: GQLVerifyEmailInput;
}
export interface MutationToVerifyEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToVerifyEmailArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToVerifyPhoneArgs {
  input?: GQLVerifyPhoneInp;
}
export interface MutationToVerifyPhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToVerifyPhoneArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToVoteInPollArgs {
  input: GQLVoteInPollInp;
}
export interface MutationToVoteInPollResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToVoteInPollArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToWaveHandlerUserArgs {
  input?: GQLWaveUserInp;
}
export interface MutationToWaveHandlerUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToWaveHandlerUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMyClassTypeResolver<TParent = any> {
  ACL?: MyClassToACLResolver<TParent>;
  createdAt?: MyClassToCreatedAtResolver<TParent>;
  id?: MyClassToIdResolver<TParent>;
  myField?: MyClassToMyFieldResolver<TParent>;
  objectId?: MyClassToObjectIdResolver<TParent>;
  updatedAt?: MyClassToUpdatedAtResolver<TParent>;
}

export interface MyClassToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MyClassToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MyClassToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MyClassToMyFieldResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MyClassToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MyClassToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMyClassConnectionTypeResolver<TParent = any> {
  count?: MyClassConnectionToCountResolver<TParent>;
  edges?: MyClassConnectionToEdgesResolver<TParent>;
  pageInfo?: MyClassConnectionToPageInfoResolver<TParent>;
}

export interface MyClassConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MyClassConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MyClassConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMyClassEdgeTypeResolver<TParent = any> {
  cursor?: MyClassEdgeToCursorResolver<TParent>;
  node?: MyClassEdgeToNodeResolver<TParent>;
}

export interface MyClassEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MyClassEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotifSendingTypeResolver<TParent = any> {
  ACL?: NotifSendingToACLResolver<TParent>;
  Community?: NotifSendingToCommunityResolver<TParent>;
  User?: NotifSendingToUserResolver<TParent>;
  amenityAutoBookedEmailSent?: NotifSendingToAmenityAutoBookedEmailSentResolver<TParent>;
  amenityAutoBookedSmsSent?: NotifSendingToAmenityAutoBookedSmsSentResolver<TParent>;
  amenityCanceledListerEmailSent?: NotifSendingToAmenityCanceledListerEmailSentResolver<TParent>;
  amenityCanceledListerSmsSent?: NotifSendingToAmenityCanceledListerSmsSentResolver<TParent>;
  amenityCanceledRequesterEmailSent?: NotifSendingToAmenityCanceledRequesterEmailSentResolver<TParent>;
  amenityCanceledRequesterSmsSent?: NotifSendingToAmenityCanceledRequesterSmsSentResolver<TParent>;
  amenityConfirmationEmailSent?: NotifSendingToAmenityConfirmationEmailSentResolver<TParent>;
  amenityConfirmationSmsSent?: NotifSendingToAmenityConfirmationSmsSentResolver<TParent>;
  amenityOrderBookedEmailSent?: NotifSendingToAmenityOrderBookedEmailSentResolver<TParent>;
  amenityOrderBookedSmsSent?: NotifSendingToAmenityOrderBookedSmsSentResolver<TParent>;
  amenityOrderCanceledEmailSent?: NotifSendingToAmenityOrderCanceledEmailSentResolver<TParent>;
  amenityOrderCanceledSmsSent?: NotifSendingToAmenityOrderCanceledSmsSentResolver<TParent>;
  amenityOrderPendingEmailSent?: NotifSendingToAmenityOrderPendingEmailSentResolver<TParent>;
  amenityOrderPendingSmsSent?: NotifSendingToAmenityOrderPendingSmsSentResolver<TParent>;
  amenityReminderEmailSent?: NotifSendingToAmenityReminderEmailSentResolver<TParent>;
  amenityReminderPushSent?: NotifSendingToAmenityReminderPushSentResolver<TParent>;
  amenityReminderSmsSent?: NotifSendingToAmenityReminderSmsSentResolver<TParent>;
  amenityRequestEmailSent?: NotifSendingToAmenityRequestEmailSentResolver<TParent>;
  amenityRequestSmsSent?: NotifSendingToAmenityRequestSmsSentResolver<TParent>;
  blockUserEmailSent?: NotifSendingToBlockUserEmailSentResolver<TParent>;
  blockUserSmsSent?: NotifSendingToBlockUserSmsSentResolver<TParent>;
  companyReportedEmailSent?: NotifSendingToCompanyReportedEmailSentResolver<TParent>;
  companyReportedSmsSent?: NotifSendingToCompanyReportedSmsSentResolver<TParent>;
  createdAt?: NotifSendingToCreatedAtResolver<TParent>;
  eventAttendeesEmailSent?: NotifSendingToEventAttendeesEmailSentResolver<TParent>;
  eventAttendeesPushSent?: NotifSendingToEventAttendeesPushSentResolver<TParent>;
  eventAttendeesSmsSent?: NotifSendingToEventAttendeesSmsSentResolver<TParent>;
  eventOrderAttendingEmailSent?: NotifSendingToEventOrderAttendingEmailSentResolver<TParent>;
  eventOrderAttendingSmsSent?: NotifSendingToEventOrderAttendingSmsSentResolver<TParent>;
  eventOrderCanceledEmailSent?: NotifSendingToEventOrderCanceledEmailSentResolver<TParent>;
  eventOrderCanceledSmsSent?: NotifSendingToEventOrderCanceledSmsSentResolver<TParent>;
  eventOrderPendingEmailSent?: NotifSendingToEventOrderPendingEmailSentResolver<TParent>;
  eventOrderPendingSmsSent?: NotifSendingToEventOrderPendingSmsSentResolver<TParent>;
  eventReminderEmailSent?: NotifSendingToEventReminderEmailSentResolver<TParent>;
  eventReminderPushSent?: NotifSendingToEventReminderPushSentResolver<TParent>;
  eventReminderSmsSent?: NotifSendingToEventReminderSmsSentResolver<TParent>;
  eventReportedEmailSent?: NotifSendingToEventReportedEmailSentResolver<TParent>;
  eventReportedSmsSent?: NotifSendingToEventReportedSmsSentResolver<TParent>;
  id?: NotifSendingToIdResolver<TParent>;
  itemReviewEmailSent?: NotifSendingToItemReviewEmailSentResolver<TParent>;
  itemReviewSmsSent?: NotifSendingToItemReviewSmsSentResolver<TParent>;
  itemViewEmailSent?: NotifSendingToItemViewEmailSentResolver<TParent>;
  itemViewPushSent?: NotifSendingToItemViewPushSentResolver<TParent>;
  itemViewSmsSent?: NotifSendingToItemViewSmsSentResolver<TParent>;
  joinCommunitySmsSent?: NotifSendingToJoinCommunitySmsSentResolver<TParent>;
  joinRequestEmailSent?: NotifSendingToJoinRequestEmailSentResolver<TParent>;
  listingApprovedEmailSent?: NotifSendingToListingApprovedEmailSentResolver<TParent>;
  listingApprovedSmsSent?: NotifSendingToListingApprovedSmsSentResolver<TParent>;
  listingPublishRequestEmailSent?: NotifSendingToListingPublishRequestEmailSentResolver<TParent>;
  listingPublishRequestPushSent?: NotifSendingToListingPublishRequestPushSentResolver<TParent>;
  listingPublishRequestSmsSent?: NotifSendingToListingPublishRequestSmsSentResolver<TParent>;
  listingRemovedEmailSent?: NotifSendingToListingRemovedEmailSentResolver<TParent>;
  listingRemovedSmsSent?: NotifSendingToListingRemovedSmsSentResolver<TParent>;
  listingRemovedSmsSmsSent?: NotifSendingToListingRemovedSmsSmsSentResolver<TParent>;
  managedAmenitiesEmailSent?: NotifSendingToManagedAmenitiesEmailSentResolver<TParent>;
  managedAmenitiesPushSent?: NotifSendingToManagedAmenitiesPushSentResolver<TParent>;
  managedAmenitiesSmsSent?: NotifSendingToManagedAmenitiesSmsSentResolver<TParent>;
  newCommentEmailSent?: NotifSendingToNewCommentEmailSentResolver<TParent>;
  newCommentInGroupEmailSent?: NotifSendingToNewCommentInGroupEmailSentResolver<TParent>;
  newCommentPollEmailSent?: NotifSendingToNewCommentPollEmailSentResolver<TParent>;
  newCommentPushSent?: NotifSendingToNewCommentPushSentResolver<TParent>;
  newCommentSmsSent?: NotifSendingToNewCommentSmsSentResolver<TParent>;
  newJoinLikeEmailSent?: NotifSendingToNewJoinLikeEmailSentResolver<TParent>;
  newJoinLikePushSent?: NotifSendingToNewJoinLikePushSentResolver<TParent>;
  newJoinLikeSmsSent?: NotifSendingToNewJoinLikeSmsSentResolver<TParent>;
  newJoinSmileEmailSent?: NotifSendingToNewJoinSmileEmailSentResolver<TParent>;
  newJoinSmilePushSent?: NotifSendingToNewJoinSmilePushSentResolver<TParent>;
  newJoinSmileSmsSent?: NotifSendingToNewJoinSmileSmsSentResolver<TParent>;
  newJoinWaveEmailSent?: NotifSendingToNewJoinWaveEmailSentResolver<TParent>;
  newJoinWavePushSent?: NotifSendingToNewJoinWavePushSentResolver<TParent>;
  newJoinWaveSmsSent?: NotifSendingToNewJoinWaveSmsSentResolver<TParent>;
  newLikeEmailSent?: NotifSendingToNewLikeEmailSentResolver<TParent>;
  newLikePollEmailSent?: NotifSendingToNewLikePollEmailSentResolver<TParent>;
  newLikePushSent?: NotifSendingToNewLikePushSentResolver<TParent>;
  newLikeSmsSent?: NotifSendingToNewLikeSmsSentResolver<TParent>;
  newListingEmailSent?: NotifSendingToNewListingEmailSentResolver<TParent>;
  newListingPushSent?: NotifSendingToNewListingPushSentResolver<TParent>;
  newListingSmsSent?: NotifSendingToNewListingSmsSentResolver<TParent>;
  newManagerAdminPostEmailSent?: NotifSendingToNewManagerAdminPostEmailSentResolver<TParent>;
  newManagerAdminPostPushSent?: NotifSendingToNewManagerAdminPostPushSentResolver<TParent>;
  newManagerAdminPostSmsSent?: NotifSendingToNewManagerAdminPostSmsSentResolver<TParent>;
  newMessageEmailSent?: NotifSendingToNewMessageEmailSentResolver<TParent>;
  newMessagePushSent?: NotifSendingToNewMessagePushSentResolver<TParent>;
  newMessageSmsSent?: NotifSendingToNewMessageSmsSentResolver<TParent>;
  newNoticeEmailSent?: NotifSendingToNewNoticeEmailSentResolver<TParent>;
  newNoticeSmsSent?: NotifSendingToNewNoticeSmsSentResolver<TParent>;
  newPostEmailSent?: NotifSendingToNewPostEmailSentResolver<TParent>;
  newPostPushSent?: NotifSendingToNewPostPushSentResolver<TParent>;
  newPostSmsSent?: NotifSendingToNewPostSmsSentResolver<TParent>;
  newResidentEmailSent?: NotifSendingToNewResidentEmailSentResolver<TParent>;
  newResidentPushSent?: NotifSendingToNewResidentPushSentResolver<TParent>;
  newResidentSmsSent?: NotifSendingToNewResidentSmsSentResolver<TParent>;
  objectId?: NotifSendingToObjectIdResolver<TParent>;
  orderBuyAcceptedEmailSent?: NotifSendingToOrderBuyAcceptedEmailSentResolver<TParent>;
  orderBuyAcceptedSmsSent?: NotifSendingToOrderBuyAcceptedSmsSentResolver<TParent>;
  orderBuyRejectedEmailSent?: NotifSendingToOrderBuyRejectedEmailSentResolver<TParent>;
  orderBuyRejectedSmsSent?: NotifSendingToOrderBuyRejectedSmsSentResolver<TParent>;
  orderRentAcceptedEmailSent?: NotifSendingToOrderRentAcceptedEmailSentResolver<TParent>;
  orderRentAcceptedSmsSent?: NotifSendingToOrderRentAcceptedSmsSentResolver<TParent>;
  orderRentRejectedEmailSent?: NotifSendingToOrderRentRejectedEmailSentResolver<TParent>;
  orderRentRejectedSmsSent?: NotifSendingToOrderRentRejectedSmsSentResolver<TParent>;
  orderRequestEmailSent?: NotifSendingToOrderRequestEmailSentResolver<TParent>;
  orderRequestSmsSent?: NotifSendingToOrderRequestSmsSentResolver<TParent>;
  orderServiceAcceptedEmailSent?: NotifSendingToOrderServiceAcceptedEmailSentResolver<TParent>;
  orderServiceAcceptedSmsSent?: NotifSendingToOrderServiceAcceptedSmsSentResolver<TParent>;
  orderServiceRejectedEmailSent?: NotifSendingToOrderServiceRejectedEmailSentResolver<TParent>;
  orderServiceRejectedSmsSent?: NotifSendingToOrderServiceRejectedSmsSentResolver<TParent>;
  rejectedRequestEmailSent?: NotifSendingToRejectedRequestEmailSentResolver<TParent>;
  reportListingEmailSent?: NotifSendingToReportListingEmailSentResolver<TParent>;
  reportListingSmsSent?: NotifSendingToReportListingSmsSentResolver<TParent>;
  reportPostEmailSent?: NotifSendingToReportPostEmailSentResolver<TParent>;
  reportPostSmsSent?: NotifSendingToReportPostSmsSentResolver<TParent>;
  reportUserEmailSent?: NotifSendingToReportUserEmailSentResolver<TParent>;
  reportUserSmsSent?: NotifSendingToReportUserSmsSentResolver<TParent>;
  residentRemovedEmailSent?: NotifSendingToResidentRemovedEmailSentResolver<TParent>;
  residentRemovedSmsSent?: NotifSendingToResidentRemovedSmsSentResolver<TParent>;
  unmanagedAmenitiesEmailSent?: NotifSendingToUnmanagedAmenitiesEmailSentResolver<TParent>;
  unmanagedAmenitiesPushSent?: NotifSendingToUnmanagedAmenitiesPushSentResolver<TParent>;
  unmanagedAmenitiesSmsSent?: NotifSendingToUnmanagedAmenitiesSmsSentResolver<TParent>;
  updatedAt?: NotifSendingToUpdatedAtResolver<TParent>;
  userViewEmailSent?: NotifSendingToUserViewEmailSentResolver<TParent>;
  userViewPushSent?: NotifSendingToUserViewPushSentResolver<TParent>;
  userViewSmsSent?: NotifSendingToUserViewSmsSentResolver<TParent>;
}

export interface NotifSendingToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityAutoBookedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityAutoBookedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityCanceledListerEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityCanceledListerSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityCanceledRequesterEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityCanceledRequesterSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityConfirmationEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityConfirmationSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityOrderBookedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityOrderBookedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityOrderCanceledEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityOrderCanceledSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityOrderPendingEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityOrderPendingSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityReminderEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityReminderPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityReminderSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityRequestEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToAmenityRequestSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToBlockUserEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToBlockUserSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToCompanyReportedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToCompanyReportedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventAttendeesEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventAttendeesPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventAttendeesSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventOrderAttendingEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventOrderAttendingSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventOrderCanceledEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventOrderCanceledSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventOrderPendingEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventOrderPendingSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventReminderEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventReminderPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventReminderSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventReportedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToEventReportedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToItemReviewEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToItemReviewSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToItemViewEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToItemViewPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToItemViewSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToJoinCommunitySmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToJoinRequestEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToListingApprovedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToListingApprovedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToListingPublishRequestEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToListingPublishRequestPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToListingPublishRequestSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToListingRemovedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToListingRemovedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToListingRemovedSmsSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToManagedAmenitiesEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToManagedAmenitiesPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToManagedAmenitiesSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewCommentEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewCommentInGroupEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewCommentPollEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewCommentPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewCommentSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinLikeEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinLikePushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinLikeSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinSmileEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinSmilePushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinSmileSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinWaveEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinWavePushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewJoinWaveSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewLikeEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewLikePollEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewLikePushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewLikeSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewListingEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewListingPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewListingSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewManagerAdminPostEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewManagerAdminPostPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewManagerAdminPostSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewMessageEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewMessagePushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewMessageSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewNoticeEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewNoticeSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewPostEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewPostPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewPostSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewResidentEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewResidentPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToNewResidentSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderBuyAcceptedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderBuyAcceptedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderBuyRejectedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderBuyRejectedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderRentAcceptedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderRentAcceptedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderRentRejectedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderRentRejectedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderRequestEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderRequestSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderServiceAcceptedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderServiceAcceptedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderServiceRejectedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToOrderServiceRejectedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToRejectedRequestEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToReportListingEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToReportListingSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToReportPostEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToReportPostSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToReportUserEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToReportUserSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToResidentRemovedEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToResidentRemovedSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToUnmanagedAmenitiesEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToUnmanagedAmenitiesPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToUnmanagedAmenitiesSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToUserViewEmailSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToUserViewPushSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingToUserViewSmsSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotifSendingConnectionTypeResolver<TParent = any> {
  count?: NotifSendingConnectionToCountResolver<TParent>;
  edges?: NotifSendingConnectionToEdgesResolver<TParent>;
  pageInfo?: NotifSendingConnectionToPageInfoResolver<TParent>;
}

export interface NotifSendingConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotifSendingEdgeTypeResolver<TParent = any> {
  cursor?: NotifSendingEdgeToCursorResolver<TParent>;
  node?: NotifSendingEdgeToNodeResolver<TParent>;
}

export interface NotifSendingEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotifSendingEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotificationTypeResolver<TParent = any> {
  ACL?: NotificationToACLResolver<TParent>;
  Community?: NotificationToCommunityResolver<TParent>;
  createdAt?: NotificationToCreatedAtResolver<TParent>;
  data?: NotificationToDataResolver<TParent>;
  event?: NotificationToEventResolver<TParent>;
  from?: NotificationToFromResolver<TParent>;
  id?: NotificationToIdResolver<TParent>;
  notifTypes?: NotificationToNotifTypesResolver<TParent>;
  objectId?: NotificationToObjectIdResolver<TParent>;
  seenDate?: NotificationToSeenDateResolver<TParent>;
  sendAt?: NotificationToSendAtResolver<TParent>;
  sentIn?: NotificationToSentInResolver<TParent>;
  status?: NotificationToStatusResolver<TParent>;
  to?: NotificationToToResolver<TParent>;
  updatedAt?: NotificationToUpdatedAtResolver<TParent>;
}

export interface NotificationToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToFromResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToNotifTypesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToSeenDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToSendAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToSentInResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotificationConnectionTypeResolver<TParent = any> {
  count?: NotificationConnectionToCountResolver<TParent>;
  edges?: NotificationConnectionToEdgesResolver<TParent>;
  pageInfo?: NotificationConnectionToPageInfoResolver<TParent>;
}

export interface NotificationConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotificationEdgeTypeResolver<TParent = any> {
  cursor?: NotificationEdgeToCursorResolver<TParent>;
  node?: NotificationEdgeToNodeResolver<TParent>;
}

export interface NotificationEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NotificationEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNotifyManagerPayloadTypeResolver<TParent = any> {
  ok?: NotifyManagerPayloadToOkResolver<TParent>;
}

export interface NotifyManagerPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOrderTypeResolver<TParent = any> {
  ACL?: OrderToACLResolver<TParent>;
  Amenity?: OrderToAmenityResolver<TParent>;
  Community?: OrderToCommunityResolver<TParent>;
  Currency?: OrderToCurrencyResolver<TParent>;
  Event?: OrderToEventResolver<TParent>;
  Item?: OrderToItemResolver<TParent>;
  Lister?: OrderToListerResolver<TParent>;
  Location?: OrderToLocationResolver<TParent>;
  Requester?: OrderToRequesterResolver<TParent>;
  acceptedByLister?: OrderToAcceptedByListerResolver<TParent>;
  acceptedByRequester?: OrderToAcceptedByRequesterResolver<TParent>;
  attendeeGuests?: OrderToAttendeeGuestsResolver<TParent>;
  cfListerAbs?: OrderToCfListerAbsResolver<TParent>;
  cfListerAmt?: OrderToCfListerAmtResolver<TParent>;
  cfListerPrc?: OrderToCfListerPrcResolver<TParent>;
  cfRequesterAbs?: OrderToCfRequesterAbsResolver<TParent>;
  cfRequesterAmt?: OrderToCfRequesterAmtResolver<TParent>;
  cfRequesterPrc?: OrderToCfRequesterPrcResolver<TParent>;
  createdAt?: OrderToCreatedAtResolver<TParent>;
  discount?: OrderToDiscountResolver<TParent>;
  discountAmount?: OrderToDiscountAmountResolver<TParent>;
  discountType?: OrderToDiscountTypeResolver<TParent>;
  endTime?: OrderToEndTimeResolver<TParent>;
  externalPayments?: OrderToExternalPaymentsResolver<TParent>;
  hangehDiscount?: OrderToHangehDiscountResolver<TParent>;
  hfListerAbs?: OrderToHfListerAbsResolver<TParent>;
  hfListerAmt?: OrderToHfListerAmtResolver<TParent>;
  hfListerPrc?: OrderToHfListerPrcResolver<TParent>;
  hfRequesterAbs?: OrderToHfRequesterAbsResolver<TParent>;
  hfRequesterAmt?: OrderToHfRequesterAmtResolver<TParent>;
  hfRequesterPrc?: OrderToHfRequesterPrcResolver<TParent>;
  id?: OrderToIdResolver<TParent>;
  itemAmount?: OrderToItemAmountResolver<TParent>;
  listerTotalAmt?: OrderToListerTotalAmtResolver<TParent>;
  listingType?: OrderToListingTypeResolver<TParent>;
  objectId?: OrderToObjectIdResolver<TParent>;
  oldStatus?: OrderToOldStatusResolver<TParent>;
  orderType?: OrderToOrderTypeResolver<TParent>;
  payMethod?: OrderToPayMethodResolver<TParent>;
  period?: OrderToPeriodResolver<TParent>;
  ppListerAbs?: OrderToPpListerAbsResolver<TParent>;
  ppListerAmt?: OrderToPpListerAmtResolver<TParent>;
  ppListerPrc?: OrderToPpListerPrcResolver<TParent>;
  ppRequesterAbs?: OrderToPpRequesterAbsResolver<TParent>;
  ppRequesterAmt?: OrderToPpRequesterAmtResolver<TParent>;
  ppRequesterPrc?: OrderToPpRequesterPrcResolver<TParent>;
  price?: OrderToPriceResolver<TParent>;
  pricePeriod?: OrderToPricePeriodResolver<TParent>;
  recurringEvent?: OrderToRecurringEventResolver<TParent>;
  reminder6atMorningSent?: OrderToReminder6atMorningSentResolver<TParent>;
  reminderSent?: OrderToReminderSentResolver<TParent>;
  requesterTotalAmt?: OrderToRequesterTotalAmtResolver<TParent>;
  rewardType?: OrderToRewardTypeResolver<TParent>;
  sfListerAmt?: OrderToSfListerAmtResolver<TParent>;
  sfRequesterAmt?: OrderToSfRequesterAmtResolver<TParent>;
  startTime?: OrderToStartTimeResolver<TParent>;
  status?: OrderToStatusResolver<TParent>;
  updatedAt?: OrderToUpdatedAtResolver<TParent>;
}

export interface OrderToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToListerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToRequesterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToAcceptedByListerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToAcceptedByRequesterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToAttendeeGuestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCfListerAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCfListerAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCfListerPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCfRequesterAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCfRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCfRequesterPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToDiscountAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToDiscountTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToEndTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToExternalPaymentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToHangehDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToHfListerAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToHfListerAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToHfListerPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToHfRequesterAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToHfRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToHfRequesterPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToItemAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToListerTotalAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToListingTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToOldStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToOrderTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPayMethodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPpListerAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPpListerAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPpListerPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPpRequesterAbsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPpRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPpRequesterPrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPriceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToPricePeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToRecurringEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToReminder6atMorningSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToReminderSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToRequesterTotalAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToRewardTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToSfListerAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToSfRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToStartTimeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOrderConnectionTypeResolver<TParent = any> {
  count?: OrderConnectionToCountResolver<TParent>;
  edges?: OrderConnectionToEdgesResolver<TParent>;
  pageInfo?: OrderConnectionToPageInfoResolver<TParent>;
}

export interface OrderConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOrderEdgeTypeResolver<TParent = any> {
  cursor?: OrderEdgeToCursorResolver<TParent>;
  node?: OrderEdgeToNodeResolver<TParent>;
}

export interface OrderEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OrderEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOrderPayloadTypeResolver<TParent = any> {
  order?: OrderPayloadToOrderResolver<TParent>;
}

export interface OrderPayloadToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPageInfoTypeResolver<TParent = any> {
  endCursor?: PageInfoToEndCursorResolver<TParent>;
  hasNextPage?: PageInfoToHasNextPageResolver<TParent>;
  hasPreviousPage?: PageInfoToHasPreviousPageResolver<TParent>;
  startCursor?: PageInfoToStartCursorResolver<TParent>;
}

export interface PageInfoToEndCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToHasNextPageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToHasPreviousPageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToStartCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPaySubscrPayloadTypeResolver<TParent = any> {
  error?: PaySubscrPayloadToErrorResolver<TParent>;
  success?: PaySubscrPayloadToSuccessResolver<TParent>;
}

export interface PaySubscrPayloadToErrorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaySubscrPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPaymentPlanTypeResolver<TParent = any> {
  ACL?: PaymentPlanToACLResolver<TParent>;
  Currency?: PaymentPlanToCurrencyResolver<TParent>;
  Location?: PaymentPlanToLocationResolver<TParent>;
  communityFee?: PaymentPlanToCommunityFeeResolver<TParent>;
  createdAt?: PaymentPlanToCreatedAtResolver<TParent>;
  descr?: PaymentPlanToDescrResolver<TParent>;
  extraListing?: PaymentPlanToExtraListingResolver<TParent>;
  extraResident?: PaymentPlanToExtraResidentResolver<TParent>;
  id?: PaymentPlanToIdResolver<TParent>;
  isPublic?: PaymentPlanToIsPublicResolver<TParent>;
  listingCap?: PaymentPlanToListingCapResolver<TParent>;
  name?: PaymentPlanToNameResolver<TParent>;
  objectId?: PaymentPlanToObjectIdResolver<TParent>;
  options?: PaymentPlanToOptionsResolver<TParent>;
  priceMonth?: PaymentPlanToPriceMonthResolver<TParent>;
  priceYear?: PaymentPlanToPriceYearResolver<TParent>;
  rentFees?: PaymentPlanToRentFeesResolver<TParent>;
  rentalExternal?: PaymentPlanToRentalExternalResolver<TParent>;
  residentCap?: PaymentPlanToResidentCapResolver<TParent>;
  salesExternal?: PaymentPlanToSalesExternalResolver<TParent>;
  salesFees?: PaymentPlanToSalesFeesResolver<TParent>;
  serviceExternal?: PaymentPlanToServiceExternalResolver<TParent>;
  serviceFees?: PaymentPlanToServiceFeesResolver<TParent>;
  status?: PaymentPlanToStatusResolver<TParent>;
  updatedAt?: PaymentPlanToUpdatedAtResolver<TParent>;
}

export interface PaymentPlanToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToCommunityFeeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToExtraListingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToExtraResidentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToIsPublicResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToListingCapResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToOptionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToPriceMonthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToPriceYearResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToRentFeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToRentalExternalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToResidentCapResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToSalesExternalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToSalesFeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToServiceExternalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToServiceFeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPaymentPlanConnectionTypeResolver<TParent = any> {
  count?: PaymentPlanConnectionToCountResolver<TParent>;
  edges?: PaymentPlanConnectionToEdgesResolver<TParent>;
  pageInfo?: PaymentPlanConnectionToPageInfoResolver<TParent>;
}

export interface PaymentPlanConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPaymentPlanEdgeTypeResolver<TParent = any> {
  cursor?: PaymentPlanEdgeToCursorResolver<TParent>;
  node?: PaymentPlanEdgeToNodeResolver<TParent>;
}

export interface PaymentPlanEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlanEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPaymentPlatformDashLinkPayloadTypeResolver<TParent = any> {
  error?: PaymentPlatformDashLinkPayloadToErrorResolver<TParent>;
  url?: PaymentPlatformDashLinkPayloadToUrlResolver<TParent>;
}

export interface PaymentPlatformDashLinkPayloadToErrorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentPlatformDashLinkPayloadToUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPermissionsListPayloadTypeResolver<TParent = any> {
  error?: PermissionsListPayloadToErrorResolver<TParent>;
  permissionsList?: PermissionsListPayloadToPermissionsListResolver<TParent>;
}

export interface PermissionsListPayloadToErrorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PermissionsListPayloadToPermissionsListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPhoneVerificationTypeResolver<TParent = any> {
  ACL?: PhoneVerificationToACLResolver<TParent>;
  User?: PhoneVerificationToUserResolver<TParent>;
  createdAt?: PhoneVerificationToCreatedAtResolver<TParent>;
  id?: PhoneVerificationToIdResolver<TParent>;
  objectId?: PhoneVerificationToObjectIdResolver<TParent>;
  updatedAt?: PhoneVerificationToUpdatedAtResolver<TParent>;
  verificationCode?: PhoneVerificationToVerificationCodeResolver<TParent>;
}

export interface PhoneVerificationToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationToVerificationCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPhoneVerificationConnectionTypeResolver<TParent = any> {
  count?: PhoneVerificationConnectionToCountResolver<TParent>;
  edges?: PhoneVerificationConnectionToEdgesResolver<TParent>;
  pageInfo?: PhoneVerificationConnectionToPageInfoResolver<TParent>;
}

export interface PhoneVerificationConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPhoneVerificationEdgeTypeResolver<TParent = any> {
  cursor?: PhoneVerificationEdgeToCursorResolver<TParent>;
  node?: PhoneVerificationEdgeToNodeResolver<TParent>;
}

export interface PhoneVerificationEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PhoneVerificationEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPollOptionTypeResolver<TParent = any> {
  ACL?: PollOptionToACLResolver<TParent>;
  Post?: PollOptionToPostResolver<TParent>;
  Translate?: PollOptionToTranslateResolver<TParent>;
  Voted?: PollOptionToVotedResolver<TParent>;
  countVotes?: PollOptionToCountVotesResolver<TParent>;
  createdAt?: PollOptionToCreatedAtResolver<TParent>;
  id?: PollOptionToIdResolver<TParent>;
  isVoted?: PollOptionToIsVotedResolver<TParent>;
  objectId?: PollOptionToObjectIdResolver<TParent>;
  position?: PollOptionToPositionResolver<TParent>;
  text?: PollOptionToTextResolver<TParent>;
  updatedAt?: PollOptionToUpdatedAtResolver<TParent>;
}

export interface PollOptionToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToVotedArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface PollOptionToVotedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PollOptionToVotedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToCountVotesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToIsVotedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToPositionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPollOptionConnectionTypeResolver<TParent = any> {
  count?: PollOptionConnectionToCountResolver<TParent>;
  edges?: PollOptionConnectionToEdgesResolver<TParent>;
  pageInfo?: PollOptionConnectionToPageInfoResolver<TParent>;
}

export interface PollOptionConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPollOptionEdgeTypeResolver<TParent = any> {
  cursor?: PollOptionEdgeToCursorResolver<TParent>;
  node?: PollOptionEdgeToNodeResolver<TParent>;
}

export interface PollOptionEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PollOptionEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPostTypeResolver<TParent = any> {
  ACL?: PostToACLResolver<TParent>;
  Attachments?: PostToAttachmentsResolver<TParent>;
  Author?: PostToAuthorResolver<TParent>;
  Community?: PostToCommunityResolver<TParent>;
  Group?: PostToGroupResolver<TParent>;
  Hide?: PostToHideResolver<TParent>;
  Items?: PostToItemsResolver<TParent>;
  Options?: PostToOptionsResolver<TParent>;
  Parent?: PostToParentResolver<TParent>;
  Pin?: PostToPinResolver<TParent>;
  Reports?: PostToReportsResolver<TParent>;
  Seen?: PostToSeenResolver<TParent>;
  Translate?: PostToTranslateResolver<TParent>;
  comments?: PostToCommentsResolver<TParent>;
  countComments?: PostToCountCommentsResolver<TParent>;
  countHides?: PostToCountHidesResolver<TParent>;
  countLikes?: PostToCountLikesResolver<TParent>;
  countSmiles?: PostToCountSmilesResolver<TParent>;
  countWaves?: PostToCountWavesResolver<TParent>;
  createdAt?: PostToCreatedAtResolver<TParent>;
  data?: PostToDataResolver<TParent>;
  id?: PostToIdResolver<TParent>;
  isComment?: PostToIsCommentResolver<TParent>;
  isDeleted?: PostToIsDeletedResolver<TParent>;
  isHidden?: PostToIsHiddenResolver<TParent>;
  isLike?: PostToIsLikeResolver<TParent>;
  isMulti?: PostToIsMultiResolver<TParent>;
  isSmile?: PostToIsSmileResolver<TParent>;
  isWave?: PostToIsWaveResolver<TParent>;
  likes?: PostToLikesResolver<TParent>;
  localRef?: PostToLocalRefResolver<TParent>;
  medium?: PostToMediumResolver<TParent>;
  notShow?: PostToNotShowResolver<TParent>;
  objectId?: PostToObjectIdResolver<TParent>;
  pollOptions?: PostToPollOptionsResolver<TParent>;
  sentAs?: PostToSentAsResolver<TParent>;
  smiles?: PostToSmilesResolver<TParent>;
  text?: PostToTextResolver<TParent>;
  type?: PostToTypeResolver<TParent>;
  updatedAt?: PostToUpdatedAtResolver<TParent>;
  waves?: PostToWavesResolver<TParent>;
}

export interface PostToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToAttachmentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToHideArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface PostToHideResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PostToHideArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToOptionsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPollOptionOrder>;
  skip?: number;
  where?: GQLPollOptionWhereInput;
}
export interface PostToOptionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PostToOptionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToParentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToPinResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToReportsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReportOrder>;
  skip?: number;
  where?: GQLReportWhereInput;
}
export interface PostToReportsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PostToReportsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToSeenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToCommentsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPostOrder>;
  skip?: number;
  where?: GQLPostWhereInput;
}
export interface PostToCommentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PostToCommentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToCountCommentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToCountHidesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToCountLikesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToCountSmilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToCountWavesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToIsCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToIsDeletedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToIsHiddenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToIsLikeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToIsMultiResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToIsSmileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToIsWaveResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToLikesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface PostToLikesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PostToLikesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToLocalRefResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToMediumResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToNotShowResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToPollOptionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToSentAsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToSmilesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface PostToSmilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PostToSmilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostToWavesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface PostToWavesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PostToWavesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPostConnectionTypeResolver<TParent = any> {
  count?: PostConnectionToCountResolver<TParent>;
  edges?: PostConnectionToEdgesResolver<TParent>;
  pageInfo?: PostConnectionToPageInfoResolver<TParent>;
}

export interface PostConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPostEdgeTypeResolver<TParent = any> {
  cursor?: PostEdgeToCursorResolver<TParent>;
  node?: PostEdgeToNodeResolver<TParent>;
}

export interface PostEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPostTranslateTypeResolver<TParent = any> {
  ACL?: PostTranslateToACLResolver<TParent>;
  PollOption?: PostTranslateToPollOptionResolver<TParent>;
  Post?: PostTranslateToPostResolver<TParent>;
  createdAt?: PostTranslateToCreatedAtResolver<TParent>;
  en?: PostTranslateToEnResolver<TParent>;
  fr?: PostTranslateToFrResolver<TParent>;
  id?: PostTranslateToIdResolver<TParent>;
  objectId?: PostTranslateToObjectIdResolver<TParent>;
  originalLang?: PostTranslateToOriginalLangResolver<TParent>;
  ru?: PostTranslateToRuResolver<TParent>;
  updatedAt?: PostTranslateToUpdatedAtResolver<TParent>;
}

export interface PostTranslateToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToPollOptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToEnResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToFrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToOriginalLangResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToRuResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPostTranslateConnectionTypeResolver<TParent = any> {
  count?: PostTranslateConnectionToCountResolver<TParent>;
  edges?: PostTranslateConnectionToEdgesResolver<TParent>;
  pageInfo?: PostTranslateConnectionToPageInfoResolver<TParent>;
}

export interface PostTranslateConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPostTranslateEdgeTypeResolver<TParent = any> {
  cursor?: PostTranslateEdgeToCursorResolver<TParent>;
  node?: PostTranslateEdgeToNodeResolver<TParent>;
}

export interface PostTranslateEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PostTranslateEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPreOrderCalcDataPayLoadTypeResolver<TParent = any> {
  hangehDiscount?: PreOrderCalcDataPayLoadToHangehDiscountResolver<TParent>;
  itemCost?: PreOrderCalcDataPayLoadToItemCostResolver<TParent>;
  ppRequesterAmt?: PreOrderCalcDataPayLoadToPpRequesterAmtResolver<TParent>;
  requesterTotalAmt?: PreOrderCalcDataPayLoadToRequesterTotalAmtResolver<TParent>;
  sfRequesterAmt?: PreOrderCalcDataPayLoadToSfRequesterAmtResolver<TParent>;
}

export interface PreOrderCalcDataPayLoadToHangehDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PreOrderCalcDataPayLoadToItemCostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PreOrderCalcDataPayLoadToPpRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PreOrderCalcDataPayLoadToRequesterTotalAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PreOrderCalcDataPayLoadToSfRequesterAmtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPromoTypeResolver<TParent = any> {
  ACL?: PromoToACLResolver<TParent>;
  Communities?: PromoToCommunitiesResolver<TParent>;
  Currency?: PromoToCurrencyResolver<TParent>;
  Location?: PromoToLocationResolver<TParent>;
  code?: PromoToCodeResolver<TParent>;
  createdAt?: PromoToCreatedAtResolver<TParent>;
  descr?: PromoToDescrResolver<TParent>;
  endDate?: PromoToEndDateResolver<TParent>;
  id?: PromoToIdResolver<TParent>;
  isCommunity?: PromoToIsCommunityResolver<TParent>;
  objectId?: PromoToObjectIdResolver<TParent>;
  startDate?: PromoToStartDateResolver<TParent>;
  type?: PromoToTypeResolver<TParent>;
  updatedAt?: PromoToUpdatedAtResolver<TParent>;
  usageLimit?: PromoToUsageLimitResolver<TParent>;
  value?: PromoToValueResolver<TParent>;
  valueType?: PromoToValueTypeResolver<TParent>;
}

export interface PromoToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToCommunitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToEndDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToIsCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToStartDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToUsageLimitResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoToValueTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPromoConnectionTypeResolver<TParent = any> {
  count?: PromoConnectionToCountResolver<TParent>;
  edges?: PromoConnectionToEdgesResolver<TParent>;
  pageInfo?: PromoConnectionToPageInfoResolver<TParent>;
}

export interface PromoConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPromoEdgeTypeResolver<TParent = any> {
  cursor?: PromoEdgeToCursorResolver<TParent>;
  node?: PromoEdgeToNodeResolver<TParent>;
}

export interface PromoEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PromoEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPublicACLTypeResolver<TParent = any> {
  read?: PublicACLToReadResolver<TParent>;
  write?: PublicACLToWriteResolver<TParent>;
}

export interface PublicACLToReadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PublicACLToWriteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPushNotificationLogTypeResolver<TParent = any> {
  ACL?: PushNotificationLogToACLResolver<TParent>;
  createdAt?: PushNotificationLogToCreatedAtResolver<TParent>;
  error?: PushNotificationLogToErrorResolver<TParent>;
  id?: PushNotificationLogToIdResolver<TParent>;
  message?: PushNotificationLogToMessageResolver<TParent>;
  objectId?: PushNotificationLogToObjectIdResolver<TParent>;
  result?: PushNotificationLogToResultResolver<TParent>;
  updatedAt?: PushNotificationLogToUpdatedAtResolver<TParent>;
  user?: PushNotificationLogToUserResolver<TParent>;
}

export interface PushNotificationLogToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogToErrorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogToResultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPushNotificationLogConnectionTypeResolver<TParent = any> {
  count?: PushNotificationLogConnectionToCountResolver<TParent>;
  edges?: PushNotificationLogConnectionToEdgesResolver<TParent>;
  pageInfo?: PushNotificationLogConnectionToPageInfoResolver<TParent>;
}

export interface PushNotificationLogConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPushNotificationLogEdgeTypeResolver<TParent = any> {
  cursor?: PushNotificationLogEdgeToCursorResolver<TParent>;
  node?: PushNotificationLogEdgeToNodeResolver<TParent>;
}

export interface PushNotificationLogEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PushNotificationLogEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLQueryTypeResolver<TParent = any> {
  admin?: QueryToAdminResolver<TParent>;
  admins?: QueryToAdminsResolver<TParent>;
  amenities?: QueryToAmenitiesResolver<TParent>;
  amenity?: QueryToAmenityResolver<TParent>;
  appFile?: QueryToAppFileResolver<TParent>;
  appFiles?: QueryToAppFilesResolver<TParent>;
  categories?: QueryToCategoriesResolver<TParent>;
  category?: QueryToCategoryResolver<TParent>;
  chat?: QueryToChatResolver<TParent>;
  chats?: QueryToChatsResolver<TParent>;
  class?: QueryToClassResolver<TParent>;
  classes?: QueryToClassesResolver<TParent>;
  communities?: QueryToCommunitiesResolver<TParent>;
  community?: QueryToCommunityResolver<TParent>;
  communityAdmin?: QueryToCommunityAdminResolver<TParent>;
  communityAdmins?: QueryToCommunityAdminsResolver<TParent>;
  companies?: QueryToCompaniesResolver<TParent>;
  company?: QueryToCompanyResolver<TParent>;
  currencies?: QueryToCurrenciesResolver<TParent>;
  currency?: QueryToCurrencyResolver<TParent>;
  document?: QueryToDocumentResolver<TParent>;
  documents?: QueryToDocumentsResolver<TParent>;
  event?: QueryToEventResolver<TParent>;
  events?: QueryToEventsResolver<TParent>;
  group?: QueryToGroupResolver<TParent>;
  groups?: QueryToGroupsResolver<TParent>;
  health?: QueryToHealthResolver<TParent>;
  helpDesk?: QueryToHelpDeskResolver<TParent>;
  helpDesks?: QueryToHelpDesksResolver<TParent>;
  installation?: QueryToInstallationResolver<TParent>;
  installations?: QueryToInstallationsResolver<TParent>;
  invitation?: QueryToInvitationResolver<TParent>;
  invitations?: QueryToInvitationsResolver<TParent>;
  item?: QueryToItemResolver<TParent>;
  itemBooking?: QueryToItemBookingResolver<TParent>;
  itemBookings?: QueryToItemBookingsResolver<TParent>;
  items?: QueryToItemsResolver<TParent>;
  joinRequest?: QueryToJoinRequestResolver<TParent>;
  joinRequests?: QueryToJoinRequestsResolver<TParent>;
  language?: QueryToLanguageResolver<TParent>;
  languages?: QueryToLanguagesResolver<TParent>;
  location?: QueryToLocationResolver<TParent>;
  locations?: QueryToLocationsResolver<TParent>;
  message?: QueryToMessageResolver<TParent>;
  messages?: QueryToMessagesResolver<TParent>;
  myClass?: QueryToMyClassResolver<TParent>;
  myClasses?: QueryToMyClassesResolver<TParent>;
  node?: QueryToNodeResolver<TParent>;
  notifSending?: QueryToNotifSendingResolver<TParent>;
  notifSendings?: QueryToNotifSendingsResolver<TParent>;
  notification?: QueryToNotificationResolver<TParent>;
  notifications?: QueryToNotificationsResolver<TParent>;
  order?: QueryToOrderResolver<TParent>;
  orders?: QueryToOrdersResolver<TParent>;
  paymentPlan?: QueryToPaymentPlanResolver<TParent>;
  paymentPlans?: QueryToPaymentPlansResolver<TParent>;
  phoneVerification?: QueryToPhoneVerificationResolver<TParent>;
  phoneVerifications?: QueryToPhoneVerificationsResolver<TParent>;
  pollOption?: QueryToPollOptionResolver<TParent>;
  pollOptions?: QueryToPollOptionsResolver<TParent>;
  post?: QueryToPostResolver<TParent>;
  postTranslate?: QueryToPostTranslateResolver<TParent>;
  postTranslates?: QueryToPostTranslatesResolver<TParent>;
  posts?: QueryToPostsResolver<TParent>;
  promo?: QueryToPromoResolver<TParent>;
  promos?: QueryToPromosResolver<TParent>;
  pushNotificationLog?: QueryToPushNotificationLogResolver<TParent>;
  pushNotificationLogs?: QueryToPushNotificationLogsResolver<TParent>;
  referral?: QueryToReferralResolver<TParent>;
  referrals?: QueryToReferralsResolver<TParent>;
  report?: QueryToReportResolver<TParent>;
  reports?: QueryToReportsResolver<TParent>;
  review?: QueryToReviewResolver<TParent>;
  reviews?: QueryToReviewsResolver<TParent>;
  role?: QueryToRoleResolver<TParent>;
  roles?: QueryToRolesResolver<TParent>;
  searchSessions?: QueryToSearchSessionsResolver<TParent>;
  session?: QueryToSessionResolver<TParent>;
  sessions?: QueryToSessionsResolver<TParent>;
  subscr?: QueryToSubscrResolver<TParent>;
  subscrPayment?: QueryToSubscrPaymentResolver<TParent>;
  subscrPayments?: QueryToSubscrPaymentsResolver<TParent>;
  subscrs?: QueryToSubscrsResolver<TParent>;
  task?: QueryToTaskResolver<TParent>;
  tasks?: QueryToTasksResolver<TParent>;
  transaction?: QueryToTransactionResolver<TParent>;
  transactions?: QueryToTransactionsResolver<TParent>;
  user?: QueryToUserResolver<TParent>;
  users?: QueryToUsersResolver<TParent>;
  viewer?: QueryToViewerResolver<TParent>;
}

export interface QueryToAdminArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAdminArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToAdminsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLAdminOrder>;
  skip?: number;
  where?: GQLAdminWhereInput;
}
export interface QueryToAdminsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAdminsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToAmenitiesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLAmenityOrder>;
  skip?: number;
  where?: GQLAmenityWhereInput;
}
export interface QueryToAmenitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAmenitiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToAmenityArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAmenityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToAppFileArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAppFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToAppFilesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLAppFileOrder>;
  skip?: number;
  where?: GQLAppFileWhereInput;
}
export interface QueryToAppFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAppFilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCategoriesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLCategoryOrder>;
  skip?: number;
  where?: GQLCategoryWhereInput;
}
export interface QueryToCategoriesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCategoriesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCategoryArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCategoryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToChatArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToChatArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToChatsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLChatOrder>;
  skip?: number;
  where?: GQLChatWhereInput;
}
export interface QueryToChatsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToChatsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToClassArgs {
  name: string;
}
export interface QueryToClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToClassesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCommunitiesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLCommunityOrder>;
  skip?: number;
  where?: GQLCommunityWhereInput;
}
export interface QueryToCommunitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCommunitiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCommunityArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCommunityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCommunityAdminArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToCommunityAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCommunityAdminArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCommunityAdminsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLCommunityAdminOrder>;
  skip?: number;
  where?: GQLCommunityAdminWhereInput;
}
export interface QueryToCommunityAdminsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCommunityAdminsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCompaniesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLCompanyOrder>;
  skip?: number;
  where?: GQLCompanyWhereInput;
}
export interface QueryToCompaniesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCompaniesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCompanyArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCompanyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCurrenciesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLCurrencyOrder>;
  skip?: number;
  where?: GQLCurrencyWhereInput;
}
export interface QueryToCurrenciesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCurrenciesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToCurrencyArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToCurrencyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToDocumentsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLDocumentOrder>;
  skip?: number;
  where?: GQLDocumentWhereInput;
}
export interface QueryToDocumentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToDocumentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToEventArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToEventsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLEventOrder>;
  skip?: number;
  where?: GQLEventWhereInput;
}
export interface QueryToEventsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToEventsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGroupArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGroupArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToGroupsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLGroupOrder>;
  skip?: number;
  where?: GQLGroupWhereInput;
}
export interface QueryToGroupsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToGroupsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToHealthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToHelpDeskArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToHelpDeskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToHelpDeskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToHelpDesksArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLHelpDeskOrder>;
  skip?: number;
  where?: GQLHelpDeskWhereInput;
}
export interface QueryToHelpDesksResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToHelpDesksArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInstallationArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToInstallationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInstallationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInstallationsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLInstallationOrder>;
  skip?: number;
  where?: GQLInstallationWhereInput;
}
export interface QueryToInstallationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInstallationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInvitationArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInvitationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInvitationsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLInvitationOrder>;
  skip?: number;
  where?: GQLInvitationWhereInput;
}
export interface QueryToInvitationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInvitationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToItemArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToItemArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToItemBookingArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToItemBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToItemBookingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToItemBookingsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLItemBookingOrder>;
  skip?: number;
  where?: GQLItemBookingWhereInput;
}
export interface QueryToItemBookingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToItemBookingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToItemsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLItemOrder>;
  skip?: number;
  where?: GQLItemWhereInput;
}
export interface QueryToItemsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToItemsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToJoinRequestArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToJoinRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToJoinRequestArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToJoinRequestsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLJoinRequestOrder>;
  skip?: number;
  where?: GQLJoinRequestWhereInput;
}
export interface QueryToJoinRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToJoinRequestsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToLanguageArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToLanguageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToLanguageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToLanguagesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLLanguageOrder>;
  skip?: number;
  where?: GQLLanguageWhereInput;
}
export interface QueryToLanguagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToLanguagesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToLocationArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToLocationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToLocationsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLLocationOrder>;
  skip?: number;
  where?: GQLLocationWhereInput;
}
export interface QueryToLocationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToLocationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToMessageArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToMessageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToMessagesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLMessageOrder>;
  skip?: number;
  where?: GQLMessageWhereInput;
}
export interface QueryToMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToMessagesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToMyClassArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToMyClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToMyClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToMyClassesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLMyClassOrder>;
  skip?: number;
  where?: GQLMyClassWhereInput;
}
export interface QueryToMyClassesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToMyClassesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToNodeArgs {
  id: string;
}
export interface QueryToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToNodeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToNotifSendingArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToNotifSendingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToNotifSendingArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToNotifSendingsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLNotifSendingOrder>;
  skip?: number;
  where?: GQLNotifSendingWhereInput;
}
export interface QueryToNotifSendingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToNotifSendingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToNotificationArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToNotificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToNotificationsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLNotificationOrder>;
  skip?: number;
  where?: GQLNotificationWhereInput;
}
export interface QueryToNotificationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToNotificationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToOrderArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToOrderArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToOrdersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLOrderOrder>;
  skip?: number;
  where?: GQLOrderWhereInput;
}
export interface QueryToOrdersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToOrdersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPaymentPlanArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToPaymentPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPaymentPlanArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPaymentPlansArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPaymentPlanOrder>;
  skip?: number;
  where?: GQLPaymentPlanWhereInput;
}
export interface QueryToPaymentPlansResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPaymentPlansArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPhoneVerificationArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToPhoneVerificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPhoneVerificationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPhoneVerificationsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPhoneVerificationOrder>;
  skip?: number;
  where?: GQLPhoneVerificationWhereInput;
}
export interface QueryToPhoneVerificationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPhoneVerificationsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPollOptionArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToPollOptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPollOptionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPollOptionsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPollOptionOrder>;
  skip?: number;
  where?: GQLPollOptionWhereInput;
}
export interface QueryToPollOptionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPollOptionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPostArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPostArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPostTranslateArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToPostTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPostTranslateArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPostTranslatesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPostTranslateOrder>;
  skip?: number;
  where?: GQLPostTranslateWhereInput;
}
export interface QueryToPostTranslatesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPostTranslatesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPostsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPostOrder>;
  skip?: number;
  where?: GQLPostWhereInput;
}
export interface QueryToPostsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPostsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPromoArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToPromoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPromoArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPromosArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPromoOrder>;
  skip?: number;
  where?: GQLPromoWhereInput;
}
export interface QueryToPromosResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPromosArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPushNotificationLogArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToPushNotificationLogResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPushNotificationLogArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToPushNotificationLogsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLPushNotificationLogOrder>;
  skip?: number;
  where?: GQLPushNotificationLogWhereInput;
}
export interface QueryToPushNotificationLogsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToPushNotificationLogsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReferralArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReferralsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReferralOrder>;
  skip?: number;
  where?: GQLReferralWhereInput;
}
export interface QueryToReferralsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReferralsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReportArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReportArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReportsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReportOrder>;
  skip?: number;
  where?: GQLReportWhereInput;
}
export interface QueryToReportsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReportsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReviewArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReviewArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToReviewsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReviewOrder>;
  skip?: number;
  where?: GQLReviewWhereInput;
}
export interface QueryToReviewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToReviewsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToRoleArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToRolesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLRoleOrder>;
  skip?: number;
  where?: GQLRoleWhereInput;
}
export interface QueryToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToRolesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSearchSessionsArgs {
  after?: string;
  first?: number;
  order?: GQL_SessionOrder;
  where?: GQLSessionWhereInput;
}
export interface QueryToSearchSessionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSearchSessionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSessionArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSessionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSessionsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLSessionOrder>;
  skip?: number;
  where?: GQLSessionWhereInput;
}
export interface QueryToSessionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSessionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSubscrArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSubscrArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSubscrPaymentArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToSubscrPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSubscrPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSubscrPaymentsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLSubscrPaymentOrder>;
  skip?: number;
  where?: GQLSubscrPaymentWhereInput;
}
export interface QueryToSubscrPaymentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSubscrPaymentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSubscrsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLSubscrOrder>;
  skip?: number;
  where?: GQLSubscrWhereInput;
}
export interface QueryToSubscrsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSubscrsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToTaskArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToTaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToTaskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToTasksArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLTaskOrder>;
  skip?: number;
  where?: GQLTaskWhereInput;
}
export interface QueryToTasksResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToTasksArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToTransactionArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToTransactionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToTransactionsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLTransactionOrder>;
  skip?: number;
  where?: GQLTransactionWhereInput;
}
export interface QueryToTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToTransactionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToUserArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToUsersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface QueryToUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToUsersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReactionHandlerPayloadTypeResolver<TParent = any> {
  success?: ReactionHandlerPayloadToSuccessResolver<TParent>;
}

export interface ReactionHandlerPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReferralTypeResolver<TParent = any> {
  ACL?: ReferralToACLResolver<TParent>;
  ReferralBy?: ReferralToReferralByResolver<TParent>;
  Referrals?: ReferralToReferralsResolver<TParent>;
  ReferralsCount?: ReferralToReferralsCountResolver<TParent>;
  User?: ReferralToUserResolver<TParent>;
  accumulatedDiscount?: ReferralToAccumulatedDiscountResolver<TParent>;
  createdAt?: ReferralToCreatedAtResolver<TParent>;
  data?: ReferralToDataResolver<TParent>;
  id?: ReferralToIdResolver<TParent>;
  objectId?: ReferralToObjectIdResolver<TParent>;
  updatedAt?: ReferralToUpdatedAtResolver<TParent>;
  userMadeTransaction?: ReferralToUserMadeTransactionResolver<TParent>;
}

export interface ReferralToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToReferralByResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToReferralsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface ReferralToReferralsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ReferralToReferralsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToReferralsCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToAccumulatedDiscountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralToUserMadeTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReferralConnectionTypeResolver<TParent = any> {
  count?: ReferralConnectionToCountResolver<TParent>;
  edges?: ReferralConnectionToEdgesResolver<TParent>;
  pageInfo?: ReferralConnectionToPageInfoResolver<TParent>;
}

export interface ReferralConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReferralEdgeTypeResolver<TParent = any> {
  cursor?: ReferralEdgeToCursorResolver<TParent>;
  node?: ReferralEdgeToNodeResolver<TParent>;
}

export interface ReferralEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferralEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReportTypeResolver<TParent = any> {
  ACL?: ReportToACLResolver<TParent>;
  Community?: ReportToCommunityResolver<TParent>;
  Company?: ReportToCompanyResolver<TParent>;
  Event?: ReportToEventResolver<TParent>;
  Group?: ReportToGroupResolver<TParent>;
  Item?: ReportToItemResolver<TParent>;
  Post?: ReportToPostResolver<TParent>;
  Reporter?: ReportToReporterResolver<TParent>;
  User?: ReportToUserResolver<TParent>;
  blockUserText?: ReportToBlockUserTextResolver<TParent>;
  createdAt?: ReportToCreatedAtResolver<TParent>;
  id?: ReportToIdResolver<TParent>;
  objectId?: ReportToObjectIdResolver<TParent>;
  reportText?: ReportToReportTextResolver<TParent>;
  updatedAt?: ReportToUpdatedAtResolver<TParent>;
}

export interface ReportToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToReporterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToBlockUserTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToReportTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReportConnectionTypeResolver<TParent = any> {
  count?: ReportConnectionToCountResolver<TParent>;
  edges?: ReportConnectionToEdgesResolver<TParent>;
  pageInfo?: ReportConnectionToPageInfoResolver<TParent>;
}

export interface ReportConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReportEdgeTypeResolver<TParent = any> {
  cursor?: ReportEdgeToCursorResolver<TParent>;
  node?: ReportEdgeToNodeResolver<TParent>;
}

export interface ReportEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReportEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLResetPasswordPayloadTypeResolver<TParent = any> {
  clientMutationId?: ResetPasswordPayloadToClientMutationIdResolver<TParent>;
  ok?: ResetPasswordPayloadToOkResolver<TParent>;
}

export interface ResetPasswordPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResetPasswordPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLResidentDashboardPayloadTypeResolver<TParent = any> {
  averageRatingGiven?: ResidentDashboardPayloadToAverageRatingGivenResolver<TParent>;
  averageRatingReceived?: ResidentDashboardPayloadToAverageRatingReceivedResolver<TParent>;
  countEarned?: ResidentDashboardPayloadToCountEarnedResolver<TParent>;
  countInteractions?: ResidentDashboardPayloadToCountInteractionsResolver<TParent>;
  countItemValue?: ResidentDashboardPayloadToCountItemValueResolver<TParent>;
  countListingViews?: ResidentDashboardPayloadToCountListingViewsResolver<TParent>;
  countListings?: ResidentDashboardPayloadToCountListingsResolver<TParent>;
  countOthersTransactions?: ResidentDashboardPayloadToCountOthersTransactionsResolver<TParent>;
  countOwnTransactions?: ResidentDashboardPayloadToCountOwnTransactionsResolver<TParent>;
  countSpent?: ResidentDashboardPayloadToCountSpentResolver<TParent>;
}

export interface ResidentDashboardPayloadToAverageRatingGivenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToAverageRatingReceivedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToCountEarnedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToCountInteractionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToCountItemValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToCountListingViewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToCountListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToCountOthersTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToCountOwnTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResidentDashboardPayloadToCountSpentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReviewTypeResolver<TParent = any> {
  ACL?: ReviewToACLResolver<TParent>;
  Amenity?: ReviewToAmenityResolver<TParent>;
  Author?: ReviewToAuthorResolver<TParent>;
  Community?: ReviewToCommunityResolver<TParent>;
  Event?: ReviewToEventResolver<TParent>;
  Item?: ReviewToItemResolver<TParent>;
  Order?: ReviewToOrderResolver<TParent>;
  User?: ReviewToUserResolver<TParent>;
  createdAt?: ReviewToCreatedAtResolver<TParent>;
  id?: ReviewToIdResolver<TParent>;
  objectId?: ReviewToObjectIdResolver<TParent>;
  stars?: ReviewToStarsResolver<TParent>;
  subject?: ReviewToSubjectResolver<TParent>;
  text?: ReviewToTextResolver<TParent>;
  updatedAt?: ReviewToUpdatedAtResolver<TParent>;
}

export interface ReviewToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToStarsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToSubjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReviewConnectionTypeResolver<TParent = any> {
  count?: ReviewConnectionToCountResolver<TParent>;
  edges?: ReviewConnectionToEdgesResolver<TParent>;
  pageInfo?: ReviewConnectionToPageInfoResolver<TParent>;
}

export interface ReviewConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReviewEdgeTypeResolver<TParent = any> {
  cursor?: ReviewEdgeToCursorResolver<TParent>;
  node?: ReviewEdgeToNodeResolver<TParent>;
}

export interface ReviewEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReviewEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoleTypeResolver<TParent = any> {
  ACL?: RoleToACLResolver<TParent>;
  createdAt?: RoleToCreatedAtResolver<TParent>;
  id?: RoleToIdResolver<TParent>;
  name?: RoleToNameResolver<TParent>;
  objectId?: RoleToObjectIdResolver<TParent>;
  roles?: RoleToRolesResolver<TParent>;
  updatedAt?: RoleToUpdatedAtResolver<TParent>;
  users?: RoleToUsersResolver<TParent>;
}

export interface RoleToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToRolesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLRoleOrder>;
  skip?: number;
  where?: GQLRoleWhereInput;
}
export interface RoleToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RoleToRolesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToUsersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface RoleToUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RoleToUsersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoleACLTypeResolver<TParent = any> {
  read?: RoleACLToReadResolver<TParent>;
  roleName?: RoleACLToRoleNameResolver<TParent>;
  write?: RoleACLToWriteResolver<TParent>;
}

export interface RoleACLToReadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleACLToRoleNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleACLToWriteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoleConnectionTypeResolver<TParent = any> {
  count?: RoleConnectionToCountResolver<TParent>;
  edges?: RoleConnectionToEdgesResolver<TParent>;
  pageInfo?: RoleConnectionToPageInfoResolver<TParent>;
}

export interface RoleConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoleEdgeTypeResolver<TParent = any> {
  cursor?: RoleEdgeToCursorResolver<TParent>;
  node?: RoleEdgeToNodeResolver<TParent>;
}

export interface RoleEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaACLFieldTypeResolver<TParent = any> {
  name?: SchemaACLFieldToNameResolver<TParent>;
}

export interface SchemaACLFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaArrayFieldTypeResolver<TParent = any> {
  name?: SchemaArrayFieldToNameResolver<TParent>;
}

export interface SchemaArrayFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaBooleanFieldTypeResolver<TParent = any> {
  name?: SchemaBooleanFieldToNameResolver<TParent>;
}

export interface SchemaBooleanFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaBytesFieldTypeResolver<TParent = any> {
  name?: SchemaBytesFieldToNameResolver<TParent>;
}

export interface SchemaBytesFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaDateFieldTypeResolver<TParent = any> {
  name?: SchemaDateFieldToNameResolver<TParent>;
}

export interface SchemaDateFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaFileFieldTypeResolver<TParent = any> {
  name?: SchemaFileFieldToNameResolver<TParent>;
}

export interface SchemaFileFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaGeoPointFieldTypeResolver<TParent = any> {
  name?: SchemaGeoPointFieldToNameResolver<TParent>;
}

export interface SchemaGeoPointFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaNumberFieldTypeResolver<TParent = any> {
  name?: SchemaNumberFieldToNameResolver<TParent>;
}

export interface SchemaNumberFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaObjectFieldTypeResolver<TParent = any> {
  name?: SchemaObjectFieldToNameResolver<TParent>;
}

export interface SchemaObjectFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaPointerFieldTypeResolver<TParent = any> {
  name?: SchemaPointerFieldToNameResolver<TParent>;
  targetClassName?: SchemaPointerFieldToTargetClassNameResolver<TParent>;
}

export interface SchemaPointerFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SchemaPointerFieldToTargetClassNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaPolygonFieldTypeResolver<TParent = any> {
  name?: SchemaPolygonFieldToNameResolver<TParent>;
}

export interface SchemaPolygonFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaRelationFieldTypeResolver<TParent = any> {
  name?: SchemaRelationFieldToNameResolver<TParent>;
  targetClassName?: SchemaRelationFieldToTargetClassNameResolver<TParent>;
}

export interface SchemaRelationFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SchemaRelationFieldToTargetClassNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaStringFieldTypeResolver<TParent = any> {
  name?: SchemaStringFieldToNameResolver<TParent>;
}

export interface SchemaStringFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSendVerificationEmailPayloadTypeResolver<TParent = any> {
  clientMutationId?: SendVerificationEmailPayloadToClientMutationIdResolver<TParent>;
  ok?: SendVerificationEmailPayloadToOkResolver<TParent>;
}

export interface SendVerificationEmailPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SendVerificationEmailPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSessionTypeResolver<TParent = any> {
  ACL?: SessionToACLResolver<TParent>;
  createdAt?: SessionToCreatedAtResolver<TParent>;
  createdWith?: SessionToCreatedWithResolver<TParent>;
  expiresAt?: SessionToExpiresAtResolver<TParent>;
  id?: SessionToIdResolver<TParent>;
  installationId?: SessionToInstallationIdResolver<TParent>;
  objectId?: SessionToObjectIdResolver<TParent>;
  restricted?: SessionToRestrictedResolver<TParent>;
  sessionToken?: SessionToSessionTokenResolver<TParent>;
  updatedAt?: SessionToUpdatedAtResolver<TParent>;
  user?: SessionToUserResolver<TParent>;
}

export interface SessionToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToCreatedWithResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToExpiresAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToInstallationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToRestrictedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToSessionTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSessionConnectionTypeResolver<TParent = any> {
  count?: SessionConnectionToCountResolver<TParent>;
  edges?: SessionConnectionToEdgesResolver<TParent>;
  pageInfo?: SessionConnectionToPageInfoResolver<TParent>;
}

export interface SessionConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSessionEdgeTypeResolver<TParent = any> {
  cursor?: SessionEdgeToCursorResolver<TParent>;
  node?: SessionEdgeToNodeResolver<TParent>;
}

export interface SessionEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSignUpPayloadTypeResolver<TParent = any> {
  clientMutationId?: SignUpPayloadToClientMutationIdResolver<TParent>;
  viewer?: SignUpPayloadToViewerResolver<TParent>;
}

export interface SignUpPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SignUpPayloadToViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSubscrTypeResolver<TParent = any> {
  ACL?: SubscrToACLResolver<TParent>;
  Communities?: SubscrToCommunitiesResolver<TParent>;
  Owner?: SubscrToOwnerResolver<TParent>;
  PaymentPlan?: SubscrToPaymentPlanResolver<TParent>;
  SubscrPayments?: SubscrToSubscrPaymentsResolver<TParent>;
  beginAt?: SubscrToBeginAtResolver<TParent>;
  createdAt?: SubscrToCreatedAtResolver<TParent>;
  expireAt?: SubscrToExpireAtResolver<TParent>;
  id?: SubscrToIdResolver<TParent>;
  netPaid?: SubscrToNetPaidResolver<TParent>;
  objectId?: SubscrToObjectIdResolver<TParent>;
  paymentPeriod?: SubscrToPaymentPeriodResolver<TParent>;
  status?: SubscrToStatusResolver<TParent>;
  updatedAt?: SubscrToUpdatedAtResolver<TParent>;
}

export interface SubscrToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToCommunitiesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLCommunityOrder>;
  skip?: number;
  where?: GQLCommunityWhereInput;
}
export interface SubscrToCommunitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: SubscrToCommunitiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToPaymentPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToSubscrPaymentsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLSubscrPaymentOrder>;
  skip?: number;
  where?: GQLSubscrPaymentWhereInput;
}
export interface SubscrToSubscrPaymentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: SubscrToSubscrPaymentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToBeginAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToExpireAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToNetPaidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToPaymentPeriodResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSubscrConnectionTypeResolver<TParent = any> {
  count?: SubscrConnectionToCountResolver<TParent>;
  edges?: SubscrConnectionToEdgesResolver<TParent>;
  pageInfo?: SubscrConnectionToPageInfoResolver<TParent>;
}

export interface SubscrConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSubscrEdgeTypeResolver<TParent = any> {
  cursor?: SubscrEdgeToCursorResolver<TParent>;
  node?: SubscrEdgeToNodeResolver<TParent>;
}

export interface SubscrEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSubscrPaymentTypeResolver<TParent = any> {
  ACL?: SubscrPaymentToACLResolver<TParent>;
  Subscr?: SubscrPaymentToSubscrResolver<TParent>;
  User?: SubscrPaymentToUserResolver<TParent>;
  amount?: SubscrPaymentToAmountResolver<TParent>;
  createdAt?: SubscrPaymentToCreatedAtResolver<TParent>;
  data?: SubscrPaymentToDataResolver<TParent>;
  date?: SubscrPaymentToDateResolver<TParent>;
  descr?: SubscrPaymentToDescrResolver<TParent>;
  id?: SubscrPaymentToIdResolver<TParent>;
  objectId?: SubscrPaymentToObjectIdResolver<TParent>;
  outerId?: SubscrPaymentToOuterIdResolver<TParent>;
  status?: SubscrPaymentToStatusResolver<TParent>;
  type?: SubscrPaymentToTypeResolver<TParent>;
  updatedAt?: SubscrPaymentToUpdatedAtResolver<TParent>;
}

export interface SubscrPaymentToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToOuterIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSubscrPaymentConnectionTypeResolver<TParent = any> {
  count?: SubscrPaymentConnectionToCountResolver<TParent>;
  edges?: SubscrPaymentConnectionToEdgesResolver<TParent>;
  pageInfo?: SubscrPaymentConnectionToPageInfoResolver<TParent>;
}

export interface SubscrPaymentConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSubscrPaymentEdgeTypeResolver<TParent = any> {
  cursor?: SubscrPaymentEdgeToCursorResolver<TParent>;
  node?: SubscrPaymentEdgeToNodeResolver<TParent>;
}

export interface SubscrPaymentEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SubscrPaymentEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSupportInsightPayloadTypeResolver<TParent = any> {
  amenitiesBooked?: SupportInsightPayloadToAmenitiesBookedResolver<TParent>;
  eventsAttended?: SupportInsightPayloadToEventsAttendedResolver<TParent>;
  listingsPosted?: SupportInsightPayloadToListingsPostedResolver<TParent>;
  listingsTransactions?: SupportInsightPayloadToListingsTransactionsResolver<TParent>;
  listingsValueSum?: SupportInsightPayloadToListingsValueSumResolver<TParent>;
  moneySpent?: SupportInsightPayloadToMoneySpentResolver<TParent>;
  totalLikes?: SupportInsightPayloadToTotalLikesResolver<TParent>;
  totalMessages?: SupportInsightPayloadToTotalMessagesResolver<TParent>;
  totalPosts?: SupportInsightPayloadToTotalPostsResolver<TParent>;
  totalSessions?: SupportInsightPayloadToTotalSessionsResolver<TParent>;
}

export interface SupportInsightPayloadToAmenitiesBookedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToEventsAttendedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToListingsPostedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToListingsTransactionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToListingsValueSumResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToMoneySpentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToTotalLikesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToTotalMessagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToTotalPostsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SupportInsightPayloadToTotalSessionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTaskTypeResolver<TParent = any> {
  ACL?: TaskToACLResolver<TParent>;
  File?: TaskToFileResolver<TParent>;
  Owner?: TaskToOwnerResolver<TParent>;
  createdAt?: TaskToCreatedAtResolver<TParent>;
  error?: TaskToErrorResolver<TParent>;
  id?: TaskToIdResolver<TParent>;
  objectId?: TaskToObjectIdResolver<TParent>;
  options?: TaskToOptionsResolver<TParent>;
  processedRow?: TaskToProcessedRowResolver<TParent>;
  result?: TaskToResultResolver<TParent>;
  updatedAt?: TaskToUpdatedAtResolver<TParent>;
}

export interface TaskToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToErrorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToOptionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToProcessedRowResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToResultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTaskConnectionTypeResolver<TParent = any> {
  count?: TaskConnectionToCountResolver<TParent>;
  edges?: TaskConnectionToEdgesResolver<TParent>;
  pageInfo?: TaskConnectionToPageInfoResolver<TParent>;
}

export interface TaskConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTaskEdgeTypeResolver<TParent = any> {
  cursor?: TaskEdgeToCursorResolver<TParent>;
  node?: TaskEdgeToNodeResolver<TParent>;
}

export interface TaskEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TaskEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTransactionTypeResolver<TParent = any> {
  ACL?: TransactionToACLResolver<TParent>;
  Community?: TransactionToCommunityResolver<TParent>;
  Order?: TransactionToOrderResolver<TParent>;
  User?: TransactionToUserResolver<TParent>;
  amount?: TransactionToAmountResolver<TParent>;
  createdAt?: TransactionToCreatedAtResolver<TParent>;
  data?: TransactionToDataResolver<TParent>;
  date?: TransactionToDateResolver<TParent>;
  descr?: TransactionToDescrResolver<TParent>;
  id?: TransactionToIdResolver<TParent>;
  objectId?: TransactionToObjectIdResolver<TParent>;
  outerId?: TransactionToOuterIdResolver<TParent>;
  status?: TransactionToStatusResolver<TParent>;
  transferDest?: TransactionToTransferDestResolver<TParent>;
  transferGroup?: TransactionToTransferGroupResolver<TParent>;
  type?: TransactionToTypeResolver<TParent>;
  updatedAt?: TransactionToUpdatedAtResolver<TParent>;
}

export interface TransactionToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToDescrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToOuterIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToTransferDestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToTransferGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTransactionConnectionTypeResolver<TParent = any> {
  count?: TransactionConnectionToCountResolver<TParent>;
  edges?: TransactionConnectionToEdgesResolver<TParent>;
  pageInfo?: TransactionConnectionToPageInfoResolver<TParent>;
}

export interface TransactionConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTransactionEdgeTypeResolver<TParent = any> {
  cursor?: TransactionEdgeToCursorResolver<TParent>;
  node?: TransactionEdgeToNodeResolver<TParent>;
}

export interface TransactionEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TransactionEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateAdminPayloadTypeResolver<TParent = any> {
  admin?: UpdateAdminPayloadToAdminResolver<TParent>;
  clientMutationId?: UpdateAdminPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateAdminPayloadToAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateAdminPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateAmenityPayloadTypeResolver<TParent = any> {
  amenity?: UpdateAmenityPayloadToAmenityResolver<TParent>;
  clientMutationId?: UpdateAmenityPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateAmenityPayloadToAmenityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateAmenityPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateAppFilePayloadTypeResolver<TParent = any> {
  appFile?: UpdateAppFilePayloadToAppFileResolver<TParent>;
  clientMutationId?: UpdateAppFilePayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateAppFilePayloadToAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateAppFilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateCategoryPayloadTypeResolver<TParent = any> {
  category?: UpdateCategoryPayloadToCategoryResolver<TParent>;
  clientMutationId?: UpdateCategoryPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateCategoryPayloadToCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateCategoryPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateChatPayloadTypeResolver<TParent = any> {
  chat?: UpdateChatPayloadToChatResolver<TParent>;
  clientMutationId?: UpdateChatPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateChatPayloadToChatResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateChatPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateClassPayloadTypeResolver<TParent = any> {
  class?: UpdateClassPayloadToClassResolver<TParent>;
  clientMutationId?: UpdateClassPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateClassPayloadToClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateCommunityAdminPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateCommunityAdminPayloadToClientMutationIdResolver<TParent>;
  communityAdmin?: UpdateCommunityAdminPayloadToCommunityAdminResolver<TParent>;
}

export interface UpdateCommunityAdminPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateCommunityAdminPayloadToCommunityAdminResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateCommunityPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateCommunityPayloadToClientMutationIdResolver<TParent>;
  community?: UpdateCommunityPayloadToCommunityResolver<TParent>;
}

export interface UpdateCommunityPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateCommunityPayloadToCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateCompanyPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateCompanyPayloadToClientMutationIdResolver<TParent>;
  company?: UpdateCompanyPayloadToCompanyResolver<TParent>;
}

export interface UpdateCompanyPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateCompanyPayloadToCompanyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateCurrencyPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateCurrencyPayloadToClientMutationIdResolver<TParent>;
  currency?: UpdateCurrencyPayloadToCurrencyResolver<TParent>;
}

export interface UpdateCurrencyPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateCurrencyPayloadToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateDocumentPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateDocumentPayloadToClientMutationIdResolver<TParent>;
  document?: UpdateDocumentPayloadToDocumentResolver<TParent>;
}

export interface UpdateDocumentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateDocumentPayloadToDocumentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateEventPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateEventPayloadToClientMutationIdResolver<TParent>;
  event?: UpdateEventPayloadToEventResolver<TParent>;
}

export interface UpdateEventPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateEventPayloadToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateGroupPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateGroupPayloadToClientMutationIdResolver<TParent>;
  group?: UpdateGroupPayloadToGroupResolver<TParent>;
}

export interface UpdateGroupPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateGroupPayloadToGroupResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateHelpDeskPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateHelpDeskPayloadToClientMutationIdResolver<TParent>;
  helpDesk?: UpdateHelpDeskPayloadToHelpDeskResolver<TParent>;
}

export interface UpdateHelpDeskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateHelpDeskPayloadToHelpDeskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateInstallationPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateInstallationPayloadToClientMutationIdResolver<TParent>;
  installation?: UpdateInstallationPayloadToInstallationResolver<TParent>;
}

export interface UpdateInstallationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateInstallationPayloadToInstallationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateInvitationPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateInvitationPayloadToClientMutationIdResolver<TParent>;
  invitation?: UpdateInvitationPayloadToInvitationResolver<TParent>;
}

export interface UpdateInvitationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateInvitationPayloadToInvitationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateItemBookingPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateItemBookingPayloadToClientMutationIdResolver<TParent>;
  itemBooking?: UpdateItemBookingPayloadToItemBookingResolver<TParent>;
}

export interface UpdateItemBookingPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateItemBookingPayloadToItemBookingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateItemPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateItemPayloadToClientMutationIdResolver<TParent>;
  item?: UpdateItemPayloadToItemResolver<TParent>;
}

export interface UpdateItemPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateItemPayloadToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateJoinRequestPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateJoinRequestPayloadToClientMutationIdResolver<TParent>;
  joinRequest?: UpdateJoinRequestPayloadToJoinRequestResolver<TParent>;
}

export interface UpdateJoinRequestPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateJoinRequestPayloadToJoinRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateLanguagePayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateLanguagePayloadToClientMutationIdResolver<TParent>;
  language?: UpdateLanguagePayloadToLanguageResolver<TParent>;
}

export interface UpdateLanguagePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateLanguagePayloadToLanguageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateLocationPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateLocationPayloadToClientMutationIdResolver<TParent>;
  location?: UpdateLocationPayloadToLocationResolver<TParent>;
}

export interface UpdateLocationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateLocationPayloadToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateMessagePayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateMessagePayloadToClientMutationIdResolver<TParent>;
  message?: UpdateMessagePayloadToMessageResolver<TParent>;
}

export interface UpdateMessagePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateMessagePayloadToMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateMyClassPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateMyClassPayloadToClientMutationIdResolver<TParent>;
  myClass?: UpdateMyClassPayloadToMyClassResolver<TParent>;
}

export interface UpdateMyClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateMyClassPayloadToMyClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateNotifSendingPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateNotifSendingPayloadToClientMutationIdResolver<TParent>;
  notifSending?: UpdateNotifSendingPayloadToNotifSendingResolver<TParent>;
}

export interface UpdateNotifSendingPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateNotifSendingPayloadToNotifSendingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateNotificationPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateNotificationPayloadToClientMutationIdResolver<TParent>;
  notification?: UpdateNotificationPayloadToNotificationResolver<TParent>;
}

export interface UpdateNotificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateNotificationPayloadToNotificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateOrderPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateOrderPayloadToClientMutationIdResolver<TParent>;
  order?: UpdateOrderPayloadToOrderResolver<TParent>;
}

export interface UpdateOrderPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateOrderPayloadToOrderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePaymentPlanPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdatePaymentPlanPayloadToClientMutationIdResolver<TParent>;
  paymentPlan?: UpdatePaymentPlanPayloadToPaymentPlanResolver<TParent>;
}

export interface UpdatePaymentPlanPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdatePaymentPlanPayloadToPaymentPlanResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePhoneVerificationPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdatePhoneVerificationPayloadToClientMutationIdResolver<TParent>;
  phoneVerification?: UpdatePhoneVerificationPayloadToPhoneVerificationResolver<TParent>;
}

export interface UpdatePhoneVerificationPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdatePhoneVerificationPayloadToPhoneVerificationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePollOptionPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdatePollOptionPayloadToClientMutationIdResolver<TParent>;
  pollOption?: UpdatePollOptionPayloadToPollOptionResolver<TParent>;
}

export interface UpdatePollOptionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdatePollOptionPayloadToPollOptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePostPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdatePostPayloadToClientMutationIdResolver<TParent>;
  post?: UpdatePostPayloadToPostResolver<TParent>;
}

export interface UpdatePostPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdatePostPayloadToPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePostTranslatePayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdatePostTranslatePayloadToClientMutationIdResolver<TParent>;
  postTranslate?: UpdatePostTranslatePayloadToPostTranslateResolver<TParent>;
}

export interface UpdatePostTranslatePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdatePostTranslatePayloadToPostTranslateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePromoPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdatePromoPayloadToClientMutationIdResolver<TParent>;
  promo?: UpdatePromoPayloadToPromoResolver<TParent>;
}

export interface UpdatePromoPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdatePromoPayloadToPromoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdatePushNotificationLogPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdatePushNotificationLogPayloadToClientMutationIdResolver<TParent>;
  pushNotificationLog?: UpdatePushNotificationLogPayloadToPushNotificationLogResolver<TParent>;
}

export interface UpdatePushNotificationLogPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdatePushNotificationLogPayloadToPushNotificationLogResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateReferralPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateReferralPayloadToClientMutationIdResolver<TParent>;
  referral?: UpdateReferralPayloadToReferralResolver<TParent>;
}

export interface UpdateReferralPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateReferralPayloadToReferralResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateReportPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateReportPayloadToClientMutationIdResolver<TParent>;
  report?: UpdateReportPayloadToReportResolver<TParent>;
}

export interface UpdateReportPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateReportPayloadToReportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateReviewPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateReviewPayloadToClientMutationIdResolver<TParent>;
  review?: UpdateReviewPayloadToReviewResolver<TParent>;
}

export interface UpdateReviewPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateReviewPayloadToReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateRolePayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateRolePayloadToClientMutationIdResolver<TParent>;
  role?: UpdateRolePayloadToRoleResolver<TParent>;
}

export interface UpdateRolePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateRolePayloadToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateSessionPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateSessionPayloadToClientMutationIdResolver<TParent>;
  session?: UpdateSessionPayloadToSessionResolver<TParent>;
}

export interface UpdateSessionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSessionPayloadToSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateSubscrPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateSubscrPayloadToClientMutationIdResolver<TParent>;
  subscr?: UpdateSubscrPayloadToSubscrResolver<TParent>;
}

export interface UpdateSubscrPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSubscrPayloadToSubscrResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateSubscrPaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateSubscrPaymentPayloadToClientMutationIdResolver<TParent>;
  subscrPayment?: UpdateSubscrPaymentPayloadToSubscrPaymentResolver<TParent>;
}

export interface UpdateSubscrPaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSubscrPaymentPayloadToSubscrPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateTaskPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateTaskPayloadToClientMutationIdResolver<TParent>;
  task?: UpdateTaskPayloadToTaskResolver<TParent>;
}

export interface UpdateTaskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateTaskPayloadToTaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateTransactionPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateTransactionPayloadToClientMutationIdResolver<TParent>;
  transaction?: UpdateTransactionPayloadToTransactionResolver<TParent>;
}

export interface UpdateTransactionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateTransactionPayloadToTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUserPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateUserPayloadToClientMutationIdResolver<TParent>;
  user?: UpdateUserPayloadToUserResolver<TParent>;
}

export interface UpdateUserPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUserPayloadToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserTypeResolver<TParent = any> {
  ACL?: UserToACLResolver<TParent>;
  Avatar?: UserToAvatarResolver<TParent>;
  Blocked?: UserToBlockedResolver<TParent>;
  Communities?: UserToCommunitiesResolver<TParent>;
  Country?: UserToCountryResolver<TParent>;
  Currency?: UserToCurrencyResolver<TParent>;
  Language?: UserToLanguageResolver<TParent>;
  Location?: UserToLocationResolver<TParent>;
  Orders?: UserToOrdersResolver<TParent>;
  ReferralCode?: UserToReferralCodeResolver<TParent>;
  Reports?: UserToReportsResolver<TParent>;
  Reviews?: UserToReviewsResolver<TParent>;
  Viewers?: UserToViewersResolver<TParent>;
  address?: UserToAddressResolver<TParent>;
  aptSuite?: UserToAptSuiteResolver<TParent>;
  authData?: UserToAuthDataResolver<TParent>;
  bio?: UserToBioResolver<TParent>;
  birthDate?: UserToBirthDateResolver<TParent>;
  cardInfo?: UserToCardInfoResolver<TParent>;
  checkList?: UserToCheckListResolver<TParent>;
  checkListSeen?: UserToCheckListSeenResolver<TParent>;
  createdAt?: UserToCreatedAtResolver<TParent>;
  distance?: UserToDistanceResolver<TParent>;
  earned?: UserToEarnedResolver<TParent>;
  email?: UserToEmailResolver<TParent>;
  emailVerified?: UserToEmailVerifiedResolver<TParent>;
  firstLetter?: UserToFirstLetterResolver<TParent>;
  firstName?: UserToFirstNameResolver<TParent>;
  gender?: UserToGenderResolver<TParent>;
  geo?: UserToGeoResolver<TParent>;
  homepage?: UserToHomepageResolver<TParent>;
  howDidYouHear?: UserToHowDidYouHearResolver<TParent>;
  id?: UserToIdResolver<TParent>;
  identityData?: UserToIdentityDataResolver<TParent>;
  interests?: UserToInterestsResolver<TParent>;
  isDeleted?: UserToIsDeletedResolver<TParent>;
  isInvited?: UserToIsInvitedResolver<TParent>;
  isOnline?: UserToIsOnlineResolver<TParent>;
  isSupport?: UserToIsSupportResolver<TParent>;
  isVerified?: UserToIsVerifiedResolver<TParent>;
  isWaved?: UserToIsWavedResolver<TParent>;
  languages?: UserToLanguagesResolver<TParent>;
  lastName?: UserToLastNameResolver<TParent>;
  lastVisitedCommunity?: UserToLastVisitedCommunityResolver<TParent>;
  listingCount?: UserToListingCountResolver<TParent>;
  livingWith?: UserToLivingWithResolver<TParent>;
  mobilePushEnabled?: UserToMobilePushEnabledResolver<TParent>;
  msgIncoming?: UserToMsgIncomingResolver<TParent>;
  notifyAmenityReminder?: UserToNotifyAmenityReminderResolver<TParent>;
  notifyDigest?: UserToNotifyDigestResolver<TParent>;
  notifyEventAttendees?: UserToNotifyEventAttendeesResolver<TParent>;
  notifyEventReminder?: UserToNotifyEventReminderResolver<TParent>;
  notifyHelpCentre?: UserToNotifyHelpCentreResolver<TParent>;
  notifyJoinRequest?: UserToNotifyJoinRequestResolver<TParent>;
  notifyLikeOrComment?: UserToNotifyLikeOrCommentResolver<TParent>;
  notifyListingView?: UserToNotifyListingViewResolver<TParent>;
  notifyListingsRequest?: UserToNotifyListingsRequestResolver<TParent>;
  notifyLoopPost?: UserToNotifyLoopPostResolver<TParent>;
  notifyManagedAmenities?: UserToNotifyManagedAmenitiesResolver<TParent>;
  notifyManagerAdminPost?: UserToNotifyManagerAdminPostResolver<TParent>;
  notifyMarketingAndFeatures?: UserToNotifyMarketingAndFeaturesResolver<TParent>;
  notifyMessage?: UserToNotifyMessageResolver<TParent>;
  notifyNewCommunities?: UserToNotifyNewCommunitiesResolver<TParent>;
  notifyNewListing?: UserToNotifyNewListingResolver<TParent>;
  notifyNewListings?: UserToNotifyNewListingsResolver<TParent>;
  notifyNewMember?: UserToNotifyNewMemberResolver<TParent>;
  notifyNewMembers?: UserToNotifyNewMembersResolver<TParent>;
  notifyNewRequests?: UserToNotifyNewRequestsResolver<TParent>;
  notifyNewResidentListings?: UserToNotifyNewResidentListingsResolver<TParent>;
  notifyNewResidents?: UserToNotifyNewResidentsResolver<TParent>;
  notifyNewTransaction?: UserToNotifyNewTransactionResolver<TParent>;
  notifyOrderRequest?: UserToNotifyOrderRequestResolver<TParent>;
  notifyProfileView?: UserToNotifyProfileViewResolver<TParent>;
  notifyUnmanagedAmenities?: UserToNotifyUnmanagedAmenitiesResolver<TParent>;
  objectId?: UserToObjectIdResolver<TParent>;
  occupation?: UserToOccupationResolver<TParent>;
  onlineDate?: UserToOnlineDateResolver<TParent>;
  personInterests?: UserToPersonInterestsResolver<TParent>;
  phone?: UserToPhoneResolver<TParent>;
  phoneVerified?: UserToPhoneVerifiedResolver<TParent>;
  platformStripeId?: UserToPlatformStripeIdResolver<TParent>;
  profileViewOff?: UserToProfileViewOffResolver<TParent>;
  rating?: UserToRatingResolver<TParent>;
  recommendations?: UserToRecommendationsResolver<TParent>;
  spent?: UserToSpentResolver<TParent>;
  status?: UserToStatusResolver<TParent>;
  stripeConnectedId?: UserToStripeConnectedIdResolver<TParent>;
  stripeId?: UserToStripeIdResolver<TParent>;
  study?: UserToStudyResolver<TParent>;
  tips?: UserToTipsResolver<TParent>;
  updatedAt?: UserToUpdatedAtResolver<TParent>;
  username?: UserToUsernameResolver<TParent>;
  work?: UserToWorkResolver<TParent>;
  zip?: UserToZipResolver<TParent>;
}

export interface UserToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAvatarResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToBlockedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCommunitiesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLCommunityOrder>;
  skip?: number;
  where?: GQLCommunityWhereInput;
}
export interface UserToCommunitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: UserToCommunitiesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToLanguageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToLocationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToOrdersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLOrderOrder>;
  skip?: number;
  where?: GQLOrderWhereInput;
}
export interface UserToOrdersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: UserToOrdersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToReferralCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToReportsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReportOrder>;
  skip?: number;
  where?: GQLReportWhereInput;
}
export interface UserToReportsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: UserToReportsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToReviewsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLReviewOrder>;
  skip?: number;
  where?: GQLReviewWhereInput;
}
export interface UserToReviewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: UserToReviewsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToViewersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface UserToViewersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: UserToViewersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAptSuiteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAuthDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToBioResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToBirthDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCardInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCheckListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCheckListSeenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToDistanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToEarnedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToEmailVerifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToFirstLetterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToFirstNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToGenderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToGeoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToHomepageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToHowDidYouHearResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIdentityDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToInterestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIsDeletedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIsInvitedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIsOnlineResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIsSupportResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIsVerifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIsWavedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToLanguagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToLastNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToLastVisitedCommunityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToListingCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToLivingWithResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToMobilePushEnabledResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToMsgIncomingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyAmenityReminderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyDigestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyEventAttendeesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyEventReminderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyHelpCentreResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyJoinRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyLikeOrCommentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyListingViewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyListingsRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyLoopPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyManagedAmenitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyManagerAdminPostResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyMarketingAndFeaturesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyMessageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewCommunitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewListingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewMemberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewMembersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewRequestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewResidentListingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewResidentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyNewTransactionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyOrderRequestResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyProfileViewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToNotifyUnmanagedAmenitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToOccupationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToOnlineDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToPersonInterestsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToPhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToPhoneVerifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToPlatformStripeIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToProfileViewOffResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToRecommendationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToSpentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToStripeConnectedIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToStripeIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToStudyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToTipsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToUsernameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToWorkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToZipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserACLTypeResolver<TParent = any> {
  read?: UserACLToReadResolver<TParent>;
  userId?: UserACLToUserIdResolver<TParent>;
  write?: UserACLToWriteResolver<TParent>;
}

export interface UserACLToReadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserACLToUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserACLToWriteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserConnectionTypeResolver<TParent = any> {
  count?: UserConnectionToCountResolver<TParent>;
  edges?: UserConnectionToEdgesResolver<TParent>;
  pageInfo?: UserConnectionToPageInfoResolver<TParent>;
}

export interface UserConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserEdgeTypeResolver<TParent = any> {
  cursor?: UserEdgeToCursorResolver<TParent>;
  node?: UserEdgeToNodeResolver<TParent>;
}

export interface UserEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLVerifyCodePayloadTypeResolver<TParent = any> {
  clientMutationId?: VerifyCodePayloadToClientMutationIdResolver<TParent>;
  ok?: VerifyCodePayloadToOkResolver<TParent>;
}

export interface VerifyCodePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface VerifyCodePayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLVerifyEmailPayloadTypeResolver<TParent = any> {
  clientMutationId?: VerifyEmailPayloadToClientMutationIdResolver<TParent>;
  ok?: VerifyEmailPayloadToOkResolver<TParent>;
}

export interface VerifyEmailPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface VerifyEmailPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLVerifyPhonePayloadTypeResolver<TParent = any> {
  clientMutationId?: VerifyPhonePayloadToClientMutationIdResolver<TParent>;
  ok?: VerifyPhonePayloadToOkResolver<TParent>;
}

export interface VerifyPhonePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface VerifyPhonePayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLViewObjectPayloadTypeResolver<TParent = any> {
  error?: ViewObjectPayloadToErrorResolver<TParent>;
  success?: ViewObjectPayloadToSuccessResolver<TParent>;
}

export interface ViewObjectPayloadToErrorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ViewObjectPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLViewerTypeResolver<TParent = any> {
  sessionToken?: ViewerToSessionTokenResolver<TParent>;
  user?: ViewerToUserResolver<TParent>;
}

export interface ViewerToSessionTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ViewerToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLWaveUserPayloadTypeResolver<TParent = any> {
  success?: WaveUserPayloadToSuccessResolver<TParent>;
}

export interface WaveUserPayloadToSuccessResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLgetEventPayloadTypeResolver<TParent = any> {
  event?: getEventPayloadToEventResolver<TParent>;
}

export interface getEventPayloadToEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLgetSeoOrderItemDataPayloadTypeResolver<TParent = any> {
  item?: getSeoOrderItemDataPayloadToItemResolver<TParent>;
}

export interface getSeoOrderItemDataPayloadToItemResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}
